// Indonesian translations, keyed by the English source string used in t().
// A missing key falls back to the English text, so this can grow module by module.
export const idMessages: Record<string, string> = {
  " · Financial snapshot saved": " · Financial snapshot tersimpan",
  " · Row {row}": " · Baris {row}",
  "% progress": "% progres",
  "& Continue to Page": "& Lanjut ke Hal",
  "(Action on the Opportunity)": "(Aksi pada Opportunity)",
  "(Assignment status updated)": "(Status assignment diperbarui)",
  "(Contact available)": "(Contact tersedia)",
  "(CR has Open status)": "(CR berstatus Open)",
  "(Customer, Opportunity, and SO)": "(Customer, Opportunity, dan SO)",
  "(from BA)": "(dari BA)",
  "(latest)": "(terkini)",
  "(old)": "(lama)",
  "(optional)": "(opsional)",
  "(Record activity or audit log)": "(Catat activity atau audit log)",
  "(Save changes)": "(Simpan perubahan)",
  "(Save customer)": "(Simpan customer)",
  "(Save IM Draft)": "(Simpan IM Draft)",
  "(Save master data)": "(Simpan master data)",
  "(Save Opportunity)": "(Simpan Opportunity)",
  "(Save or replace the GPI dataset)": "(Simpan atau ganti dataset GPI)",
  "(Save PO with Received status)": "(Simpan PO dengan status Diterima)",
  "(Save release snapshot)": "(Simpan release snapshot)",
  "(Save released version snapshot)": "(Simpan snapshot versi released)",
  "(Save Sales Order Draft)": "(Simpan Sales Order Draft)",
  "(Save Timeline Plan)": "(Simpan Timeline Plan)",
  "(Step 1)": "(Tahap 1)",
  "*A note is required if you choose Reject.": "*Catatan wajib diisi jika Anda memilih Reject.",
  "+ Add PO": "+ Tambah PO",
  "+ Create New IM (Referencing": "+ Buat IM Baru (Merujuk ke",
  "+ Upload new PO": "+ Upload PO baru",
  "+ Upload New PO": "+ Upload PO Baru",
  ", enter a Google Drive link. Files": ", masukkan link Google Drive. File",
  "- Completed": "- Selesai",
  "- Select Customer Company -": "- Pilih Perusahaan Customer -",
  "-- Choose a Task --": "-- Pilih Tugas --",
  "-- Party Category --": "-- Kategori Pihak --",
  "-- Select --": "-- Pilih --",
  "-- Select an Approved IM Document --": "-- Pilih Dokumen IM yang Disetujui --",
  "-- Select an Available PO Document --": "-- Pilih Dokumen PO yang Tersedia --",
  "-- Select Assessment Team --": "-- Pilih Tim Pemeriksa --",
  "-- Select Company --": "-- Pilih Company --",
  "-- Select Contract Type --": "-- Pilih Tipe Kontrak --",
  "-- Select Customer --": "-- Pilih Pelanggan --",
  "-- Select Institution --": "-- Pilih Instansi --",
  "-- Select Name --": "-- Pilih Nama --",
  "-- Select Reason --": "-- Pilih Alasan --",
  "-- Select Superior --": "-- Pilih Atasan --",
  "-- Select Type --": "-- Pilih Tipe --",
  "-- Vendor Type --": "-- Tipe Vendor --",
  ". Fill in progress with": ". Isi progres dengan",
  ". Google Spreadsheets and folder links are only attached to evidence without being copied. Other file formats will be rejected.": ". Google Spreadsheet dan link folder hanya di-attach ke evidence tanpa disalin. Format file lain akan ditolak.",
  ". If you proceed, their schedule will be automatically swapped to room": ". Jika dilanjutkan, maka jadwal mereka akan otomatis ditukar ke ruangan",
  ". The PO file can be linked again at any time.": ". Berkas PO dapat ditautkan kembali kapan saja.",
  ". The signature will be embedded in the SO document.": ". Tanda tangan akan disematkan pada dokumen SO.",
  ". You can still proceed with PO upload using ID": ". Anda tetap dapat melanjutkan unggah PO menggunakan ID",
  "0 contracts already Expired": "0 kontrak sudah Expired",
  "1 Month Before Expiry": "1 Bulan Sebelum Habis",
  "1. Budget S-Curve (from GPI)": "1. Kurva-S Budget (dari GPI)",
  "1. Recipient Roles": "1. Role Penerima",
  "1. Relation Type": "1. Tipe Relasi",
  "1. Select Company / Entity": "1. Pilih Company / Entitas",
  "2-step finish approval": "Approval finish 2 step",
  "2. Document Type": "2. Jenis Dokumen",
  "2. Linked To": "2. Terhubung Dengan",
  "2. Message Content": "2. Konten Pesan",
  "2. Progress S-Curve (from Timeline)": "2. Kurva-S Progres (dari Linimasa)",
  "3. Send Confirmation": "3. Konfirmasi Pengiriman",
  "8–14 days": "8–14 hari",
  "; leave a cell empty if there is no change. Values of 0 and decimals are not accepted, and the batch must be corrected and re-uploaded. If the stage progress is filled": "; kosongkan sel jika tidak ada perubahan. Nilai 0 dan angka desimal tidak diterima dan batch harus diperbaiki lalu diupload ulang. Jika progress stage diisi",
  "> 14 days": "> 14 hari",
  "? All active approval processes will be reset.": "? Seluruh proses approval aktif akan direset.",
  "A connection error occurred": "Terjadi kesalahan koneksi",
  "A connection error occurred while importing data": "Terjadi gangguan koneksi saat import data",
  "A drop request cannot be resubmitted until the previous request is approved or rejected.": "Request drop tidak bisa disubmit ulang sebelum request sebelumnya di-approve atau di-reject.",
  "A network error occurred": "Terjadi kesalahan jaringan",
  "A network error occurred while uploading the file.": "Terjadi kesalahan jaringan saat mengunggah file.",
  "A network error occurred while withdrawing the document.": "Terjadi kesalahan jaringan saat menarik dokumen.",
  "A Network/Server Error Occurred": "Terjadi Kesalahan Jaringan/Server",
  "A new file is selected. Saving will replace the current attachment file.": "Berkas baru dipilih. Menyimpan akan menggantikan berkas lampiran saat ini.",
  "A note is required when rejecting!": "Catatan wajib diisi jika melakukan Reject!",
  "A rejection reason is required before rejecting.": "Alasan penolakan wajib diisi sebelum menolak.",
  "A rejection reason is required.": "Alasan penolakan wajib diisi.",
  "A rejection reason is required...": "Alasan penolakan wajib diisi...",
  "A server error occurred": "Terjadi kesalahan server",
  "A signature is required. Please draw your signature.": "Tanda tangan diperlukan. Silakan gambar TTD Anda.",
  "A system error occurred": "Terjadi kesalahan sistem",
  "A System Issue Occurred": "Terjadi Kendala Sistem",
  "Absensi TLH gps": "Absensi TLH GPS",
  "AC (Actual) :": "AC (Aktual) :",
  "Accept": "Terima",
  "Access Audit Logs": "Log Audit Akses",
  "Access Denied": "Akses Ditolak",
  "Access denied for this customer. Please contact your admin.": "Akses ditolak untuk customer ini. Silakan hubungi admin.",
  "Access denied to edit this opportunity. Please contact your admin.": "Akses ditolak untuk mengedit opportunity ini. Silakan hubungi admin.",
  "Access denied. Please contact your admin to get access to this page.": "Akses ditolak. Silakan hubungi admin untuk mendapatkan akses ke halaman ini.",
  "Access denied. Please contact your admin.": "Akses ditolak. Silakan hubungi admin.",
  "Access denied. You do not have permission to create bookings. Please contact your administrator.": "Akses ditolak. Anda tidak memiliki izin untuk membuat booking. Silakan hubungi administrator.",
  "Access Matrix": "Matriks Akses",
  "Access Roles": "Role Akses",
  "Accessible modules": "Modul yang dapat diakses",
  "Account & RBAC Editor": "Editor Akun & RBAC",
  "Account Manager": "Account Manager",
  "Account Manager action": "Aksi Account Manager",
  "Account Manager Performance": "Kinerja Account Manager",
  "Account Manager responsibilities from Lead to Deal and sales document submission.": "Tanggung jawab Account Manager dari Lead sampai Deal dan pengajuan dokumen sales.",
  "Account Password": "Password Akun",
  "Account User": "Pengguna Akun",
  "Account {name} {value1} successfully!": "Akun {name} berhasil {value1}!",
  "Acknowledge": "Akui",
  "Acknowledge Request": "Akui Permintaan",
  "Acknowledged": "Diakui",
  "Acknowledged By": "Diakui Oleh",
  "Across all active operational stages": "Di seluruh tahap operasional aktif",
  "Action": "Aksi",
  "Action Event": "Peristiwa Aksi",
  "Action Needed": "Perlu Tindakan",
  "Action Needed: Expiring Soon": "Action Needed: Segera Expired",
  "Action permission is not available": "Permission action tidak tersedia",
  "Action Required": "Perlu Tindakan",
  "Action Taken": "Tindakan yang Diambil",
  "Action type": "Tipe aksi",
  "Action Type": "Tipe Aksi",
  "Actions": "Aksi",
  "Activate Account": "Aktifkan Akun",
  "Activate the next approver": "Aktifkan approver berikutnya",
  "Active": "Aktif",
  "Active again in the pipeline": "Kembali aktif pada pipeline",
  "Active Alarm": "Alarm Aktif",
  "Active approver decision": "Keputusan approver aktif",
  "Active Contracts": "Kontrak Aktif",
  "active filters": "filter aktif",
  "Active IM": "IM Aktif",
  "Active IM:": "IM aktif:",
  "Active mitigations": "Mitigasi aktif",
  "active permissions": "permissions aktif",
  "Active Projects": "Proyek Aktif",
  "Active roles on this account:": "Role aktif pada akun ini:",
  "Active scope:": "Cakupan aktif:",
  "Active Sites": "Site Aktif",
  "Active Status": "Status Aktif",
  "Active step decision": "Keputusan step aktif",
  "Active user": "User aktif",
  "Activity": "Aktivitas",
  "Activity Description": "Deskripsi Aktivitas",
  "Activity history of documents, vendors, and approvals in the Procurement module.": "Riwayat aktivitas dokumen, vendor, dan approval pada modul Procurement.",
  "Activity Logs": "Log Aktivitas",
  "Activity logs export created successfully": "Ekspor log aktivitas berhasil dibuat",
  "Activity Timeline": "Linimasa Aktivitas",
  "Activity Timeline (": "Linimasa Aktivitas (",
  "Activity will appear once documents are created or processed.": "Aktivitas akan tampil setelah dokumen mulai dibuat atau diproses.",
  "Actor Name": "Nama Pelaksana",
  "Actor:": "Pelaksana:",
  "Actual (AC)": "Aktual (AC)",
  "Actual :": "Aktual :",
  "Actual Budget": "Budget Aktual",
  "Actual Progress": "Progres Aktual",
  "Actual Progress (%)": "Aktual Progress (%)",
  "Actual Time Arrival (ATA)": "Waktu Kedatangan Aktual (ATA)",
  "Add": "Tambah",
  "Add a message for the requestor if there are revisions or additional notes...": "Tambahkan pesan untuk pengaju jika ada revisi atau catatan tambahan...",
  "Add a note for the requestor...": "Tambahkan catatan untuk pemohon...",
  "Add Bank": "Tambah Bank",
  "Add Brief": "Tambah Ringkasan",
  "Add Catalog": "Tambah Katalog",
  "Add Company": "Tambah Company",
  "Add Contact": "Tambah Kontak",
  "Add Contact Person": "Tambah Contact Person",
  "Add context notes for the Account Manager...": "Tambahkan catatan konteks untuk Account Manager...",
  "Add customer": "Tambah customer",
  "Add Data": "Tambah Data",
  "Add detailed explanation here... (Note: Combined reason + notes must be at least 10 characters)": "Tambahkan penjelasan rinci di sini... (Catatan: Gabungan alasan + catatan minimal 10 karakter)",
  "Add Document": "Tambah Dokumen",
  "Add Material Catalog": "Tambah Katalog Material",
  "Add multi-line notes here...": "Tambahkan catatan multi-baris di sini...",
  "Add Negotiation": "Tambah Negosiasi",
  "Add New Company": "Tambah Company Baru",
  "Add New Contact": "Tambah Kontak Baru",
  "Add New Level": "Tambah Jenjang Baru",
  "Add New Partner": "Tambah Partner Baru",
  "Add New {categorySlug}": "Tambah {categorySlug} Baru",
  "Add notes or details about the document contents...": "Tambahkan catatan atau rincian isi dokumen...",
  "Add notes...": "Tambahkan notes...",
  "Add optional notes...": "Tambahkan catatan opsional...",
  "Add or change a partner": "Tambah atau ubah partner",
  "Add or change a product": "Tambah atau ubah produk",
  "Add PO": "Tambah PO",
  "Add progress": "Tambah progres",
  "Add Project Brief Update": "Tambah Pembaruan Ringkasan Proyek",
  "Add risk entry": "Tambah entri risiko",
  "Add Row": "Tambah Baris",
  "Add signature picture or draw it before approval.": "Tambahkan atau gambar tanda tangan sebelum persetujuan.",
  "Add Stage": "Tambah Tahap",
  "Add Stage 1 Approver": "Tambahkan Approver Tahap 1",
  "Add the GPI via file or link": "Tambahkan GPI melalui file atau link",
  "Add Unit": "Tambah Unit",
  "Add update without changing stage": "Tambah pembaruan tanpa mengubah tahap",
  "Add User": "Tambah Pengguna",
  "Add Vendor": "Tambah Vendor",
  "Added new risk factor: {newRiskFactor}": "Faktor risiko baru ditambahkan: {newRiskFactor}",
  "Adding...": "Menambahkan...",
  "Additional Competencies & Notes": "Kompetensi Tambahan & Catatan",
  "Additional Contact Data (Optional)": "Data Kontak Tambahan (Opsional)",
  "Additional Notes": "Catatan Tambahan",
  "Additional notes (optional)...": "Catatan tambahan (opsional)...",
  "Additional notes...": "Catatan tambahan...",
  "Address": "Alamat",
  "Address *": "Alamat *",
  "Admin Center": "Pusat Admin",
  "Admin Control Center": "Pusat Kontrol Admin",
  "Admin Home": "Beranda Admin",
  "Admin Sales responsibilities for master data and Sales Order preparation.": "Tanggung jawab Admin Sales pada master data dan preparation Sales Order.",
  "Admin Workspace": "Ruang Kerja Admin",
  "Administration": "Administrasi",
  "ADMINISTRATION": "ADMINISTRASI",
  "Advanced Column Filter": "Filter Lanjutan Kolom",
  "After release, open the OPS Project": "Setelah release, buka Project OPS",
  "Age": "Umur",
  "Aging and action-needed list": "Daftar aging dan action needed",
  "Aging resets after rejection": "Aging reset setelah rejection",
  "Aging resolved": "Aging terselesaikan",
  "Agreement": "Perjanjian",
  "AIBAS is temporarily unavailable": "AiBAS sementara tidak tersedia",
  "AiBAS Logo": "Logo AiBAS",
  "AiBAS. All rights reserved.": "AiBAS. Hak cipta dilindungi.",
  "Alita Logo": "Logo Alita",
  "ALL": "SEMUA",
  "All": "Semua",
  "All Account Managers": "Semua Account Manager",
  "All Accounts": "Semua Akun",
  "All Accounts (including without a role)": "Semua Account (termasuk tanpa role)",
  "All Actions": "Semua Aksi",
  "All Aging": "Semua Aging",
  "All AMs": "Semua AM",
  "All Business Types": "Semua Business Type",
  "All Categories": "Semua Kategori",
  "All caught up!": "Semua sudah beres!",
  "All Companies": "Semua Company",
  "All Customers": "Semua Pelanggan",
  "all data": "semua data",
  "All data": "Semua data",
  "All Documents": "Semua Dokumen",
  "All Entities": "Semua Entitas",
  "All fields are required, including the visitor photo.": "Semua field wajib diisi, termasuk foto visitor.",
  "All GPI line item data for this Sales Order has been deleted.": "Seluruh data line item GPI untuk Sales Order ini telah dihapus.",
  "All Health": "Semua Kesehatan",
  "All Modules": "Semua Modul",
  "All notifications marked as read": "Semua notifikasi sudah ditandai dibaca",
  "All PMs": "Semua PM",
  "All POs Released": "Semua PO Release",
  "All Projects": "Semua Proyek",
  "All RBAC Roles": "Semua Role RBAC",
  "All RCA summaries on this page use the same tickets table data source as the dashboard.": "Seluruh ringkasan RCA di halaman ini memakai sumber data tabel tickets yang sama dengan dashboard.",
  "All Regions": "Semua Wilayah",
  "All remaining approvers must have a saved signature.": "Semua approver yang tersisa wajib memiliki tanda tangan tersimpan.",
  "All Requesters": "Semua Requester",
  "All Roles": "Semua Role",
  "All Rooms": "Semua Ruangan",
  "All Severity": "Semua Tingkat Keparahan",
  "ALL STATUS": "SEMUA STATUS",
  "All Status": "Semua Status",
  "All Statuses": "Semua Status",
  "All Task Types": "Semua Tipe Tugas",
  "All Time": "Semua Waktu",
  "All TPD progress returns to 0 / Not Started.": "Semua progress TPD kembali ke 0 / Not Started.",
  "All Types": "Semua Tipe",
  "All Users": "Semua Pengguna",
  "All Vehicles": "Semua Kendaraan",
  "All work for this TPD is complete.": "Semua pekerjaan untuk TPD ini selesai.",
  "Allow Camera Access": "Izinkan Akses Kamera",
  "Allowed Modules:": "Modul yang Diizinkan (Allowed Modules):",
  "Already": "Sudah",
  "AM Capacity Guard": "Pengaman Kapasitas AM",
  "AM Capacity Widget": "Widget Kapasitas AM",
  "AM revises then resubmits": "AM revisi lalu submit ulang",
  "AM revises then resubmits from the start": "AM revisi lalu submit ulang dari awal",
  "AM submits a Drop": "AM mengajukan Drop",
  "Amount": "Nilai",
  "Amount (EURO)": "Jumlah (EURO)",
  "Amount (IDR)": "Jumlah (IDR)",
  "Amount (USD)": "Jumlah (USD)",
  "An account must have at least one role.": "Akun wajib memiliki minimal satu role.",
  "An error occurred": "Terjadi kesalahan",
  "An error occurred during upload": "Terjadi kesalahan saat mengunggah",
  "An error occurred while progressing the stage": "Terjadi kesalahan saat memajukan tahap",
  "An error occurred. Please try again.": "Terjadi kesalahan. Silakan coba lagi.",
  "Analyst": "Analis",
  "Analyst Workspace": "Ruang Kerja Analis",
  "Analyzing date columns and rows from {name}...": "Menganalisis kolom dan baris tanggal dari {name}...",
  "and business type complete?": "dan business type lengkap?",
  "and each": "dan setiap",
  "and enters the approval circulation as soon as it is saved.": "dan masuk ke Approval Circulir begitu disimpan.",
  "and market value greater than 0?": "dan market value lebih dari 0?",
  "and Timeline complete?": "dan Timeline lengkap?",
  "Annual Revenue": "Pendapatan Tahunan",
  "API Error: {status} {statusText}": "Error API: {status} {statusText}",
  "App:": "Aplikasi:",
  "Application navigation": "Navigasi aplikasi",
  "Approval": "Persetujuan",
  "Approval Chain": "Rantai Persetujuan",
  "Approval Circulation": "Approval Circulir",
  "Approval circulation configuration saved.": "Konfigurasi Approval Circulir tersimpan.",
  "Approval Circulation Sequence": "Urutan Approval Circulir",
  "Approval Confirmation": "Konfirmasi Approval",
  "Approval Decision Summary": "Ringkasan Keputusan Persetujuan",
  "Approval failed": "Persetujuan gagal",
  "Approval Flow Progress": "Progress Alur Persetujuan",
  "Approval Journey": "Perjalanan Persetujuan",
  "Approval notes (optional)...": "Catatan approval (opsional)...",
  "Approval Pending": "Persetujuan Tertunda",
  "Approval Progress": "Progres Persetujuan",
  "Approval Queue": "Antrean Persetujuan",
  "Approval route updated successfully.": "Jalur approval berhasil diperbarui.",
  "Approval Settings Updated": "Pengaturan Persetujuan Diperbarui",
  "Approval Signature": "Tanda Tangan Approval",
  "Approval signature": "Tanda tangan approval",
  "Approval Stage": "Tahap Persetujuan",
  "Approval Timeline Stepper": "Stepper Linimasa Persetujuan",
  "Approval Workflow": "Alur Persetujuan",
  "Approvals from the previous version are kept as history and are not changed by this Change Request.": "Approval versi sebelumnya tersimpan sebagai riwayat dan tidak diubah oleh Change Request ini.",
  "approve": "menyetujui",
  "Approve": "Setujui",
  "APPROVE": "SETUJUI",
  "Approve & Assign": "Setujui & Tugaskan",
  "Approve (Approval)": "Approve (Persetujuan)",
  "Approve / Reject": "Setujui / Tolak",
  "Approve and there are other steps": "Approve dan ada step lain",
  "Approve Drop": "Setujui Drop",
  "APPROVE FINISH": "SETUJUI PENYELESAIAN",
  "Approve Internal Memo": "Setujui Internal Memo",
  "Approve is only available when your approval step is active.": "Persetujuan hanya tersedia saat langkah persetujuan Anda aktif.",
  "Approve Negotiation": "Setujui Negosiasi",
  "Approve Only": "Hanya Setujui",
  "Legal approval user manual": "Manual pengguna approval Legal",
  "CRM Account Manager user manual": "Manual pengguna CRM untuk Account Manager",
  "The user manual could not be opened.": "Manual pengguna tidak dapat dibuka.",
  "Approve or reject IM pending actions for Finance role.": "Setujui atau tolak tindakan IM yang menunggu untuk role Finance.",
  "Approve Page": "Setujui Hal",
  "Approve Request": "Setujui Permintaan",
  "Approve seluruh chain yang tersisa?": "Setujui seluruh rantai yang tersisa?",
  "Approve SO & Save Signature": "Setujui SO & Simpan Tanda Tangan",
  "Approve Task": "Setujui Tugas",
  "Approve the entire remaining chain?": "Setujui seluruh rantai yang tersisa?",
  "Approve, steps remaining": "Approve, masih ada step",
  "Approved": "Disetujui",
  "approved": "menyetujui",
  "Approved Budget": "Anggaran Disetujui",
  "Approved budget, spending, and what is left.": "Anggaran disetujui, pemakaian, dan sisanya.",
  "Approved by": "Disetujui oleh",
  "Approver": "Approver",
  "Approver 1 (Initial)": "Approver 1 (Paraf)",
  "Approver 2 initials after stage 1 is done. Becomes the": "Approver 2 memberi paraf setelah tahap 1 selesai. Menjadi",
  "Approver 3 gives the final approval for BAK and Others documents. Not applicable to Cancellation Letter.": "Approver 3 memberikan persetujuan final untuk dokumen tipe BAK dan Others. Tidak berlaku untuk Cancellation Letter.",
  "Approver configuration is incomplete in Settings.": "Konfigurasi approver belum lengkap di Settings.",
  "Approver configuration is incomplete.": "Konfigurasi approver belum lengkap.",
  "Approver decision": "Keputusan approver",
  "Approver not found": "Approver tidak ditemukan",
  "Approver Signature": "Tanda Tangan Approver",
  "Approving this approval step is": "Menyetujui langkah approval ini bersifat",
  "Approving...": "Menyetujui...",
  "Archive center for Incoming and Outgoing Letters.": "Pusat arsip Surat Masuk dan Surat Keluar.",
  "Archive document saved directly!": "Dokumen Arsip berhasil disimpan langsung!",
  "Archived": "Diarsipkan",
  "Are all POs on the IM Released?": "Semua PO pada IM sudah Release?",
  "Are the active IM limit and exposure safe?": "Limit IM aktif dan exposure aman?",
  "Are the folder, amount, and business type complete?": "Folder, amount, dan business type lengkap?",
  "Are the prerequisites complete?": "Prerequisite lengkap?",
  "Are you sure you want to withdraw this document submission back to": "Apakah Anda yakin ingin menarik kembali pengajuan dokumen ini menjadi",
  "Areas with the highest TT volume under the active filter": "Area dengan volume TT tertinggi pada filter aktif",
  "Articles of Association": "Anggaran Dasar",
  "Assessed By": "Assessed By (Pemeriksa)",
  "Asset data not found.": "Data asset tidak ditemukan.",
  "Assets": "Aset",
  "Assets Management": "Manajemen Aset",
  "Assign Category": "Tetapkan Kategori",
  "Assign Data": "Tetapkan Data",
  "Assign Roles": "Atur Role",
  "Assign SA PIC": "Tetapkan PIC SA",
  "Assign security roles (RBAC) and monitor the effective modules each employee can access on the AiBAS platform.": "Tetapkan peran keamanan (RBAC) dan pantau modul efektif yang dapat diakses oleh setiap pegawai pada platform AiBAS.",
  "Assign Selected (": "Tetapkan yang Dipilih (",
  "Assign Users": "Tetapkan Pengguna",
  "Assigned Category": "Kategori yang Ditetapkan",
  "Assigned PDP Data": "Data PDP yang Ditetapkan",
  "Assignment completed successfully!": "Penugasan berhasil diselesaikan!",
  "Assignment type": "Jenis assignment",
  "Assignments": "Penugasan",
  "at": "pada",
  "At least 1 line item is required to continue to the next stage.": "Minimal 1 line item dibutuhkan untuk lanjut ke tahap berikutnya.",
  "At Risk": "Berisiko",
  "At-Risk": "Berisiko",
  "Attach an Approved IM Document": "Lampirkan Dokumen IM yang Telah Disetujui",
  "Attach evidence": "Lampirkan bukti",
  "Attach external docs (PDF/DOC/XLS, multiple files, max 10MB each)": "Lampirkan dokumen eksternal (PDF/DOC/XLS, beberapa file, maks 10MB per file)",
  "Attach external files (PDF/DOC/XLS, multiple files, max 10MB per file)": "Lampirkan berkas eksternal (PDF/DOC/XLS, multiple files, maks 10MB per file)",
  "Attach failed ({status})": "Menautkan gagal ({status})",
  "Attach internal docs (PDF/DOC/XLS, multiple files, max 10MB each)": "Lampirkan dokumen internal (PDF/DOC/XLS, beberapa file, maks 10MB per file)",
  "Attach internal files (PDF/DOC/XLS, multiple files, max 10MB per file)": "Lampirkan berkas internal (PDF/DOC/XLS, multiple files, maks 10MB per file)",
  "Attach PO failed.": "Menautkan PO gagal.",
  "Attached": "Terlampir",
  "Attached Document": "Dokumen Terlampir",
  "Attached Documents": "Dokumen Lampiran",
  "Attached Files": "File Terlampir",
  "Attachment": "Lampiran",
  "Attachment marked for delete": "Lampiran ditandai untuk dihapus",
  "Attachment Uploaded": "Lampiran Diunggah",
  "Attachments": "Lampiran",
  "Attendance": "Kehadiran",
  "Attention / Errors:": "Perhatian / Kesalahan:",
  "Attention:": "Perhatian:",
  "Audit & Activity": "Audit & Aktivitas",
  "Audit Log": "Log Audit",
  "Audit Logs": "Log Audit",
  "Audit Score": "Skor Audit",
  "Audit Status": "Status Audit",
  "Audit Status (Assessment)": "Status Audit (Assessment)",
  "Authority": "Otoritas",
  "Authority (User, Buyer)": "Otoritas (User, Buyer)",
  "Authority / Decision Maker": "Otoritas / Pengambil Keputusan",
  "Authority / Decision Maker is required": "Otoritas / Pengambil Keputusan wajib diisi",
  "Authority / Decision Maker is required for moving to Negotiation stage": "Otoritas / Pengambil Keputusan wajib diisi untuk maju ke tahap Negosiasi",
  "Authority is required for moving to Proposal": "Otoritas wajib diisi untuk maju ke Proposal",
  "Authorization & Approval": "Otorisasi & Approval",
  "Auto": "Otomatis",
  "Auto-Generated": "Dibuat Otomatis",
  "Auto-Save Failed": "Gagal Menyimpan Otomatis",
  "Automated processes performed by AiBAS without manual work handoffs.": "Proses otomatis yang dilakukan AiBAS tanpa perpindahan pekerjaan manual.",
  "Automatic Log Out In": "Log Out Otomatis Dalam",
  "Automatic release": "Release otomatis",
  "Automatically apply this to new projects with the same type.": "Terapkan otomatis ke proyek baru dengan tipe yang sama.",
  "Automatically saving {length} task dates to the database...": "Menyimpan otomatis {length} task dates ke database...",
  "Available": "Tersedia",
  "Available Templates": "Template Tersedia",
  "AVG MTTR": "Rata-rata MTTR",
  "Awaiting Approval": "Menunggu Persetujuan",
  "Awaiting Drop Approval": "Menunggu Drop Approval",
  "Awaiting Negotiation Approval": "Menunggu Negotiation Approval",
  "Awaiting You": "Menunggu Anda",
  "AX ERP Customer ID": "Customer ID AX ERP",
  "AX ERP ID": "ID AX ERP",
  "AX ERP Status": "Status ERP AX",
  "AX Integration Status": "Status Integrasi AX",
  "Back": "Kembali",
  "Back to Admin Center": "Kembali ke Admin Center",
  "Back to CRM": "Kembali ke CRM",
  "Back to Customer Database": "Kembali ke Customer Database",
  "Back to Customers": "Kembali ke Pelanggan",
  "Back to Dashboard": "Kembali ke Dasbor",
  "Back to Home": "Kembali ke Beranda",
  "Back to IM List": "Kembali ke IM List",
  "Back to Internal Memo List": "Kembali ke Internal Memo List",
  "Back to List": "Kembali ke Daftar",
  "Back to MyTasks": "Kembali ke Tugas Saya",
  "Back to Opportunities": "Kembali ke Peluang",
  "Back to Partner Management": "Kembali ke Partner Management",
  "Back to Partners": "Kembali ke Mitra",
  "Back to PDP Requests": "Kembali ke Permintaan PDP",
  "Back to Pipeline": "Kembali ke Pipeline",
  "Back to Product Catalog": "Kembali ke Katalog Produk",
  "Back to Products": "Kembali ke Produk",
  "Back to Progress Update": "Kembali ke Pembaruan Progres",
  "Back to Project Dashboard": "Kembali ke Dasbor Proyek",
  "Back to Project List": "Kembali ke Daftar Proyek",
  "Back to RBAC Matrix": "Kembali ke RBAC Matrix",
  "Back to Room List": "Kembali ke Daftar Ruangan",
  "Back to sales orders": "Kembali ke sales order",
  "Back to SO Workbench": "Kembali ke SO Workbench",
  "Back to ticket": "Kembali ke tiket",
  "Back to Tickets": "Kembali ke Tickets",
  "Back to tickets": "Kembali ke tiket",
  "Back to User Management": "Kembali ke User Management",
  "Back to:": "Kembali ke:",
  "BAK Material Procurement": "BAK Pengadaan Material",
  "Bank Code": "Kode Bank",
  "Bank deleted successfully!": "Bank berhasil dihapus!",
  "Bank Name": "Nama Bank",
  "Bank Name & Code": "Nama & Kode Bank",
  "Bank Name is required!": "Nama Bank wajib diisi!",
  "Bank {value1} successfully!": "Bank berhasil di{value1}!",
  "Banks": "Bank",
  "BANT entry, Head of SA review, and PIC assignment before Proposal.": "Pengisian BANT, review Head of SA, dan penetapan PIC sebelum Proposal.",
  "based on recent metrics. Please review the EVM and S-Curve analytics to address variances.": "berdasarkan metrik terbaru. Mohon tinjau analitik EVM dan Kurva-S untuk mengatasi varians.",
  "Batch completed with failures": "Batch selesai dengan kegagalan",
  "Batch data": "Data batch",
  "Batch Progress Upload": "Unggah Progres Batch",
  "Batch queued": "Batch masuk antrean",
  "Batch Update": "Pembaruan Batch",
  "Batch update failed": "Batch update gagal",
  "Batch update failed.": "Batch update gagal.",
  "Batch update processed successfully.": "Batch update berhasil diproses.",
  "Batch update successful": "Batch update berhasil",
  "Batch update successful.": "Batch update berhasil.",
  "Batch Upload": "Unggah Batch",
  "below.": "di bawah.",
  "Blocked": "Terblokir",
  "Booked": "Dipesan",
  "Booked by: {value1}": "Dipesan oleh: {value1}",
  "Booking": "Pemesanan",
  "Booking Approval": "Persetujuan Pemesanan",
  "Booking cancelled successfully": "Booking berhasil dibatalkan",
  "Booking confirmed successfully!": "Booking berhasil dikonfirmasi!",
  "Booking For (Requester)": "Pemesanan Untuk (Pemohon)",
  "Booking History": "Riwayat Pemesanan",
  "Booking history export created successfully": "Export booking history berhasil dibuat",
  "Booking updated successfully": "Booking berhasil diupdate",
  "Brand": "Merek",
  "Breakdown for the selected period": "Komposisi pada periode terpilih",
  "Brief description...": "Deskripsi singkat...",
  "Briefly explain why this IM is needed...": "Jelaskan secara singkat alasan dibutuhkannya IM ini...",
  "Broadcast": "Siaran",
  "Broadcast Center": "Pusat Siaran",
  "Broadcast recipient roles:": "Role penerima broadcast:",
  "Budget & Progress S-Curves": "Kurva-S Budget & Progres",
  "Budget (IDR) is required for moving to Proposal": "Budget (IDR) wajib diisi untuk maju ke Proposal",
  "Budget (Planned)": "Budget (Rencana)",
  "Budget (Total Cost Price):": "Budget (Total Harga Pokok):",
  "Budget Absorption Plan (%)": "Rencana Penyerapan Anggaran (%)",
  "Budget Breakdown": "Rincian Anggaran",
  "Budget data for this project has not been synchronized yet. Synchronization runs automatically every day at 00:00 and 12:00.": "Data budget untuk proyek ini belum disinkronisasi. Sinkronisasi berjalan secara otomatis setiap hari pukul 00:00 dan 12:00.",
  "budget points": "titik budget",
  "Budget S-Curve": "Kurva-S Budget",
  "Budget S-Curve (Expanded View)": "Kurva-S Budget (Tampilan Diperluas)",
  "Budget Used": "Budget Terpakai",
  "Budget Utilization": "Utilisasi Budget",
  "Builder & Matrix": "Pembangun & Matriks",
  "Building, Street, City, Postal Code...": "Gedung, Jalan, Kota, Kode Pos...",
  "Bus Type": "Tipe Bisnis",
  "Business": "Bisnis",
  "Business Analyst Module": "Modul Business Analyst",
  "Business Entity Form": "Bentuk Badan Usaha",
  "Business Entity Type": "Tipe Badan Usaha",
  "Business Type": "Tipe Bisnis",
  "button in the main table to edit the data in full.": "di tabel utama untuk mengubah data secara penuh.",
  "By": "Oleh",
  "by": "oleh",
  "By Amount (Rp)": "Berdasarkan Nilai (Rp)",
  "By Customer": "Berdasarkan Pelanggan",
  "By Quantity": "Berdasarkan Jumlah",
  "By Sector": "Berdasarkan Sektor",
  "By submitting this form, you declare that the information provided is accurate and complete to the best of your knowledge. This request will be processed in accordance with our Privacy Policy and applicable laws.": "Dengan mengirimkan formulir ini, Anda menyatakan bahwa informasi yang diberikan akurat dan lengkap sepengetahuan Anda. Permintaan ini akan diproses sesuai dengan Kebijakan Privasi kami dan hukum yang berlaku.",
  "By Time": "Berdasarkan Waktu",
  "Cabinet A, Shelf 3": "Lemari A, Rak 3",
  "Calculate revenue, cost, and margin": "Hitung revenue, cost, dan margin",
  "Calculate the S-Curve, progress rollup, and health": "Hitung S-Curve, progress rollup, dan health",
  "Calculate total duration and buffer": "Hitung total duration dan buffer",
  "Calculated severity:": "Tingkat keparahan terhitung:",
  "Camera stream unavailable": "Aliran kamera tidak tersedia",
  "Cancel": "Batal",
  "CANCEL - {value1}": "BATAL - {value1}",
  "Cancel Booking": "Batalkan Pemesanan",
  "Cancel Edit": "Batal Edit",
  "Cancel Reject": "Batal Reject",
  "Cancel Ticket": "Batalkan Tiket",
  "Cancel Upload": "Batalkan Upload",
  "Cancel uploading this file": "Batal upload file ini",
  "Cancellation Letter": "Surat Pembatalan",
  "Cancellation Letter ends at Stage 2 as the final approval.": "Cancellation Letter berhenti di Tahap 2 sebagai final approval.",
  "Cancellation mode activated. Action cannot be undone.": "Mode pembatalan diaktifkan. Aksi tidak dapat dibatalkan.",
  "Cancellation Reason *": "Alasan Pembatalan *",
  "Cancelled": "Dibatalkan",
  "Cannot access this opportunity.": "Tidak dapat mengakses opportunity ini.",
  "Cannot book a past time": "Tidak bisa booking di waktu lampau",
  "Capacity data is not available.": "Data kapasitas tidak tersedia.",
  "Capacity data unavailable for this opportunity.": "Data kapasitas tidak tersedia untuk peluang ini.",
  "Capture": "Ambil",
  "Capture Photo": "Ambil Foto",
  "Captured visitor": "Pengunjung yang diambil",
  "Case Management": "Manajemen Kasus",
  "Case Number": "Nomor Kasus",
  "Catalog": "Katalog",
  "Catalog created": "Katalog dibuat",
  "Catalog of sensitive data assets uploaded by Legal Team.": "Katalog aset data sensitif yang diunggah oleh Tim Legal.",
  "Category": "Kategori",
  "Category (PMM/NPD): Assigned via Task Assignment workflow": "Kategori (PMM/NPD): Ditetapkan melalui alur Penugasan Tugas",
  "Category / Document Type": "Kategori / Jenis Dokumen",
  "Category approval rejected successfully!": "Persetujuan kategori berhasil ditolak!",
  "Category Distribution": "Distribusi Kategori",
  "Category not assigned": "Kategori belum ditetapkan",
  "Category, Price & Unit": "Kategori, Harga & Satuan",
  "Center": "Pusat",
  "Certification": "Sertifikasi",
  "Certification details, project experience, etc...": "Detail sertifikasi, pengalaman proyek, dll...",
  "Change": "Perubahan",
  "Change Password": "Ubah Kata Sandi",
  "Change request acknowledged successfully": "Permintaan perubahan berhasil diakui",
  "Change request has been acknowledged. Review the revised SO data, regenerate PDF if needed, then submit it for approval again.": "Permintaan perubahan telah diakui. Tinjau data SO yang direvisi, buat ulang PDF jika perlu, lalu ajukan kembali untuk persetujuan.",
  "Change request rejected": "Permintaan perubahan ditolak",
  "Change Request submitted successfully": "Permintaan Perubahan berhasil diajukan",
  "Change Requests": "Permintaan Perubahan",
  "Change the filters or try again once there is new activity.": "Ubah filter atau coba lagi setelah ada aktivitas baru.",
  "Change the keywords or filters to see other results.": "Ubah kata kunci atau filter untuk melihat hasil lain.",
  "Change the search term or add a new vendor.": "Ubah kata pencarian atau tambahkan vendor baru.",
  "Change the SO into a new version Draft": "Ubah SO menjadi Draft versi baru",
  "Changes apply to the shared vendor master and are visible in other modules that use this data.": "Perubahan berlaku pada master vendor bersama dan dapat terlihat di modul lain yang memakai data ini.",
  "Changes Saved": "Perubahan Tersimpan",
  "Changes to a Released Sales Order without altering the history of previous versions.": "Perubahan Sales Order Released tanpa mengubah histori versi sebelumnya.",
  "Check back later": "Periksa kembali nanti",
  "Check or change the data": "Periksa atau ubah data",
  "Checking access...": "Memeriksa akses...",
  "Checking access…": "Memeriksa akses…",
  "Checking...": "Memeriksa...",
  "Choose a file or drag it here": "Pilih file atau tarik ke area ini",
  "Choose a Project Manager if available": "Pilih Project Manager bila tersedia",
  "Choose a signature option to approve the document:": "Pilih opsi tanda tangan untuk menyetujui dokumen:",
  "Choose a signature to continue the approval.": "Pilih tanda tangan untuk melanjutkan persetujuan.",
  "Choose a template or type your own message.": "Pilih template atau ketik pesan Anda sendiri.",
  "Choose a WBS Template": "Pilih WBS Template",
  "Choose Approval Route": "Pilih Jalur Approval",
  "Choose from the list or type a new project type.": "Pilih dari daftar atau ketik tipe proyek baru.",
  "Choose Image": "Pilih Gambar",
  "Choose or create your signature to embed in the Sales Order document.": "Pilih atau buat tanda tangan Anda untuk disematkan pada dokumen Sales Order.",
  "Choose PMM or NPD": "Pilih PMM atau NPD",
  "Choose sequential superiors (Step 1, Step 2, etc.) who will validate this document.": "Pilih atasan berurutan (Step 1, Step 2, dst) yang akan memvalidasi dokumen ini.",
  "Choose Signature Position": "Pilih Posisi Tanda Tangan",
  "Choose the customer and contact": "Pilih customer dan contact",
  "Choose the PMM or NPD category": "Pilih kategori PMM atau NPD",
  "Choose the room that suits your meeting needs today.": "Pilih ruangan yang sesuai dengan kebutuhan meeting kamu hari ini.",
  "Clear": "Hapus",
  "Clear / Unassigned": "Hapus / Belum Ditugaskan",
  "Clear and Redraw": "Hapus Ulang",
  "Clear assignment search": "Hapus pencarian penugasan",
  "CLEAR CANVAS": "BERSIHKAN KANVAS",
  "Clear Filters": "Hapus Filter",
  "Clear risk search": "Hapus pencarian risiko",
  "Clear role search": "Hapus pencarian role",
  "Clear search": "Hapus pencarian",
  "Clear search filter": "Hapus filter pencarian",
  "Click background or press ESC to close": "Klik latar belakang atau tekan ESC untuk menutup",
  "Click Create Opportunity": "Klik Create Opportunity",
  "Click Create Sales Order": "Klik Create Sales Order",
  "Click or Drag & Drop a file here": "Klik atau Drag & Drop file ke sini",
  "Click or drag a file to this area": "Klik atau seret file ke area ini",
  "Click outside to save": "Tekan luar utk simpan",
  "Click the": "Klik tombol",
  "Click the lock or camera icon in the browser address bar, then change the Camera permission to Allow. After that, click the button below to try again.": "Klik ikon kunci atau kamera di address bar browser, lalu ubah permission Camera menjadi Allow. Setelah itu klik tombol di bawah untuk mencoba lagi.",
  "Click to add/replace file": "Klik untuk menambah/mengganti file",
  "Click to choose a PDF / JPG / PNG document (max. 10 MB)": "Klik untuk memilih dokumen PDF / JPG / PNG (maks. 10 MB)",
  "Click to choose a PDF/JPG/PNG file (max. 10MB)": "Klik untuk memilih berkas PDF/JPG/PNG (maks. 10MB)",
  "Click to replace the current PDF/JPG/PNG (max 10MB)": "Klik untuk mengganti PDF/JPG/PNG saat ini (maks 10MB)",
  "Click to replace the PDF/JPG/PNG file (max. 10MB)": "Klik untuk mengganti berkas PDF/JPG/PNG (maks. 10MB)",
  "Click to select PDF/JPG/PNG (max 10MB)": "Klik untuk memilih PDF/JPG/PNG (maks 10MB)",
  "Click to upload contract file": "Klik untuk mengunggah file kontrak",
  "Click to upload or drag and drop": "Klik untuk mengunggah atau seret dan lepas",
  "Click to upload your signature (PNG/JPG/PDF, max 5MB)": "Klik untuk mengunggah tanda tangan Anda (PNG/JPG/PDF, maks 5MB)",
  "Click to zoom": "Klik untuk memperbesar",
  "Client": "Klien",
  "Client Company (Customer)": "Perusahaan Klien (Customer)",
  "Client directory data, enterprise ID codes, market segmentation (Local/Export), and office addresses.": "Data direktori klien, kode enterprise ID, segmentasi pasar (Local/Export), dan alamat kantor.",
  "Client Organization:": "Organisasi Klien:",
  "Close": "Tutup",
  "Close & Refresh Data": "Tutup & Refresh Data",
  "Close (ESC)": "Tutup (ESC)",
  "Close (View Only)": "Tutup (Hanya Lihat)",
  "Close add project brief dialog": "Tutup dialog tambah ringkasan proyek",
  "Close batch failure notification": "Tutup notifikasi kegagalan batch",
  "Close batch success notification": "Tutup notifikasi keberhasilan batch",
  "Close confirmation": "Tutup konfirmasi",
  "Close Date": "Tanggal Penutupan",
  "Close Details": "Tutup Detail",
  "Close dialog": "Tutup dialog",
  "Close document details": "Tutup detail dokumen",
  "Close drop opportunity dialog": "Tutup dialog drop peluang",
  "Close dropped opportunities": "Tutup peluang yang dibatalkan",
  "Close Evidence History": "Tutup Evidence History",
  "Close extend aging dialog": "Tutup dialog perpanjang aging",
  "Close filter": "Tutup filter",
  "Close host list": "Tutup daftar host",
  "Close Info": "Info Penutupan",
  "Close modal": "Tutup modal",
  "Close navigation menu": "Tutup menu navigasi",
  "Close negotiation dialog": "Tutup dialog negosiasi",
  "Close notification": "Tutup notifikasi",
  "Close opportunity details": "Tutup detail peluang",
  "Close progress detail": "Tutup detail progres",
  "Close progress reset modal": "Tutup modal reset progress",
  "Close stage progression dialog": "Tutup dialog kemajuan tahap",
  "Close the active IM or adjust the value": "Tutup IM aktif atau sesuaikan nilai",
  "Close TPD selector": "Tutup pemilih TPD",
  "Closed": "Ditutup",
  "Closed status": "Status Closed",
  "Collapse sidebar": "Ciutkan sidebar",
  "Color = PIC · Arrow = handoff · Diamond = decision": "Warna = PIC · Panah = handoff · Diamond = keputusan",
  "column is a Stage": "kolom adalah Stage",
  "Combined S-Curve": "Kurva-S Gabungan",
  "Command Center": "Pusat Komando",
  "Command Hub": "Pusat Komando",
  "Comment (optional)": "Komentar (opsional)",
  "Comment:": "Komentar:",
  "Commercial": "Komersial",
  "Commercial documents": "Dokumen komersial",
  "Commit Update": "Simpan Pembaruan",
  "Commitment (PO)": "Komitmen (PO)",
  "Commitment :": "Komitmen :",
  "Commitment PO Release Date": "Tanggal Rilis PO Komitmen",
  "Comp (%)": "Sel. (%)",
  "Companies": "Perusahaan",
  "Company": "Perusahaan",
  "Company Address": "Alamat Perusahaan",
  "Company deleted successfully!": "Company berhasil dihapus!",
  "Company Email *": "Email Perusahaan *",
  "Company Entity": "Entitas Perusahaan",
  "Company Identity": "Identitas Badan Usaha",
  "Company Information": "Informasi Perusahaan",
  "Company Legality": "Legalitas Perusahaan",
  "Company name": "Nama perusahaan",
  "Company Name": "Nama Perusahaan",
  "Company Name is required!": "Nama Company wajib diisi!",
  "Company of Origin": "Asal Perusahaan",
  "Company Type": "Tipe Perusahaan",
  "Company {value1} successfully!": "Company berhasil di{value1}!",
  "Company:": "Perusahaan:",
  "Comparing V{value1} → V{current_version}": "Membandingkan V{value1} → V{current_version}",
  "Comparison": "Perbandingan",
  "Comparison is unavailable.": "Perbandingan tidak tersedia.",
  "Comparison V{previousVersion} → V{currentVersion}": "Perbandingan V{previousVersion} → V{currentVersion}",
  "Competencies & Audit Status": "Kompetensi & Status Audit",
  "Complete": "Lengkap",
  "Complete category routing and solution architect assignments for incoming opportunities.": "Selesaikan routing kategori dan penugasan solution architect untuk peluang masuk.",
  "Complete Data": "Lengkapi Data",
  "Complete or Edit Form Data": "Lengkapi atau Edit Form Data",
  "Complete Stage": "Selesaikan Stage",
  "Complete the booking date and time": "Lengkapi tanggal dan waktu booking",
  "Complete the brief or market value": "Lengkapi brief atau market value",
  "Complete the brief, market value, and business type": "Lengkapi brief, market value, dan business type",
  "Complete the data first": "Lengkapi data terlebih dahulu",
  "Complete the data then resubmit": "Lengkapi data lalu submit ulang",
  "Complete the document data (click the Complete Data button) before submitting!": "Lengkapi data dokumen (klik tombol Lengkapi Data) terlebih dahulu sebelum mengajukan!",
  "Complete the GPI": "Lengkapi GPI",
  "Complete the guest details below to register the visit.": "Lengkapi data tamu di bawah ini untuk pendaftaran kunjungan.",
  "Complete the items then recheck the checklist": "Lengkapi item lalu periksa ulang checklist",
  "Complete the Lead data": "Lengkapi data Lead",
  "Complete the metadata form and upload the data protection document.": "Lengkapi formulir metadata dan unggah dokumen pelindungan data.",
  "Complete the negotiation approval": "Selesaikan negotiation approval",
  "Complete the Opportunity data": "Lengkapi data Opportunity",
  "Complete the Opportunity data then revalidate": "Lengkapi data Opportunity lalu validasi ulang",
  "Complete the PO estimate and GPI evidence": "Lengkapi estimasi PO dan evidence GPI",
  "Complete the preparation items": "Lengkapi item preparation",
  "Complete the project brief if needed": "Lengkapi project brief bila diperlukan",
  "Complete the Project Code, GPI, and Timeline": "Lengkapi Project Code, GPI, dan Timeline",
  "Complete the project internal memo submission form along with file attachments and AM limit verification.": "Lengkapi formulir pengajuan memo internal proyek beserta lampiran berkas dan verifikasi limit AM.",
  "Complete the qualification review": "Selesaikan qualification review",
  "Complete this stage to proceed to the next stage.": "Selesaikan stage ini untuk melanjutkan ke stage berikutnya.",
  "Complete your details for the visit approval process.": "Lengkapi data diri Anda untuk proses approval kunjungan.",
  "Completed": "Selesai",
  "COMPLETED": "SELESAI",
  "Completed approvals along with their notes and signatures will be preserved. Only the": "Approval yang sudah selesai beserta note dan TTD-nya akan dipertahankan. Hanya",
  "Completed Date": "Tgl Selesai",
  "Completed Document Value": "Nilai Dokumen Selesai",
  "Completion": "Penyelesaian",
  "Completion (%)": "Penyelesaian (%)",
  "Completion description": "Deskripsi penyelesaian",
  "Completion Progress (%)": "Progress Penyelesaian (%)",
  "Compliance": "Kepatuhan",
  "Composition of disruption categories in the active scope": "Komposisi kategori gangguan pada scope aktif",
  "Condition": "Kondisi",
  "Config": "Konfigurasi",
  "Configuration changes only apply to new submissions. Circulations already in progress keep their approver snapshot.": "Perubahan konfigurasi hanya berlaku untuk pengajuan baru. Circulir yang sudah berjalan mempertahankan snapshot approver-nya.",
  "Configuration ready for the system to use": "Konfigurasi siap digunakan sistem",
  "Configure Access": "Atur Akses",
  "Configure Employee Access": "Atur Hak Akses Pegawai",
  "Configure global roles, granular permissions (Scope: All/Own), and AiBAS application module mapping.": "Konfigurasi peran global, hak akses granular (Scope: All/Own), serta pemetaan modul aplikasi AiBAS.",
  "Confirm & Register": "Konfirmasi & Daftarkan",
  "CONFIRM APPROVAL": "KONFIRMASI PERSETUJUAN",
  "Confirm Approval": "Konfirmasi Persetujuan",
  "Confirm Approve All": "Konfirmasi Setujui Semua",
  "Confirm Booking": "Konfirmasi Pemesanan",
  "Confirm Check-out": "Konfirmasi Check-out",
  "Confirm Drop": "Konfirmasi Drop",
  "Confirm Fast Track": "Konfirmasi Fast Track",
  "Confirm Finish": "Konfirmasi Penyelesaian",
  "Confirm new password": "Konfirmasi kata sandi baru",
  "Confirm Reject": "Konfirmasi Reject",
  "Confirm Reset": "Konfirmasi Reset",
  "Confirm Send Broadcast": "Konfirmasi Kirim Broadcast",
  "Confirm SO Submission": "Konfirmasi Pengiriman SO",
  "Confirmation Required": "Konfirmasi Diperlukan",
  "Confirmed": "Dikonfirmasi",
  "Connect Admin": "Admin Connect",
  "Connect Dashboard": "Dasbor Connect",
  "Connect module encountered an error": "Modul Connect mengalami error",
  "CONNECT OPERATIONS": "OPERASIONAL CONNECT",
  "Connect Requestor": "Pemohon Connect",
  "Connect View Only": "Connect Hanya Lihat",
  "Connecting...": "Menghubungkan...",
  "Consolidated Detail Panel": "Panel Detail Terkonsolidasi",
  "Consumed": "Terpakai (Consumed)",
  "Consumed :": "Terpakai :",
  "Consumed + commitment of approved budget": "Terpakai + komitmen dari anggaran disetujui",
  "Contact": "Kontak",
  "Contact Created": "Kontak Dibuat",
  "Contact created successfully": "Kontak berhasil dibuat",
  "Contact Data Not Found": "Data Kontak Tidak Ditemukan",
  "Contact deleted successfully!": "Contact berhasil dihapus!",
  "Contact deleted!": "Kontak dihapus!",
  "Contact Email": "Email Kontak",
  "Contact Form": "Formulir Kontak",
  "Contact Info": "Info Kontak",
  "Contact Information": "Informasi Kontak",
  "Contact List": "Daftar Kontak",
  "Contact marked as dropped": "Kontak ditandai sebagai dibatalkan",
  "Contact Name": "Nama Kontak",
  "Contact Person": "Narahubung",
  "Contact Profile": "Profil Kontak",
  "Contact restored successfully": "Kontak berhasil dipulihkan",
  "Contact saved successfully!": "Kontak berhasil disimpan!",
  "Contact Status": "Status Kontak",
  "Contact Updated": "Kontak Diperbarui",
  "Context": "Konteks",
  "Continue all remaining SO approvals, release the related processes, and update the PDFs.": "Lanjutkan seluruh approval SO yang tersisa, release proses terkait, dan perbarui PDF.",
  "Continue monitoring": "Lanjut monitoring",
  "Continue sequential approval": "Lanjutkan approval berurutan",
  "Continue Session": "Lanjutkan Sesi",
  "Continue the active workflow": "Lanjutkan workflow aktif",
  "Continue to Fill Form": "Lanjut Isi Form",
  "Continue to GPI": "Lanjut ke GPI",
  "Continue to Internal Memo": "Lanjut ke Internal Memo",
  "Continue to Place Signature": "Lanjut Posisikan TTD",
  "Continue to the next approver": "Lanjut ke approver berikutnya",
  "Continue to the next stage": "Lanjut ke stage berikutnya",
  "Contract created successfully!": "Kontrak berhasil dibuat!",
  "Contract deleted successfully!": "Contract berhasil dihapus!",
  "Contract Management -": "Manajemen Kontrak -",
  "Contract No.": "No. Kontrak",
  "Contract not found": "Kontrak tidak ditemukan",
  "Contract Num": "No. Kontrak",
  "Contract Number *": "Nomor Kontrak *",
  "Contract Specifications": "Spesifikasi Kontrak",
  "Contract Status": "Status Kontrak",
  "Contract Type": "Tipe Kontrak",
  "Contract updated successfully!": "Kontrak berhasil diperbarui!",
  "Contract Value": "Nilai Kontrak",
  "Contract Value (IDR)": "Nilai Kontrak (IDR)",
  "Contract Value (Optional)": "Nilai Kontrak (Opsional)",
  "Contracts": "Kontrak",
  "Contracts & Agreements": "Kontrak & Perjanjian",
  "contracts already Expired": "kontrak sudah Expired",
  "Control Center": "Pusat Kendali",
  "Control Sheet": "Lembar Kontrol",
  "Control sheet downloaded successfully": "Control sheet berhasil diunduh",
  "Coordinate Signature Placement Vector": "Koordinat Penempatan Tanda Tangan",
  "Copied": "Tersalin",
  "Copied!": "Tersalin!",
  "Copy": "Salinan",
  "Copy Log": "Salin Log",
  "Copy the project identity, customer, value, and timeline": "Salin identitas project, customer, nilai, dan timeline",
  "Corrections must be submitted as a new document, and the approval process restarts from the first stage.": "Koreksi harus diajukan sebagai dokumen baru dan proses approval dimulai kembali dari tahap pertama.",
  "Cost": "Biaya",
  "Cost Incurred": "Biaya Terpakai",
  "Cost Price": "Harga Pokok",
  "Cost Under Run": "Di Bawah Biaya",
  "Counterpart": "Pihak Lawan",
  "Counterpart (Related Party)": "Counterpart (Pihak Terkait)",
  "CPI (Cost)": "CPI (Biaya)",
  "Create (New)": "Create (Buat Baru)",
  "Create a new legal document record.": "Buat catatan dokumen legal baru.",
  "Create a new template version": "Buat versi template baru",
  "Create a project from the Released SO": "Membuat project dari SO Released",
  "Create a template version and set the stages": "Buat versi template dan atur stage",
  "Create an IM if the PO is not available yet": "Buat IM jika PO belum tersedia",
  "Create and manage Opportunities": "Buat dan kelola Opportunity",
  "Create Contact": "Buat Kontak",
  "Create First Opportunity": "Buat Peluang Pertama",
  "Create Form": "Buat Formulir",
  "Create IM": "Buat IM",
  "Create Internal": "Buat Internal",
  "Create Internal Memo": "Buat Internal Memo",
  "Create Lead": "Buat Lead",
  "Create New Document": "Buat Dokumen Baru",
  "Create New Draft": "Buat Draft Baru",
  "Create New Lead": "Buat Lead Baru",
  "Create New Role": "Buat Role Baru",
  "Create New Template": "Buat Templat Baru",
  "Create Non-Project": "Buat Non-Project",
  "Create Opportunity": "Buat Peluang",
  "Create OPS Project": "Buat Project OPS",
  "Create SA PIC Assignment": "Buat SA PIC Assignment",
  "Create Sales Order": "Buat Sales Order",
  "Create Sales Order Draft": "Buat Sales Order Draft",
  "Create SO": "Buat SO",
  "Create Template": "Buat Templat",
  "Create the SO, prepare the PO and GPI": "Buat SO, siapkan PO dan GPI",
  "Create User & Assign Roles": "Buat Pengguna & Tetapkan Role",
  "Created": "Dibuat",
  "created": "membuat",
  "Created:": "Dibuat:",
  "Creating & downloading control sheet...": "Membuat & mengunduh control sheet...",
  "Creating a new version based on v{version}": "Membuat versi baru berdasarkan v{version}",
  "Creating one Sales Order Draft from an opportunity that is already a Deal.": "Pembuatan satu Sales Order Draft dari opportunity yang sudah Deal.",
  "Creating SO...": "Membuat SO...",
  "Creating...": "Membuat...",
  "Critical": "Kritis",
  "Critical Project Alert": "Peringatan Proyek Kritis",
  "CRM Admin": "Admin CRM",
  "CRM Dashboard": "Dasbor CRM",
  "CRM Executive Dashboard": "Dasbor Eksekutif CRM",
  "CRM Flow Library": "Pustaka Alur CRM",
  "CRM Module": "Modul CRM",
  "CRM process flow library": "Pustaka alur proses CRM",
  "CRM Stage": "Tahap CRM",
  "CRM User": "Pengguna CRM",
  "CRM V2 · Create Memo Submission": "CRM V2 · Buat Pengajuan Memo",
  "CRM View Only": "CRM Hanya Lihat",
  "CRM · Sales Orders": "CRM · Sales Order",
  "CRO or CMO reviews the reason": "CRO atau CMO review alasan",
  "Cumulative pipeline value and stage distribution over time": "Nilai pipeline kumulatif dan distribusi tahap dari waktu ke waktu",
  "Cumulative Total:": "Total Kumulatif:",
  "Currency": "Mata Uang",
  "Current": "Saat Ini",
  "CURRENT": "SAAT INI",
  "Current Approval": "Persetujuan Saat Ini",
  "Current Approver": "Approver Saat Ini",
  "Current attached PDF": "PDF terlampir saat ini",
  "Current attachment will be removed when you save changes.": "Lampiran saat ini akan dihapus saat Anda menyimpan perubahan.",
  "Current Details": "Detail Saat Ini",
  "Current Exposure": "Eksposur Saat Ini",
  "Current exposure:": "Eksposur saat ini:",
  "Current File": "File Saat Ini",
  "Current File (Saved):": "File Saat Ini (Tersimpan):",
  "Current File:": "File Saat Ini:",
  "Current password": "Kata sandi saat ini",
  "Current PO Amount": "Jumlah PO Saat Ini",
  "Current PO attachment preview": "Pratinjau lampiran PO saat ini",
  "Current PO File": "Berkas PO Saat Ini",
  "Current SLA": "SLA Saat Ini",
  "Current Stage": "Tahap Saat Ini",
  "Current Stage:": "Tahap Saat Ini:",
  "Current State": "Kondisi Saat Ini",
  "Custom: {name}": "Kustom: {name}",
  "Customer": "Pelanggan",
  "Customer & Project": "Pelanggan & Proyek",
  "Customer & Project Code": "Pelanggan & Kode Proyek",
  "Customer / Company Name": "Nama Customer / Perusahaan",
  "Customer Base": "Basis Pelanggan",
  "Customer Company": "Perusahaan Customer",
  "Customer Contact Person (CP)": "Narahubung Pelanggan (CP)",
  "Customer created successfully!": "Pelanggan berhasil dibuat!",
  "Customer Data Not Found": "Data Customer Tidak Ditemukan",
  "Customer deleted successfully!": "Customer berhasil dihapus!",
  "Customer ID": "ID Pelanggan",
  "Customer Info": "Info Pelanggan",
  "Customer Item ID": "ID Item Pelanggan",
  "Customer Master Database": "Database Master Pelanggan",
  "Customer Mix": "Campuran Pelanggan",
  "Customer Name": "Nama Customer",
  "Customer Name *": "Nama Pelanggan *",
  "Customer not available yet": "Customer belum tersedia",
  "Customer not found": "Pelanggan tidak ditemukan",
  "Customer Profile": "Profil Pelanggan",
  "Customer Ref": "Ref Pelanggan",
  "Customer Request": "Permintaan Pelanggan",
  "Customers": "Pelanggan",
  "Cut Point Information": "Informasi Titik Potong",
  "D365 Serial Number": "Nomor Seri D365",
  "D365 Warehouse ID": "ID Gudang D365",
  "Daily Detail": "Detail Harian",
  "Daily Report": "Laporan Harian",
  "Dashboard": "Dasbor",
  "Dashboard Filters": "Filter Dasbor",
  "Dashboard period": "Periode dashboard",
  "Dashboard updated": "Dashboard diperbarui",
  "Data assigned": "Data ditetapkan",
  "Data Completeness": "Kelengkapan Data",
  "Data deleted successfully!": "Data berhasil dihapus!",
  "Data is incomplete for submission": "Data belum lengkap untuk diajukan",
  "Data is not available yet.": "Data belum tersedia.",
  "Data is traceable": "Data dapat ditelusuri",
  "Data Not Found": "Data Tidak Ditemukan",
  "Data Not Synchronized": "Data Belum Disinkronisasi",
  "Data Privacy Request (PDP)": "Permintaan Privasi Data (PDP)",
  "Data Retention": "Retensi Data",
  "Data to be reset": "Data yang akan di-reset",
  "Data type": "Jenis data",
  "Data Types Requested": "Jenis Data yang Diminta",
  "Data updated": "Data diperbarui",
  "Data validation before an Opportunity can enter Qualification.": "Validasi data sebelum Opportunity dapat masuk ke Qualification.",
  "Date": "Tanggal",
  "Date & Time": "Tanggal & Waktu",
  "Date & Validity": "Tanggal & Validitas",
  "Date & Value": "Tanggal & Nilai",
  "Date Created": "Tanggal Dibuat",
  "Date:": "Tanggal:",
  "Dates & Context": "Tanggal & Konteks",
  "Days": "Hari",
  "days": "hari",
  "days ({sign}{pct}%)": "hari ({sign}{pct}%)",
  "days · Buffer:": "hari · Buffer:",
  "Deactivate Account": "Nonaktifkan Akun",
  "Deadline": "Tenggat",
  "DEADLINE:": "TENGGAT:",
  "Deal Info": "Info Deal",
  "Deal/Won": "Deal/Menang",
  "Deals": "Deal",
  "Deals & Opportunity Registry": "Registri Deal & Peluang",
  "Deals (Won)": "Deal (Menang)",
  "Deals • Total Value:": "Deal • Total Nilai:",
  "Dealsheet Data": "Data Dealsheet",
  "Dealsheet Editor": "Editor Dealsheet",
  "Dealsheet History": "Riwayat Dealsheet",
  "Dealsheet Studio": "Studio Dealsheet",
  "Dealt": "Deal",
  "Decision by the creator or the SO AM": "Keputusan pembuat atau AM SO",
  "Declaration": "Pernyataan",
  "Deeds, NIB, NPWP, Permits.": "Akta, NIB, NPWP, Perizinan.",
  "Define stages and weights for your new WBS structure.": "Tentukan tahap dan bobot untuk struktur WBS baru Anda.",
  "Define the dates of each stage": "Definisikan tanggal setiap stage",
  "Define the sequence and weight of each task.": "Tentukan urutan dan bobot tiap tugas.",
  "Define the WBS and Timeline": "Tentukan WBS dan Timeline",
  "Delay": "Terlambat",
  "Delete": "Hapus",
  "Delete (Remove)": "Delete (Hapus)",
  "Delete all current GPI rows and clear the SO GPI dataset": "Hapus semua baris GPI saat ini dan kosongkan dataset GPI SO",
  "Delete Asset": "Hapus Aset",
  "Delete Attachment": "Hapus Lampiran",
  "Delete attachment": "Hapus lampiran",
  "Delete Attachment File": "Hapus File Attachment",
  "Delete Bank": "Hapus Bank",
  "Delete Company?": "Hapus Company?",
  "Delete Contact": "Hapus Kontak",
  "Delete Customer": "Hapus Customer",
  "Delete Data Asset": "Hapus Data Asset",
  "Delete Document": "Hapus Dokumen",
  "Delete evidence copies from the AiBAS Drive": "Hapus salinan evidence dari Drive AiBAS",
  "Delete File": "Hapus Berkas",
  "Delete Partner": "Hapus Partner",
  "Delete Product": "Hapus Produk",
  "Delete Role": "Hapus Role",
  "Delete this file": "Hapus file ini",
  "Delete Vendor": "Hapus Vendor",
  "Delete {name}": "Hapus {name}",
  "Deleted": "Dihapus",
  "deleted": "menghapus",
  "Deleted successfully": "Berhasil dihapus",
  "Deleting...": "Menghapus...",
  "Deletion Method": "Metode Penghapusan",
  "Deletion Method (Auto)": "Metode Penghapusan (Otomatis)",
  "Delivery Date": "Tanggal Pengiriman",
  "Delivery Method *": "Metode Pengiriman *",
  "Delivery SOW Set": "Set SOW Pengiriman",
  "Department": "Departemen",
  "Describe needs or scope of work": "Jelaskan kebutuhan atau lingkup pekerjaan",
  "Describe the completed work before marking this TPD done…": "Jelaskan pekerjaan yang diselesaikan sebelum menandai TPD ini selesai…",
  "Describe the details of this meeting's purpose...": "Jelaskan detail tujuan meeting ini...",
  "Describe the document summary, purpose, or other key points...": "Jelaskan ringkasan isi dokumen, tujuan, atau poin penting lainnya...",
  "Describe the field action": "Jelaskan tindakan di lapangan",
  "Describe the latest progress for this TPD…": "Jelaskan progres terbaru untuk TPD ini…",
  "Describe the negotiation details, key discussion points, and outcomes...": "Jelaskan detail negosiasi, poin diskusi utama, dan hasilnya...",
  "Describe what needs to be changed, why, and the impact...": "Jelaskan apa yang perlu diubah, alasannya, dan dampaknya...",
  "Description": "Deskripsi",
  "Description & Specifications": "Deskripsi & Spesifikasi",
  "Description (Optional)": "Deskripsi (Opsional)",
  "Description / Details": "Keterangan / Deskripsi",
  "Description / Notes": "Deskripsi / Catatan",
  "Description, user, action...": "Deskripsi, pengguna, aksi...",
  "Description:": "Keterangan:",
  "Destination": "Tujuan",
  "Destination & Purpose": "Tujuan & Keperluan",
  "Detail Asset": "Detail Aset",
  "Detail Information": "Informasi Detail",
  "Detailed Description": "Deskripsi Terperinci",
  "Detailed history of system transactions.": "Riwayat rinci transaksi sistem.",
  "Details": "Detail",
  "Determine the document storage location.": "Tentukan lokasi penyimpanan dokumen.",
  "Determine the signing superiors order": "Tentukan urutan atasan penandatangan",
  "Digest:": "Digest:",
  "Digital Archive": "Arsip Digital",
  "Digital Document": "Dokumen Digital",
  "Digital Scan": "Pindaian Digital",
  "Digital Signature": "Tanda Tangan Digital",
  "Digital Signature (Required)": "Tanda Tangan Digital (Diperlukan)",
  "Direct Role Provisioning": "Penyediaan Role Langsung",
  "Disable Edit Mode": "Nonaktifkan Mode Edit",
  "Disc": "Diskon",
  "Dismiss": "Tutup",
  "Dispatch": "Kirim",
  "Dispatch Task": "Kirim Tugas",
  "Dispatch to Task Mgmt": "Kirim ke Manajemen Tugas",
  "Dispatching...": "Mengirim tugas...",
  "Distribution of official announcements and priority notifications to all registered users via CC batching.": "Distribusi pengumuman resmi dan notifikasi prioritas ke seluruh pengguna terdaftar via CC batching.",
  "Division": "Divisi",
  "Division/Department *": "Divisi/Departemen *",
  "DMS & Approval": "DMS & Persetujuan",
  "Do not litter or throw cigarette butts carelessly.": "Dilarang membuang sampah dan puntung rokok sembarangan.",
  "Doc Number": "Nomor Dokumen",
  "Doc. Number": "No. Dokumen",
  "Document": "Dokumen",
  "Document & Name": "Dokumen & Nama",
  "Document / GPI": "Dokumen / GPI",
  "Document / Letter Number": "Nomor Dokumen / Surat",
  "Document attachment not found.": "Attachment dokumen tidak ditemukan.",
  "Document Category": "Kategori Dokumen",
  "Document closed because it was rejected.": "Dokumen ditutup karena ditolak.",
  "Document created and submitted to the approval circulation.": "Dokumen dibuat dan diajukan ke Approval Circulir.",
  "Document Date": "Tanggal Dokumen",
  "Document deleted successfully!": "Dokumen berhasil dihapus!",
  "Document File": "File Dokumen",
  "Document flow from draft to completion.": "Alur dokumen dari draft hingga selesai.",
  "Document Information": "Informasi Dokumen",
  "Document Management": "Manajemen Dokumen",
  "Document Name": "Nama Dokumen",
  "Document Number": "Nomor Dokumen",
  "Document Preview": "Pratinjau Dokumen",
  "Document Register": "Register Dokumen",
  "Document rejected.": "Dokumen ditolak.",
  "Document saved, but it could not be submitted to the approval circulation: {value1}": "Dokumen tersimpan, tetapi tidak dapat diajukan ke sirkulasi persetujuan: {value1}",
  "Document sent to the approval circulation.": "Dokumen masuk ke Approval Circulir.",
  "Document Status": "Status Dokumen",
  "Document Status Distribution": "Distribusi Status Dokumen",
  "Document submission successfully withdrawn back to Draft.": "Pengajuan dokumen berhasil ditarik kembali menjadi Draft.",
  "Document Submissions": "Pengajuan Dokumen",
  "Document submitted for approval successfully!": "Dokumen berhasil diajukan untuk Approval!",
  "Document submitted for approval successfully.": "Dokumen berhasil diajukan untuk approval.",
  "Document Summary (Doc Summary)": "Ringkasan Dokumen (Doc Summary)",
  "Document Summary *": "Ringkasan Dokumen (Doc Summary) *",
  "Document Summary is required!": "Ringkasan Dokumen (Doc Summary) wajib diisi!",
  "Document Title": "Judul Dokumen",
  "Document Title / Subject is required!": "Judul / Perihal Dokumen wajib diisi!",
  "Document Type": "Tipe Dokumen",
  "Document type": "Tipe dokumen",
  "Document Value": "Nilai Dokumen",
  "Document Value (Rp)": "Nilai Dokumen (Rp)",
  "Document {value1} successfully": "Dokumen berhasil di-{value1}",
  "Documents": "Dokumen",
  "DOCUMENTS AVAILABLE": "DOKUMEN TERSEDIA",
  "Documents created in the selected period": "Dokumen dibuat pada periode terpilih",
  "Documents fully approved in this period": "Dokumen selesai disetujui pada periode ini",
  "Documents still in the approval flow": "Dokumen masih dalam alur persetujuan",
  "Documents whose validity expires within 30 days.": "Dokumen yang masa berlakunya habis dalam 30 hari.",
  "Does it need to be reactivated?": "Perlu diaktifkan kembali?",
  "Does the customer already exist?": "Customer sudah ada?",
  "Does the OPS project already exist?": "Project OPS sudah ada?",
  "Does the Sales Order already exist?": "Sales Order sudah ada?",
  "Does the template match the project?": "Template sesuai project?",
  "Does the template need to be changed?": "Template perlu diubah?",
  "Doing": "Sedang Dikerjakan",
  "Domestic": "Domestik",
  "Done": "Selesai",
  "Done (100%)": "Selesai (100%)",
  "Done Selecting (": "Selesai Memilih (",
  "Done!": "Selesai!",
  "Download": "Unduh",
  "DOWNLOAD": "UNDUH",
  "Download BA's file": "Unduh file BA",
  "Download Complete Evidence (PDF)": "Unduh Evidence Lengkap (PDF)",
  "Download Control Sheet": "Unduh Control Sheet",
  "Download Control Sheet (Approval Sheet)": "Download Control Sheet (Lembar Persetujuan)",
  "Download failed": "Unduhan gagal",
  "Download failed.": "Unduhan gagal.",
  "Download File": "Unduh File",
  "Download GPI File": "Unduh File GPI",
  "Download Sample": "Unduh Contoh",
  "Download sample GPI upload (XLSX)": "Unduh contoh unggahan GPI (XLSX)",
  "Download Template": "Unduh Templat",
  "Download Template XLSX": "Unduh Template XLSX",
  "Download URL is missing": "URL unduhan tidak ada",
  "Downloading...": "Mengunduh...",
  "Draft": "Draf",
  "Draft saved successfully!": "Draft berhasil disimpan!",
  "Draft submissions are allowed, but submitting for approval requires a signature.": "Pengajuan draft diperbolehkan, namun submit persetujuan memerlukan tanda tangan.",
  "Draft Title / Subject *": "Judul / Perihal Draft *",
  "Drag the signature box to your desired position, then click Confirm.": "Seret kotak TTD ke posisi yang Anda inginkan, lalu klik Konfirmasi.",
  "Drag the signature target to the matching PDF page coordinates, then press Confirm.": "Seret target tanda tangan ke koordinat halaman PDF yang sesuai, kemudian tekan Konfirmasi.",
  "Draw": "Gambar",
  "Draw New": "Gambar Baru",
  "DRAW NEW": "GAMBAR BARU",
  "Draw New Signature": "Gambar TTD Baru",
  "DRAW SIGNATURE": "GAMBAR TANDA TANGAN",
  "Draw your signature to authorize this Internal Memo": "Gambar tanda tangan Anda untuk mengotorisasi Internal Memo ini",
  "Drive sync is in progress": "Drive sync sedang berjalan",
  "Drop": "Batal",
  "Drop approval by the Chief Sales and reactivation of an opportunity.": "Approval drop oleh Chief Sales serta pengaktifan kembali opportunity.",
  "Drop approval request submitted successfully!": "Permintaan persetujuan drop berhasil diajukan!",
  "Drop Contact": "Drop Kontak",
  "Drop files or browse": "Letakkan file atau telusuri",
  "Drop has been submitted. Wait for approval/rejection first.": "Drop sudah disubmit. Tunggu approve/reject dulu.",
  "Drop Opportunity": "Drop Peluang",
  "Drop opportunity": "Drop peluang",
  "Drop Reason": "Alasan Drop",
  "Drop reason must be at least 10 characters.": "Alasan drop minimal 10 karakter.",
  "Drop Reasons": "Alasan Drop",
  "Drop request approved successfully!": "Permintaan drop berhasil disetujui!",
  "Drop request rejected successfully!": "Permintaan drop berhasil ditolak!",
  "Dropped": "Dibatalkan",
  "Dropped on:": "Didrop pada:",
  "Dropped Opportunities": "Peluang yang Dibatalkan",
  "Dropped status": "Status Dropped",
  "Dropping...": "Men-drop...",
  "Due to inactivity, your session will be closed automatically soon to keep your data secure.": "Karena tidak ada aktivitas, sesi Anda akan segera ditutup secara otomatis untuk menjaga keamanan data.",
  "Duration": "Durasi",
  "Duration (Days)": "Durasi (Hari)",
  "Duration (Days) *": "Durasi (Hari) *",
  "Duration (months)": "Durasi (bulan)",
  "Duration (months) is required for moving to Proposal": "Durasi (bulan) wajib diisi untuk maju ke Proposal",
  "Duration:": "Durasi:",
  "E-Sign Status": "Status E-Sign",
  "e.g. 1 Month Before": "mis. 1 Bulan Sebelumnya",
  "e.g. 20240101": "misal: 20240101",
  "e.g. Account Manager": "misal: Account Manager",
  "E.g. BOD operational needs": "Misal: Keperluan operasional BOD",
  "e.g. Budi Santoso": "cth: Budi Santoso",
  "e.g. Electronics, Hardware, Maintenance": "cth: Electronics, Hardware, Maintenance",
  "e.g. Fiber Optic Cable 24 Core": "cth: Fiber Optic Cable 24 Core",
  "e.g. IT INFRASTRUCTURE & FIBER OPTIC": "cth: IT INFRASTRUCTURE & FIBER OPTIC",
  "e.g. Meeting": "mis. Rapat",
  "e.g. NDA with PT ABC...": "Misal: NDA dengan PT ABC...",
  "e.g. PMM/2026/001": "mis. PMM/2026/001",
  "e.g. PRJ-ALITA-99": "mis. PRJ-ALITA-99",
  "e.g. procurement_admin": "misal: procurement_admin",
  "e.g. PT Solusi Teknologi Nusantara": "cth: PT Solusi Teknologi Nusantara",
  "e.g. PT Telekomunikasi Selular": "cth: PT Telekomunikasi Selular",
  "E.g. Q3 Marketing Campaign": "Cth: Q3 Marketing Campaign",
  "e.g. Rack A-04": "mis. Rak A-04",
  "e.g. Vendor delivery delay": "mis. Keterlambatan pengiriman vendor",
  "E.g., Change quantity of Main Router from 5 to 7": "Mis., Ubah kuantitas Main Router dari 5 menjadi 7",
  "e.g., Customer no longer responsive, moved to competitor, etc.": "mis. Pelanggan tidak lagi responsif, pindah ke kompetitor, dll.",
  "e.g., Initialization": "mis. Inisialisasi",
  "e.g., MW, FTTH, MS, CUSTOM": "mis. MW, FTTH, MS, CUSTOM",
  "e.g., Standard FTTH Deployment Phase 1": "mis. Deployment FTTH Standar Fase 1",
  "Each tagged member will receive a risk notification email after this entry is added.": "Setiap anggota yang ditandai akan menerima email notifikasi risiko setelah entri ini ditambahkan.",
  "Edit": "Ubah",
  "Edit / Complete Data": "Edit / Lengkapi Data",
  "Edit a single GPI line and save without re-uploading the entire file.": "Ubah satu baris GPI lalu simpan tanpa upload ulang seluruh file.",
  "Edit Akun: {value1}": "Ubah Akun: {value1}",
  "Edit Booking": "Ubah Pemesanan",
  "Edit Contact": "Edit Kontak",
  "Edit Contract": "Ubah Kontrak",
  "Edit Copy": "Ubah Salinan",
  "Edit Customer": "Ubah Pelanggan",
  "Edit Customer Contact": "Edit Kontak Customer",
  "Edit Full Data": "Edit Data Penuh",
  "Edit GPI Line": "Ubah Baris GPI",
  "Edit IM Revision": "Edit Revisi IM",
  "Edit Opportunity": "Ubah Peluang",
  "Edit Partner Profile": "Ubah Profil Mitra",
  "Edit PO Document Metadata": "Edit Metadata Dokumen PO",
  "Edit PO Metadata": "Ubah Metadata PO",
  "Edit Product": "Edit Produk",
  "Edit Profile": "Ubah Profil",
  "Edit Reservation": "Ubah Reservasi",
  "Edit Site": "Ubah Site",
  "Edit SO": "Ubah SO",
  "Edit SO, GPI, or Timeline data": "Edit data SO, GPI, atau Timeline",
  "Edit Team": "Ubah Tim",
  "Edit Template": "Ubah Templat",
  "Edit the line items then revalidate": "Edit line item lalu validasi ulang",
  "Edit User": "Edit Pengguna",
  "Edit Vendor": "Ubah Vendor",
  "Edit {name}": "Ubah {name}",
  "Effective": "Berlaku",
  "Effective Date": "Tanggal Efektif",
  "Effective Module Access": "Akses Modul Efektif",
  "Email Address": "Alamat Email",
  "Email subject...": "Subject email...",
  "Employee": "Pegawai",
  "Employee Full Name": "Nama Lengkap Pegawai",
  "Employee ID": "ID Karyawan",
  "Employee ID (NIK) *": "ID Karyawan (NIK) *",
  "Employee Profile": "Profil Pegawai",
  "Employees": "Karyawan",
  "employees": "pegawai",
  "Empty": "Kosong",
  "Empty Queue": "Antrian Kosong",
  "Enable Edit Mode": "Aktifkan Mode Edit",
  "Enable to save an existing document directly as completed without an approval/digital signature flow.": "Aktifkan untuk menyimpan dokumen yang sudah ada langsung sebagai dokumen selesai tanpa alur approval/tanda tangan digital.",
  "End Date": "Tanggal Berakhir",
  "End Date & Time": "Tanggal & Waktu Selesai",
  "End of Agreement": "Akhir Perjanjian",
  "End Time": "Waktu Selesai",
  "End time must be after start time": "Waktu selesai harus setelah waktu mulai",
  "End time must be later than start time": "Jam selesai harus lebih dari jam mulai",
  "End:": "Selesai:",
  "Enter any additional details...": "Masukkan detail tambahan...",
  "Enter budget in IDR": "Masukkan budget dalam IDR",
  "Enter detailed project brief for this stage transition...": "Masukkan ringkasan proyek terperinci untuk transisi tahap ini...",
  "Enter estimated margin percentage": "Masukkan persentase estimasi margin",
  "Enter estimated PO amount": "Masukkan jumlah estimasi PO",
  "Enter full name": "Masukkan nama lengkap",
  "Enter line items": "Masukkan line item",
  "Enter margin as percentage (e.g., 25 for 25%)": "Masukkan margin dalam persentase (mis. 25 untuk 25%)",
  "Enter market value estimate amount": "Masukkan jumlah estimasi nilai pasar",
  "Enter PO estimate amount": "Masukkan jumlah estimasi PO",
  "Enter project name...": "Masukkan nama proyek...",
  "Enter project updates, progress notes, or any relevant information...": "Masukkan pembaruan proyek, catatan progres, atau informasi relevan lainnya...",
  "Enter your password": "Masukkan kata sandi Anda",
  "Enterprise ID:": "ID Enterprise:",
  "Enterprise SLA Operations": "Operasi SLA Enterprise",
  "Enters the assignment history": "Masuk riwayat assignment",
  "Enters the Sales Order workspace": "Masuk workspace Sales Order",
  "Entity": "Entitas",
  "Entity / Company Name": "Nama Entitas / Company",
  "entries": "entri",
  "Entry of cost and revenue line items as the basis of the commercial summary.": "Pengisian line item biaya dan revenue sebagai dasar ringkasan komersial.",
  "Equipment Required": "Peralatan yang Dibutuhkan",
  "Error deleting data": "Terjadi kesalahan saat menghapus data",
  "Error Details": "Detail Error",
  "Error Diagnostics": "Diagnostik Error",
  "Error Loading Audit Logs": "Gagal Memuat Log Audit",
  "Error Loading Project": "Gagal Memuat Proyek",
  "Error: Data not found": "Error: Data tidak ditemukan",
  "Escalate": "Eskalasi",
  "Est Margin": "Est Margin",
  "Est. Start": "Est. Mulai",
  "Estimated Margin": "Estimasi Margin",
  "Estimated Margin (%)": "Estimasi Margin (%)",
  "Estimated Margin must be a number between 0 and 100": "Estimasi Margin harus berupa angka antara 0 dan 100",
  "Estimated Start (MM/YYYY)": "Estimasi Mulai (BB/TTTT)",
  "Estimated Start (MM/YYYY) is required for moving to Proposal": "Estimasi Mulai (BB/TTTT) wajib diisi untuk maju ke Proposal",
  "Estimated Start must be in MM/YYYY format": "Estimasi Mulai harus berformat BB/TTTT",
  "Estimated time: 30–60 minutes": "Perkiraan waktu: 30–60 menit",
  "Estimated Value": "Estimasi Nilai",
  "Event": "Kejadian",
  "Evidence": "Bukti",
  "Evidence Attachment (Optional)": "Lampiran Bukti (Opsional)",
  "Evidence Document (Optional)": "Evidence Document (Opsional)",
  "Evidence file": "File evidence",
  "Evidence files": "File bukti",
  "Evidence History": "Riwayat Evidence",
  "Evidence History database and Actual S-Curve will be deleted.": "Evidence History database dan S-Curve Actual akan dihapus.",
  "Evidence is available at this stage or a previous stage": "Evidence tersedia pada stage ini atau stage sebelumnya",
  "Evidence method": "Metode evidence",
  "Evidences": "Bukti",
  "EVM Performance Indices": "Indeks Kinerja EVM",
  "example: 150000000": "contoh: 150000000",
  "Example: Alita Singapore": "Contoh: Alita Singapore",
  "Example: Employee Data Consent Form": "Contoh: Form Persetujuan Data Karyawan",
  "Example: Finish approved, please continue with finalization.": "Contoh: Finish disetujui, mohon lanjut finalisasi.",
  "Example: Internal, External, Vendor...": "Contoh: Internal, Eksternal, Vendor...",
  "Example: Meeting with Client A...": "Contoh: Meeting dengan Klien A...",
  "Example: Procurement of FO Cable Materials for the Telkom Project": "Contoh: Pengadaan Material Kabel FO Proyek Telkom",
  "Example: PT ABC Jaya": "Contoh: PT ABC Jaya",
  "Example: Sudirman Branch Office...": "Contoh: Kantor Cabang Sudirman...",
  "Example: Surabaya, East Java...": "Contoh: Surabaya, East Java...",
  "Excel export is being processed{value1}...": "Export Excel sedang diproses{value1}...",
  "Excel files (.xlsx) up to 10MB": "File Excel (.xlsx) hingga 10MB",
  "Excellent": "Sangat Baik",
  "Executive Summary": "Ringkasan Eksekutif",
  "Expand sidebar": "Perluas sidebar",
  "Expected Completion": "Perkiraan Selesai",
  "Expired": "Kedaluwarsa",
  "Expires": "Kedaluwarsa",
  "Expiring Soon": "Segera Expired",
  "Expiry Date": "Tanggal Kedaluwarsa",
  "Explain the cause and approval of the reset.": "Jelaskan penyebab dan persetujuan reset.",
  "Explain why you need to extend the aging period (e.g., waiting for client response, pending internal approvals, etc.)": "Jelaskan mengapa Anda perlu memperpanjang periode aging (mis. menunggu respons klien, persetujuan internal tertunda, dll.)",
  "Export": "Ekspor",
  "Export activity logs berhasil dibuat": "Ekspor log aktivitas berhasil dibuat",
  "Export all pipeline data to an Excel file": "Export seluruh data pipeline ke file Excel",
  "Export Contacts": "Export Kontak",
  "Export CSV": "Ekspor CSV",
  "Export current GPI data (CSV)": "Ekspor data GPI saat ini (CSV)",
  "Export downloaded successfully!": "Export berhasil diunduh!",
  "Export Failed": "Export Gagal",
  "Export GPI": "Ekspor GPI",
  "Export is being processed...": "Export sedang diproses...",
  "Export pipeline data per active filter ({value1})": "Export data pipeline sesuai filter aktif ({value1})",
  "Export Successful": "Export Berhasil",
  "Export Template": "Ekspor Templat",
  "Export XLSX": "Ekspor XLSX",
  "Export XLSX Template": "Ekspor Templat XLSX",
  "Exporting XLSX Template": "Mengekspor Template XLSX",
  "Exporting...": "Mengekspor...",
  "Exposure": "Eksposur",
  "Exposure:": "Eksposur:",
  "Extend": "Perpanjang",
  "Extend 7 days": "Extend 7 hari",
  "Extend Aging": "Perpanjang Aging",
  "Extend aging - stays in current stage": "Perpanjang aging - tetap di tahap saat ini",
  "Extend Aging Period": "Perpanjang Periode Aging",
  "Extend failed.": "Perpanjangan gagal.",
  "Extended status": "Status Diperpanjang",
  "Extending...": "Memperpanjang...",
  "External Document (WO / SPK / LOI)": "Dokumen Eksternal (WO / SPK / LOI)",
  "External Documents (": "Dokumen Eksternal (",
  "External Documents (WO / SPK / Customer LOI)": "Dokumen Eksternal (WO / SPK / LOI Customer)",
  "External Documents (WO / SPK / LOI)": "Dokumen Eksternal (WO / SPK / LOI)",
  "Failed": "Gagal",
  "failed": "gagal",
  "failed rows": "data gagal",
  "Failed to acknowledge the Change Request.": "Gagal meng-acknowledge Change Request.",
  "Failed to add brief": "Gagal menambahkan ringkasan",
  "Failed to approve drop request": "Gagal menyetujui permintaan drop",
  "Failed to approve request": "Gagal menyetujui permintaan",
  "Failed to approve vehicle booking": "Gagal menyetujui booking kendaraan",
  "Failed to attach IM number.": "Gagal melampirkan nomor IM.",
  "Failed to cancel booking": "Gagal membatalkan booking",
  "Failed to complete assignment": "Gagal menyelesaikan penugasan",
  "Failed to create catalog": "Gagal membuat katalog",
  "Failed to create contact": "Gagal membuat kontak",
  "Failed to create drop approval request": "Gagal membuat permintaan persetujuan drop",
  "Failed to create IM.": "Gagal membuat IM.",
  "Failed to create risk": "Gagal membuat risiko",
  "Failed to create role": "Gagal membuat role",
  "Failed to create SO": "Gagal membuat SO",
  "Failed to create unit": "Gagal membuat unit",
  "Failed to delete": "Gagal menghapus",
  "Failed to delete data": "Gagal menghapus data",
  "Failed to delete file": "Gagal menghapus file",
  "Failed to delete role": "Gagal menghapus role",
  "Failed to delete the vendor.": "Vendor tidak dapat dihapus.",
  "Failed to download control sheet": "Gagal mengunduh control sheet",
  "Failed to download dealsheet.": "Gagal mengunduh dealsheet.",
  "Failed to download evidence (the file may not exist yet)": "Gagal mengunduh evidence (Mungkin belum ada file)",
  "Failed to download file": "Gagal mengunduh file",
  "Failed to download template": "Gagal mengunduh templat",
  "Failed to download the attachment.": "Attachment tidak dapat diunduh.",
  "Failed to download the dealsheet file.": "Gagal mengunduh file dealsheet.",
  "Failed to download the export file": "Gagal mengunduh file export",
  "Failed to download the pipeline export file": "Gagal mengunduh file export pipeline",
  "Failed to download the template": "Gagal mengunduh template",
  "Failed to download the template.": "Download template gagal.",
  "Failed to download vendor data.": "Data vendor tidak dapat diunduh.",
  "Failed to drop contact": "Gagal membatalkan kontak",
  "Failed to drop opportunity.": "Gagal melakukan drop peluang.",
  "Failed to export activity logs": "Gagal mengekspor log aktivitas",
  "Failed to export booking history": "Gagal mengekspor booking history",
  "Failed to export report": "Gagal mengekspor laporan",
  "Failed to extend aging": "Gagal memperpanjang aging",
  "Failed to fetch": "Gagal mengambil data",
  "Failed to fetch dashboard data": "Gagal mengambil data dasbor",
  "Failed to fetch document data": "Gagal mengambil data dokumen",
  "Failed to fetch global audit logs": "Gagal mengambil log audit global",
  "Failed to fetch projects": "Gagal mengambil proyek",
  "Failed to fetch RBAC data": "Gagal mengambil data RBAC",
  "Failed to fetch request": "Gagal mengambil permintaan",
  "Failed to fetch tasks": "Gagal mengambil tugas",
  "Failed to import contacts": "Gagal import kontak",
  "Failed to install material": "Gagal memasang material",
  "Failed to load": "Gagal memuat",
  "Failed to load activity logs": "Gagal memuat log aktivitas",
  "Failed to load Analyst Workspace.": "Gagal memuat Analyst Workspace.",
  "Failed to load approval queue": "Gagal memuat antrian persetujuan",
  "Failed to load assignments": "Gagal memuat penugasan",
  "Failed to load assignments ({status})": "Gagal memuat penugasan ({status})",
  "Failed to load audit logs": "Gagal memuat log audit",
  "Failed to load Audit Logs": "Gagal memuat Log Audit",
  "Failed to load bank data": "Gagal memuat data bank",
  "Failed to load booking history": "Gagal memuat history booking",
  "Failed to load booking master data": "Gagal memuat data master booking",
  "Failed to load catalogs": "Gagal memuat katalog",
  "Failed to load change requests": "Gagal memuat permintaan perubahan",
  "Failed to load Connect data": "Gagal memuat data Connect",
  "Failed to load contact stats": "Gagal memuat statistik kontak",
  "Failed to load contacts": "Gagal memuat kontak",
  "Failed to load dashboard data": "Gagal memuat data dashboard",
  "Failed to Load Dashboard Data": "Gagal Memuat Data Dashboard",
  "Failed to load data.": "Gagal memuat data.",
  "Failed to load document details.": "Detail dokumen tidak dapat dimuat.",
  "Failed to load entity data": "Gagal memuat data entitas",
  "Failed to load Fast Track.": "Gagal memuat Fast Track.",
  "Failed to load finance queue.": "Gagal memuat antrean finance.",
  "Failed to load geojson: {status}": "Gagal memuat geojson: {status}",
  "Failed to load hosts list": "Gagal memuat daftar host",
  "Failed to load IM detail.": "Gagal memuat detail IM.",
  "Failed to load IM list.": "Gagal memuat daftar IM.",
  "Failed to load Internal Memo list.": "Gagal memuat daftar Internal Memo.",
  "Failed to load limit info": "Gagal memuat info batas",
  "Failed to load master sites": "Gagal memuat master site",
  "Failed to load My Tasks.": "Gagal memuat Tugas Saya.",
  "Failed to load notifications.": "Gagal memuat notifikasi.",
  "Failed to load opportunities ({status})": "Gagal memuat peluang ({status})",
  "Failed to load partner data": "Gagal memuat data partner",
  "Failed to Load Pipeline": "Gagal Memuat Pipeline",
  "Failed to load PO list.": "Gagal memuat daftar PO.",
  "Failed to load progress history": "Gagal memuat riwayat progres",
  "Failed to load project details": "Gagal memuat detail proyek",
  "Failed to load project risks": "Gagal memuat risiko proyek",
  "Failed to load RBAC data": "Gagal memuat data RBAC",
  "Failed to load relocation options": "Gagal memuat opsi relokasi",
  "Failed to load report": "Gagal memuat laporan",
  "Failed to load report summary": "Gagal memuat ringkasan laporan",
  "Failed to load room data": "Gagal memuat data ruangan",
  "Failed to load S-Curve": "Gagal memuat Kurva-S",
  "Failed to load S-Curve data": "Gagal memuat data Kurva-S",
  "Failed to load Sales Orders": "Gagal memuat Sales Order",
  "Failed to load SCM data": "Gagal memuat data SCM",
  "Failed to load signature image": "Gambar tanda tangan gagal dimuat",
  "Failed to load SO detail": "Gagal memuat detail SO",
  "Failed to load submission documents": "Gagal memuat dokumen pengajuan",
  "Failed to load the approval configuration.": "Konfigurasi approval tidak dapat dimuat.",
  "Failed to load the company/institution name list": "Gagal memuat daftar nama perusahaan/instansi",
  "Failed to load the contact list": "Gagal memuat daftar kontak",
  "Failed to load the dashboard": "Dashboard tidak dapat dimuat",
  "Failed to load the dashboard.": "Dashboard gagal dimuat.",
  "Failed to load the document list.": "Daftar dokumen tidak dapat dimuat.",
  "Failed to load the host list. Please try again.": "Failed to load host list. Please try again.",
  "Failed to load the PDF. Make sure the file is accessible.": "Gagal memuat PDF. Pastikan file dapat diakses.",
  "Failed to load the user list.": "Gagal memuat daftar pengguna.",
  "Failed to load the user's RBAC data.": "Gagal memuat data RBAC pengguna.",
  "Failed to load users.": "User tidak dapat dimuat.",
  "Failed to load vendor data": "Gagal memuat data vendor",
  "Failed to load vendor data.": "Data vendor tidak dapat dimuat.",
  "Failed to load vendors.": "Vendor tidak dapat dimuat.",
  "Failed to load visitor visits": "Gagal memuat kunjungan pengunjung",
  "Failed to move unit": "Gagal memindahkan unit",
  "Failed to open evidence": "Gagal membuka evidence",
  "Failed to post progress": "Gagal memposting progres",
  "Failed to preview generated PDF.": "Gagal menampilkan pratinjau PDF yang dihasilkan.",
  "Failed to process approval": "Gagal memproses approval",
  "Failed to process selected signature image.": "Gagal memproses gambar tanda tangan yang dipilih.",
  "Failed to process the approval stage.": "Tahap approval tidak dapat diproses.",
  "Failed to process the batch upload (HTTP {status})": "Gagal memproses batch upload (HTTP {status})",
  "Failed to process the document.": "Gagal memproses dokumen.",
  "Failed to process {action}": "Gagal memproses {action}",
  "Failed to progress stage": "Gagal memajukan tahap",
  "Failed to read selected signature image.": "Gagal membaca gambar tanda tangan yang dipilih.",
  "Failed to refresh master sites": "Gagal memperbarui master site",
  "Failed to reject category approval": "Gagal menolak persetujuan kategori",
  "Failed to reject drop request": "Gagal menolak permintaan drop",
  "Failed to reject negotiation": "Gagal menolak negosiasi",
  "Failed to reject the Change Request.": "Gagal me-reject Change Request.",
  "Failed to reject vehicle booking": "Gagal menolak booking kendaraan",
  "Failed to relocate room": "Gagal merelokasi ruangan",
  "Failed to resolve file URL.": "Gagal menentukan URL file.",
  "Failed to restore contact": "Gagal memulihkan kontak",
  "Failed to restore the opportunity.": "Gagal mengembalikan opportunity.",
  "Failed to roll back Sales Order": "Gagal me-rollback Sales Order",
  "Failed to save": "Gagal menyimpan",
  "Failed to save contact": "Gagal menyimpan kontak",
  "Failed to save data": "Gagal menyimpan data",
  "Failed to save document": "Gagal menyimpan dokumen",
  "Failed to save modules": "Gagal menyimpan modules",
  "Failed to save permissions": "Gagal menyimpan permissions",
  "Failed to save role mapping": "Gagal menyimpan mapping role",
  "Failed to save the approval configuration.": "Konfigurasi approval tidak dapat disimpan.",
  "Failed to save the coordinator team.": "Gagal menyimpan tim coordinator.",
  "Failed to save the document.": "Dokumen tidak dapat disimpan.",
  "Failed to save the vendor.": "Vendor tidak dapat disimpan.",
  "Failed to save user data": "Gagal menyimpan data pengguna",
  "Failed to save user roles.": "Gagal menyimpan role pengguna.",
  "Failed to send reply": "Gagal mengirim balasan",
  "Failed to submit change request": "Gagal mengajukan permintaan perubahan",
  "Failed to submit dealsheet.": "Gagal mensubmit dealsheet.",
  "Failed to submit negotiation": "Gagal mengajukan negosiasi",
  "Failed to submit progress": "Gagal mengirim progres",
  "Failed to submit request": "Gagal mengajukan permintaan",
  "Failed to submit the document.": "Dokumen tidak dapat diajukan.",
  "Failed to update": "Gagal memperbarui",
  "Failed to update booking": "Gagal mengupdate booking",
  "Failed to update contact": "Gagal update kontak",
  "Failed to update notification status": "Gagal memperbarui status notifikasi",
  "Failed to update site": "Gagal memperbarui site",
  "Failed to update task.": "Gagal memperbarui task.",
  "Failed to update the document.": "Gagal memperbarui dokumen.",
  "Failed to update user status.": "Gagal memperbarui status user.",
  "Failed to upload evidence": "Gagal mengupload evidence",
  "Failed to upload file": "Gagal mengunggah file",
  "Failed to withdraw the document submission.": "Gagal menarik pengajuan dokumen.",
  "Fast Track action failed.": "Aksi Fast Track gagal.",
  "Fast Track request failed.": "Permintaan Fast Track gagal.",
  "Fax": "Faks",
  "Feel free to choose any time.": "Bebas pilih waktu.",
  "Fetching infrastructure tickets...": "Mengambil tiket infrastruktur...",
  "Field": "Kolom",
  "Field Update": "Pembaruan Lapangan",
  "File & Location": "File & Lokasi",
  "File deleted successfully!": "File berhasil dihapus!",
  "File format:": "Format file:",
  "File format: Name, Customer, Mobile, Email, Division, Position, Status": "Format file: Nama, Customer, HP, Email, Divisi, Posisi, Status",
  "File is not available.": "File tidak tersedia.",
  "File must be a PDF or DOCX.": "File harus berformat PDF atau DOCX.",
  "File Name": "Nama File",
  "File No:": "No File:",
  "File Number": "Nomor File",
  "File size ({value1} MB) exceeds the 50 MB limit!": "Ukuran file ({value1} MB) melebihi batas maksimal 50 MB!",
  "File size exceeds the 10 MB limit.": "Ukuran file melebihi batas maksimal 10 MB.",
  "File size exceeds the server upload limit (413 Request Entity Too Large).": "Ukuran file melebihi batas upload server (413 Request Entity Too Large).",
  "File uploaded successfully": "File berhasil diunggah",
  "File uploaded successfully!": "File berhasil diunggah!",
  "File URL is missing from server response.": "URL file tidak ada dalam respons server.",
  "Fill in and validate the contact": "Isi dan validasi contact",
  "Fill in Budget and Authority": "Isi Budget dan Authority",
  "Fill in Needs, estimated start, and duration": "Isi Needs, estimasi mulai, dan durasi",
  "Fill in Overview and Project Code": "Isi Overview dan Project Code",
  "Fill in the customer, number, date, value, and file": "Isi customer, nomor, tanggal, nilai, dan file",
  "Fill in the Document Title/Subject on the left, then click": "Isi Judul/Perihal Dokumen di sebelah kiri, lalu klik",
  "Fill in the drop reason": "Isi alasan drop",
  "Fill in the metadata and Project Code": "Isi metadata dan Project Code",
  "Fill in the name, market value, business type, and owner": "Isi nama, market value, business type, dan owner",
  "Fill in the PO estimate": "Isi estimasi PO",
  "Fill in the Qualification data": "Isi data Qualification",
  "Fill in the start and end date of each stage": "Isi start dan end date setiap stage",
  "Fill in the submission notes for the next approver": "Isi catatan pengiriman untuk approver berikutnya",
  "Filter assignment type": "Filter tipe penugasan",
  "Filter by Action": "Filter berdasarkan Aksi",
  "Filter by Entity": "Filter berdasarkan Entitas",
  "Filter identified risks by progress status": "Filter risiko teridentifikasi berdasarkan status progres",
  "Filter opportunity category": "Filter kategori peluang",
  "Filter reporting year": "Filter tahun pelaporan",
  "Filter tasks by module": "Filter tugas berdasarkan modul",
  "Filtered operational scope": "Cakupan operasional terfilter",
  "Filters": "Filter",
  "Final Approval": "Persetujuan Final",
  "final approval": "persetujuan final",
  "Final approval for BAK and Others": "Final approval untuk BAK dan Others",
  "Final Approve": "Setujui Final",
  "Final decision": "Keputusan akhir",
  "Final Evidence Document (IM + Attachments)": "Dokumen Evidence Final (IM + Lampiran)",
  "Final for Cancellation Letter; initial for BAK/Others": "Final untuk Cancellation Letter; paraf untuk BAK/Others",
  "Final project completion": "Penyelesaian akhir proyek",
  "Final result or rejection": "Hasil final atau reject",
  "BAK Completed": "BAK Selesai",
  "Emails the signed BAK once its approval circulation is complete": "Kirim email berisi BAK yang sudah ditandatangani setelah sirkulir approval selesai",
  "Add BAK Completion Recipient": "Tambah Penerima BAK Selesai",
  "No recipients yet. No email is sent when a BAK is completed.": "Belum ada penerima. Tidak ada email yang dikirim saat BAK selesai.",
  "Final result?": "Hasil akhir?",
  "Final SO approval": "Final approval SO",
  "Finalize Deal 100%": "Finalisasi Deal 100%",
  "Finalize Negotiation into Deal": "Finalisasi Negotiation menjadi Deal",
  "Finance and Procurement": "Finance dan Procurement",
  "Finance approval queue and Sales Order management.": "Antrean persetujuan Finance dan manajemen Sales Order.",
  "Finance or Procurement": "Finance atau Procurement",
  "Finance Queue": "Antrean Finance",
  "Financials": "Keuangan",
  "Find your": "Temukan",
  "Finish": "Selesaikan",
  "Finish Flow": "Selesaikan Alur",
  "Finish submit failed.": "Penyelesaian pengajuan gagal.",
  "Finished": "Selesai",
  "Finished status": "Status Selesai",
  "First": "Awal",
  "First approval step": "Approval step pertama",
  "First Name": "Nama Depan",
  "First Occur": "Kemunculan Pertama",
  "First Page": "Halaman Pertama",
  "First Transaction": "Transaksi Pertama",
  "Fix the cause of the failure, then re-upload the batch update file.": "Perbaiki penyebab kegagalan, lalu upload kembali file batch update.",
  "Fix the data then revalidate": "Perbaiki data lalu validasi ulang",
  "Fix the form then resubmit": "Perbaiki form lalu kirim ulang",
  "Fix the PO estimate or GPI": "Perbaiki estimasi PO atau GPI",
  "Fix the PO number then re-upload": "Perbaiki nomor PO lalu upload ulang",
  "Fix the preparation then resubmit": "Perbaiki preparation lalu submit ulang",
  "Fix the problematic rows then re-upload": "Perbaiki baris bermasalah lalu upload ulang",
  "Fix the stage order and duration": "Perbaiki urutan dan durasi stage",
  "Fix the stage then revalidate": "Perbaiki stage lalu validasi ulang",
  "Fleet": "Armada",
  "Fleet Management": "Manajemen Armada",
  "Flow Library": "Pustaka Alur",
  "Flow not found": "Flow tidak ditemukan",
  "flows": "alur",
  "Folder Link": "Tautan Folder",
  "Folder Link (required for Opportunity → Qualification)": "Tautan Folder (wajib untuk Peluang → Kualifikasi)",
  "Folder link is required for transitioning to Qualification": "Tautan folder wajib diisi untuk transisi ke Kualifikasi",
  "Follow-up action": "Aksi lanjutan",
  "Follow-up when an opportunity stays too long in an active stage.": "Tindak lanjut saat opportunity berada terlalu lama pada stage aktif.",
  "for Cancellation Letter documents.": "untuk dokumen tipe Cancellation Letter.",
  "FOREIGN COMPANY": "PERUSAHAAN ASING",
  "Form Submitted": "Formulir Terkirim",
  "Format: JPG, JPEG, PNG, PDF, DOC, DOCX. Max. 10 MB.": "Format: JPG, JPEG, PNG, PDF, DOC, DOCX. Maks. 10 MB.",
  "Format: JPG, PNG, PDF, DOC (Max 10MB)": "Format: JPG, PNG, PDF, DOC (Maks 10MB)",
  "From": "Dari",
  "From date": "Dari tanggal",
  "From Date": "Dari Tanggal",
  "Front line for incident intake & validation.": "Garda terdepan penerimaan & validasi insiden.",
  "Full": "Penuh",
  "Full Address": "Alamat Lengkap",
  "Full address": "Alamat lengkap",
  "Full Audit Log": "Log Audit Lengkap",
  "Full Booked": "Penuh Terpesan",
  "Full Name": "Nama Lengkap",
  "Full Name *": "Nama Lengkap *",
  "Full Page": "Halaman Penuh",
  "Full Submission Details": "Detail Lengkap Pengajuan",
  "Full View →": "Tampilan Penuh →",
  "GA Assets": "Aset GA",
  "Gagal mengekspor activity logs": "Gagal mengekspor log aktivitas",
  "Gap (Actual - Plan):": "Selisih (Aktual - Rencana):",
  "Gate:": "Gerbang:",
  "General": "Umum",
  "GENERAL": "UMUM",
  "General Info": "Info Umum",
  "General Information": "Informasi Umum",
  "Generate Budget and Progress S-Curves": "Generate Budget dan Progress S-Curve",
  "Generate PDF": "Buat PDF",
  "Generate PDF First": "Buat PDF Dahulu",
  "Generate PDF, snapshot, or version history": "Generate PDF, snapshot, atau version history",
  "Generate the document number and audit log": "Generate nomor dokumen dan audit log",
  "Generate the S-Curve from the": "Buat Kurva-S dari",
  "Generate the SO number, PDF, and version snapshot": "Generate nomor SO, PDF, dan snapshot versi",
  "Generate the SO overview PDF before submitting for approval.": "Buat PDF ikhtisar SO sebelum mengajukan untuk persetujuan.",
  "Generated PDF download failed.": "Unduhan PDF yang dihasilkan gagal.",
  "Generated PDF preview failed.": "Pratinjau PDF yang dihasilkan gagal.",
  "Generated PDF URL is missing.": "URL PDF yang dihasilkan tidak ada.",
  "Generating SO overview PDF…": "Membuat PDF ikhtisar SO…",
  "Generating…": "Membuat…",
  "Get started by creating your first WBS template.": "Mulai dengan membuat templat WBS pertama Anda.",
  "Global / Not Specified": "Global / Tidak Ditentukan",
  "Global Audit Logs": "Log Audit Global",
  "GO TO ADMIN CENTER": "BUKA PUSAT ADMIN",
  "Go to the first accessible module": "Buka modul pertama yang dapat diakses",
  "Good": "Baik",
  "Google Spreadsheet link or Drive folder": "Link Google Spreadsheet atau folder Drive",
  "Google Spreadsheets and Drive folders are only attached to evidence, without being copied to the AIBASDEV Drive.": "Google Spreadsheet dan folder Drive hanya di-attach ke evidence, tanpa disalin ke Drive AIBASDEV.",
  "Governance": "Tata Kelola",
  "GOVERNANCE": "TATA KELOLA",
  "GPI & Timeline": "GPI & Linimasa",
  "GPI Data Reset Successfully": "Data GPI Berhasil Direset",
  "GPI Document": "Dokumen GPI",
  "GPI is valid.": "GPI valid.",
  "GPI Link": "Tautan GPI",
  "GPI Link / SharePoint Link": "Tautan GPI / Tautan SharePoint",
  "GPI Link must be a valid URL": "Tautan GPI harus berupa URL yang valid",
  "GPI Link or GPI File is required": "Tautan GPI atau File GPI wajib diisi",
  "GPI link or GPI file is required for moving to Negotiation stage": "Tautan GPI atau file GPI wajib diisi untuk maju ke tahap Negosiasi",
  "GPI Preparation": "Persiapan GPI",
  "GPI ready for SO submission": "GPI siap untuk submission SO",
  "GPI Revenue / Deal Value": "Pendapatan GPI / Nilai Deal",
  "GPI Studio": "Studio GPI",
  "GPI validation failed.": "Validasi GPI gagal.",
  "Grand Total": "Total Keseluruhan",
  "Group": "Grup",
  "Grouped lines + SLA 4H dashed line": "Grouped lines + garis putus-putus SLA 4J",
  "Handling": "Penanganan",
  "Handling Time": "Waktu Penanganan",
  "Handoff back to Account Manager": "Handoff kembali ke Account Manager",
  "Handoff Deal to Admin Sales": "Handoff Deal ke Admin Sales",
  "Handoff of Released Sales Order data into a project that OPS can execute.": "Handoff data Sales Order Released menjadi project yang dapat dieksekusi OPS.",
  "Handoff SO for approval": "Handoff SO untuk approval",
  "Handoff Timeline to Project Manager": "Handoff Timeline ke Project Manager",
  "Has it been 7 days or more?": "Sudah 7 hari atau lebih?",
  "Head of Finance and Procurement": "Head of Finance dan Procurement",
  "Head of SA performs the review": "Head of SA melakukan review",
  "Health & Risks": "Kesehatan & Risiko",
  "Health Change": "Perubahan Kesehatan",
  "Health Score": "Skor Kesehatan",
  "Health Status Change": "Perubahan Status Kesehatan",
  "Hello, here is an important message from the": "Halo, berikut adalah pesan penting dari tim",
  "Hide": "Sembunyikan",
  "Hide Mermaid Code": "Sembunyikan Kode Mermaid",
  "Hierarchical decomposition of project scopes and weighted physical progress.": "Dekomposisi hierarkis lingkup proyek dan progres fisik berbobot.",
  "High": "Tinggi",
  "History": "Riwayat",
  "History ({count})": "Riwayat ({count})",
  "History of user activity trails, data changes, transaction approvals, and real-time system logs.": "Riwayat jejak aktivitas pengguna, perubahan data, persetujuan transaksi, dan log sistem real-time.",
  "Hooray! No documents need review right now.": "Hore! Tidak ada dokumen yang perlu di-review saat ini.",
  "Host & Purpose": "Host & Keperluan",
  "Host (Destination)": "Host (Tujuan)",
  "Host (Visit Destination)": "Host (Tujuan Kunjungan)",
  "Host list": "Daftar host",
  "Host name not found. Try another name.": "Nama host tidak ditemukan. Coba nama lain.",
  "Host will review your visit request.": "Host akan meninjau permintaan kunjungan Anda.",
  "Hotspot Map": "Peta Titik Panas",
  "Hours Spent": "Jam Kerja",
  "How transaction data is summarized into KPIs and a sales follow-up list.": "Cara data transaksi diringkas menjadi KPI dan daftar tindak lanjut sales.",
  "HTTP Error: {status}": "Error HTTP: {status}",
  "Human Resource": "Sumber Daya Manusia",
  "I have read, understood, and agree to all the Safety Terms above.": "Saya telah membaca, memahami, dan menyetujui seluruh Ketentuan Keselamatan di atas.",
  "I understand this will send a broadcast email to": "Saya paham ini akan mengirim email broadcast ke",
  "ID": "ID",
  "ID number": "Nomor identitas",
  "ID Number": "Nomor Identitas",
  "ID Number (KTP/Passport) *": "Nomor Identitas (KTP/Paspor) *",
  "ID:": "ID:",
  "Identified risks": "Risiko teridentifikasi",
  "Identity": "Identitas",
  "Identity & Contact": "Identitas & Kontak",
  "Identity & roles updated successfully!": "Identitas & Role berhasil diperbarui!",
  "Identity Access Matrix": "Matriks Akses Identitas",
  "Identity Control Suite": "Suite Kontrol Identitas",
  "If approved, the IM will be marked Finished and the material quota will be officially released.": "Jika disetujui, IM akan dinyatakan Selesai dan kuota material akan dilepaskan secara resmi.",
  "If the customer has not issued the PO yet, you can choose": "Jika PO belum diterbitkan oleh customer, Anda dapat memilih",
  "If the IM has not been approved by the superior / Finance, complete the approval process at": "Apabila IM belum disetujui oleh atasan / Finance, selesaikan proses persetujuan di",
  "If you find a hazardous situation, report it to your escort/guide/Security.": "Jika menemukan keadaan bahaya, laporkan pada pendamping/pemandu/Satpam.",
  "If you have technical issues or further questions, please reply directly to this email or contact the AiBAS Support team.": "Apabila Anda memiliki kendala teknis atau pertanyaan lebih lanjut, silakan langsung membalas email ini atau menghubungi tim Support AiBAS.",
  "IM Completion Confirmation": "Konfirmasi Penyelesaian IM",
  "IM created successfully:": "IM berhasil dibuat:",
  "IM Document Created Successfully:": "Dokumen IM Berhasil Dibuat:",
  "IM is standalone and requestor is assigned automatically from active account.": "IM bersifat mandiri dan pemohon ditetapkan otomatis dari akun yang aktif.",
  "IM Number": "Nomor IM",
  "IM Number & Subject": "Nomor & Subjek IM",
  "IM or SO": "IM atau SO",
  "IM Rejected": "IM Ditolak",
  "Impact": "Dampak",
  "Import": "Impor",
  "Import & Save Successful": "Import & Simpan Berhasil",
  "Import and export the Partner-to-Asset reference master.": "Import dan export master referensi Mitra ke Aset.",
  "Import Contacts": "Import Kontak",
  "Import Dates": "Impor Tanggal",
  "Import Failed. Check the Excel format.": "Import Gagal. Cek format Excel.",
  "Import pipeline opportunity data from an Excel/CSV file": "Import data opportunity pipeline dari file Excel/CSV",
  "Import Product": "Impor Produk",
  "Import Successful!": "Import Berhasil!",
  "Import XLSX": "Impor XLSX",
  "Import {importProgress}%": "Impor {importProgress}%",
  "Important activity trails for auditing and tracing CRM data changes.": "Jejak aktivitas penting untuk audit dan penelusuran perubahan data CRM.",
  "Important Announcement": "Pengumuman Penting",
  "Important Dates": "Tanggal Penting",
  "Imported": "Diimpor",
  "imported": "mengimpor",
  "Importing...": "Mengimpor...",
  "In an emergency, follow the evacuation route to the available assembly point.": "Dalam keadaan darurat, ikuti jalur evakuasi menuju titik kumpul yang tersedia.",
  "In Approval": "Dalam Persetujuan",
  "In Progress": "Dalam Proses",
  "In Review": "Dalam Tinjauan",
  "in the field below to confirm:": "pada kolom di bawah untuk mengonfirmasi:",
  "In-City": "Dalam Kota",
  "Inactive": "Tidak Aktif",
  "Incoming & Outgoing Letters.": "Surat Masuk & Surat Keluar.",
  "Incomplete": "Belum lengkap",
  "Individual": "Individual (Perorangan)",
  "Indonesia Province Choropleth (Real Map)": "Koroplet Provinsi Indonesia (Peta Nyata)",
  "Industry": "Industri",
  "Industry Sector": "Sektor Industri",
  "Industry Sector:": "Sektor Industri:",
  "Infrastructure Ticket Detail": "Detail Tiket Infrastruktur",
  "Initial": "Berikan Paraf",
  "Initial / Final": "Paraf / Final",
  "Initial preparation": "Persiapan awal",
  "Initial release": "Rilis awal",
  "Direct SO edit": "Edit SO langsung",
  "GPI uploaded": "GPI diunggah",
  "GPI lines replaced": "Baris GPI diganti",
  "GPI line edited": "Baris GPI diubah",
  "GPI deleted": "GPI dihapus",
  "Timeline plan changed": "Rencana timeline diubah",
  "Timeline task dates changed": "Tanggal task timeline diubah",
  "SO data changed": "Data SO diubah",
  "Changed through": "Perubahan melalui",
  "Not released yet": "Belum dirilis",
  "The released SO was edited directly, so it is now a new draft version. Review the changes, regenerate PDF if needed, then submit it for approval again.": "SO yang sudah dirilis diubah langsung, sehingga sekarang menjadi versi draft baru. Tinjau perubahannya, buat ulang PDF jika perlu, lalu ajukan kembali untuk persetujuan.",
  "Approvals from the previous version are kept as history and are not changed by this direct SO edit.": "Approval versi sebelumnya tersimpan sebagai riwayat dan tidak diubah oleh edit SO langsung ini.",
  "Initial saved successfully.": "Paraf berhasil disimpan.",
  "Initial Score": "Skor Awal (Initial Score)",
  "Initial the Document": "Paraf Dokumen",
  "Initialed": "Diparaf",
  "initialed": "memberi paraf pada",
  "Input method": "Metode input",
  "Input Method: Existing Document (Direct Archive)": "Metode Input: Dokumen Existing (Arsip Langsung)",
  "Input SA name/code": "Masukkan nama/kode SA",
  "Inputs & Action": "Input & Aksi",
  "Install Material": "Pasang Material",
  "Install serialized materials for closed tickets.": "Pasang material berseri untuk tiket yang sudah ditutup.",
  "Installing...": "Memasang...",
  "Instansi Bank": "Institusi Bank",
  "Insurance": "Asuransi",
  "Interim batch summary": "Ringkasan batch sementara",
  "Internal / No Customer": "Internal / Tanpa Pelanggan",
  "Internal / None": "Internal / Tidak Ada",
  "Internal Document (Draft GPI / Deal Sheet)": "Dokumen Internal (Draf GPI / Deal Sheet)",
  "Internal Documents (": "Dokumen Internal (",
  "Internal Documents (Draft GPI / Deal Sheet)": "Dokumen Internal (Draft GPI / Deal Sheet)",
  "Internal Memo": "Memo Internal",
  "Internal Memo (Release for IM)": "Internal Memo (Release untuk IM)",
  "Internal Memo Document": "Dokumen Internal Memo",
  "Internal Memo is automatically Closed": "Internal Memo otomatis Closed",
  "Internal Memo Menu": "Menu Internal Memo",
  "Internal Memo not found.": "Internal Memo tidak ditemukan.",
  "Internal Memo stays active": "Internal Memo tetap aktif",
  "Internal Review": "Tinjauan Internal",
  "International": "Internasional",
  "Invalid": "Tidak valid",
  "Invalid date.": "Tanggal tidak valid.",
  "Invalid File Format": "Format Berkas Tidak Sesuai",
  "Invalid Sales Order ID.": "ID Sales Order tidak valid.",
  "Invalid server response": "Respons server tidak valid",
  "Invalid user ID": "ID pengguna tidak valid",
  "Inventory": "Inventaris",
  "Is all qualification data complete?": "Semua data qualification lengkap?",
  "is not available for this schedule. Choose another unit.": "tidak tersedia pada jadwal ini. Pilih unit lain.",
  "Is the data valid?": "Data valid?",
  "Is the GPI also available?": "GPI juga tersedia?",
  "Is the opportunity already a Deal?": "Opportunity sudah Deal?",
  "Is the PO number unique for the customer?": "Nomor PO unik untuk customer?",
  "Is the proposal data valid?": "Data proposal valid?",
  "Is the qualification viable?": "Qualification layak?",
  "Is the SO finally approved?": "SO final approved?",
  "Is the timeline valid?": "Timeline valid?",
  "Issue / Alarm": "Masalah / Alarm",
  "Item ID": "ID Item",
  "Item ID:": "ID Item:",
  "Job Title:": "Jabatan:",
  "JPG, JPEG, PNG, PDF, DOC, DOCX, or PST": "JPG, JPEG, PNG, PDF, DOC, DOCX, atau PST",
  "JPG, PNG": "JPG, PNG",
  "Keep the active version": "Pertahankan versi aktif",
  "Key earned value analytics reflecting scheduling and cost baselines.": "Analitik earned value utama yang mencerminkan baseline jadwal dan biaya.",
  "KM marker / pole reference": "Penanda KM / referensi tiang",
  "Lack of Budget": "Kekurangan Anggaran",
  "Language": "Bahasa",
  "Largest budget usage this week": "Pemakaian budget terbesar minggu ini",
  "Largest progress gain this week": "Kenaikan progres terbesar minggu ini",
  "Last": "Akhir",
  "Last Name": "Nama Belakang",
  "Last Occur": "Kemunculan Terakhir",
  "Last Occur Date & Time": "Tanggal & Waktu Kemunculan Terakhir",
  "Last occur:": "Kemunculan terakhir:",
  "Last Page": "Halaman Terakhir",
  "Last refresh:": "Muat ulang terakhir:",
  "Last RSL": "RSL Terakhir",
  "Last synchronized:": "Terakhir disinkronisasi:",
  "Last Transaction": "Transaksi Terakhir",
  "Last Update:": "Pembaruan Terakhir:",
  "Last Updated": "Terakhir Diperbarui",
  "Latest changes to procurement documents": "Perubahan terakhir pada procurement documents",
  "Latest Documents": "Dokumen Terbaru",
  "Latest Ticket Activity": "Aktivitas Tiket Terbaru",
  "Leave blank if no change from current amount": "Kosongkan jika tidak ada perubahan dari jumlah saat ini",
  "LEGAL & COMPLIANCE": "LEGAL & KEPATUHAN",
  "Legal Document": "Dokumen Legal",
  "Legal Partner": "Mitra Legal",
  "Legal Partners": "Mitra Legal",
  "Legal Pipeline": "Pipeline Legal",
  "Legal User": "Pengguna Legal",
  "Legal View Only": "Legal Hanya Lihat",
  "Legal, Services & SCM": "Legal, Layanan & SCM",
  "Legalitas": "Legalitas",
  "Legality": "Legalitas",
  "Legality -": "Legalitas -",
  "Legality Classification": "Klasifikasi Legalitas",
  "Legality Document": "Dokumen Legalitas",
  "Legality document deleted successfully!": "Dokumen Legalitas berhasil dihapus!",
  "Legality Type": "Tipe Legalitas",
  "Legend": "Legenda",
  "Letter Archive": "Arsip Surat",
  "Letter Archive -": "Arsip Surat -",
  "Letter Number": "Nomor Surat",
  "Letter Status": "Status Surat",
  "Letters": "Surat",
  "Lifecycle Status": "Status Siklus Hidup",
  "Lifetime Value": "Nilai Seumur Hidup",
  "Line": "Baris",
  "Line Items": "Item Baris",
  "Line Number": "Nomor Baris",
  "Link": "Tautan",
  "Link a Previously Uploaded PO": "Tautkan PO yang Sudah Pernah Diunggah",
  "Link ID": "ID Link",
  "Link Purchase Order": "Tautkan Purchase Order",
  "Link the active Internal Memo": "Tautkan Internal Memo aktif",
  "Link the PO to one or more Sales Orders": "Tautkan PO ke satu atau lebih Sales Order",
  "Link to GPI documents (SharePoint/GPI system)": "Tautan ke dokumen GPI (SharePoint/sistem GPI)",
  "Link to project documents in SharePoint/GPI system": "Tautan ke dokumen proyek di SharePoint/sistem GPI",
  "Link to Sales Order": "Tautkan ke Sales Order",
  "Link to SO": "Hubungkan ke SO",
  "Linked IM Number:": "Nomor IM Terhubung:",
  "Linked POs": "PO Terkait",
  "Linked Purchase Orders": "Purchase Orders Terhubung",
  "Linked To": "Terhubung Dengan",
  "Linking...": "Menautkan...",
  "List": "Daftar",
  "List of all uploaded customer PO files, validation status, and contract validity period.": "Daftar seluruh berkas PO customer yang terunggah, status validasi, dan masa berlaku kontrak.",
  "List of client company PIC contacts, divisions, positions, phone numbers, and official emails.": "Daftar kontak PIC perusahaan klien, divisi, jabatan, nomor telepon, dan email resmi.",
  "List of documents awaiting your review and approval.": "Daftar dokumen yang menunggu *review* dan persetujuan Anda.",
  "Live Email Preview": "Pratinjau Email Langsung",
  "Live full audit log": "Log audit lengkap langsung",
  "Live Operational Data": "Data Operasional Langsung",
  "Live total": "Total langsung",
  "Live tracking": "Pelacakan langsung",
  "Loading active mitigations": "Memuat mitigasi aktif",
  "Loading activity log...": "Memuat log aktivitas...",
  "Loading activity logs...": "Memuat log aktivitas...",
  "Loading admin access...": "Memuat akses admin...",
  "Loading AM capacity...": "Memuat kapasitas AM...",
  "Loading AM Performance...": "Memuat Kinerja AM...",
  "Loading approved IM data...": "Memuat data IM yang disetujui...",
  "Loading approver list...": "Memuat daftar approver...",
  "Loading bookings...": "Memuat pemesanan...",
  "Loading capacity data...": "Memuat data kapasitas...",
  "Loading catalogs...": "Memuat katalog...",
  "Loading change requests...": "Memuat permintaan perubahan...",
  "Loading comparison…": "Memuat perbandingan…",
  "Loading configuration...": "Memuat konfigurasi...",
  "Loading contract data...": "Memuat data kontrak...",
  "Loading dashboard...": "Memuat dashboard...",
  "Loading Data...": "Memuat Data...",
  "Loading data...": "Memuat data...",
  "Loading detail asset...": "Memuat detail aset...",
  "Loading details...": "Memuat detail...",
  "Loading document list": "Memuat daftar dokumen",
  "Loading document...": "Memuat dokumen...",
  "Loading full audit log...": "Memuat log audit lengkap...",
  "Loading Growth Data...": "Memuat Data Pertumbuhan...",
  "Loading history": "Memuat riwayat",
  "Loading history...": "Memuat riwayat...",
  "Loading internal memo details...": "Memuat detail memo internal...",
  "Loading map layer...": "Memuat lapisan peta...",
  "Loading Market Share...": "Memuat Pangsa Pasar...",
  "Loading My Tasks...": "Memuat Tugas Saya...",
  "Loading negotiation history...": "Memuat riwayat negosiasi...",
  "Loading notifications...": "Memuat notifikasi...",
  "Loading PDF Document...": "Memuat Dokumen PDF...",
  "Loading Pipeline...": "Memuat Pipeline...",
  "Loading PO data…": "Memuat data PO…",
  "Loading procurement metrics": "Memuat metrik procurement",
  "Loading progress journey...": "Memuat perjalanan progres...",
  "Loading QR code...": "Memuat kode QR...",
  "Loading queue...": "Memuat antrian...",
  "Loading RCA data...": "Memuat data RCA...",
  "Loading requests...": "Memuat permintaan...",
  "Loading risk register": "Memuat register risiko",
  "Loading role list...": "Memuat daftar role...",
  "Loading room status...": "Memuat status ruangan...",
  "Loading sales order detail...": "Memuat detail sales order...",
  "Loading Sales Order Workspace": "Memuat Ruang Kerja Sales Order",
  "Loading Sales Orders…": "Memuat Sales Order…",
  "Loading shared vendor database...": "Memuat shared vendor database...",
  "Loading sites...": "Memuat site...",
  "Loading SO detail...": "Memuat detail SO...",
  "Loading submission data...": "Memuat data pengajuan...",
  "Loading ticket activity...": "Memuat aktivitas tiket...",
  "Loading ticket details...": "Memuat detail tiket...",
  "Loading ticket...": "Memuat tiket...",
  "Loading units...": "Memuat unit...",
  "Loading vehicles...": "Memuat kendaraan...",
  "Loading vendors...": "Memuat vendor...",
  "Loading version history…": "Memuat riwayat versi…",
  "Loading visitors...": "Memuat pengunjung...",
  "Loading Workspace...": "Memuat Ruang Kerja...",
  "Loading...": "Memuat...",
  "Local": "Lokal",
  "LOCAL": "LOKAL",
  "LOCAL COMPANY": "PERUSAHAAN LOKAL",
  "Location": "Lokasi",
  "Location Type": "Tipe Lokasi",
  "Log Activity": "Log Aktivitas",
  "Log Activity shows the actor, time, and action": "Log Activity menampilkan pelaku, waktu, dan aksi",
  "LOG OUT": "KELUAR",
  "Log Out": "Keluar",
  "Login (System Entry)": "Login (Masuk Sistem)",
  "Login failed. Please check your credentials.": "Login gagal. Periksa kredensial Anda.",
  "Login timeout. Please try again.": "Waktu login habis. Silakan coba lagi.",
  "Logs": "Log",
  "Lost Amount": "Nilai Hilang",
  "Lost to Competitor": "Kalah dari Kompetitor",
  "Lost Value (Est PO)": "Nilai yang Hilang (Est PO)",
  "LTV Score": "Skor LTV",
  "Main Competence": "Kompetensi Utama",
  "Main Information": "Informasi Utama",
  "Maintain part numbers, brands, and categories.": "Kelola part number, merek, dan kategori.",
  "Maintenance": "Pemeliharaan",
  "Maintenance of the product catalog and partner data as references for the sales process.": "Pemeliharaan katalog produk dan data partner sebagai referensi proses sales.",
  "Major": "Mayor",
  "Make sure the API endpoint is connected correctly.": "Pastikan Endpoint API terhubung dengan benar.",
  "Manage": "Kelola",
  "Manage and monitor all project opportunities, approval status, deal stages, and market value estimates.": "Kelola dan pantau seluruh peluang proyek, status approval, tahapan deal, dan estimasi nilai pasar.",
  "Manage and process data privacy requests": "Kelola dan proses permintaan privasi data",
  "Manage and update all meeting room and vehicle bookings": "Kelola dan perbarui seluruh pemesanan ruang rapat dan kendaraan",
  "Manage Approval Route": "Kelola Jalur Approval",
  "MANAGE APPROVAL ROUTE": "KELOLA JALUR APPROVAL",
  "Manage approval rules": "Kelola approval rules",
  "Manage bank institution data.": "Kelola data instansi bank.",
  "Manage Companies": "Kelola Perusahaan",
  "Manage customers, contacts, products, and partners": "Kelola customer, contact, product, dan partner",
  "Manage goods or service provider data.": "Kelola data penyedia barang atau jasa.",
  "Manage Master Roles": "Kelola Master Role",
  "Manage the contact directory (PIC) for all business relations.": "Kelola direktori kontak (PIC) untuk semua relasi bisnis.",
  "Manage the list of collaborating third parties.": "Kelola daftar pihak ketiga yang bekerjasama.",
  "Manage the list of entities or subsidiaries dynamically.": "Kelola daftar entitas atau anak perusahaan secara dinamis.",
  "Manage the Sales Pipeline": "Kelola Sales Pipeline",
  "Manage user accounts, activation status, and employee identities. Detailed access assignment can be configured in the RBAC Center.": "Kelola akun pengguna, status aktivasi, dan identitas pegawai. Penugasan hak akses mendalam dapat diatur pada RBAC Center.",
  "Manage user accounts, active/inactive status, position profiles, and access rights.": "Kelola akun pengguna, status aktif/nonaktif, profil jabatan, dan hak akses.",
  "Manage users, roles, permissions, and scope": "Kelola user, role, permission, dan scope",
  "Manage visitor queues and fast check-ins.": "Kelola antrean pengunjung dan check-in cepat.",
  "Manage WBS Templates per project type": "Kelola WBS Template per project type",
  "Manage, inspect, and monitor all active operational projects.": "Kelola, periksa, dan pantau seluruh proyek operasional aktif.",
  "Management": "Manajemen",
  "Management of Articles of Association, Permits & Certifications.": "Manajemen Anggaran Dasar, Perizinan & Sertifikasi.",
  "Management of customer identities and contact persons used by CRM transactions.": "Pengelolaan identitas customer dan contact person yang dipakai transaksi CRM.",
  "Manager": "Manajer",
  "Manager IT": "Manajer IT",
  "Manual Progress Update": "Pembaruan Progres Manual",
  "Mapping {length} date rows to WBS stages...": "Memetakan {length} baris tanggal ke tahapan WBS...",
  "Margin": "Margin",
  "Mark All as Read": "Tandai Semua Dibaca",
  "Mark all read": "Tandai semua dibaca",
  "Mark as Read": "Tandai Dibaca",
  "Mark for Deletion": "Tandai untuk Dihapus",
  "Marked as Aging": "Ditandai sebagai Aging",
  "Market Type": "Tipe Pasar",
  "Market Value Estimate": "Estimasi Nilai Pasar",
  "Market Value Estimate (required for Lead → Opportunity)": "Estimasi Nilai Pasar (wajib untuk Lead → Peluang)",
  "Market Value Estimate is required for transitioning from Lead to Opportunity": "Estimasi Nilai Pasar wajib diisi untuk transisi dari Lead ke Peluang",
  "Market Value Estimate:": "Estimasi Nilai Pasar:",
  "Master Banks": "Master Bank",
  "Master Contact List": "Master Daftar Kontak",
  "Master list for part numbers and categories.": "Daftar master untuk part number dan kategori.",
  "Master list of service locations consolidated from asset spans.": "Daftar master lokasi layanan yang dikonsolidasikan dari span aset.",
  "Master Partners": "Master Mitra",
  "Master site updated": "Master site diperbarui",
  "Master TPD, Planned S-Curve, risks, batch history, and old audit remain.": "Master TPD, S-Curve Planned, risk, batch history, dan audit lama tetap ada.",
  "Master Vendors": "Master Vendor",
  "Matching WBS Tasks": "Mencocokkan Task WBS",
  "Material Catalog": "Katalog Material",
  "Material Catalogs": "Katalog Material",
  "Material History": "Riwayat Material",
  "Material installed to site": "Material terpasang di site",
  "Material Stock": "Stok Material",
  "Material Transactions": "Transaksi Material",
  "Material Unit": "Unit Material",
  "Material unit created": "Unit material dibuat",
  "Material unit updated": "Unit material diperbarui",
  "Material Units": "Unit Material",
  "Material Usage": "Penggunaan Material",
  "Materials, services, IT...": "Material, jasa, IT...",
  "Max Exposure": "Eksposur Maksimum",
  "Max exposure:": "Eksposur maksimum:",
  "Max. 50 MB": "Maks. 50 MB",
  "Maybe Later": "Nanti Saja",
  "Meet the requirements": "Lengkapi syarat",
  "Meeting": "Rapat",
  "Meeting Booking": "Pemesanan Rapat",
  "Meeting Bookings": "Booking Meeting",
  "Meeting Room": "Ruang Rapat",
  "Meeting Rooms": "Ruang Rapat",
  "Meeting Title": "Judul Rapat",
  "Meets Standard": "Sesuai Standar",
  "Member": "Anggota",
  "Memo Content": "Isi Memo",
  "Memo List": "Daftar Memo",
  "Memo Pending": "Memo Tertunda",
  "Memo Submission Information": "Informasi Pengajuan Memo",
  "Mermaid Source": "Sumber Mermaid",
  "Mermaid syntax error": "Kesalahan sintaks Mermaid",
  "Message": "Pesan",
  "Message Body (Information)": "Isi Pesan (Informasi)",
  "Message must not be empty.": "Pesan tidak boleh kosong.",
  "Metric": "Metrik",
  "Metrics summary": "Ringkasan metrik",
  "Milestone completed! Proceed to the next stage.": "Milestone selesai! Lanjut ke stage berikutnya.",
  "Minimum 8 characters": "Minimal 8 karakter",
  "minutes": "menit",
  "minutes are marked red.": "menit ditandai merah.",
  "Mitigation replies by tagged members": "Balasan mitigasi oleh anggota yang ditandai",
  "Mitra & Aset Reference": "Referensi Mitra & Aset",
  "mm (Page": "mm (Hal",
  "Mobile": "HP",
  "Module": "Modul",
  "modules linked": "modul terhubung",
  "Modules that will be active (": "Modul yang akan aktif (",
  "Monitor deal movements, sales funnel stages, and revenue estimates in real time.": "Pantau pergerakan deals, tahapan sales funnel, dan estimasi revenue secara real-time.",
  "Monitor Deals from the Account Manager": "Monitor Deal dari Account Manager",
  "Monitor the audit log and workflow exceptions": "Monitor audit log dan workflow exception",
  "Monitor the health status and actual S-Curve": "Pantau health status dan S-Curve aktual",
  "Monitor the portfolio and health status": "Monitor portfolio dan health status",
  "Monitor the status of documents currently in drafting or approval.": "Pantau status dokumen yang sedang dalam proses drafting atau approval.",
  "Monitor ticket status movement in real time: where tickets move from and to.": "Monitor perpindahan status tiket secara realtime: tiket pindah dari mana ke mana.",
  "Monitoring": "Pemantauan",
  "Monitoring customer contracts & legal documents status.": "Pantau status kontrak pelanggan & dokumen legal.",
  "Monitoring of Sales Order creation, PO/GPI/Timeline document completeness, and approval flow.": "Monitoring pembuatan Sales Order, kelengkapan berkas PO/GPI/Timeline, dan alur approval.",
  "Month": "Bulan",
  "Monthly Document Volume": "Volume Dokumen Bulanan",
  "Monthly MTTR Trend": "Tren MTTR Bulanan",
  "Monthly Ticket Volume": "Volume Tiket Bulanan",
  "months": "bulan",
  "MOU, PKS, NDA, dsb.": "MOU, PKS, NDA, dll.",
  "Move": "Pindahkan",
  "Move to close": "Pindah ke close",
  "Move to degrade": "Pindah ke degrade",
  "Move Unit": "Pindahkan Unit",
  "Moving to Negotiation requires approval from the assigned business approver. Please provide PO Estimate and GPI link or upload a GPI file.": "Maju ke Negosiasi memerlukan persetujuan dari approver bisnis yang ditugaskan. Mohon berikan Estimasi PO dan tautan GPI atau unggah file GPI.",
  "MTTR above 04:00": "MTTR di atas 04:00",
  "Multiple files · max 50 MB each": "Beberapa file · maks 50 MB masing-masing",
  "My Signature": "Tanda Tangan Saya",
  "MY TASKS": "TUGAS SAYA",
  "My Tasks": "Tugas Saya",
  "Name": "Nama",
  "Name & Code": "Nama & Kode",
  "Name & Position": "Nama & Jabatan",
  "Name / role of authority": "Nama / peran otoritas",
  "Name not found": "Nama tidak ditemukan",
  "Name the template...": "Beri nama template...",
  "Name:": "Nama:",
  "National ID Number": "Nomor Induk Kependudukan",
  "Need Changed": "Perlu Perubahan",
  "Need urgent access? Contact the admin team.": "Butuh akses mendesak? Hubungi tim admin.",
  "Needs": "Kebutuhan",
  "Needs (SOW, BOQ, etc)": "Kebutuhan (SOW, BOQ, dll)",
  "Needs Action (V2+)": "Perlu Tindakan (V2+)",
  "Needs Approval": "Perlu Persetujuan",
  "Needs correction?": "Perlu koreksi?",
  "Needs description is required for moving to Proposal": "Deskripsi kebutuhan wajib diisi untuk maju ke Proposal",
  "Needs Driver": "Butuh Driver",
  "Needs follow-up?": "Perlu tindak lanjut?",
  "Needs Projector": "Butuh Proyektor",
  "Needs Refreshment": "Butuh Konsumsi",
  "Negotiation History": "Riwayat Negosiasi",
  "Negotiation history for {opportunityName} at {currentStage} stage": "Riwayat negosiasi untuk {opportunityName} pada tahap {currentStage}",
  "Negotiation rejected successfully!": "Negosiasi berhasil ditolak!",
  "Network": "Jaringan",
  "Network connection error.": "Gangguan koneksi jaringan.",
  "Network error": "Gangguan jaringan",
  "Network Error": "Kesalahan Jaringan",
  "Network error during upload": "Kesalahan jaringan saat mengunggah",
  "Network error occurred while executing operation.": "Terjadi kesalahan jaringan saat menjalankan operasi.",
  "Network error while creating role": "Gangguan jaringan saat membuat role",
  "Network error while creating SO": "Kesalahan jaringan saat membuat SO",
  "Network error while deleting role": "Gangguan jaringan saat menghapus role",
  "Network error while saving data": "Gangguan jaringan saat menyimpan data",
  "Network error.": "Gangguan jaringan.",
  "Network error. Please try again.": "Kesalahan jaringan. Silakan coba lagi.",
  "Network Inventory": "Inventaris Jaringan",
  "Network Node (Site)": "Node Jaringan (Site)",
  "Network Node / Alarm": "Node Jaringan / Alarm",
  "Networking": "Jaringan",
  "New": "Baru",
  "New Contact": "Kontak Baru",
  "New Contract": "Kontrak Baru",
  "New Customer": "Customer Baru",
  "New Document": "Dokumen Baru",
  "New documents over the last six months": "Dokumen baru selama enam bulan terakhir",
  "New entries will appear here for the project team.": "Entri baru akan muncul di sini untuk tim proyek.",
  "New evidence version uploaded successfully": "Versi evidence baru berhasil diunggah",
  "New file selected. Saving will replace the current attachment.": "File baru dipilih. Menyimpan akan menggantikan lampiran saat ini.",
  "New File:": "File Baru:",
  "New Internal Memo": "Internal Memo Baru",
  "New Non-Project IM": "IM Non-Proyek Baru",
  "New Opportunity": "Peluang Baru",
  "New Partner": "Partner Baru",
  "New password": "Kata sandi baru",
  "New Password (Leave blank to keep unchanged)": "Password Baru (Kosongkan jika tidak ingin mengubah)",
  "New PDP Request": "Permintaan PDP Baru",
  "New Product": "Produk Baru",
  "New Request": "Permintaan Baru",
  "New role created successfully!": "Role baru berhasil dibuat!",
  "New Room": "Ruangan Baru",
  "New Signature": "Tanda Tangan Baru",
  "New State": "Kondisi Baru",
  "New Template": "Templat Baru",
  "New ticket notifications from the FLP create endpoint.": "Notifikasi tiket baru dari endpoint FLP create.",
  "New type:": "Tipe baru:",
  "Next": "Berikutnya",
  "Next Page": "Halaman Berikutnya",
  "Next page": "Halaman berikutnya",
  "Next Stage": "Tahap Berikutnya",
  "No": "Tidak",
  "NO": "TIDAK",
  "No account": "Tanpa akun",
  "No Account": "Tanpa Akun",
  "No Action": "Tanpa Aksi",
  "No active hosts yet.": "Belum ada host aktif.",
  "No activities recorded": "Belum ada aktivitas tercatat",
  "No activity log provided.": "Tidak ada log aktivitas.",
  "No activity logs found": "Tidak ada log aktivitas",
  "No Activity Logs Found": "Tidak Ada Log Aktivitas yang Ditemukan",
  "No activity recorded yet.": "Belum ada aktivitas tercatat.",
  "No activity yet": "Belum ada aktivitas",
  "No additional competency notes.": "Tidak ada catatan kompetensi tambahan.",
  "No additional description": "Tidak ada deskripsi tambahan",
  "No additional description.": "Tidak ada keterangan tambahan.",
  "No additional information provided.": "Tidak ada informasi tambahan.",
  "No address recorded yet.": "Belum ada alamat yang tercatat.",
  "No address yet": "Belum ada alamat",
  "No approval history yet.": "Belum ada history persetujuan.",
  "No approval steps generated yet.": "Belum ada langkah persetujuan yang dibuat.",
  "No approver email": "Tidak ada email approver",
  "No area data for current filters.": "Tidak ada data area untuk filter saat ini.",
  "No Assignments Found": "Tidak Ada Penugasan",
  "No At-Risk Projects": "Tidak Ada Proyek Berisiko",
  "No audit activity is available.": "Tidak ada aktivitas audit.",
  "No brief has been provided for this opportunity.": "Belum ada ringkasan untuk peluang ini.",
  "No capacity data yet.": "Belum ada data kapasitas.",
  "No Category": "Tanpa Kategori",
  "No category data for current filters.": "Tidak ada data kategori untuk filter saat ini.",
  "No change requests received for this project.": "Tidak ada permintaan perubahan yang diterima untuk proyek ini.",
  "No Change Requests Yet": "Belum Ada Permintaan Perubahan",
  "No changes": "Tidak ada perubahan",
  "No Code": "Tanpa Kode",
  "No company data found.": "Tidak ada data company yang ditemukan.",
  "No contact data registered yet.": "Belum ada data kontak yang terdaftar.",
  "No contacts match the keyword \"{searchQuery}\".": "Tidak ada kontak yang sesuai dengan kata kunci \"{searchQuery}\".",
  "No contracts found.": "Tidak ada kontrak ditemukan.",
  "No coordinates available.": "Tidak ada koordinat tersedia.",
  "No coordinators found": "Tidak ada coordinator ditemukan",
  "No customer data for current filters.": "Tidak ada data pelanggan untuk filter saat ini.",
  "No customer data registered yet.": "Belum ada data customer yang terdaftar.",
  "No customers match the keyword \"{searchQuery}\".": "Tidak ada customer yang sesuai dengan kata kunci \"{searchQuery}\".",
  "No data": "Tidak ada data",
  "No Data Assets Found": "Tidak Ada Aset Data",
  "No data assigned yet.": "Belum ada data yang ditetapkan.",
  "No Data Available": "Tidak Ada Data",
  "No data available": "Tidak ada data",
  "No data available for the selected period": "Tidak ada data untuk periode yang dipilih",
  "No data for selected filters.": "Tidak ada data untuk filter yang dipilih.",
  "No data.": "Tidak ada data.",
  "No dealsheet history yet.": "Belum ada riwayat dealsheet.",
  "No Decision": "Tidak Ada Keputusan",
  "No Description": "Tanpa Keterangan",
  "No description": "Tidak ada deskripsi",
  "No description provided.": "Tidak ada deskripsi.",
  "No description recorded.": "Tidak ada deskripsi yang tercatat.",
  "No direct module": "Tidak ada modul langsung",
  "No document": "Tidak ada dokumen",
  "No Document Number Yet": "Belum Ada Nomor Dokumen",
  "No documents are currently in Draft or In Review status. Click the \"Create New Draft\" button to start.": "Tidak ada dokumen yang sedang dalam status Draft atau In Review. Klik tombol \"Buat Draft Baru\" untuk memulai.",
  "No documents found": "Dokumen tidak ditemukan",
  "No documents found.": "Tidak ada dokumen ditemukan.",
  "No documents yet": "Belum ada dokumen",
  "No driver assigned": "Belum ada driver ditugaskan",
  "No dropped opportunities found.": "Tidak ada peluang yang dibatalkan.",
  "No employees found.": "Tidak ada pegawai yang ditemukan.",
  "No evidence": "Tanpa evidence",
  "Close Install through an RFS Checklist": "Selesaikan Install melalui RFS Checklist",
  "No EVM data available": "Tidak ada data EVM",
  "No executive summary or description provided for this project.": "Tidak ada ringkasan eksekutif atau deskripsi untuk proyek ini.",
  "No external documents attached.": "Tidak ada dokumen eksternal yang dilampirkan.",
  "No File Attached": "Tidak Ada File Terlampir",
  "No files selected": "Tidak ada file dipilih",
  "No GPI data yet. Upload a spreadsheet file to populate line items.": "Belum ada data GPI. Unggah file spreadsheet untuk mengisi item baris.",
  "No GPI document": "Tidak ada dokumen GPI",
  "No identified risks are {value1}.": "Tidak ada risiko teridentifikasi yang {value1}.",
  "No identified risks match “{riskSearch}”.": "Tidak ada risiko teridentifikasi yang cocok dengan “{riskSearch}”.",
  "No internal documents attached.": "Tidak ada dokumen internal yang dilampirkan.",
  "No Internal Memo documents found.": "Tidak ada dokumen Internal Memo yang ditemukan.",
  "No letters found.": "Tidak ada surat ditemukan.",
  "No Link": "Tidak Ada Tautan",
  "No link provided": "Tidak ada tautan",
  "No logs found": "Tidak ada log ditemukan",
  "No managers found.": "Tidak ada manajer ditemukan.",
  "No matching employee data.": "Tidak ada data pegawai yang sesuai.",
  "No matching employees.": "Tidak ada karyawan yang cocok.",
  "No matching roles.": "Tidak ada role yang cocok.",
  "No matching users.": "Tidak ada pengguna yang sesuai.",
  "No material usage yet.": "Belum ada penggunaan material.",
  "No meeting room booking history yet": "Belum ada riwayat pemesanan ruang rapat",
  "No message": "Tanpa pesan",
  "No Module": "Tidak Ada Modul",
  "No module assigned": "Belum ada modul yang ditetapkan",
  "No modules selected yet": "Belum ada modul yang dipilih",
  "No name": "Tanpa nama",
  "No Name": "Tanpa Nama",
  "No negotiation submission details": "Tidak ada detail pengajuan negosiasi",
  "No negotiation submissions yet": "Belum ada pengajuan negosiasi",
  "No notes.": "Tidak ada catatan.",
  "No notifications found.": "Tidak ada notifikasi.",
  "No notifications yet.": "Belum ada notifikasi.",
  "No Number": "Tanpa Nomor",
  "No Number Yet": "Belum Ada Nomor",
  "No open tickets with coordinates available.": "Tidak ada tiket terbuka dengan koordinat.",
  "No opportunities": "Tidak ada opportunity",
  "No opportunities found.": "Tidak ada peluang ditemukan.",
  "No opportunities match the filter.": "Tidak ada opportunity yang sesuai dengan filter.",
  "No opportunities yet": "Belum ada peluang",
  "No partner data registered yet.": "Belum ada data partner yang terdaftar.",
  "No partners match the keyword \"{searchQuery}\".": "Tidak ada partner yang sesuai dengan kata kunci \"{searchQuery}\".",
  "No payload changes recorded.": "Tidak ada perubahan payload tercatat.",
  "No PDP requests found": "Tidak ada permintaan PDP",
  "No pending actions right now.": "Tidak ada tindakan yang menunggu saat ini.",
  "No pending approver": "Tidak ada approver tertunda",
  "No photo available": "Tidak ada foto",
  "No Physical Document Attached": "Tidak Ada Dokumen Fisik Terlampir",
  "No physical file is attached to this document.": "Tidak ada file fisik yang terlampir pada dokumen ini.",
  "No physical file uploaded": "Tidak ada file fisik yang diunggah",
  "No PO": "Tanpa PO",
  "No PO is linked to this IM yet": "Belum ada PO yang terhubung ke IM ini",
  "No PO is linked yet. Please upload or attach a PO file below.": "Belum ada PO yang terhubung. Silakan unggah atau attach berkas PO di bawah.",
  "No PO Yet": "Belum Ada PO",
  "No POs linked yet": "Belum ada PO terkait",
  "No procurement activity yet": "Belum ada aktivitas procurement",
  "No product data registered yet.": "Belum ada data produk yang terdaftar.",
  "No products match the keyword \"{searchQuery}\".": "Tidak ada produk yang sesuai dengan kata kunci \"{searchQuery}\".",
  "No progress logs.": "Tidak ada log progres.",
  "No progress updates found.": "Tidak ada pembaruan progres.",
  "No project code": "Tanpa kode proyek",
  "No projects found": "Tidak ada proyek ditemukan",
  "No Purchase Order documents found.": "Tidak ada dokumen Purchase Order yang ditemukan.",
  "No RCA Category": "Tanpa Kategori RCA",
  "No RCA data for current filters.": "Tidak ada data RCA untuk filter saat ini.",
  "No reason provided": "Tidak ada alasan",
  "No released snapshots yet.": "Belum ada snapshot yang dirilis.",
  "No replies yet. Discuss the mitigation here.": "Belum ada balasan. Diskusikan mitigasi di sini.",
  "No results for \"{search}\"": "Tidak ada hasil untuk \"{search}\"",
  "No risks registered": "Tidak ada risiko terdaftar",
  "No roles match your search.": "Tidak ada role yang sesuai dengan pencarian.",
  "No Rooms": "Tidak Ada Ruangan",
  "No RSL Data": "Tanpa Data RSL",
  "No S-Curve Data Yet": "Belum Ada Data S-Curve",
  "No S-Curve data yet.": "Belum ada data Kurva-S.",
  "No S-Curve Data Yet. Complete the WBS, Timeline, and Budget (GPI) first to generate the S-Curve automatically.": "Belum Ada Data S-Curve. Lengkapi WBS, Timeline, dan Budget (GPI) terlebih dahulu untuk memunculkan S-Curve secara otomatis.",
  "No sales order data registered yet.": "Belum ada data sales order yang terdaftar.",
  "No sales orders match the keyword \"{query}\".": "Tidak ada sales order yang sesuai dengan kata kunci \"{query}\".",
  "No Sales Orders need a fast track": "Tidak ada Sales Order yang perlu di-fast-track",
  "No saved signature yet": "Belum ada saved signature",
  "No Saved Signature Yet": "Belum Ada Tanda Tangan Tersimpan",
  "No saved signature yet. Please draw or upload a new signature.": "Belum ada tanda tangan tersimpan. Silakan gambar atau unggah TTD baru.",
  "No saved signature yet. Please use the 'Draw New' or 'Upload' tab.": "Belum ada tanda tangan tersimpan. Silakan gunakan tab 'Gambar Baru' atau 'Unggah'.",
  "No scope description available": "Tidak ada deskripsi lingkup",
  "No signature selected": "Belum ada tanda tangan yang dipilih",
  "No signature selected yet": "Belum ada tanda tangan yang dipilih",
  "No SO Yet": "Belum Ada SO",
  "No stage 1 approvers yet.": "Belum ada approver tahap 1.",
  "No stage transitions yet. This opportunity is still in the initial stage.": "Belum ada transisi tahap. Peluang ini masih di tahap awal.",
  "No stopclock remarks provided.": "Tidak ada catatan stopclock.",
  "No submissions yet": "Belum ada pengajuan",
  "No submitted SOs match the search keyword.": "Tidak ada SO submitted yang cocok dengan kata pencarian.",
  "No summary": "Tidak ada ringkasan",
  "No tasks found matching \"{searchQuery}\"": "Tidak ada tugas yang cocok dengan \"{searchQuery}\"",
  "No tasks found.": "Tidak ada tugas ditemukan.",
  "No tasks.": "Tidak ada task.",
  "No Template (Custom)": "Tanpa Template (Custom)",
  "No templates available for {filterType} projects.": "Tidak ada templat untuk proyek {filterType}.",
  "No templates found": "Tidak ada templat",
  "No ticket movement logs yet.": "Belum ada movement log tiket.",
  "No tickets match the current filters.": "Tidak ada tiket yang cocok dengan filter saat ini.",
  "No TPD ID matches “": "Tidak ada ID TPD yang cocok “",
  "No TPD is linked to this identified risk.": "Tidak ada TPD yang terkait dengan risiko teridentifikasi ini.",
  "No update history for this task yet.": "Belum ada riwayat update untuk task ini.",
  "No updates yet": "Belum ada pembaruan",
  "No users found.": "Tidak ada pengguna yang ditemukan.",
  "No values available": "Tidak ada nilai tersedia",
  "No vehicle booking history yet": "Belum ada riwayat pemesanan kendaraan",
  "No vehicles": "Tidak ada kendaraan",
  "No vehicles are available for this schedule. You can reject this booking.": "Tidak ada kendaraan yang tersedia pada jadwal ini. Anda dapat menolak booking ini.",
  "No vendor": "Tanpa vendor",
  "No vendors found": "Vendor tidak ditemukan",
  "No vendors found.": "Vendor tidak ditemukan.",
  "No visitor data in this period.": "Tidak ada data visitor pada periode ini.",
  "No visitor visits found": "Tidak ada kunjungan pengunjung",
  "No visitors": "Tidak ada visitor",
  "No WBS stages configured.": "Tidak ada tahap WBS yang dikonfigurasi.",
  "NO-ID": "TANPA-ID",
  "Non-Financial": "Non-Finansial",
  "Non-Project": "Non-Proyek",
  "Non-Project IM": "IM Non-Proyek",
  "None yet": "Belum ada",
  "Normalize the header and data": "Normalisasi header dan data",
  "Not active": "Belum aktif",
  "Not Approved": "Belum Approved",
  "Not assigned": "Belum ditetapkan",
  "Not available": "Tidak tersedia",
  "Not Available": "Tidak Tersedia",
  "Not closed yet": "Belum close",
  "Not enough data points to render Budget S-Curve": "Titik data tidak cukup untuk menampilkan Kurva-S Budget",
  "Not enough data points to render Progress S-Curve": "Titik data tidak cukup untuk menampilkan Kurva-S Progres",
  "Not found": "Tidak ditemukan",
  "Not Needed": "Tidak Perlu",
  "Not provided": "Tidak diisi",
  "Not set": "Belum diatur",
  "Not Started": "Belum Dimulai",
  "Not Submitted": "Belum Diajukan",
  "Not used": "Tidak digunakan",
  "Not yet": "Belum",
  "Not Yet Integrated": "Belum Terintegrasi",
  "Not Yet Submitted": "Belum Diajukan",
  "Note:": "Catatan:",
  "Notes": "Catatan",
  "Notes (Optional)": "Catatan (Opsional)",
  "Notes (required)": "Notes (wajib)",
  "Notes / Description": "Catatan / Deskripsi",
  "Notes / Reason (Optional)": "Catatan / Alasan (Opsional)",
  "Notes for AM": "Catatan untuk AM",
  "Notes returned to the Project Manager": "Catatan kembali ke Project Manager",
  "Notes returned to the requestor": "Catatan kembali ke requestor",
  "Notes:": "Catatan:",
  "Notification": "Notifikasi",
  "Notification Center": "Pusat Notifikasi",
  "Notification feed unavailable": "Umpan notifikasi tidak tersedia",
  "Notifications": "Notifikasi",
  "Occupied Schedule": "Jadwal Terpakai",
  "of": "dari",
  "Office": "Kantor",
  "Office & Operational Address": "Alamat Kantor & Operasional",
  "Old evidence is kept; this file will be created as the next version.": "Evidence lama tetap tersimpan; file ini akan dibuat sebagai versi berikutnya.",
  "Older versions remain immutable in Version History": "Versi lama tetap immutable di Version History",
  "on": "pada",
  "On Hold": "Ditahan",
  "On Progress": "Sedang Berjalan",
  "On Progress (Active Pipeline)": "Sedang Berjalan (Pipeline Aktif)",
  "On Track": "Sesuai Jalur",
  "One inbox for category, SA PIC, negotiation, and drop approval tasks.": "Satu inbox untuk tugas category, SA PIC, negotiation, dan drop approval.",
  "One is required": "Wajib salah satu",
  "One vendor master shared by Procurement, CRM, and Legal.": "Satu master vendor dipakai bersama oleh Procurement, CRM, dan Legal.",
  "One-way email": "Email satu arah",
  "ongoing across all PMs": "berjalan di seluruh PM",
  "Only files in the AiBAS TPD folder are deleted. Spreadsheets and source folders that were only attached remain safe.": "Hanya file yang berada di folder TPD AiBAS yang dihapus. Spreadsheet dan folder sumber yang hanya di-attach tetap aman.",
  "Only image files are allowed for signature picture.": "Hanya file gambar yang diizinkan untuk gambar tanda tangan.",
  "Only members tagged on this risk can reply to its discussion.": "Hanya anggota yang ditandai pada risiko ini yang dapat membalas diskusinya.",
  "Only SOs with Submitted or Approval Pending status.": "Hanya SO berstatus Submitted atau Approval Pending.",
  "OPEN": "BUKA",
  "Open": "Buka",
  "Open account settings": "Buka pengaturan akun",
  "Open Administration": "Buka Administration",
  "Open AiBAS": "Buka AiBAS",
  "Open Camera": "Buka Kamera",
  "Open Full Data": "Buka Data Penuh",
  "Open GPI Document Link": "Buka Tautan Dokumen GPI",
  "Open GPI Link": "Buka Tautan GPI",
  "Open GPI Studio": "Buka GPI Studio",
  "Open host list": "Buka daftar host",
  "Open IM Detail": "Buka Detail IM",
  "Open in Drive": "Buka di Drive",
  "Open in New Tab": "Buka di Tab Baru",
  "Open Link": "Buka Tautan",
  "Open master data": "Buka master data",
  "Open Module": "Buka Modul",
  "Open navigation menu": "Buka menu navigasi",
  "Open PDF": "Buka PDF",
  "Open Pipeline or Assignment": "Buka Pipeline atau Assignment",
  "Open Settings": "Buka Settings",
  "Open SO": "Buka SO",
  "Open the Customer master": "Buka master Customer",
  "Open the existing Sales Order": "Buka Sales Order yang ada",
  "Open the Purchase Order menu": "Buka menu Purchase Order",
  "Open Visitor Registration": "Buka Pendaftaran Pengunjung",
  "Opened:": "Dibuka:",
  "Operation": "Operasional",
  "Operational reports — meeting rooms, guest visits, and vehicle usage.": "Laporan operasional — ruang meeting, kunjungan tamu, dan penggunaan kendaraan.",
  "OPERATIONS": "OPERASIONAL",
  "Operations Dashboard": "Dasbor Operasional",
  "Operations follows up on the risk": "Operations menindaklanjuti risk",
  "Opportunities": "Peluang",
  "Opportunities (": "Peluang (",
  "Opportunity & Customer": "Peluang & Pelanggan",
  "Opportunity Amount": "Nilai Peluang",
  "Opportunity created successfully in Lead stage!": "Peluang berhasil dibuat di tahap Lead!",
  "Opportunity Details": "Detail Peluang",
  "Opportunity details": "Detail peluang",
  "Opportunity dropped successfully.": "Peluang berhasil di-drop.",
  "Opportunity KPIs and pipeline value": "KPI opportunity dan nilai pipeline",
  "Opportunity Name": "Nama Opportunity",
  "Opportunity not found": "Peluang tidak ditemukan",
  "Opportunity or IM": "Opportunity atau IM",
  "Opportunity restored successfully.": "Opportunity berhasil dikembalikan.",
  "Opportunity to SO Workflow": "Alur Peluang ke SO",
  "Optional": "Opsional",
  "Optional at Draft stage": "Opsional di tahap Draft",
  "Optional for the Others type; type to search.": "Opsional untuk tipe Others; ketik untuk mencari.",
  "Optional step": "Langkah opsional",
  "Optional, up to 2,000 characters.": "Opsional, maksimal 2.000 karakter.",
  "Optional, use percentage (e.g., 25 for 25%)": "Opsional, gunakan persentase (mis. 25 untuk 25%)",
  "Optional. Enter the amount in Rupiah, if any.": "Opsional. Masukkan nominal dalam Rupiah jika ada.",
  "OR": "ATAU",
  "or drag and drop": "atau seret dan lepas",
  "Original": "Asli",
  "Original (Asli)": "Asli",
  "Original Budget": "Budget Asli",
  "Original vs Revised Comparison": "Perbandingan Original vs Revised",
  "Other": "Lainnya",
  "Other Competences": "Kompetensi Lainnya",
  "other failures": "kegagalan lainnya",
  "Others": "Lainnya",
  "Out-of-City": "Luar Kota",
  "Over Budget": "Over Budget",
  "Overview": "Ikhtisar",
  "Overwrite the form message body when a template is selected": "Timpa isi pesan form saat template dipilih",
  "own data": "data sendiri",
  "Own data": "Data sendiri",
  "Page": "Halaman",
  "Page Not Found": "Halaman Tidak Ditemukan",
  "Page {current} of {total}": "Halaman {current} dari {total}",
  "Page {pageNum} ({value1})": "Halaman {pageNum} ({value1})",
  "Page {page}": "Halaman {page}",
  "Pages Approved": "Hal Di-approve",
  "Pagination": "Paginasi",
  "Part number and name are required": "Part number dan nama wajib diisi",
  "Participants:": "Peserta:",
  "Partner": "Mitra",
  "Partner & Asset List": "Daftar Mitra & Aset",
  "Partner / Customer *": "Mitra / Pelanggan *",
  "Partner Code": "Kode Partner",
  "Partner created successfully!": "Mitra berhasil dibuat!",
  "Partner database, subcontractor vendors, technical competency assessment, and Microsoft AX ERP integration.": "Database partner, vendor subkontraktor, penilaian kompetensi teknis, dan integrasi Microsoft AX ERP.",
  "Partner deleted successfully!": "Partner berhasil dihapus!",
  "Partner Name": "Nama Partner",
  "Partner Name is required!": "Nama Partner wajib diisi!",
  "Partner not found": "Partner tidak ditemukan",
  "Partner Profile": "Profil Mitra",
  "Partner Registration": "Registrasi Partner",
  "Partner {value1} successfully!": "Partner berhasil di{value1}!",
  "Partners": "Mitra",
  "Passenger Count": "Jumlah Penumpang",
  "Passengers": "Penumpang",
  "Password": "Kata Sandi",
  "Past 5 Weeks TT Volume": "Volume TT 5 Minggu Terakhir",
  "Pax": "Orang",
  "Payload Changes": "Perubahan Payload",
  "PDF and approval status are shown here.": "Status PDF dan persetujuan ditampilkan di sini.",
  "PDF Document Preview": "Pratinjau Dokumen PDF",
  "PDF Format": "Format PDF",
  "PDF or DOCX, up to 10 MB.": "PDF atau DOCX, maksimal 10 MB.",
  "PDF · DOCX · Max 10 MB": "PDF · DOCX · Maks 10 MB",
  "PDF, DOC, DOCX (Max 10MB)": "PDF, DOC, DOCX (Maks 10MB)",
  "PDP Compliance Rate": "Tingkat Kepatuhan PDP",
  "PDP Data": "Data PDP",
  "PDP Data Assets": "Aset Data PDP",
  "PDP Form": "Formulir PDP",
  "PDP List": "Daftar PDP",
  "PDP Request Details": "Detail Permintaan PDP",
  "PDP request submitted successfully!": "Permintaan PDP berhasil diajukan!",
  "Pending": "Menunggu",
  "Pending (": "Menunggu (",
  "Pending ({count})": "Menunggu ({count})",
  "Pending Approval": "Menunggu Approval",
  "Pending Estimate": "Estimasi Tertunda",
  "Pending SO": "SO Tertunda",
  "Pending Tasks": "Tugas Tertunda",
  "people": "orang",
  "Per Page:": "Per Hal:",
  "Performance summary of legal documents, contracts, and PDP compliance status.": "Ringkasan performa dokumen legal, kontrak, dan status kepatuhan PDP.",
  "Period": "Periode",
  "Perjanjian": "Perjanjian",
  "permanent and cannot be undone": "permanen dan tidak dapat dibatalkan",
  "Permission active": "Permission aktif",
  "Permission is not available for this feature": "Permission tidak tersedia untuk fitur ini",
  "Permission not available": "Permission tidak tersedia",
  "Permits": "Perizinan",
  "Personal": "Pribadi",
  "Personal Information": "Informasi Pribadi",
  "Phone": "Telepon",
  "Phone / Contact No.": "No. Telepon / Kontak",
  "Phone / WhatsApp Number": "Nomor Telepon / WA",
  "Phone No.": "No. Telp",
  "Phone Number": "Nomor Telepon",
  "Physical Form": "Bentuk Fisik",
  "Physical Location (File Location)": "Lokasi Fisik (File Location)",
  "Physical Location (Lemari/Rak)": "Lokasi Fisik (Lemari/Rak)",
  "Physical Progress": "Progres Fisik",
  "Physical Status": "Status Fisik",
  "PIC Email": "Email PIC",
  "PIC Full Name": "Nama Lengkap PIC",
  "PIC Name": "Nama PIC",
  "Pick either one from the Stage 1 approver list — either may act first.": "Bebas memilih salah satu dari daftar Approver Tahap 1 — siapa pun boleh memproses lebih dulu.",
  "Pick either one; the document is submitted to the approval circulation right after saving.": "Bebas pilih salah satu; dokumen langsung diajukan ke Approval Circulir setelah disimpan.",
  "Picture E-Sign Submitted": "E-Sign Gambar Diajukan",
  "Pipeline data import successful!": "Import data pipeline berhasil!",
  "Pipeline Error": "Kesalahan Pipeline",
  "Pipeline Growth": "Pertumbuhan Pipeline",
  "Pipeline Growth (YTD)": "Pertumbuhan Pipeline (YTD)",
  "Pipeline Status": "Status Pipeline",
  "Pipeline Value": "Nilai Pipeline",
  "Planned (PV)": "Rencana (PV)",
  "Planned :": "Rencana :",
  "Planned Budget": "Budget Rencana",
  "Planned Progress": "Progres Rencana",
  "Please choose a PO document file.": "Mohon pilih file dokumen PO.",
  "Please choose Draw New or Upload to save a usable signature.": "Silakan pilih Gambar Baru atau Upload untuk menyimpan tanda tangan yang dapat digunakan.",
  "Please complete all required fields": "Mohon lengkapi semua kolom yang wajib diisi",
  "Please complete required fields": "Mohon lengkapi kolom yang wajib diisi",
  "Please complete the qualification data. This will be reviewed by Head of SA before moving to Proposal.": "Mohon lengkapi data kualifikasi. Ini akan ditinjau oleh Head of SA sebelum maju ke Proposal.",
  "Please complete this step before proceeding.": "Mohon selesaikan langkah ini sebelum melanjutkan.",
  "Please complete your signature first.": "Silakan lengkapi tanda tangan terlebih dahulu.",
  "Please draw your signature first.": "Silakan gambar tanda tangan Anda terlebih dahulu.",
  "Please enter a drop reason": "Mohon masukkan alasan drop",
  "Please fill in Budget, Sales Value, and Margin.": "Harap isi Budget, Sales Value, dan Margin.",
  "Please fill start and end date time": "Mohon isi tanggal dan waktu mulai serta selesai",
  "Please provide a reason for dropping this contact": "Mohon berikan alasan untuk membatalkan kontak ini",
  "Please provide a reason for dropping this opportunity.": "Mohon berikan alasan untuk membatalkan peluang ini.",
  "Please provide a reason to drop this deal.": "Mohon berikan alasan untuk membatalkan deal ini.",
  "Please provide a rejection reason": "Mohon berikan alasan penolakan",
  "Please reload this page. If this keeps happening, check logs and report the action that triggered it.": "Silakan muat ulang halaman ini. Jika terus terjadi, periksa log dan laporkan aksi yang memicunya.",
  "Please review the request details and attached document, then click the button below to approve.": "Mohon tinjau detail permintaan dan dokumen terlampir, lalu klik tombol di bawah untuk menyetujui.",
  "Please select a category": "Mohon pilih kategori",
  "Please select a Company and Document Category first": "Harap pilih Company dan Kategori Dokumen terlebih dahulu",
  "Please select a file": "Mohon pilih file",
  "Please select a file first": "Tolong pilih file terlebih dahulu",
  "Please select a PO document file.": "Mohon pilih file dokumen PO.",
  "Please select a signature image first.": "Silakan pilih gambar tanda tangan terlebih dahulu.",
  "Please select a task to update.": "Mohon pilih tugas untuk diperbarui.",
  "Please select an existing PO first.": "Mohon pilih PO yang sudah ada terlebih dahulu.",
  "Please select an SA PIC": "Mohon pilih PIC SA",
  "Please select at least one Requester (Booking For)": "Mohon pilih setidaknya satu Pemohon (Pemesanan Untuk)",
  "Please specify...": "Mohon tentukan...",
  "Please submit it manually from the document details.": "Silakan ajukan manual dari detail dokumen.",
  "Please upload a file or enter a SharePoint/Drive link.": "Harap upload file atau masukkan link SharePoint/Drive.",
  "Please upload a signature image first.": "Silakan unggah gambar tanda tangan terlebih dahulu.",
  "Please use the new signature drawing option.": "Silakan gunakan opsi gambar tanda tangan baru.",
  "PMM or NPD": "PMM atau NPD",
  "PMM or NPD receives the assignment": "PMM atau NPD menerima penugasan",
  "PMO Edit Mode": "Mode Edit PMO",
  "PMO or approver": "PMO atau approver",
  "PMO or Operations": "PMO atau Operations",
  "PNG, JPG, PDF up to 10MB": "PNG, JPG, PDF hingga 10MB",
  "PO available": "PO tersedia",
  "PO Date": "Tanggal PO",
  "PO Document": "Dokumen PO",
  "PO document": "Dokumen PO",
  "PO Document File (PDF/JPG/PNG)": "Berkas Dokumen PO (PDF/JPG/PNG)",
  "PO Document Metadata": "Metadata Dokumen PO",
  "PO Estimate": "Estimasi PO",
  "PO Estimate (IDR)": "Estimasi PO (IDR)",
  "PO estimate and GPI approved?": "Estimasi PO dan GPI approved?",
  "PO estimate and GPI validation before approval to move to Negotiation.": "Validasi estimasi PO dan GPI sebelum approval menuju Negotiation.",
  "PO Estimate is required for moving to Negotiation stage": "Estimasi PO wajib diisi untuk maju ke tahap Negosiasi",
  "PO Estimate must be a valid positive number": "Estimasi PO harus berupa angka positif yang valid",
  "PO Estimate, GPI Link or GPI File, and Authority (for Proposal → Negotiation)": "Estimasi PO, Tautan GPI atau File GPI, dan Otoritas (untuk Proposal → Negosiasi)",
  "PO Estimate:": "Estimasi PO:",
  "PO Estimate: Added via Negotiation Approval": "Estimasi PO: Ditambahkan melalui Persetujuan Negosiasi",
  "PO Estimate: via Negotiation Approval": "Estimasi PO: melalui Persetujuan Negosiasi",
  "PO ID:": "ID PO:",
  "PO Issue Date Commitment": "Komitmen Tanggal Terbit PO",
  "PO Line Number": "Nomor Baris PO",
  "PO Metadata": "Metadata PO",
  "PO not available yet": "PO belum tersedia",
  "PO Number": "Nomor PO",
  "PO PDF preview": "Pratinjau PDF PO",
  "PO preview": "Pratinjau PO",
  "PO Release Status:": "Status Release PO:",
  "PO upload failed.": "Unggah PO gagal.",
  "PO Uploaded Successfully": "Berhasil Mengunggah PO",
  "PO Uploader": "Pengunggah PO",
  "PO Value (IDR)": "Nilai PO (IDR)",
  "PO Value (IDR) — Excl. VAT": "Nilai PO (IDR) — Excl. PPN",
  "PO Value (IDR) — Exclude PPN": "Nilai PO (IDR) — Tidak Termasuk PPN",
  "Poor": "Buruk",
  "Portfolio EVM Trend": "Tren EVM Portofolio",
  "Portfolio is currently stable with no projects in Warning or Critical state.": "Portofolio saat ini stabil tanpa proyek dalam status Peringatan atau Kritis.",
  "Portfolio Score": "Skor Portofolio",
  "POs Linked to This SO (": "PO Terhubung ke SO Ini (",
  "Position": "Jabatan",
  "Position & NIP": "Jabatan & NIP",
  "Position / Job Title": "Posisi / Jabatan",
  "Position / Title": "Jabatan / Posisi",
  "Position:": "Posisi:",
  "Post progress": "Posting progres",
  "Pre-Assessment Score": "Skor Pre-Assessment",
  "Pre-filled from Analyst": "Terisi otomatis dari Analis",
  "Preferences": "Preferensi",
  "Prepare": "Persiapan",
  "Prepare master data": "Siapkan master data",
  "Prepare solution support for the Proposal": "Siapkan dukungan solusi untuk Proposal",
  "Prepare tasks and the operational baseline": "Siapkan task dan baseline operasional",
  "Prepare the customer, contact, and product masters": "Siapkan master customer, contact, dan product",
  "Prepare the GPI": "Siapkan GPI",
  "Prepare the PO or IM and GPI": "Siapkan PO atau IM dan GPI",
  "Prepare the WBS and Timeline": "Siapkan WBS dan Timeline",
  "Preparing CSV...": "Menyiapkan CSV...",
  "Preparing Dashboard...": "Menyiapkan Dashboard...",
  "Preparing PDF…": "Menyiapkan PDF…",
  "Preparing the signature size to match the final PDF…": "Menyiapkan ukuran TTD sesuai PDF final…",
  "Preparing {length} task date rows for download...": "Menyiapkan {length} baris task dates untuk diunduh...",
  "Preparing...": "Menyiapkan...",
  "Prev": "Sebelumnya",
  "Preview": "Pratinjau",
  "PREVIEW": "PRATINJAU",
  "Preview appears after selecting a file.": "Pratinjau muncul setelah memilih file.",
  "Preview failed.": "Pratinjau gagal.",
  "Preview is not supported for this file type.": "Pratinjau tidak didukung untuk tipe berkas ini.",
  "Preview not supported for this file type.": "Pratinjau tidak didukung untuk tipe file ini.",
  "Previous": "Sebelumnya",
  "Previous Page": "Halaman Sebelumnya",
  "Previous page": "Halaman sebelumnya",
  "Previous State": "Kondisi Sebelumnya",
  "Previous Version Approval": "Persetujuan Versi Sebelumnya",
  "Previous:": "Sebelumnya:",
  "Price (IDR) *": "Harga (IDR) *",
  "Pricing & Unit": "Harga & Satuan",
  "Priority": "Prioritas",
  "Priority Actions": "Tindakan Prioritas",
  "Priority Email Dispatch": "Pengiriman Email Prioritas",
  "Probability": "Probabilitas",
  "Process Complete": "Proses Selesai",
  "Process Drive": "Proses Drive",
  "Process File": "Proses File",
  "PROCESS FLOW": "ALUR PROSES",
  "Process Flow": "Alur Proses",
  "Process the PO status": "Proses status PO",
  "Process the related items": "Proses item terkait",
  "Processed:": "Diproses:",
  "Processing Data...": "Memproses Data...",
  "Processing evidence": "Memproses evidence",
  "Processing evidence...": "Memproses evidence...",
  "Processing Method": "Metode Pemrosesan",
  "Processing...": "Memproses...",
  "PROCESSING...": "MEMPROSES...",
  "Processing…": "Memproses…",
  "PROCUREMENT": "PROCUREMENT",
  "Procurement Approval Settings": "Pengaturan Persetujuan Procurement",
  "Procurement Audit Log": "Log Audit Procurement",
  "procurement documents": "dokumen procurement",
  "Procurement Documents": "Dokumen Procurement",
  "Procurement documents you create will appear in this register.": "Dokumen procurement yang dibuat akan tampil di register ini.",
  "Procurement PO": "PO Procurement",
  "Procurement Type": "Tipe Pengadaan",
  "Search Procurement ID, number, name, project, or vendor...": "Cari ID Procurement, nomor, nama, proyek, atau vendor...",
  "Select at least one procurement type.": "Pilih minimal satu tipe pengadaan.",
  "Pick one or both.": "Pilih salah satu atau keduanya.",
  "Material": "Material",
  "Procurement ID": "ID Procurement",
  "Procurement type": "Tipe procurement",
  "Procurement Vendors": "Vendor Procurement",
  "Product": "Produk",
  "Product & Solution Catalog": "Katalog Produk & Solusi",
  "Product / Service Name": "Nama Produk / Layanan",
  "Product Category": "Kategori Produk",
  "Product created successfully!": "Produk berhasil dibuat!",
  "Product Data Not Found": "Data Produk Tidak Ditemukan",
  "Product deleted successfully!": "Product berhasil dihapus!",
  "Product Details": "Detail Produk",
  "Product Information Details": "Detail Informasi Produk",
  "Product Name *": "Nama Produk *",
  "Products": "Produk",
  "Progress": "Progres",
  "PROGRESS": "PROGRES",
  "Progress (Actual)": "Progres (Aktual)",
  "Progress (Planned)": "Progres (Rencana)",
  "Progress Accumulation Plan (%)": "Rencana Akumulasi Progress (%)",
  "Progress Description": "Deskripsi Progres",
  "Progress history": "Riwayat progres",
  "Progress Journey": "Perjalanan Progres",
  "Progress Log (Handling Time UI)": "Log Progres (UI Waktu Penanganan)",
  "progress points ·": "titik progres ·",
  "Progress posted": "Progres diposting",
  "Progress posted and TPD marked as done": "Progres diposting dan TPD ditandai selesai",
  "Progress Reset": "Reset Progres",
  "Progress reset failed to process.": "Reset progress gagal diproses.",
  "Progress S-Curve (Expanded View)": "Kurva-S Progres (Tampilan Diperluas)",
  "Progress stage: via CRM Pipeline / approval flow": "Kemajuan tahap: melalui Pipeline CRM / alur persetujuan",
  "Progress this opportunity to Deal, then create the SO draft.": "Majukan peluang ini ke Deal, lalu buat draf SO.",
  "Progress to Next Stage": "Maju ke Tahap Berikutnya",
  "Most Active Stage": "Tahap Paling Aktif",
  "Planned to date": "Rencana hingga hari ini",
  "vs plan": "dari rencana",
  "Progress Update": "Pembaruan Progres",
  "Progress Update History": "Riwayat Pembaruan Progres",
  "Progress Update Terminal": "Terminal Pembaruan Progres",
  "Progress:": "Progres:",
  "Project": "Proyek",
  "Project & Customer": "Proyek & Pelanggan",
  "Project / Vendor": "Proyek / Vendor",
  "Project At Risk": "Proyek Berisiko",
  "Project Audit Log": "Log Audit Proyek",
  "Project Brief": "Ringkasan Proyek",
  "Project Brief (always required)": "Ringkasan Proyek (selalu wajib)",
  "Project Brief / Notes": "Ringkasan Proyek / Catatan",
  "Project Brief / Update": "Ringkasan Proyek / Pembaruan",
  "Project brief added successfully!": "Ringkasan proyek berhasil ditambahkan!",
  "Project brief available": "Project brief tersedia",
  "Project Brief is required": "Ringkasan Proyek wajib diisi",
  "Project brief is required": "Ringkasan proyek wajib diisi",
  "Project Budget": "Budget Proyek",
  "Project Category": "Kategori Proyek",
  "Project Code": "Kode Proyek",
  "Project Code Identity:": "Identitas Kode Proyek:",
  "Project Details": "Detail Proyek",
  "Project duration": "Durasi proyek",
  "Project File Link (Optional)": "Tautan File Proyek (Opsional)",
  "Project Intake": "Penerimaan Proyek",
  "Project Link": "Tautan Proyek",
  "Project List": "Daftar Proyek",
  "Project Manager": "Manajer Proyek",
  "Project Manager responsibilities for SO planning and OPS project execution.": "Tanggung jawab Project Manager pada perencanaan SO dan eksekusi project OPS.",
  "Project Meta": "Meta Proyek",
  "Project Metadata": "Metadata Proyek",
  "Project Name": "Nama Proyek",
  "Project Overview Summary": "Ringkasan Proyek",
  "Project not available yet": "Project belum tersedia",
  "Project not found": "Proyek tidak ditemukan",
  "Project Operations": "Operasional Proyek",
  "Project or Released SO": "Project atau SO Released",
  "Project S-Curve": "Kurva-S Proyek",
  "Project Scope": "Lingkup Proyek",
  "Project Stages": "Tahap Proyek",
  "Project Type": "Tipe Proyek",
  "Project:": "Proyek:",
  "Projects": "Proyek",
  "Propose Close": "Usulkan Penutupan",
  "Protected & Active": "Terlindungi & Aktif",
  "Provide a clear reason...": "Berikan alasan yang jelas...",
  "Provide detailed information about what needs to be changed in this project. The Sales Admin will review and process this request manually.": "Berikan informasi terperinci tentang apa yang perlu diubah pada proyek ini. Sales Admin akan meninjau dan memproses permintaan ini secara manual.",
  "Provide details about this negotiation round": "Berikan detail tentang putaran negosiasi ini",
  "Provide reason if rejecting...": "Berikan alasan jika menolak...",
  "Province": "Provinsi",
  "Purchase Order": "Purchase Order",
  "Purpose": "Tujuan",
  "Purpose and Objective is required": "Maksud dan Tujuan wajib diisi",
  "Purpose of Request *": "Tujuan Permintaan *",
  "Purpose of visit": "Tujuan kunjungan",
  "PV (Planned) :": "PV (Rencana) :",
  "Qty": "Jml",
  "Qty:": "Jml:",
  "Qualification → Proposal Requirements": "Persyaratan Kualifikasi → Proposal",
  "Quantity": "Kuantitas",
  "Queue": "Antrean",
  "Quick Actions": "Aksi Cepat",
  "Quick Navigation": "Navigasi Cepat",
  "Quick Stats": "Statistik Cepat",
  "Raise the Lead stage to Opportunity": "Naikkan stage Lead ke Opportunity",
  "Raise the SO target version": "Naikkan target versi SO",
  "RBAC Matrix": "Matriks RBAC",
  "RBAC Matrix Editor": "Editor Matriks RBAC",
  "RCA & Last RSL": "RCA & RSL Terakhir",
  "RCA Analytics": "Analitik RCA",
  "RCA Analytics from Live Tickets": "Analitik RCA dari Tiket Langsung",
  "RCA Attachment": "Lampiran RCA",
  "RCA Cancel": "RCA Dibatalkan",
  "RCA Category": "Kategori RCA",
  "RCA Category *": "Kategori RCA *",
  "RCA Close": "RCA Ditutup",
  "RCA Detail": "Detail RCA",
  "RCA Detail Table": "Tabel Detail RCA",
  "RCA distribution donut based on filtered tickets": "Donut distribusi RCA berdasarkan ticket terfilter",
  "RCA distribution donut with color per RCA category": "Donut distribusi RCA dengan warna per kategori RCA",
  "RCA Library": "Pustaka RCA",
  "RCA Split": "Pembagian RCA",
  "RCA ticket count per week (top RCA)": "Jumlah tiket RCA per minggu (top RCA)",
  "RCA ticket count per week for the top RCA": "Jumlah ticket RCA per minggu untuk top RCA",
  "RCA Weekly Volume": "Volume RCA Mingguan",
  "Re-upload the Excel file you have filled in.": "Unggah kembali file Excel yang sudah Anda isi.",
  "Read": "Dibaca",
  "read on this page": "sudah dibaca di halaman ini",
  "Read Only": "Hanya Baca",
  "Read:": "Dibaca:",
  "Readiness Checklist": "Daftar Periksa Kesiapan",
  "Reading batch data and preparing evidence": "Membaca data batch dan menyiapkan evidence",
  "Reading Excel File": "Membaca Berkas Excel",
  "Ready": "Siap",
  "Ready for use by the CRM process": "Siap digunakan oleh proses CRM",
  "Ready to approve": "Siap disetujui",
  "Ready to be submitted for approval": "Siap diajukan untuk approval",
  "Ready to enter Qualification 50%": "Siap masuk Qualification 50%",
  "Ready to mark Done after posting.": "Siap ditandai Selesai setelah diposting.",
  "Ready to Resubmit": "Siap Diajukan Ulang",
  "Ready to Submit Revision": "Siap Mengajukan Revisi",
  "Ready to upload": "Siap diunggah",
  "Ready to upload - Save to confirm": "Siap diunggah - Simpan untuk mengonfirmasi",
  "Real-time portfolio monitoring, EVM progress, and health metrics.": "Pemantauan portofolio real-time, progres EVM, dan metrik kesehatan.",
  "Reason": "Alasan",
  "Reason for dropping": "Alasan drop",
  "Reason for Extension": "Alasan Perpanjangan",
  "Reason/brief is required": "Alasan/ringkasan wajib diisi",
  "Reassign": "Tugaskan Ulang",
  "Receive the project for execution": "Terima project untuk eksekusi",
  "Receive the review result and the PMM or NPD PIC": "Terima hasil review dan PIC PMM atau NPD",
  "Recent Activity": "Aktivitas Terkini",
  "Receptionist Checklist": "Checklist Resepsionis",
  "Reconciliation:": "Rekonsiliasi:",
  "records": "catatan",
  "Redirecting to Assignments...": "Mengalihkan ke Penugasan...",
  "Redirecting to Services Dashboard...": "Mengalihkan ke Dasbor Layanan...",
  "Redirecting...": "Mengalihkan...",
  "Reference Item": "Item Referensi",
  "Refresh": "Muat Ulang",
  "Refresh from Assets": "Muat Ulang dari Aset",
  "Refresh Queue": "Refresh Antrean",
  "Refresh RBAC": "Muat Ulang RBAC",
  "Refreshed {count} sites": "{count} site diperbarui",
  "Refreshing...": "Memuat ulang...",
  "Reg. Date": "Tgl Registrasi",
  "Regenerate PDF": "Buat Ulang PDF",
  "Region": "Wilayah",
  "Register a new visitor or change filter": "Daftarkan pengunjung baru atau ubah filter",
  "Register a risk first to start its discussion.": "Daftarkan risiko terlebih dahulu untuk memulai diskusinya.",
  "Register New Risk": "Daftarkan Risiko Baru",
  "Register New Visitor": "Daftarkan Pengunjung Baru",
  "Register of procurement documents and their active attachments.": "Register dokumen procurement dan attachment aktif.",
  "Register the client company identity, AX ERP code, market type, and operational address.": "Daftarkan identitas badan usaha klien, kode ERP AX, tipe pasar, dan alamat operasional.",
  "Register the product SKU, unit price, unit of measure, and Microsoft AX ERP integration.": "Daftarkan SKU produk, harga satuan, satuan (unit), dan integrasi Microsoft AX ERP.",
  "Register the vendor identity, contact number, technical competencies, and initial audit information.": "Daftarkan identitas vendor, nomor kontak, kompetensi teknis, dan informasi audit awal.",
  "Register Visitor": "Daftarkan Pengunjung",
  "Registered Roles": "Roles Terdaftar",
  "Registration": "Registrasi",
  "Registration Date": "Tanggal Registrasi",
  "Registration submitted successfully": "Pendaftaran berhasil dikirim",
  "Registry": "Registri",
  "Reject": "Tolak",
  "reject": "menolak",
  "REJECT": "TOLAK",
  "Reject Booking": "Tolak Pemesanan",
  "Reject failed.": "Penolakan gagal.",
  "Reject IM": "Tolak IM",
  "Reject Internal Memo": "Tolak Internal Memo",
  "Reject the next step": "Reject step berikutnya",
  "Reject Visitor Request": "Tolak Permintaan Pengunjung",
  "Rejected": "Ditolak",
  "rejected": "menolak",
  "Rejected status": "Status Ditolak",
  "Rejection Reason": "Alasan Penolakan",
  "Rejection Reason: {rejection_reason}": "Alasan Penolakan: {rejection_reason}",
  "Related Modules": "Modul Terkait",
  "Related Party": "Pihak Terkait",
  "Related Party (Counterpart)": "Pihak Terkait (Counterpart)",
  "Related Sales Order (Optional)": "Sales Order Terkait (Opsional)",
  "Related To": "Berhubungan Dengan",
  "Release a new version": "Release versi baru",
  "Release author unavailable": "Pembuat rilis tidak tersedia",
  "Release decision": "Keputusan release",
  "Release the SO and create a snapshot": "Release SO dan buat snapshot",
  "Release the SO and create or sync the OPS Project": "Release SO dan buat atau sync Project OPS",
  "Released": "Dirilis",
  "Released by {name}": "Dirilis oleh {name}",
  "Reload documents": "Muat ulang dokumen",
  "Sort by last updated": "Urutkan berdasarkan terakhir diperbarui",
  "Latest updated": "Pembaruan terbaru",
  "Earliest updated": "Pembaruan terlama",
  "Default order": "Urutan bawaan",
  "Click to change the order": "Klik untuk mengubah urutan",
  "Reload Page": "Muat Ulang Halaman",
  "Relocation Reason (Optional)": "Alasan Relokasi (Opsional)",
  "Remaining Budget": "Sisa Anggaran",
  "Remaining Capacity": "Sisa Kapasitas",
  "remaining steps are processed using each approver's own signature, then the release, project intake, audit log, notifications, and PDF regeneration are run.": "step tersisa yang diproses memakai TTD masing-masing, lalu release, project intake, audit log, notifikasi, dan regenerasi PDF dijalankan.",
  "Remaining:": "Sisa:",
  "Remind (Notes)": "Remind (Catatan)",
  "Reminder Alert": "Pengingat",
  "Remove": "Hapus",
  "Remove evidence file": "Hapus file bukti",
  "Remove selected file": "Hapus file terpilih",
  "Remove Stage": "Hapus Tahap",
  "Remove Step": "Hapus Step",
  "Remove TPD {tpd_id}": "Hapus TPD {tpd_id}",
  "Remove vendor {value1}": "Hapus vendor {value1}",
  "Remove {label}": "Hapus {label}",
  "Remove {name}": "Hapus {name}",
  "Repair": "Perbaikan",
  "Replace": "Ganti",
  "Replace File": "Ganti File",
  "Report exported successfully": "Laporan berhasil diekspor",
  "Reporting Center": "Pusat Pelaporan",
  "Reports": "Laporan",
  "Request approved successfully": "Permintaan berhasil disetujui",
  "Request changes to SO details (e.g., Qty, TPD, Timeline). Changes will be processed by Sales Admin.": "Minta perubahan pada detail SO (mis. Qty, TPD, Linimasa). Perubahan akan diproses oleh Sales Admin.",
  "Request Details": "Detail Permintaan",
  "Request failed ({status}). Please refresh and try again.": "Permintaan gagal ({status}). Silakan muat ulang dan coba lagi.",
  "Request ID:": "ID Permintaan:",
  "Request not found": "Permintaan tidak ditemukan",
  "Request PDP": "Permintaan PDP",
  "Requested by": "Diminta oleh",
  "Requested By": "Diminta Oleh",
  "Requested Unit": "Unit Diminta",
  "Requested unit": "Unit yang diminta",
  "Requested Value": "Nilai yang Diminta",
  "Requested Value (IDR)": "Nilai yang Diminta (IDR)",
  "Requester": "Pemohon",
  "Requester Email": "Email Pemohon",
  "Requester Information": "Informasi Pemohon",
  "Requestor": "Pemohon",
  "Requests received this week": "Permintaan masuk minggu ini",
  "Required at 100%": "Wajib di 100%",
  "Required Fields:": "Kolom Wajib:",
  "Required for moving to Negotiation stage": "Wajib untuk maju ke tahap Negosiasi",
  "Required for transitioning from Lead to Opportunity": "Wajib untuk transisi dari Lead ke Peluang",
  "Required for transitioning to Qualification stage": "Wajib untuk transisi ke tahap Kualifikasi",
  "Required permission:": "Izin yang diperlukan:",
  "Required when moving from Opportunity to Qualification": "Wajib saat maju dari Peluang ke Kualifikasi",
  "Reserve": "Pesan",
  "Reset 7-day timer for this opportunity": "Atur ulang timer 7 hari untuk peluang ini",
  "Reset all filters": "Reset semua filter",
  "Reset All GPI Data": "Reset Seluruh Data GPI",
  "Reset all project progress": "Reset seluruh progress project",
  "Reset diagram size": "Kembalikan ukuran diagram",
  "Reset Filters": "Reset Filter",
  "Reset Project Progress": "Reset Progress Project",
  "Reset reason": "Alasan reset",
  "Reset to 100%": "Kembalikan ke 100%",
  "Resetting progress...": "Mereset progress...",
  "Resetting...": "Mereset...",
  "Resolved in {value1}": "Selesai dalam {value1}",
  "Responsibilities for intake, monitoring, and project update control after the SO is released.": "Tanggung jawab intake, monitoring, dan kontrol update project setelah SO dirilis.",
  "Responsibilities for sequential approval of PO, IM, SO, and Change Requests.": "Tanggung jawab approval PO, IM, SO, dan Change Request secara berurutan.",
  "Responsibilities for template configuration, approval rules, access, and oversight.": "Tanggung jawab konfigurasi template, approval rules, akses, dan oversight.",
  "Responsibilities of the Head of SA and the PMM/NPD PIC for Qualification and Proposal.": "Tanggung jawab Head of SA serta PIC PMM/NPD pada Qualification dan Proposal.",
  "Responsibility": "Tanggung Jawab",
  "Restore": "Pulihkan",
  "Restricted Access": "Akses Terbatas",
  "Resubmit": "Submit Ulang",
  "Resubmit failed.": "Resubmit gagal.",
  "Resubmit for Approval": "Ajukan Ulang untuk Persetujuan",
  "Results": "Hasil",
  "results. Type a more specific TPD ID to narrow the list.": "hasil pertama. Ketik ID TPD yang lebih spesifik untuk mempersempit daftar.",
  "Retake Photo": "Ambil Ulang Foto",
  "Retention Period *": "Periode Retensi *",
  "Retry": "Coba Lagi",
  "Retry Sync": "Coba Sinkron Lagi",
  "Return the notes to the Account Manager": "Kembalikan catatan ke Account Manager",
  "Return to Draft V1 to redo the approval.": "Kembali ke Draft V1 untuk mengulang approval.",
  "Return to Projects": "Kembali ke Proyek",
  "Return to the Account Manager": "Kembalikan ke Account Manager",
  "Return to {rollbackTarget}. All released version signatures are preserved.": "Kembali ke {rollbackTarget}. Seluruh TTD versi released tetap tersimpan.",
  "Revenue": "Pendapatan",
  "Revenue Intelligence": "Intelijen Pendapatan",
  "Revenue Market Share": "Pangsa Pasar Pendapatan",
  "Revenue − Cost": "Pendapatan − Biaya",
  "Review": "Tinjau",
  "Review & Process": "Tinjau & Proses",
  "Review & Process Document": "Tinjau & Proses Dokumen",
  "Review & Sign Document": "Tinjau & Tanda Tangani Dokumen",
  "Review and give approval decisions on Internal Memo documents assigned to you.": "Review dan berikan keputusan persetujuan dokumen Internal Memo yang ditugaskan kepada Anda.",
  "Review Budget, Authority, Needs, and Timeline": "Review Budget, Authority, Needs, dan Timeline",
  "Review revision requests submitted by the OPS team.": "Tinjau permintaan revisi yang diajukan oleh tim OPS.",
  "Review the progress update": "Review progress update",
  "Review the update": "Review update",
  "Review this generated PDF before submitting the SO for approval.": "Tinjau PDF yang dihasilkan ini sebelum mengajukan SO untuk persetujuan.",
  "Revise Data": "Revisi Data",
  "Revise into a new version then resubmit": "Revisi versi baru lalu submit ulang",
  "Revise the proposal per the notes": "Revisi proposal sesuai catatan",
  "Revise the qualification per the notes": "Revisi qualification sesuai catatan",
  "Revised Budget (Approval)": "Budget Revisi (Persetujuan)",
  "Revision": "Revisi",
  "Revision Draft": "Draf Revisi",
  "Revision draft active": "Draf revisi aktif",
  "Revision failed.": "Revisi gagal.",
  "Rises to Opportunity 25%": "Naik ke Opportunity 25%",
  "RISK": "RISIKO",
  "Risk Distribution": "Distribusi Risiko",
  "Risk factor": "Faktor risiko",
  "Risk or Critical status?": "Status Risk atau Critical?",
  "Risk registered": "Risiko terdaftar",
  "Risk was created, but the attachment could not be uploaded. Check Google Drive folder access and try again.": "Risiko dibuat, tetapi lampiran tidak dapat diunggah. Periksa akses folder Google Drive dan coba lagi.",
  "RKAP Status": "Status RKAP",
  "RKAP Status:": "Status RKAP:",
  "Role Access Assignment (RBAC)": "Penetapan Hak Akses Role (RBAC)",
  "Role access configuration saved successfully!": "Konfigurasi hak akses role berhasil disimpan!",
  "Role Assignment": "Penugasan Role",
  "Role deleted successfully!": "Role berhasil dihapus!",
  "role groups": "grup role",
  "Role Matrix Configuration": "Konfigurasi Matrix Role",
  "Role Name (slug format, e.g. sales_manager)": "Nama Role (slug format, misal: sales_manager)",
  "Role name is required": "Nama role wajib diisi",
  "Role System": "Role Sistem",
  "roles selected": "role dipilih",
  "Rollback Available": "Rollback Tersedia",
  "Rollback to {rollbackTarget}": "Rollback ke {rollbackTarget}",
  "Room": "Ruangan",
  "Room #{room_id}": "Ruangan #{room_id}",
  "Room not found": "Ruangan tidak ditemukan",
  "Room relocated successfully": "Ruangan berhasil direlokasi",
  "Rooms": "Ruangan",
  "Route to the Chief Sales": "Route ke Chief Sales",
  "Route to the next assignment or approval": "Route assignment atau approval berikutnya",
  "Routing Rule": "Aturan Alur",
  "Row": "Baris",
  "row is a Task ID": "baris adalah Task ID",
  "rows": "baris",
  "Rows that exceed the 4-hour SLA are colored red.": "Baris yang melewati SLA 4 jam akan diwarnai merah.",
  "Rows with MTTR greater than": "Baris dengan MTTR lebih dari",
  "Rows:": "Baris:",
  "S-Curve": "Kurva-S",
  "S-Curve data is not yet available or incomplete.": "Data S-Curve belum tersedia atau belum lengkap.",
  "S-Curve Preview": "Pratinjau Kurva-S",
  "S-Curve Projection": "Proyeksi Kurva-S",
  "S-Curve tab": "tab Kurva-S",
  "SA PIC": "PIC SA",
  "SA PIC: Assigned via Task Assignment workflow": "PIC SA: Ditetapkan melalui alur Penugasan Tugas",
  "Safe! No urgent contracts.": "Aman! Tidak ada kontrak yang mendesak.",
  "Safety Induction": "Induksi Keselamatan",
  "Sales": "Penjualan",
  "SALES CRM": "CRM PENJUALAN",
  "Sales CRM": "CRM Penjualan",
  "Sales Order created successfully!": "Sales Order berhasil dibuat!",
  "Sales Order Data Not Found": "Data Sales Order Tidak Ditemukan",
  "Sales Order detail is unavailable.": "Detail Sales Order tidak tersedia.",
  "Sales Order Draft or Revision": "Sales Order Draft atau Revision",
  "Sales Order · Internal Memo Stage": "Sales Order · Tahap Internal Memo",
  "Sales Order · Purchase Order Stage": "Sales Order · Tahap Purchase Order",
  "Sales Orders": "Sales Order",
  "Sales Pipeline": "Pipeline Penjualan",
  "Sales Pipeline & Stage Deals": "Pipeline Penjualan & Deal per Tahap",
  "Sales Pipeline Summary": "Ringkasan Pipeline Penjualan",
  "Sales Price": "Harga Jual",
  "Sales Stage": "Tahap Penjualan",
  "Sales Value": "Nilai Penjualan",
  "Sales Value (IDR)": "Nilai Penjualan (IDR)",
  "Save": "Simpan",
  "SAVE & APPROVE": "SIMPAN & SETUJUI",
  "Save & Approve Document": "Simpan & Setujui Dokumen",
  "Save a snapshot of the current released version": "Simpan snapshot versi released saat ini",
  "Save Access Rights": "Simpan Hak Akses",
  "Save Archive (Done)": "Simpan Arsip (Selesai)",
  "Save as a New Custom Template?": "Simpan sebagai Template Custom Baru?",
  "SAVE CHANGES": "SIMPAN PERUBAHAN",
  "Save Changes": "Simpan Perubahan",
  "Save Configuration": "Simpan Konfigurasi",
  "Save Contact": "Simpan Kontak",
  "Save Contract": "Simpan Kontrak",
  "Save Customer": "Simpan Customer",
  "Save Data": "Simpan Data",
  "Save Document": "Simpan Dokumen",
  "Save Draft": "Simpan Draft",
  "Save Matrix Configuration": "Simpan Konfigurasi Matriks",
  "Save New Version": "Simpan Versi Baru",
  "Save PO Changes": "Simpan Perubahan PO",
  "Save Product": "Simpan Produk",
  "Save Progress": "Simpan Progress",
  "Save Relocation": "Simpan Relokasi",
  "Save Retake": "Simpan Ulang",
  "Save Revision": "Simpan Revisi",
  "Save Role": "Simpan Role",
  "Save Task Dates": "Simpan Tanggal Tugas",
  "Save Team": "Simpan Tim",
  "Save Template": "Simpan Template",
  "Save the unit or import?": "Simpan satuan atau import?",
  "Save User & Roles": "Simpan Pengguna & Role",
  "Save Vendor": "Simpan Vendor",
  "Saved": "Tersimpan",
  "Saved signature": "Tanda tangan tersimpan",
  "Saved Signature Profile": "Profil Tanda Tangan Tersimpan",
  "Saving": "Menyimpan",
  "Saving Configuration...": "Menyimpan Konfigurasi...",
  "Saving document...": "Menyimpan dokumen...",
  "Saving evidence link...": "Menyimpan link evidence...",
  "Saving risk...": "Menyimpan risiko...",
  "Saving to Server": "Menyimpan ke Server",
  "Saving to server...": "Menyimpan di server...",
  "Saving...": "Menyimpan...",
  "SAVING...": "MENYIMPAN...",
  "Saving…": "Menyimpan…",
  "Scan QR untuk membuka halaman Visitor Registration.": "Pindai QR untuk membuka halaman Pendaftaran Pengunjung.",
  "Scan the QR to open the Visitor Registration page.": "Pindai QR untuk membuka halaman Pendaftaran Pengunjung.",
  "Scanning notifications...": "Memindai notifikasi...",
  "Schedule": "Jadwal",
  "Schedule Goal": "Target Jadwal",
  "Schedule Slip": "Keterlambatan Jadwal",
  "SCM Admin": "Admin SCM",
  "SCM Assets": "Aset SCM",
  "SCM Dashboard": "Dasbor SCM",
  "SCM User": "Pengguna SCM",
  "Scope": "Lingkup",
  "Scope & Details": "Lingkup & Detail",
  "Scope & Performance": "Lingkup & Kinerja",
  "Scope / Feature": "Scope / Fitur",
  "Scope Description": "Deskripsi Lingkup",
  "Scope Description:": "Deskripsi Lingkup:",
  "Scope {name}: {value1} — click to change": "Scope {name}: {value1} — klik untuk ubah",
  "Scope:": "Lingkup:",
  "Scrollable data table": "Tabel data yang dapat digulir",
  "Search": "Cari",
  "Search activity": "Cari aktivitas",
  "Search bank name / code...": "Cari nama / kode bank...",
  "Search by Doc. Number or Subject...": "Cari berdasarkan No. Dokumen atau Perihal...",
  "Search by ID, requestor, customer...": "Cari berdasarkan ID, pemohon, pelanggan...",
  "Search by ID, Site, or Alarm...": "Cari berdasarkan ID, Site, atau Alarm...",
  "Search by opportunity name, customer, project code, or account manager...": "Cari berdasarkan nama peluang, pelanggan, kode proyek, atau account manager...",
  "Search by Order ID, Site Name...": "Cari berdasarkan Order ID, Nama Site...",
  "Search companies...": "Cari company...",
  "Search contract, counterpart...": "Cari kontrak, pihak lawan...",
  "Search coordinator name...": "Cari nama coordinator...",
  "Search data assets...": "Cari aset data...",
  "Search data...": "Cari data...",
  "Search destinations...": "Cari destination...",
  "Search document number...": "Cari nomor dokumen...",
  "Search document, customer...": "Cari dokumen, pelanggan...",
  "Search documents": "Cari dokumen",
  "Search employee name to tag…": "Cari nama karyawan untuk ditandai…",
  "Search employee name...": "Cari nama karyawan...",
  "Search flows...": "Cari flow...",
  "Search host by name...": "Cari host berdasarkan nama...",
  "Search host name...": "Cari nama host...",
  "Search letter number, description...": "Cari nomor surat, keterangan...",
  "Search logs": "Cari log",
  "Search meetings...": "Cari meeting...",
  "Search members to tag": "Cari anggota untuk ditandai",
  "Search name / institution...": "Cari nama / instansi...",
  "Search name, email, customer...": "Cari nama, email, customer...",
  "Search name, email, NIP, position...": "Cari nama, email, NIP, jabatan...",
  "Search name, email, or job title...": "Cari nama, email, atau jabatan...",
  "Search name, ID, address...": "Cari nama, ID, alamat...",
  "Search name...": "Cari nama...",
  "Search Not Found": "Pencarian Tidak Ditemukan",
  "Search opportunity or customer...": "Cari opportunity atau customer...",
  "Search partners...": "Cari partner...",
  "Search PN, name, brand": "Cari PN, nama, merek",
  "Search process flow": "Cari process flow",
  "Search product name, SKU...": "Cari nama produk, SKU...",
  "Search project manager...": "Cari manajer proyek...",
  "Search project, customer...": "Cari project, customer...",
  "Search projects by name, ID, or customer...": "Cari proyek berdasarkan nama, ID, atau pelanggan...",
  "Search Risk ID, Task ID, or risk factor…": "Cari ID Risiko, ID Tugas, atau faktor risiko…",
  "Search role / module name...": "Cari nama role / modul...",
  "Search role or group name...": "Cari nama role atau grup...",
  "Search role or module name...": "Cari nama role atau modul...",
  "Search rooms...": "Cari ruangan...",
  "Search scope...": "Cari lingkup...",
  "Search serial, PN, site": "Cari serial, PN, site",
  "Search site ID, name, region...": "Cari ID site, nama, wilayah...",
  "Search SO / Opportunity": "Cari SO / Peluang",
  "Search SO number, deal, customer...": "Cari nomor SO, deal, customer...",
  "Search SO number, project, or customer": "Cari nomor SO, project, atau customer",
  "Search span, partner, site, area...": "Cari span, mitra, site, area...",
  "Search superior name or role...": "Cari nama atau role atasan...",
  "Search ticket, actor, or status...": "Cari tiket, actor, atau status...",
  "Search TPD ID...": "Cari ID TPD...",
  "Search user, action, or item...": "Cari user, aksi, atau item...",
  "Search user, module, action...": "Cari user, modul, aksi...",
  "Search users by name, email, position...": "Cari user berdasarkan nama, email, jabatan...",
  "Search vendor / group...": "Cari vendor / group...",
  "Search vendor name or account...": "Cari nama atau kode vendor...",
  "Search vendor name, account, group, or email...": "Cari nama, kode, kategori, atau email vendor...",
  "Search vendor, competency...": "Cari vendor, kompetensi...",
  "Search vendors": "Cari vendor",
  "Search visitor, host, company...": "Cari pengunjung, host, perusahaan...",
  "Searching vendors": "Mencari vendor",
  "Security & Frontdesk": "Keamanan & Resepsionis",
  "Security Permissions Suite": "Suite Izin Keamanan",
  "Security Settings": "Pengaturan Keamanan",
  "Security State": "Status Keamanan",
  "Segment": "Segmen",
  "Select a file to add": "Pilih file untuk ditambahkan",
  "Select a file to add...": "Pilih file untuk ditambahkan...",
  "Select a processing method first": "Pilih metode pemrosesan terlebih dahulu",
  "Select a room": "Pilih ruangan",
  "Select a Stage 1 approver first.": "Pilih Approver Tahap 1 terlebih dahulu.",
  "Select a Stage 1 approver to submit the document to the approval circulation.": "Pilih Approver Tahap 1 untuk mengajukan dokumen ke Approval Circulir.",
  "Select a vehicle": "Pilih kendaraan",
  "Select a WBS template above to assign target dates per stage.": "Pilih templat WBS di atas untuk menetapkan tanggal target per tahap.",
  "Select Access Roles": "Pilih Role Akses",
  "Select All": "Pilih Semua",
  "Select Approver {index}": "Pilih Approver {index}",
  "Select approver...": "Pilih approver...",
  "Select at least 1 approver!": "Pilih minimal 1 approver!",
  "Select at least 1 participant (Booking For)": "Pilih setidaknya 1 peserta (Booking For)",
  "Select at least 1 superior!": "Pilih minimal 1 atasan!",
  "Select at least one PDP Data": "Pilih setidaknya satu Data PDP",
  "Select at least one recipient role.": "Pilih minimal satu role penerima.",
  "Select at least one role for this account": "Pilih minimal satu role untuk akun ini",
  "Select at least one vendor.": "Pilih minimal satu vendor.",
  "Select catalog": "Pilih katalog",
  "Select Category": "Pilih Kategori",
  "Select Coordinator": "Pilih Coordinator",
  "Select Customer": "Pilih Customer",
  "Select customer": "Pilih pelanggan",
  "Select Driver": "Pilih Driver",
  "Select driver...": "Pilih driver...",
  "Select End": "Pilih Selesai",
  "Select one or more recipient roles...": "Pilih satu atau beberapa role penerima...",
  "Select one or more roles...": "Pilih satu atau beberapa role...",
  "Select one or more vendors; type to search.": "Pilih satu atau lebih vendor; ketik untuk mencari.",
  "Select or search host...": "Pilih atau cari host...",
  "Select Page {pageNum}": "Pilih Halaman {pageNum}",
  "Select Partner...": "Pilih Mitra...",
  "Select RBAC Roles:": "Pilih Role RBAC:",
  "Select RCA Category": "Pilih RCA Category",
  "Select reason": "Pilih reason",
  "Select Recipient Roles": "Pilih Role Penerima",
  "Select recipient roles...": "Pilih role penerima...",
  "Select Room": "Pilih Ruangan",
  "Select SA PIC": "Pilih PIC SA",
  "Select serial number": "Pilih nomor seri",
  "Select site": "Pilih site",
  "Select Start": "Pilih Mulai",
  "Select Task (TPD)": "Pilih Tugas (TPD)",
  "Select team members...": "Pilih anggota tim...",
  "Select the Entity Type and Name first!": "Pilih Tipe dan Nama Entitas terlebih dahulu!",
  "Select the PDF or DOCX file to upload.": "Pilih file PDF atau DOCX yang akan diunggah.",
  "Select the user groups that will receive this email.": "Pilih grup pengguna yang akan menerima email ini.",
  "Select Time": "Pilih Jam",
  "Select TPD progress": "Pilih progres TPD",
  "Select TPDs": "Pilih TPD",
  "Select Transition Target": "Pilih Target Transisi",
  "Select Type...": "Pilih Tipe...",
  "Select unit and site before installing": "Pilih unit dan site sebelum memasang",
  "Select Vehicle": "Pilih Kendaraan",
  "Select Vehicle...": "Pilih Kendaraan...",
  "Select warehouse": "Pilih gudang",
  "selected": "dipilih",
  "Selected on the Opportunity or SO": "Dipilih pada Opportunity atau SO",
  "Selected PO not found.": "PO yang dipilih tidak ditemukan.",
  "Send & mark Done": "Kirim & tandai Selesai",
  "Send a notification to the related PIC": "Kirim notifikasi kepada PIC terkait",
  "SEND BROADCAST": "KIRIM BROADCAST",
  "Send Document to Superior": "Kirim Dokumen ke Atasan",
  "Send Email": "Kirim Email",
  "Send Now": "Kirim Sekarang",
  "Send official announcement emails and system alerts simultaneously using CC batches.": "Kirim email pengumuman resmi dan alert sistem serentak menggunakan CC batch.",
  "Send reply": "Kirim balasan",
  "Send Submission": "Kirim Pengajuan",
  "Send the error to the related PIC": "Kirim error ke PIC terkait",
  "Send to Circulation": "Kirim ke Circulir",
  "Send Update": "Kirim Pembaruan",
  "Sender:": "Pengirim:",
  "Sending...": "Mengirim...",
  "Sends the final outcome to the requester.": "Kirim hasil akhir kepada requester.",
  "Sent to the next stage approver.": "Kirim ke approver tahap berikutnya.",
  "Sent to the Stage 1 approver chosen by the requester.": "Kirim ke Approver Tahap 1 yang dipilih requestor.",
  "Sequential approval": "Persetujuan berurutan",
  "Sequential approval by division": "Approval berurutan sesuai division",
  "Sequential approval flow with SLA 48 hours per step": "Alur persetujuan berurutan dengan SLA 48 jam per langkah",
  "Serial Number": "Nomor Seri",
  "Serial number and catalog are required": "Nomor seri dan katalog wajib diisi",
  "Serialized": "Berseri",
  "Serialized inventory tracking by warehouse and site.": "Pelacakan inventaris berseri per gudang dan site.",
  "Serialized material tracking and stock management.": "Pelacakan material berseri dan manajemen stok.",
  "Service": "Jasa",
  "Service Is Busy": "Layanan Sedang Sibuk",
  "Service Notifications": "Notifikasi Layanan",
  "SERVICE OPERATIONS": "OPERASIONAL LAYANAN",
  "Services": "Layanan",
  "Services Admin": "Admin Layanan",
  "Services Operations": "Operasional Layanan",
  "Services Suite": "Layanan",
  "Services User": "Pengguna Layanan",
  "Services View Only": "Layanan Hanya Lihat",
  "Session ended due to inactivity": "Sesi berakhir karena tidak ada aktivitas",
  "Sessions already booked today": "Sesi yang sudah dipesan hari ini",
  "Set as default template": "Jadikan templat default",
  "Set Default": "Jadikan Default",
  "Set global roles, permissions, and the access rights matrix for all application modules.": "Atur role global, permission, dan matriks hak akses seluruh modul aplikasi.",
  "Set progress to 10% and status to Go": "Set progress 10% dan status Go",
  "Set the default template": "Set template default",
  "Set the stage to Lead": "Set stage Lead",
  "Settings": "Pengaturan",
  "SETTINGS": "PENGATURAN",
  "Severity": "Tingkat Keparahan",
  "Severity:": "Tingkat Keparahan:",
  "Shared Data Action": "Tindakan Shared Data",
  "Shared Master Data": "Master Data Bersama",
  "Shared Vendor Database": "Database Vendor Bersama",
  "SharePoint / Drive Link": "Link SharePoint / Drive",
  "Short purpose or scope of the document...": "Tujuan atau ruang lingkup singkat dokumen...",
  "Show SPI, CPI, EAC, and VAC": "Tampilkan SPI, CPI, EAC, dan VAC",
  "Show:": "Tampilkan:",
  "Showing": "Menampilkan",
  "Showing the first": "Menampilkan",
  "Showing the last loaded data. Refresh failed:": "Data terakhir tetap ditampilkan. Refresh gagal:",
  "Showing the planned budget projection from GPI delivery dates.": "Menampilkan proyeksi budget rencana dari tanggal pengiriman GPI.",
  "Showing {from} to {to} of {total}": "Menampilkan {from} sampai {to} dari {total}",
  "Sign Config:": "Konfigurasi Tanda Tangan:",
  "Sign Here": "Tanda Tangan di Sini",
  "Sign In": "Masuk",
  "Sign in to your account": "Masuk ke akun Anda",
  "Sign Mode:": "Mode Tanda Tangan:",
  "Signature": "Tanda Tangan",
  "Signature already saved. Upload only if you want to replace it (PNG/JPG/PDF, max 5MB)": "Tanda tangan sudah tersimpan. Unggah hanya jika ingin menggantinya (PNG/JPG/PDF, maks 5MB)",
  "Signature image is unavailable": "Gambar tanda tangan tidak tersedia",
  "Signature incomplete": "TTD belum lengkap",
  "Signature is saved. Upload if you want to replace it (PNG/JPG/PDF, max 5MB)": "Tanda tangan telah tersimpan. Unggah jika ingin mengganti (PNG/JPG/PDF, maks 5MB)",
  "Signature missing:": "TTD belum ada:",
  "Signature Preview": "Preview TTD",
  "Signed Document": "Dokumen Ditandatangani",
  "Signing Date": "Tanggal Penandatanganan",
  "Single Page": "Satu Halaman",
  "Sign type: {label}": "Jenis tanda tangan: {label}",
  "Single Page Mode": "Mode Satu Halaman",
  "Site & Location": "Site & Lokasi",
  "Site / Warehouse": "Site / Gudang",
  "Site ID": "ID Site",
  "Site is required": "Site wajib diisi",
  "Site Management": "Manajemen Site",
  "Site Name": "Nama Site",
  "Site status at a glance.": "Status site secara ringkas.",
  "Site Status": "Status Site",
  "A site is completed once all of its stages reach 100%.": "Site dianggap selesai jika semua tahapnya sudah 100%.",
  "Sites": "Site",
  "sites": "site",
  "Skip to IM": "Lewati ke IM",
  "Skipped": "Di-skip",
  "SKU / AX Code": "SKU / Kode AX",
  "SKU / AX Code (Unique)": "SKU / AX Code (Unik)",
  "SKU / AX Code:": "SKU / Kode AX:",
  "SKU catalog of goods and services, Microsoft AX ERP integration codes, unit categories, and pricing.": "Katalog SKU barang dan jasa, kode integrasi Microsoft AX ERP, kategori unit, dan penetapan harga.",
  "SLA Breach Tickets": "Tiket Melanggar SLA",
  "SLA Compliance": "Kepatuhan SLA",
  "SLA Countdown": "Hitung Mundur SLA",
  "SLA Health": "Kesehatan SLA",
  "SLA Started": "SLA Dimulai",
  "SLA Status:": "Status SLA:",
  "SLA target 04:00": "Target SLA 04:00",
  "SLA Targets": "Target SLA",
  "Snacks, coffee, or other needs...": "Snack, kopi, atau kebutuhan lain...",
  "SO Admin": "Admin SO",
  "SO Approval": "Persetujuan SO",
  "SO Approval Workspace": "Ruang Kerja Persetujuan SO",
  "SO can only be created for Won / Deal opportunities": "SO hanya dapat dibuat untuk peluang Won / Deal",
  "SO checklist complete?": "Checklist SO lengkap?",
  "SO created: {value1}": "SO dibuat: {value1}",
  "SO detail is not available.": "Detail SO tidak tersedia.",
  "SO Detail Snapshot": "Snapshot Detail SO",
  "SO draft created: {value1} (ID: {so_draft_id})": "Draf SO dibuat: {value1} (ID: {so_draft_id})",
  "SO Fast Track runs the entire approval chain and is not available to other roles.": "SO Fast Track menjalankan seluruh rantai approval dan tidak tersedia untuk role lain.",
  "SO Generated": "SO Dibuat",
  "SO has not been submitted for approval. Ensure GPI is uploaded and timeline is defined before submitting.": "SO belum diajukan untuk persetujuan. Pastikan GPI sudah diunggah dan linimasa sudah ditentukan sebelum mengajukan.",
  "SO Number": "Nomor SO",
  "SO or GPI": "SO atau GPI",
  "SO Overview": "Ikhtisar SO",
  "SO Overview PDF": "PDF Ikhtisar SO",
  "SO Phase 1 Workbench": "Meja Kerja SO Fase 1",
  "SO reverted to {rollbackTarget}": "SO kembali ke {rollbackTarget}",
  "SO Sales": "Sales SO",
  "SO Stage": "Tahap SO",
  "SO Status": "Status SO",
  "SO Value": "Nilai SO",
  "SO Version History": "Riwayat Versi SO",
  "SO View Only": "SO Hanya Lihat",
  "SO was rejected. Revise the SO data, regenerate PDF if needed, then resubmit for approval.": "SO ditolak. Revisi data SO, buat ulang PDF jika perlu, lalu ajukan ulang untuk persetujuan.",
  "Something went wrong": "Terjadi kesalahan",
  "SOP Handoff Between PICs": "SOP Handoff antar-PIC",
  "SOP references by PIC. Node colors show the work owner and arrows show the handoff to the next PIC.": "Referensi SOP berdasarkan PIC. Warna node menunjukkan pemilik pekerjaan dan panah menunjukkan handoff ke PIC berikutnya.",
  "Sort assignments": "Urutkan penugasan",
  "Source:": "Sumber:",
  "space": "ruang",
  "Span ID not found.": "Span ID tidak ditemukan.",
  "Specific Name": "Nama Spesifik",
  "Specify Other Data Type": "Tentukan Jenis Data Lainnya",
  "SPI (Schedule)": "SPI (Jadwal)",
  "Stage": "Tahap",
  "Stage / Task": "Tahap / Tugas",
  "Stage 1 · Initial": "Tahap 1 · Paraf",
  "Stage 2 · Initial / Final Approval": "Tahap 2 · Paraf / Final Approval",
  "Stage 3 gives the final approval for this document type.": "Tahap 3 memberikan final approval untuk tipe dokumen ini.",
  "Stage 3 · Final Approval": "Tahap 3 · Final Approval",
  "Stage and status distribution": "Distribusi stage dan status",
  "Stage Flow": "Alur Tahapan",
  "Stage Name": "Nama Tahap",
  "Stage progress updated successfully": "Progres tahap berhasil diperbarui",
  "Stage Progress Details": "Detail Progres Tahap",
  "Stages": "Tahap",
  "Stage Progression": "Kemajuan Tahap",
  "Stage Progression History": "Riwayat Kemajuan Tahap",
  "Stage Transition": "Transisi Tahap",
  "Stage transition and PO Estimate still follow the approval workflow.": "Stage transition and PO Estimate tetap mengikuti workflow approval.",
  "Stage WBS": "Tahap WBS",
  "Stage {index}": "Tahap {index}",
  "Stage:": "Tahap:",
  "stages": "tahap",
  "Standard / No Template": "Standar / Tanpa Templat",
  "Start": "Mulai",
  "Start by creating a new request": "Mulai dengan membuat permintaan baru",
  "START CLOCK": "MULAI JAM",
  "Start Clock": "Mulai Jam",
  "Start Clock mode activated. The SLA countdown will resume.": "Start Clock mode activated. SLA countdown akan lanjut kembali.",
  "Start Date": "Tanggal Mulai",
  "Start Date & Time": "Tanggal & Waktu Mulai",
  "Start the Admin Sales work": "Mulai pekerjaan Admin Sales",
  "Start Time": "Waktu Mulai",
  "Start time cannot be in the past": "Waktu mulai tidak boleh di masa lalu",
  "State": "Kondisi",
  "Status": "Status",
  "Status Distribution": "Distribusi Status",
  "Status: Active": "Status: Aktif",
  "Status: Inactive": "Status: Nonaktif",
  "Stays in the Drop history": "Tetap dalam riwayat Drop",
  "Step": "Langkah",
  "Step 0 (Requestor):": "Langkah 0 (Pemohon):",
  "Step 1: Draft Creation": "Step 1: Pembuatan Draft",
  "Step not completed": "Langkah belum selesai",
  "Step Progress": "Progress Step",
  "Step {step_order}": "Langkah {step_order}",
  "Step {value1}": "Langkah {value1}",
  "STEP {value1}": "LANGKAH {value1}",
  "Stop": "Berhenti",
  "Stop Clock": "Hentikan Jam",
  "STOP CLOCK - {value1}": "HENTIKAN JAM - {value1}",
  "Stop Clock Reason *": "Alasan Hentikan Jam *",
  "Storage & Archive": "Penyimpanan & Arsip",
  "STORAGE BY COMPANY": "PENYIMPANAN PER PERUSAHAAN",
  "Stored in the system": "Tersimpan di sistem",
  "Strategic Revenue Monitoring & KPIs": "Pemantauan Pendapatan Strategis & KPI",
  "Subject": "Subjek",
  "Subject / Perihal": "Subjek / Perihal",
  "Subject / Title": "Perihal / Judul",
  "Subject and description are required": "Subjek dan deskripsi wajib diisi",
  "Subject Email": "Subjek Email",
  "Subject must not be empty.": "Subject tidak boleh kosong.",
  "Subject:": "Subjek:",
  "Submission Description": "Deskripsi Pengajuan",
  "Submission failed": "Pengajuan gagal",
  "Submission Name": "Nama Pengajuan",
  "Submission of project & non-project internal memos, authorization flow approvals, and exposure monitoring.": "Pengajuan memo internal proyek & non-proyek, approval alur otorisasi, dan monitoring exposure.",
  "Submission Status": "Status Pengajuan",
  "Submission Value (IDR)": "Nilai Pengajuan (IDR)",
  "Submission, per-version sequential approval, and automatic release after final approval.": "Submission, approval berurutan per versi, dan release otomatis setelah final approval.",
  "Submit": "Ajukan",
  "Submit a new Data Privacy Request": "Ajukan Permintaan Privasi Data baru",
  "Submit Again for Approval": "Ajukan Lagi untuk Persetujuan",
  "Submit Another": "Kirim Lainnya",
  "Submit Booking": "Kirim Pemesanan",
  "Submit Change Request": "Ajukan Permintaan Perubahan",
  "Submit Dealsheet": "Kirim Dealsheet",
  "Submit Drop to Executive": "Ajukan Drop ke Executive",
  "Submit failed.": "Pengajuan gagal.",
  "Submit for Approval": "Ajukan Approval",
  "SUBMIT FOR APPROVAL": "AJUKAN APPROVAL",
  "Submit later requires a saved signature": "Pengajuan nanti memerlukan tanda tangan tersimpan",
  "Submit Negotiation": "Ajukan Negosiasi",
  "Submit or export the Sales Order per access": "Submit atau export Sales Order sesuai akses",
  "Submit Progress": "Kirim Progres",
  "Submit progress updates manually per task or upload a batch via Excel.": "Kirim pembaruan progres secara manual per tugas atau unggah batch melalui Excel.",
  "Submit Registration": "Kirim Pendaftaran",
  "Submit Request": "Kirim Permintaan",
  "Submit requires a saved signature": "Submit memerlukan tanda tangan tersimpan",
  "Submit Sales Order": "Kirim Sales Order",
  "Submit SO for approval": "Ajukan approval SO",
  "Submit the review to Head of SA": "Submit review ke Head of SA",
  "Submit the SO for approval": "Submit SO untuk approval",
  "Submit the SO for approval of the new version": "Submit SO untuk approval versi baru",
  "Submit the update for PMO or approver review": "Submit update untuk review PMO atau approver",
  "Submit to AM": "Submit ke AM",
  "Submit to Superior": "Ajukan ke Atasan",
  "Submit Update": "Kirim Pembaruan",
  "Submitted": "Diajukan",
  "submitted": "mengajukan",
  "Submitted At": "Diajukan Pada",
  "Submitted By": "Diajukan Oleh",
  "Submitted by": "Diajukan oleh",
  "Submitter": "Pengaju",
  "Submitting will move the opportunity to stage": "Submit akan memindahkan opportunity ke stage",
  "Submitting...": "Mengajukan...",
  "Submitting…": "Mengajukan…",
  "Successful": "Berhasil",
  "successful": "berhasil",
  "Successful data remains saved. Fix the failed data, then re-upload; unchanged data will be skipped.": "Data yang berhasil tetap tersimpan. Perbaiki data gagal, lalu upload ulang; data tanpa perubahan akan dilewati.",
  "successful ·": "berhasil ·",
  "Summary of dominant root causes under the active filter": "Ringkasan akar masalah dominan pada filter aktif",
  "Summary of submitted SO fields and current approval progress, similar to IM detail view.": "Ringkasan kolom SO yang diajukan dan progres persetujuan saat ini, mirip tampilan detail IM.",
  "Super Admin cannot deactivate their own account": "Super Admin tidak dapat menonaktifkan akun sendiri",
  "Super Admin cannot deactivate their own account.": "Super Admin tidak dapat menonaktifkan akun sendiri.",
  "Superadmin access required": "Akses superadmin diperlukan",
  "Superadmin Command Active": "Perintah Superadmin Aktif",
  "Superadmin only": "Hanya Superadmin",
  "Superiors who have already approved (Approved) cannot be changed or removed to preserve document integrity.": "Atasan yang sudah menyetujui (Approved) tidak dapat diubah atau dihapus untuk menjaga integritas dokumen.",
  "Supply Chain": "Rantai Pasok",
  "Supporting Document": "Dokumen Pendukung",
  "Supporting Documents": "Dokumen Pendukung",
  "Supports PDF, Excel, CSV, JSON, TXT, and ZIP (Max. 50 MB)": "Mendukung PDF, Excel, CSV, JSON, TXT, dan ZIP (Maks. 50 MB)",
  "Surat": "Surat",
  "Swap Room (Relocate)": "Tukar Ruangan (Relocate)",
  "Swipe horizontally to see other days": "Geser horizontal untuk melihat hari lain",
  "Swipe to see other rooms": "Geser untuk melihat room lainnya",
  "Sync the OPS Project": "Sinkronkan Project OPS",
  "SYSTEM": "SISTEM",
  "System": "Sistem",
  "System Audit Trails & History": "Jejak Audit Sistem & Riwayat",
  "System security control center, user identity management, RBAC access rights, and AiBAS application announcement distribution.": "Pusat kendali keamanan sistem, manajemen identitas pengguna, hak akses RBAC, dan distribusi pengumuman aplikasi AiBAS.",
  "Tag members": "Tandai anggota",
  "Tagged": "Ditandai",
  "Takes time": "Perlu waktu",
  "Task approved successfully": "Tugas berhasil disetujui",
  "Task Assignments": "Penugasan Tugas",
  "Task Connect": "Tugas Connect",
  "Task Hub": "Pusat Tugas",
  "Task ID": "ID Tugas",
  "Task rejected successfully": "Tugas berhasil ditolak",
  "Task status": "Status tugas",
  "Task sync failed": "Sinkronisasi tugas gagal",
  "Task Type": "Tipe Tugas",
  "Tasks": "Tugas",
  "Team members (Coordinators) who are added will get access to view and fill in the work progress on this project.": "Anggota tim (Coordinator) yang ditambahkan akan mendapatkan akses untuk melihat dan mengisi progress pekerjaan pada project ini.",
  "Team:": "Tim:",
  "Technical Error Details (For Developers / IT)": "Detail Teknis Error (Untuk Developer / IT)",
  "Technical specifications, warranty, additional notes...": "Spesifikasi teknis, garansi, catatan tambahan...",
  "Template Name": "Nama Templat",
  "Template: Disruption / Maintenance Warning": "Template: Peringatan Gangguan / Maintenance",
  "Template: New Feature Update": "Template: Pembaruan Fitur Baru",
  "Template: Update Completed": "Template: Pembaruan Selesai",
  "Terminated": "Diakhiri",
  "The advanced detail form (Upload PDF, Date, and Value) will open after the Draft is saved.": "Form detail lanjutan (Upload PDF, Tanggal, dan Nilai) akan terbuka setelah Draft disimpan.",
  "The AiBAS Team": "Tim AiBAS",
  "The AM needs to create a new Internal Memo. The old IM can be used as a reference.": "AM perlu membuat Internal Memo baru. IM lama dapat dijadikan referensi.",
  "The application service is back to normal and ready to use.": "Layanan aplikasi telah kembali normal dan sudah dapat digunakan.",
  "The approval status is recorded, but the signature image for this version is unavailable.": "Status approval sudah tercatat, tetapi gambar TTD untuk versi ini tidak tersedia.",
  "The approved PO value is saved": "Nilai PO approved disimpan",
  "The Approver 1 pool and all fixed approvers are required.": "Pool Approver 1 dan seluruh approver tetap wajib diisi.",
  "The approver reviews": "Approver melakukan review",
  "The approver reviews the PO estimate": "Approver review estimasi PO",
  "The assignment appears as Action Needed": "Assignment tampil sebagai Action Needed",
  "The attachment file will be deleted when you save the changes.": "Berkas lampiran akan dihapus saat Anda menyimpan perubahan.",
  "The batch process failed. Reopen Batch Update to see the result details.": "Proses batch gagal. Buka kembali Batch Update untuk melihat detail hasil.",
  "The big picture of the CRM process from master data to an active project in OPS.": "Peta besar proses CRM dari master data sampai project aktif di OPS.",
  "The CR becomes Completed and is recorded in the snapshot": "CR menjadi Completed dan tercatat pada snapshot",
  "The Dealsheet shows the commercial summary": "Dealsheet menampilkan ringkasan komersial",
  "The document becomes": "Dokumen menjadi",
  "The document could not be loaded.": "Dokumen tidak dapat dimuat.",
  "The document enters the Approval Queue": "Dokumen masuk Approval Queue",
  "The document file could not be loaded or has not been uploaded.": "File dokumen tidak dapat dimuat atau belum diunggah.",
  "The document will be submitted to the following approval circulation:": "Dokumen akan diajukan ke Approval Circulir berikut:",
  "The file preview will appear after a document is selected.": "Pratinjau berkas akan tampil setelah dokumen dipilih.",
  "The file preview will appear after you select a document.": "Pratinjau berkas akan tampil setelah Anda memilih dokumen.",
  "The file task-dates-so{soId}.xlsx was downloaded to your device successfully.": "Berkas task-dates-so{soId}.xlsx berhasil diunduh ke perangkat Anda.",
  "The file will be downloaded in Excel/CSV format.": "File akan diunduh dalam format Excel/CSV.",
  "The first step has Pending status": "Step pertama berstatus Pending",
  "The flow of creating a new opportunity and the initial data that forms a Lead.": "Alur pembuatan opportunity baru dan data awal yang membentuk Lead.",
  "The following fields are managed separately:": "Kolom berikut dikelola secara terpisah:",
  "The IM lifecycle from Draft, sequential approval, revision, to completed or closed.": "Siklus IM dari Draft, approval berurutan, revision, sampai selesai atau closed.",
  "The link you visited may have been moved, deleted, or the URL you entered is incorrect.": "Tautan yang Anda tuju mungkin sudah dipindahkan, dihapus, atau alamat URL yang Anda masukkan kurang tepat.",
  "The message content will appear here.": "Isi pesan informasi akan muncul di sini.",
  "The opportunity enters the Sales Pipeline": "Opportunity masuk Sales Pipeline",
  "The opportunity is closed": "Opportunity ditutup",
  "The opportunity is in an active stage": "Opportunity berada di stage aktif",
  "The opportunity stays active": "Opportunity tetap aktif",
  "The order of preparing documents and data before a Sales Order is submitted.": "Urutan penyiapan dokumen dan data sebelum Sales Order diajukan.",
  "The PDF URL is not available for this document.": "URL PDF tidak tersedia untuk dokumen ini.",
  "The PIC who submits the data": "PIC yang submit data",
  "The PMM or NPD PIC receives the assignment": "PIC PMM atau NPD menerima assignment",
  "The project code does not match yet.": "Project code belum cocok.",
  "The project is available in the OPS module": "Project tersedia di modul OPS",
  "The project is created or synced to OPS": "Project dibuat atau disinkronkan ke OPS",
  "The Project Manager prepares the Timeline": "Project Manager menyiapkan Timeline",
  "The relationship between the WBS template, stage schedule, GPI, and project performance projection.": "Hubungan template WBS, jadwal stage, GPI, dan proyeksi performa project.",
  "The requested user does not exist or you do not have permission to view it.": "Pengguna yang diminta tidak ada atau Anda tidak memiliki izin untuk melihatnya.",
  "The requester does not need a driver, so no driver can be assigned.": "Requestor tidak membutuhkan driver, jadi driver tidak dapat diisi.",
  "The requester picks one approver from the Stage 1 list when submitting a document; either may act first.": "Requestor memilih salah satu approver dari daftar Tahap 1 saat mengajukan dokumen; siapa pun boleh diproses lebih dulu.",
  "The requester picks one from this list when submitting a document": "Requestor memilih salah satu dari daftar berikut saat mengajukan dokumen",
  "The requester picks one Stage 1 approver to initial, then Approver 2. Approver 3 gives the final approval, except for Cancellation Letters, which are finalized by Approver 2.": "Requestor memilih salah satu Approver Tahap 1 untuk paraf, lalu Approver 2. Approver 3 memberi final approval, kecuali untuk Cancellation Letter yang final di Approver 2.",
  "The requestor fills in the signature and submits": "Requestor isi tanda tangan dan submit",
  "The required stage order from Lead to Deal without skipping any stage.": "Urutan stage wajib dari Lead sampai Deal tanpa melewati stage.",
  "The same user cannot fill more than one stage.": "User yang sama tidak boleh mengisi lebih dari satu tahap.",
  "The schedule is still empty.": "Jadwal masih kosong.",
  "The selected time conflicts with another schedule": "Waktu yang dipilih bertabrakan dengan jadwal lain",
  "The sequence of responsibility handoffs from sales preparation until the project is accepted by OPS.": "Urutan perpindahan tanggung jawab dari persiapan sales sampai project diterima OPS.",
  "The server did not return the batch update result.": "Server tidak mengembalikan hasil batch update.",
  "The server experienced an unexpected disruption while processing your request. Our team has logged this event for prompt handling.": "Server mengalami gangguan tak terduga saat memproses permintaan Anda. Tim kami telah mencatat peristiwa ini untuk segera ditangani.",
  "The server failed to process the batch update (HTTP {status}).": "Server gagal memproses batch update (HTTP {status}).",
  "The server rejected the file (500 Internal Server Error). The post_max_size or upload_max_filesize limit in php.ini/Nginx was exceeded.": "Server menolak file (500 Internal Server Error). Batas post_max_size atau upload_max_filesize di php.ini/Nginx terlampaui.",
  "The server response could not be read.": "Respons server tidak dapat dibaca.",
  "The signature preview could not be loaded. Choose or re-upload your signature.": "Preview TTD tidak dapat dimuat. Pilih atau unggah ulang tanda tangan.",
  "The signature will be placed automatically in your approval slot on the SO document.": "Tanda tangan akan ditempatkan otomatis pada slot persetujuan Anda di dokumen SO.",
  "The Slug (URL) will be generated automatically by the system based on the Company Name.": "Slug (URL) akan otomatis di-generate oleh sistem berdasarkan Nama Company.",
  "The stage becomes Negotiation 90%": "Stage menjadi Negotiation 90%",
  "The stage becomes Proposal 70%": "Stage menjadi Proposal 70%",
  "The system activates the IM or releases the SO": "System mengaktifkan IM atau release SO",
  "The system brings over the customer, AM, and deal value": "Sistem membawa customer, AM, dan deal value",
  "The system calculates the stage age": "Sistem menghitung umur stage",
  "The system creates the number, PDF, and snapshot": "System membuat nomor, PDF, dan snapshot",
  "The system creates the planned S-Curve": "System membuat S-Curve rencana",
  "The system creates the SA PIC Assignment": "System membuat SA PIC Assignment",
  "The system is undergoing synchronization or periodic maintenance. Please try again in a moment.": "Sistem sedang dalam proses sinkronisasi atau pemeliharaan berkala. Silakan coba kembali beberapa saat lagi.",
  "The system processes the transaction": "Sistem memproses transaksi",
  "The system requires your signature before the document is approved.": "Sistem meminta TTD Anda sebelum Dokumen disetujui.",
  "The system rolls up progress and calculates health": "System rollup progress dan hitung health",
  "The system will embed your saved signature shown below:": "Sistem akan menyematkan tanda tangan Anda yang tersimpan di bawah ini:",
  "The template uses a matrix format: each": "Template menggunakan format matriks: setiap",
  "The timer is reset and monitoring starts again": "Timer di-reset dan monitoring dimulai lagi",
  "The user creates a Change Request": "User membuat Change Request",
  "The user opens the details and gives a decision": "User membuka detail dan memberi keputusan",
  "The user performs an action": "User melakukan aksi",
  "The vendor will be deleted from the shared master. The system rejects deletion if the vendor is already used by a Procurement document.": "Vendor akan dihapus dari master bersama. Sistem menolak penghapusan jika vendor sudah dipakai dokumen Procurement.",
  "There are no Internal Memo documents awaiting your approval right now.": "Tidak ada dokumen Internal Memo yang menunggu persetujuan Anda saat ini.",
  "There is currently maintenance or a service disruption. We will let you know again once it is finished.": "Saat ini sedang ada pemeliharaan atau gangguan layanan. Kami akan menginfokan kembali jika sudah selesai.",
  "This action is permanent and only available to Super Admin.": "Aksi ini permanen dan hanya tersedia untuk Super Admin.",
  "This action will permanently delete all GPI line item data for this Sales Order. Deleted data cannot be restored.": "Tindakan ini akan menghapus seluruh data line item GPI untuk Sales Order ini secara permanen. Data yang telah dihapus tidak dapat dikembalikan.",
  "This contact will be marked as dropped (lost). It will still be in the database but counted as a loss.": "Kontak ini akan ditandai sebagai dibatalkan (hilang). Tetap ada di database tetapi dihitung sebagai kerugian.",
  "This data is already selected": "Data ini sudah dipilih",
  "This document is a merge of the IM Summary and all PDF/Image attachments. Updated automatically after approval.": "Dokumen ini adalah gabungan dari Ringkasan IM dan semua lampiran berformat PDF/Gambar. Update otomatis setelah persetujuan.",
  "This feature allows you to add project updates and notes without progressing to the next stage. Perfect for regular status updates!": "Fitur ini memungkinkan Anda menambahkan pembaruan dan catatan proyek tanpa maju ke tahap berikutnya. Cocok untuk pembaruan status berkala!",
  "This IM has been finally rejected.": "IM ini telah ditolak secara final.",
  "This Month": "Bulan Ini",
  "This opportunity is already at the final stage (Deal). No further progression is available.": "Peluang ini sudah berada di tahap akhir (Deal). Tidak ada kemajuan lebih lanjut.",
  "This opportunity is in the Drop approval queue by VP Sales/CRO.": "Opportunity ini sedang dalam antrean persetujuan Drop oleh VP Sales/CRO.",
  "This opportunity is in the Margin/PO Estimate value change approval queue.": "Opportunity ini sedang dalam antrean persetujuan perubahan nilai Margin/PO Estimate.",
  "This percentage is calculated from the approval ratio of personal data protection documents.": "Persentase ini dihitung dari rasio persetujuan dokumen pelindungan data pribadi.",
  "this project": "proyek ini",
  "This project's health status is currently marked as": "Status kesehatan proyek ini saat ini ditandai sebagai",
  "This relocation will move the meeting to a new room and automatically send a change notification email to the related attendees.": "Relokasi ini akan memindahkan meeting ke ruangan baru dan otomatis mengirimkan email notifikasi perubahan ke peserta terkait.",
  "This request has been approved and is now active.": "Permintaan ini telah disetujui dan kini aktif.",
  "This room is already booked by": "Ruangan ini sudah dipesan oleh",
  "This stage requires a manual signature on the document (same as the Legal module).": "Tahap ini memerlukan tanda tangan manual pada dokumen (sama seperti modul Legal).",
  "This stage requires an approved Internal Memo (IM) number. If you do not have one yet, create and submit it first at": "Tahap ini memerlukan nomor Internal Memo (IM) yang telah disetujui. Jika belum memiliki, buat dan ajukan terlebih dahulu di",
  "This TPD is complete and no longer accepts progress updates.": "TPD ini sudah selesai dan tidak lagi menerima pembaruan progres.",
  "This will be saved in stage history without changing the current stage": "Ini akan disimpan dalam riwayat tahap tanpa mengubah tahap saat ini",
  "This will reset the 7-day aging timer and keep the opportunity in the current stage. Your reason will be recorded in the stage history.": "Ini akan mengatur ulang timer aging 7 hari dan mempertahankan peluang di tahap saat ini. Alasan Anda akan dicatat dalam riwayat tahap.",
  "This Year": "Tahun Ini",
  "Ticket Created": "Tiket Dibuat",
  "Ticket Detail": "Detail Tiket",
  "Ticket ID": "ID Tiket",
  "Ticket Identifiers": "Pengenal Tiket",
  "Ticket Lifecycle": "Siklus Tiket",
  "Ticket Lifecycle Console": "Konsol Siklus Tiket",
  "Ticket Movement Logs": "Log Perpindahan Tiket",
  "Ticket must be closed before installing materials.": "Tiket harus ditutup sebelum memasang material.",
  "Ticket not found.": "Ticket tidak ditemukan.",
  "Ticket Ref": "Ref Tiket",
  "Ticket Start": "Tiket Mulai",
  "Ticketing": "Tiket",
  "Ticketing System": "Sistem Tiket",
  "tickets": "tiket",
  "Tickets within 4-hour cap": "Tiket dalam batas 4 jam",
  "Time": "Waktu",
  "Time & Date": "Waktu & Tanggal",
  "Time Frame *": "Kerangka Waktu *",
  "Time Prepare (minutes)": "Waktu Persiapan (menit)",
  "Time unavailable": "Waktu tidak tersedia",
  "Timeline": "Linimasa",
  "Timeline data unavailable": "Data linimasa tidak tersedia",
  "Timeline or Progress": "Timeline atau Progress",
  "Timestamp": "Stempel Waktu",
  "Timezone (Optional)": "Zona Waktu (Opsional)",
  "Timing Issue": "Masalah Waktu",
  "Title": "Jabatan",
  "Title & Description": "Judul & Deskripsi",
  "to": "sampai",
  "To": "Sampai",
  "To date": "Sampai tanggal",
  "To Date": "Sampai Tanggal",
  "To Do": "Akan Dikerjakan",
  "To import, open the Contracts list for the target company entity.": "Untuk import, buka daftar Contracts pada entitas perusahaan yang dituju.",
  "To:": "Kepada:",
  "Today": "Hari Ini",
  "Toggle PMO Edit Mode": "Ubah Mode Edit PMO",
  "Top 5 Budget": "5 Budget Teratas",
  "Top 5 Progress": "5 Progres Teratas",
  "Top 5 RCA": "5 RCA Teratas",
  "Top Problem Areas": "Area Masalah Teratas",
  "Total Asset": "Total Aset",
  "Total Brief Updates": "Total Pembaruan Ringkasan",
  "Total Cost": "Total Biaya",
  "Total Deal Value": "Total Nilai Deal",
  "Total Documents": "Total Dokumen",
  "Total Dropped": "Total Dibatalkan",
  "Total Guest Visits": "Total Kunjungan Tamu",
  "Total Linked PO Value:": "Total Nilai PO Terhubung:",
  "Total movement": "Total perpindahan",
  "Total Opportunities": "Total Peluang",
  "Total Opportunities (All Projects)": "Total Peluang (Semua Proyek)",
  "Total pause:": "Total jeda:",
  "Total Permissions": "Total Izin",
  "Total Permissions Included:": "Total Permission Terkandung:",
  "Total Pipeline Value": "Total Nilai Pipeline",
  "Total PO Value:": "Total Nilai PO:",
  "Total Portfolio Budget": "Total Budget Portofolio",
  "Total Progress": "Total Progres",
  "Total Qualification": "Total Kualifikasi",
  "Total Revenue": "Total Pendapatan",
  "Total Sell Price": "Total Harga Jual",
  "Total Tickets": "Total Tiket",
  "Total Weight": "Total Bobot",
  "Total Weight:": "Total Bobot:",
  "Total Weighted Summary": "Ringkasan Total Berbobot",
  "Tower Owner": "Pemilik Menara",
  "TPD ID": "ID TPD",
  "Traceable lifecycle activities across all operational projects.": "Aktivitas siklus hidup yang dapat dilacak di seluruh proyek operasional.",
  "Traceable lifecycle activities and state mutations for": "Aktivitas siklus hidup dan perubahan status yang dapat dilacak untuk",
  "Tracing": "Penelusuran",
  "Track Asset:": "Lacak Aset:",
  "Track Progress": "Lacak Progres",
  "Track serial-based inventory by warehouse and site.": "Lacak inventaris berbasis serial per gudang dan site.",
  "Track task-level completion and log engineering metrics": "Lacak penyelesaian tingkat tugas dan catat metrik engineering",
  "Tracking Planned Value (PV), Earned Value (EV), and Actual Cost (AC) across selected period.": "Melacak Planned Value (PV), Earned Value (EV), dan Actual Cost (AC) pada periode yang dipilih.",
  "Tracking Planned vs Actual (%) over time": "Melacak Rencana vs Aktual (%) dari waktu ke waktu",
  "Transaction Type": "Tipe Transaksi",
  "Transmitting...": "Mengirimkan...",
  "Trends": "Tren",
  "Trip": "Perjalanan",
  "Trip Details": "Detail Perjalanan",
  "Try adjusting the module filter, keyword, or date range.": "Coba sesuaikan filter modul, kata kunci, atau rentang tanggal.",
  "Try adjusting your filters": "Coba sesuaikan filter Anda",
  "Try adjusting your filters or search criteria.": "Coba sesuaikan filter atau kriteria pencarian Anda.",
  "Try adjusting your search keyword": "Coba sesuaikan kata kunci pencarian Anda",
  "Try again": "Coba lagi",
  "Try Again": "Coba Lagi",
  "Try Allowing Camera": "Coba Izinkan Kamera",
  "Try changing the keyword or clearing your status filter.": "Coba ubah kata kunci atau hapus filter status Anda.",
  "Try changing the search keyword or status/role filter.": "Coba ubah kata kunci pencarian atau filter status/role.",
  "Try resetting your search or filters to see more results.": "Coba atur ulang pencarian atau filter untuk melihat lebih banyak hasil.",
  "Try using another process or feature name.": "Coba gunakan nama proses atau fitur lain.",
  "TT Progress": "Progres TT",
  "TT volume distribution per customer (top 4)": "Sebaran volume TT per customer (top 4)",
  "Type": "Tipe",
  "Type the details of the information to be conveyed...": "Ketik detail informasi yang akan disampaikan...",
  "Type the project code": "Ketik project code",
  "Type to create": "Ketik untuk membuat",
  "Type:": "Tipe:",
  "Unable to load Sales Order #": "Tidak dapat memuat Sales Order #",
  "Unable to load Sales Order details:": "Tidak dapat memuat detail Sales Order:",
  "Unable to resolve your user ID from current session.": "Tidak dapat menentukan ID pengguna Anda dari sesi saat ini.",
  "Unassigned": "Belum Ditugaskan",
  "Unified operational dashboard for meeting rooms, company vehicles and office visitors.": "Dasbor operasional terpadu untuk ruang rapat, kendaraan perusahaan, dan pengunjung kantor.",
  "Unique ID": "ID Unik",
  "Unit": "Satuan (Unit)",
  "Unit (UOM)": "Satuan (Unit / UOM)",
  "Unit (UOM) *": "Satuan (UOM) *",
  "Unit Price": "Harga Satuan",
  "Unit Price (IDR)": "Harga Satuan (IDR)",
  "Unknown": "Tidak Diketahui",
  "Unknown Customer": "Pelanggan Tidak Dikenal",
  "Unknown Division": "Divisi Tidak Diketahui",
  "Unknown error encountered": "Terjadi error yang tidak diketahui",
  "Unknown Position": "Jabatan Tidak Diketahui",
  "Unknown Site": "Site Tidak Dikenal",
  "Unknown Size": "Ukuran Tidak Diketahui",
  "Unknown User": "User Tidak Diketahui",
  "Unknown Visitor": "Pengunjung Tidak Dikenal",
  "UNREAD": "BELUM DIBACA",
  "unread on this page": "belum dibaca di halaman ini",
  "Unread:": "Belum dibaca:",
  "Unregistered": "Belum Terdaftar",
  "UOM": "Satuan",
  "Update": "Perbarui",
  "Update (Change)": "Update (Perubahan)",
  "Update Approval Route": "Update Jalur Approval",
  "Update Customer": "Perbarui Pelanggan",
  "Update Infrastructure Stage": "Perbarui Tahap Infrastruktur",
  "Update many tasks at once via Excel": "Update banyak task sekaligus via Excel",
  "Update opportunity status and documentation": "Perbarui status dan dokumentasi peluang",
  "Update Partner Data": "Perbarui Data Mitra",
  "UPDATE PASSWORD": "PERBARUI KATA SANDI",
  "Update Product": "Perbarui Produk",
  "Update Progress": "Perbarui Progres",
  "Update progress and manage risks": "Update progress dan kelola risiko",
  "Update Project Progress": "Perbarui Progres Proyek",
  "Update Stage": "Perbarui Tahap",
  "Update the contract information.": "Perbarui informasi kontrak.",
  "Update the superior order midway": "Update urutan atasan di tengah jalan",
  "Update Ticket Progress": "Perbarui Progres Tiket",
  "Update User & Roles": "Perbarui Pengguna & Role",
  "Update V": "Perbarui V",
  "Update WBS or TPD progress": "Update progress WBS atau TPD",
  "Updated": "Diperbarui",
  "updated": "memperbarui",
  "Updated Successfully!": "Berhasil Diperbarui!",
  "updated the configuration": "memperbarui konfigurasi",
  "Updated:": "Diperbarui:",
  "Updating...": "Memperbarui...",
  "Upload": "Unggah",
  "Upload & Link": "Unggah & Tautkan",
  "Upload & Process": "Upload & Proses",
  "Upload a new file or keep the existing one.": "Upload file baru atau pertahankan yang sudah ada.",
  "Upload a new file to replace it, or remove it to upload later": "Unggah file baru untuk menggantinya, atau hapus untuk mengunggah nanti",
  "Upload and link the Purchase Order": "Upload dan tautkan Purchase Order",
  "Upload and validate the file": "Upload dan validasi file",
  "Upload cancelled": "Unggah dibatalkan",
  "Upload Cancelled": "Upload Dibatalkan",
  "Upload Data": "Unggah Data",
  "Upload Digital Document (PDF)": "Upload Dokumen Digital (PDF)",
  "Upload evidence": "Unggah evidence",
  "Upload evidence and record risks": "Upload evidence dan catat risiko",
  "Upload failed": "Gagal mengunggah",
  "Upload failed ({status})": "Unggah gagal ({status})",
  "Upload failed: {value1}": "Upload gagal: {value1}",
  "Upload files": "Unggah file",
  "Upload from Device": "Unggah dari Perangkat",
  "Upload GPI document instead of link (max 50MB)": "Unggah dokumen GPI sebagai pengganti tautan (maks 50MB)",
  "Upload GPI File": "Unggah File GPI",
  "Upload GPI File (Optional)": "Unggah File GPI (Opsional)",
  "UPLOAD IMAGE": "UNGGAH GAMBAR",
  "Upload in progress": "Upload sedang berlangsung",
  "Upload New PO": "Upload PO Baru",
  "Upload New PO Document": "Upload Dokumen PO Baru",
  "Upload New Version": "Upload Versi Baru",
  "Upload one or more customer POs for this Sales Order. Each linked PO will be listed below.": "Unggah satu atau lebih PO customer untuk Sales Order ini. Setiap PO yang ditautkan akan terdaftar di bawah.",
  "Upload or correct the GPI": "Upload atau koreksi GPI",
  "Upload PDP Data": "Upload Data PDP",
  "Upload PO": "Unggah PO",
  "Upload PO Document": "Unggah Dokumen PO",
  "Upload PO file with metadata and server-side uniqueness validation.": "Unggah file PO dengan metadata dan validasi keunikan di sisi server.",
  "Upload Progress: {uploadProgress}% - {uploadStage}": "Progres Unggah: {uploadProgress}% - {uploadStage}",
  "Upload Purchase Order": "Unggah Purchase Order",
  "Upload Required / Action Needed": "Wajib Upload / Aksi Diperlukan",
  "Upload successful": "Unggah berhasil",
  "Upload Successful! (100%)": "Upload Berhasil! (100%)",
  "Upload the customer PO document file, verify the PO number, amount, validity period, and server validation.": "Unggah berkas dokumen PO customer, verifikasi nomor PO, nominal, masa berlaku, dan validasi server.",
  "Upload the GPI template and choose a region": "Upload template GPI dan pilih region",
  "Upload warnings:": "Peringatan unggahan:",
  "Upload, validation, linking, and status changes of a PO through to Release.": "Upload, validasi, penautan, dan perubahan status PO sampai Release.",
  "Uploaded": "Terunggah",
  "uploaded an attachment for": "mengunggah lampiran untuk",
  "Uploaded by": "Diunggah oleh",
  "Uploaded Date": "Tanggal Unggah",
  "Uploaded signature": "Tanda tangan yang diunggah",
  "Uploading Document...": "Mengunggah Dokumen...",
  "Uploading file...": "Mengunggah file...",
  "Uploading to Drive...": "Mengunggah ke Drive...",
  "Uploading to Google Drive...": "Mengunggah ke Google Drive...",
  "Uploading {stage_name} evidence {batchProgress}%": "Upload evidence {stage_name} {batchProgress}%",
  "Uploading...": "Mengunggah...",
  "Uploading... {uploadProgress}%": "Mengunggah... {uploadProgress}%",
  "USD (Dollar)": "USD (Dolar)",
  "Use a whole number 1–100. Progress cannot be lower than the current value (": "Gunakan angka bulat 1–100. Progress tidak bisa lebih kecil dari nilai saat ini (",
  "Use camera to add image": "Gunakan kamera untuk menambah gambar",
  "Use this option if the PO document was uploaded earlier in the general PO list.": "Gunakan opsi ini jika dokumen PO telah diunggah sebelumnya pada daftar PO umum.",
  "Use This Signature": "Gunakan Tanda Tangan Ini",
  "Used": "Terpakai",
  "User": "Pengguna",
  "User #{user_id}": "Pengguna #{user_id}",
  "User access rights updated successfully!": "Hak akses pengguna berhasil diperbarui!",
  "User added successfully!": "Pengguna berhasil ditambahkan!",
  "User ID:": "ID Pengguna:",
  "User Management": "Manajemen Pengguna",
  "User Not Found": "Pengguna Tidak Ditemukan",
  "User not found or already selected.": "User tidak ditemukan atau sudah dipilih.",
  "USER SETTINGS": "PENGATURAN PENGGUNA",
  "users": "pengguna",
  "Using saved signature from your profile": "Menggunakan tanda tangan tersimpan dari profil Anda",
  "Using the saved profile signature": "Menggunakan tanda tangan profil yang tersimpan",
  "V1 is the initial release, so there is no earlier version to compare.": "V1 adalah rilis awal, sehingga tidak ada versi sebelumnya untuk dibandingkan.",
  "Valid brief and market value?": "Brief dan market value valid?",
  "Valid rows were saved; {length} rows need correction — {preview}{more}.{duplicateNote}": "Baris yang valid telah disimpan; {length} baris perlu dikoreksi — {preview}{more}.{duplicateNote}",
  "Validate and approve the PO": "Validasi dan approve PO",
  "Validate fields, status, and permissions": "Validasi field, status, dan permission",
  "Validate the code, name, category, and price": "Validasi kode, nama, kategori, dan harga",
  "Validate the customer data": "Validasi data customer",
  "Validate the date order and duration": "Validasi urutan tanggal dan durasi",
  "Validate the partner identity and information": "Validasi identitas dan informasi partner",
  "Validate the weight then choose the template again": "Validasi weight lalu pilih template kembali",
  "Validated": "Divalidasi",
  "Validation or error message": "Pesan validasi atau error",
  "Validation Warnings:": "Peringatan Validasi:",
  "Validity End (Expiry)": "Masa Berlaku Akhir (Expiry)",
  "Validity Start": "Masa Berlaku Awal (Start)",
  "Valuation (IDR)": "Valuasi (IDR)",
  "Value": "Nilai",
  "Value (IDR)": "Nilai (IDR)",
  "Value Summary & Version Comparison": "Ringkasan Nilai & Perbandingan Versi",
  "Vehicle": "Kendaraan",
  "Vehicle #{vehicle_id}": "Kendaraan #{vehicle_id}",
  "Vehicle Booking": "Pemesanan Kendaraan",
  "Vehicle booking approved": "Booking kendaraan disetujui",
  "Vehicle booking rejected": "Booking kendaraan ditolak",
  "Vehicle booking submitted successfully!": "Pemesanan kendaraan berhasil diajukan!",
  "Vehicle Bookings": "Booking Kendaraan",
  "Vehicle Fleet": "Armada Kendaraan",
  "Vehicles": "Kendaraan",
  "Vendor": "Vendor",
  "Vendor & Strategic Partners": "Vendor & Mitra Strategis",
  "Vendor (Multi)": "Vendor (Beberapa)",
  "Vendor (Optional)": "Vendor (Opsional)",
  "Vendor / Company Name": "Nama Vendor / Perusahaan",
  "Vendor / Supplier": "Vendor / Pemasok",
  "Vendor Account": "Akun Vendor",
  "Vendor added successfully.": "Vendor berhasil ditambahkan.",
  "Vendor Category": "Kategori Vendor",
  "Vendor data downloaded successfully.": "Data vendor berhasil diunduh.",
  "Vendor deleted from the shared master data.": "Vendor berhasil dihapus dari shared master data.",
  "Vendor deleted successfully!": "Vendor berhasil dihapus!",
  "Vendor Identity": "Identitas Vendor",
  "Vendor import failed.": "Import vendor gagal.",
  "Vendor import finished.": "Import vendor selesai.",
  "Vendor import finished. {length} rows were skipped because the vendor account already exists.": "Impor vendor selesai. {length} baris dilewati karena akun vendor sudah ada.",
  "Vendor Management": "Manajemen Vendor",
  "Vendor Name": "Nama Vendor",
  "Vendor Name is required!": "Nama Vendor wajib diisi!",
  "Vendor office address": "Alamat kantor vendor",
  "Vendor Type": "Tipe Vendor",
  "Vendor updated successfully.": "Vendor berhasil diperbarui.",
  "Vendor {value1} successfully!": "Vendor berhasil di{value1}!",
  "Vendors": "Vendor",
  "vendors registered": "vendor terdaftar",
  "Verified": "Terverifikasi",
  "Verified Audit Score": "Skor Audit Terverifikasi",
  "Verified Score": "Skor Terverifikasi",
  "Verify the intake and baseline": "Verifikasi intake dan baseline",
  "Version": "Versi",
  "Version History": "Riwayat Versi",
  "Version history is unavailable.": "Riwayat versi tidak tersedia.",
  "Version V{currentVersion} (Initial)": "Versi V{currentVersion} (Awal)",
  "Version {value1} · First submitted": "Versi {value1} · Pertama kali diajukan",
  "VIEW": "LIHAT",
  "View": "Lihat",
  "View 360°": "Lihat 360°",
  "View all past progress submissions for this project.": "Lihat semua pengajuan progres sebelumnya untuk proyek ini.",
  "View All Projects": "Lihat Semua Proyek",
  "View Booking History →": "Lihat Riwayat Pemesanan →",
  "View detail": "Lihat detail",
  "View Details": "Lihat Detail",
  "View Document": "Lihat Dokumen",
  "View File": "Lihat Berkas",
  "View Full Details": "Lihat Detail Lengkap",
  "View History": "Lihat History",
  "View Merged PDF": "Lihat PDF Gabungan",
  "View Mermaid Code": "Lihat Kode Mermaid",
  "View newest documents across contracts, legality, and letters.": "Lihat dokumen terbaru dari kontrak, legalitas, dan surat.",
  "View only": "Hanya lihat",
  "View Partner": "Lihat Partner",
  "View Payload Details": "Lihat Detail Payload",
  "View PDF": "Lihat PDF",
  "View PDF SO": "Lihat PDF SO",
  "View PO List": "Lihat Daftar PO",
  "View Sales Order": "Lihat Sales Order",
  "View the S-Curve projection": "Lihat proyeksi S-Curve",
  "View {document_name}": "Lihat {document_name}",
  "View {name}": "Lihat {name}",
  "View-only mode — actions are only for approvers per the rules": "Mode lihat saja — tindakan hanya untuk approver sesuai aturan",
  "Visit Date": "Tanggal Kunjungan",
  "Visit date cannot be in the past": "Tanggal kunjungan tidak boleh di masa lalu",
  "Visit Information": "Informasi Kunjungan",
  "Visitor": "Pengunjung",
  "Visitor Detail": "Detail Pengunjung",
  "Visitor Info": "Info Pengunjung",
  "Visitor Name": "Nama Pengunjung",
  "Visitor Photo": "Foto Pengunjung",
  "Visitor Photo Identity": "Identitas Foto Pengunjung",
  "Visitor photo updated": "Foto pengunjung diperbarui",
  "Visitor Portal": "Portal Pengunjung",
  "Visitor Registration": "Pendaftaran Pengunjung",
  "Visitor Registration QR": "QR Pendaftaran Pengunjung",
  "Visitor Registration QR Code": "Kode QR Pendaftaran Pengunjung",
  "Visitor Status": "Status Pengunjung",
  "Visitor visit submitted": "Kunjungan pengunjung diajukan",
  "Visitor visits exported": "Kunjungan pengunjung diekspor",
  "Visitors": "Pengunjung",
  "Wait Approval": "Menunggu Persetujuan",
  "Wait for the batch update to finish before resetting.": "Tunggu batch update selesai sebelum reset.",
  "Waiting": "Menunggu",
  "Waiting Drop Approval": "Menunggu Persetujuan Drop",
  "Waiting for Google Drive retry": "Menunggu percobaan ulang Google Drive",
  "Waiting for the Drive process to start": "Menunggu proses Drive dimulai",
  "Waiting for turn": "Menunggu giliran",
  "WAREHOUSE": "GUDANG",
  "Warehouse": "Gudang",
  "Warehouse is required": "Gudang wajib diisi",
  "Warehouses": "Gudang",
  "Warm regards,": "Salam hangat,",
  "Warning": "Peringatan",
  "Was the GPI validation successful?": "Validasi GPI berhasil?",
  "Was the transaction successful?": "Transaksi berhasil?",
  "WBS S-Curve Revision": "Revisi Kurva-S WBS",
  "WBS Task Dates (from GPI)": "Tanggal Tugas WBS (dari GPI)",
  "WBS Template": "Templat WBS",
  "WBS Template Library": "Pustaka Templat WBS",
  "WBS Template:": "Templat WBS:",
  "WBS Templates": "Templat WBS",
  "WBS-linked Timeline Planner": "Perencana Linimasa Terhubung WBS",
  "We have added several new features to the AiBAS system to improve the user experience. Please check the system for more info.": "Kami telah menambahkan beberapa fitur baru ke dalam sistem AiBAS untuk meningkatkan pengalaman pengguna. Silakan periksa sistem untuk info lebih lanjut.",
  "Week": "Minggu",
  "Week View": "Tampilan Mingguan",
  "Weight": "Bobot",
  "Weight, plan, and actual progress at a glance.": "Bobot, rencana, dan progres aktual secara ringkas.",
  "Weighted": "Berbobot",
  "Welcome Back": "Selamat Datang Kembali",
  "We’re applying critical updates to restore full service. Your data is safe and remains intact.": "Kami sedang menerapkan pembaruan penting untuk memulihkan layanan penuh. Data Anda aman dan tetap utuh.",
  "What could happen, and where would it affect the project?": "Apa yang bisa terjadi, dan di mana dampaknya terhadap proyek?",
  "What happens when you extend?": "Apa yang terjadi saat Anda memperpanjang?",
  "When a document is submitted": "Saat dokumen diajukan",
  "When each stage is approved": "Setiap tahap disetujui",
  "When entering certain areas, use Personal Protective Equipment (PPE) according to the signs.": "Jika memasuki area tertentu, gunakan Alat Pelindung Diri (APD) sesuai dengan rambu.",
  "whole numbers 1–100": "angka bulat 1–100",
  "will be copied to": "akan disalin ke",
  "Win Rate": "Tingkat Kemenangan",
  "Window": "Jendela",
  "Withdraw Submission": "Tarik Pengajuan",
  "Withdraw Submission?": "Tarik Pengajuan?",
  "Withdraw the document to Draft to be revised/cancelled": "Tarik kembali dokumen ke Draft untuk direvisi/dibatalkan",
  "Withdrawing...": "Menarik...",
  "Within the next 30 days": "Dalam 30 hari kedepan",
  "Won Deals": "Deal Menang",
  "Work Breakdown Structure (WBS)": "Struktur Rincian Kerja (WBS)",
  "Work on the Proposal": "Kerjakan Proposal",
  "Workbench": "Meja Kerja",
  "WORKSPACE": "RUANG KERJA",
  "Workspace": "Ruang Kerja",
  "Workspace Management": "Manajemen Ruang Kerja",
  "Write a mitigation update…": "Tulis pembaruan mitigasi…",
  "Write approval notes...": "Tulis catatan persetujuan...",
  "Write the email subject here...": "Tulis subject email di sini...",
  "Write the rejection reason clearly so it can be corrected...": "Tuliskan alasan penolakan secara jelas agar dapat diperbaiki...",
  "x Revisions": "x Revisi",
  "XLSX export failed.": "Export XLSX gagal.",
  "XLSX export successful.": "Export XLSX berhasil.",
  "XLSX import failed.": "Import XLSX gagal.",
  "XLSX import successful. Inserted: {value1}, Updated: {value2}, Duplicates removed: {value3}, Skipped: {value4}. Sites synced: {value5}": "Import XLSX berhasil. Inserted: {value1}, Updated: {value2}, Duplicate dihapus: {value3}, Skipped: {value4}. Sites synced: {value5}",
  "XLSX template downloaded successfully.": "Template XLSX berhasil diunduh.",
  "Year": "Tahun",
  "Yearly": "Tahunan",
  "Yes": "Ada",
  "YES": "YA",
  "Yes, Approve": "Ya, Setujui",
  "Yes, Borrow": "Ya, Pinjam",
  "Yes, Finish IM": "Ya, Selesaikan IM",
  "Yes, Required": "Ya, Diperlukan",
  "Yes, Withdraw": "Ya, Tarik",
  "You": "Anda",
  "You are currently in Edit Mode and can mutate project data. Use with caution.": "Anda sedang dalam Mode Edit dan dapat mengubah data proyek. Gunakan dengan hati-hati.",
  "You are prohibited from being in the Company environment under the influence of alcohol/illegal drugs.": "Anda dilarang berada di lingkungan Perusahaan dalam kondisi pengaruh minuman keras/obat terlarang.",
  "You are the current approver for this SO.": "Anda adalah approver saat ini untuk SO ini.",
  "You can create draft IM, but submit will require a saved signature.": "Anda dapat membuat draf IM, tetapi pengajuan memerlukan tanda tangan tersimpan.",
  "You can edit basic project information, category, and solution architect here. For stage progression, continue via CRM Pipeline / Detail page.": "Anda dapat mengubah informasi dasar proyek, kategori, dan solution architect di sini. Untuk kemajuan tahap, lanjutkan melalui Pipeline CRM / halaman Detail.",
  "You do not have access rights to open the Approval Queue.": "Anda tidak memiliki hak akses untuk membuka antrean persetujuan (Approval Queue).",
  "You do not have admin broadcast permission.": "Anda tidak memiliki permission broadcast admin.",
  "You do not have permission to create SO": "Anda tidak memiliki izin untuk membuat SO",
  "You do not have permission to create vehicle bookings.": "Anda tidak memiliki izin untuk membuat booking kendaraan.",
  "You do not have permission to export contacts.": "Anda tidak memiliki permission export kontak.",
  "You do not have permission to import contacts.": "Anda tidak memiliki permission import kontak.",
  "You do not have permission to view the OPS Dashboard.": "Anda tidak memiliki izin untuk melihat Dasbor OPS.",
  "You do not have sufficient security permissions (RBAC) to open this page. Contact the Super Administrator if you need access.": "Anda tidak memiliki izin keamanan (RBAC) yang cukup untuk membuka halaman ini. Hubungi Super Administrator jika Anda memerlukan akses.",
  "You don't have any {activeTab} assignments at the moment.": "Anda tidak memiliki penugasan {activeTab} saat ini.",
  "You don't have permission to access this page.": "Anda tidak memiliki izin untuk mengakses halaman ini.",
  "You have {count} approvals pending today.": "Anda memiliki {count} persetujuan yang menunggu hari ini.",
  "You haven't submitted any change requests for this project.": "Anda belum mengajukan permintaan perubahan untuk proyek ini.",
  "You must agree to the Safety Terms first.": "Anda harus menyetujui Ketentuan Keselamatan terlebih dahulu.",
  "You must be accompanied by a Supervisor/Guide if you will tour the Project Site Area.": "Anda harus didampingi Pengawas/Pemandu jika akan mengelilingi Areal Lokasi Proyek.",
  "Your Action": "Aksi Anda",
  "Your name": "Nama Anda",
  "Your profile has no saved signature yet. Please click the": "Profil Anda belum memiliki tanda tangan tersimpan. Silakan klik tombol",
  "Your profile signature will be affixed to the IM completion document": "Tanda tangan profil Anda akan dibubuhkan pada dokumen penyelesaian IM",
  "Your Session Is About to End": "Sesi Anda Akan Berakhir",
  "Your signature": "Tanda tangan Anda",
  "Your Signature": "Tanda Tangan Anda",
  "Your Signature (Required)": "Tanda Tangan Anda (Wajib)",
  "Your signature picture is ready to be used for approval.": "Gambar tanda tangan Anda siap digunakan untuk persetujuan.",
  "Your signature will be affixed to this Internal Memo document": "Tanda tangan Anda akan dibubuhkan pada dokumen Internal Memo ini",
  "Your turn ·": "Giliran Anda ·",
  "Zoom": "Perbesar",
  "Zoom in diagram": "Perbesar diagram",
  "Zoom out diagram": "Perkecil diagram",
  "Zoom Visitor": "Perbesar Pengunjung",
  "{active_issue_count} active issues on TPD {value1}": "{active_issue_count} issue aktif pada TPD {value1}",
  "{active_issue_count} active issues on TPD {value1}. Check the Health & Risk tab.": "{active_issue_count} issue aktif pada TPD {value1}. Periksa tab Health & Risk.",
  "{categorySlug} Details": "Detail {categorySlug}",
  "{createdRiskCount} identified risks created—one for each selected task.": "{createdRiskCount} risiko teridentifikasi dibuat—satu untuk setiap tugas yang dipilih.",
  "{dealt} Dealt": "{dealt} Deal",
  "{dropped} Dropped": "{dropped} Batal",
  "{duration} days": "{duration} hari",
  "{fileName} · Preparing batch data": "{fileName} · Menyiapkan data batch",
  "{label}: {count} documents": "{label}: {count} dokumen",
  "{length} evidence detected": "{length} evidence terdeteksi",
  "{length} match{value1}": "{length} cocok{value1}",
  "{length} New Documents Selected": "{length} Dokumen Baru Terpilih",
  "{length} registered item{value1}": "{length} item terdaftar{value1}",
  "{length} task date rows have been saved in real time.": "Sebanyak {length} baris task dates telah tersimpan secara realtime.",
  "{length} TPD selected": "{length} TPD dipilih",
  "{progress} Progress": "{progress} Berjalan",
  "{stage_name} evidence versions": "Versi evidence {stage_name}",
  "{stage_name}: evidence processed successfully": "{stage_name}: evidence berhasil diproses",
  "{timeline_duration_days} days": "{timeline_duration_days} hari",
  "{total} Leads": "{total} Lead",
  "{tpds_reset} TPDs were reset successfully.{driveMessage}": "{tpds_reset} TPD berhasil di-reset.{driveMessage}",
  "{value1} left": "Sisa {value1}",
  "{value1} of {value2} stages completed": "{value1} dari {value2} tahap selesai",
  "{value1} over": "Lewat {value1}",
  "| Comp:": "| Sel:",
  "| Valid until": "| Berlaku hingga",
  "© 2026 AiBAS Platform. All rights reserved.": "© 2026 Platform AiBAS. Hak cipta dilindungi.",
  "· max 50 MB": "· maks 50 MB",
  "— Select Related IM —": "— Pilih IM Terkait —",
  "— Select Sales Order —": "— Pilih Sales Order —",
  "— Select WBS Template —": "— Pilih Templat WBS —",
  "• AX ID:": "• ID AX:",
  "• Last update:": "• Pembaruan terakhir:",
  "← Back to Dashboard": "← Kembali ke Dasbor",
  "↓ Download PDF": "↓ Unduh PDF",
  "≤ 7 days": "≤ 7 hari",
  "⊘ Can Skip": "⊘ Dapat Dilewati",
  "⏰ Start Time": "⏰ Jam Mulai",
  "○ Required": "○ Wajib",
  "☕ Additional Request": "☕ Permintaan Tambahan",
  "⚠️ Negotiation Stage Requirements": "⚠️ Persyaratan Tahap Negosiasi",
  "⚠️ Please assign at least one PDP Data before approval": "⚠️ Mohon tetapkan setidaknya satu Data PDP sebelum persetujuan",
  "⚠️ {missingFields}  Please update the opportunity with the required information before moving to the next stage.": "⚠️ {missingFields}  Mohon perbarui peluang dengan informasi yang diperlukan sebelum maju ke tahap berikutnya.",
  "✅ Approve Negotiation": "✅ Setujui Negosiasi",
  "✏️ Edit Revision": "✏️ Edit Revisi",
  "✓ Activity log is updated": "✓ Log aktivitas diperbarui",
  "✓ Aging timer resets to 0 days (7 more days)": "✓ Timer aging diatur ulang ke 0 hari (7 hari lagi)",
  "✓ Approve Page {currentPage} & Complete Entire Document ({totalPages}/{totalPages1})": "✓ Setujui Hal {currentPage} & Selesaikan Seluruh Dokumen ({totalPages}/{totalPages1})",
  "✓ Approved": "✓ Disetujui",
  "✓ Complete": "✓ Selesai",
  "✓ Completed": "✓ Selesai",
  "✓ Confirm Approve": "✓ Konfirmasi Persetujuan",
  "✓ Confirm Position & Complete Document": "✓ Konfirmasi Posisi & Selesaikan Dokumen",
  "✓ Confirm Position & Complete Document (Page": "✓ Konfirmasi Posisi & Selesaikan Dokumen (Hal",
  "✓ GPI uploaded successfully. Data has been refreshed.": "✓ GPI berhasil diunggah. Data telah dimuat ulang.",
  "✓ Opportunity stays in current stage": "✓ Peluang tetap di tahap saat ini",
  "✓ Update synchronized successfully.": "✓ Pembaruan berhasil disinkronkan.",
  "✓ Your reason is recorded in history": "✓ Alasan Anda dicatat dalam riwayat",
  "✕ Close": "✕ Tutup",
  "✗ Rejected": "✗ Ditolak",
  "❌ Approve Drop": "❌ Setujui Drop",
  "⨯ Incomplete": "⨯ Belum Lengkap",
  "🎥 Projector": "🎥 Proyektor",
  "🏁 End Time": "🏁 Jam Selesai",
  "🏙️ In Town": "🏙️ Dalam Kota",
  "👤 Assign SA PIC": "👤 Tetapkan PIC SA",
  "👥 Participants / Booking For": "👥 Peserta / Booking For",
  "📅 Date": "📅 Tanggal",
  "📋 Assign Category": "📋 Tetapkan Kategori",
  "📌 Purpose and Objective": "📌 Maksud dan Tujuan",
  "📎 View Link": "📎 Lihat Tautan",
  "📢 ANNOUNCEMENT": "📢 PENGUMUMAN",
  "📥 Download File": "📥 Unduh File",
  "📺 Smart TV & Projector": "📺 Smart TV & Proyektor",
  "📽️ Need a Projector?": "📽️ Butuh Proyektor?",
  "📽️ Yes": "📽️ Ya",
  "🚕 Order Online Taxi": "🚕 Pesan Taksi Online",
  "🛣️ Out of Town": "🛣️ Luar Kota",
  "🧑‍✈️ Needs Driver": "🧑‍✈️ Butuh Driver",
  "Template name is required before saving.": "Nama template wajib diisi sebelum disimpan.",
  "Template message cannot be empty.": "Pesan template tidak boleh kosong.",
  "Template subject cannot be empty.": "Subject template tidak boleh kosong.",
  "Custom template saved successfully.": "Template custom berhasil disimpan.",
  "Confirmation incomplete. Tick the confirmation and type the phrase KIRIM BROADCAST.": "Konfirmasi belum lengkap. Centang konfirmasi dan isi frasa KIRIM BROADCAST.",
  "Failed to send broadcast.": "Gagal mengirim broadcast.",
  "Broadcast sent to {sent} recipients.": "Broadcast berhasil dikirim ke {sent} penerima.",
  "You are about to send this email to {length} user role groups. Make sure the information is correct.": "Anda akan mengirim email ini ke {length} grup role pengguna. Pastikan informasi sudah benar.",
  "Yes, Send Broadcast": "Ya, Kirim Broadcast",
  "Export failed.": "Export gagal.",
  "Template download failed.": "Download template gagal.",
  "XLSX import successful. Inserted: {value1}, Updated: {value2}, Duplicates removed: {value3}, Skipped: {value4}.": "Import XLSX berhasil. Inserted: {value1}, Updated: {value2}, Duplicate dihapus: {value3}, Skipped: {value4}.",
  "Failed to load asset data.": "Gagal memuat data aset.",
  "Failed to update notification.": "Gagal update notifikasi.",
  "All notifications marked as read.": "Semua notifikasi ditandai sudah dibaca.",
  "No bookings this week.": "Tidak ada booking minggu ini.",
  "No meetings on this date.": "Tidak ada meeting pada tanggal ini.",
  "Failed to load available vehicles.": "Gagal memuat kendaraan yang tersedia.",
  "Vehicle unavailable, the GA team will book an online taxi": "Kendaraan tidak tersedia, akan dipesankan Taksi Online oleh tim GA",
  "Customer ID is missing. Complete it first via the Stop Clock form.": "Customer ID belum ada. Lengkapi dulu via Stop Clock form.",
  "Customer ID is required.": "Customer ID wajib diisi.",
  "Stop Clock reason is required.": "Stop Clock reason wajib dipilih.",
  "Cancel reason is required.": "Cancel reason wajib dipilih.",
  "Description is required for close/degrade.": "Description wajib diisi untuk close/degrade.",
  "RCA Category is required for close/degrade.": "RCA Category wajib dipilih untuk close/degrade.",
  "RCA is required for close/degrade.": "RCA wajib diisi untuk close/degrade.",
  "Last Occur is required for close/degrade.": "Last Occur wajib diisi untuk close/degrade.",
  "Last RSL is required for close/degrade.": "Last RSL wajib diisi untuk close/degrade.",
  "Reason is required for {value1}.": "Reason wajib diisi untuk {value1}.",
  "Failed to update ticket.": "Gagal update tiket.",
  "No vehicle": "Tidak ada kendaraan",
  "This booking will be cancelled and cannot be reactivated from this page.": "Booking ini akan dibatalkan dan tidak dapat diaktifkan kembali dari halaman ini.",
  "Camera preview failed to start. Try closing and reopening the camera.": "Preview kamera gagal dimulai. Coba tutup lalu buka kamera lagi.",
  "This browser does not support the camera. Use the latest Chrome, Firefox, Safari, or Edge.": "Browser tidak mendukung kamera. Gunakan Chrome, Firefox, Safari, atau Edge terbaru.",
  "Camera access is blocked. Click the lock/camera icon in the browser address bar and allow Camera for this site.": "Akses kamera diblokir. Klik ikon kunci/kamera di address bar browser lalu izinkan Camera untuk situs ini.",
  "Camera permission denied. Open Settings > Privacy > Camera, then allow access for your browser, or use an old photo.": "Izin kamera ditolak. Buka Settings > Privacy > Camera, lalu izinkan akses untuk browser Anda, atau gunakan foto lama.",
  "Failed to load notifications": "Gagal memuat notifikasi",
  "Unread": "Belum Dibaca",
  "Import successful! ": "Import Berhasil! ",
  "Import failed: ": "Gagal Import: ",
  "Check the file format": "Cek format file",
  "Are you sure you want to delete this product? This action cannot be undone.": "Yakin ingin menghapus produk ini? Tindakan ini tidak dapat dibatalkan.",
  "Failed to create booking": "Gagal membuat booking",
  "Mermaid diagram could not be rendered.": "Diagram Mermaid tidak dapat dirender.",
  "Warning: Changing the WBS Template will reset the dates you have already filled in. Are you sure you want to continue?": "Perhatian: Mengubah WBS Template akan mengatur ulang susunan tanggal yang sudah Anda isi. Anda yakin ingin melanjutkan?",
  "All WBS stages must have a target date:": "Semua tahap WBS wajib memiliki tanggal target:",
  "...and {value1} more.": "...dan {value1} lainnya.",
  "Export successful! File task-dates-so{soId}.xlsx downloaded successfully.": "Export berhasil! Berkas task-dates-so{soId}.xlsx berhasil diunduh.",
  "Failed to create the XLSX export file.": "Gagal membuat berkas export XLSX.",
  "Import data is incomplete. Some date columns are not filled:": "Data import tidak lengkap. Beberapa kolom tanggal belum diisi:",
  "Import successful! {length} task dates saved to the database.": "Import berhasil! {length} task dates berhasil disimpan ke database.",
  "Auto-save failed: {message}. Click 'Save Task Dates' manually.": "Auto-save gagal: {message}. Klik 'Save Task Dates' manual.",
  "The XLSX file format could not be read.": "Format berkas XLSX tidak dapat dibaca.",
  "Check the file format again": "Periksa kembali format file",
  "Failed to roll back to the previously released version.": "Gagal kembali ke versi released sebelumnya.",
  "Actual: {value1}%": "Aktual: {value1}%",
  "No actual data yet": "Belum ada data aktual",
  "Notes are required from the AM before submitting for approval.": "Notes wajib diisi oleh AM sebelum submit approval.",
  "Please draw a signature first.": "Silakan gambar tanda tangan terlebih dahulu.",
  "Please select/upload a signature file first.": "Silakan pilih/unggah file tanda tangan terlebih dahulu.",
  "You don't have a saved signature yet. Please choose the New Drawing or Upload tab.": "Anda belum memiliki tanda tangan tersimpan. Silakan pilih tab Gambar Baru atau Upload.",
  "Please upload a signature first.": "Silakan unggah tanda tangan terlebih dahulu.",
  "The saved signature image is not available. Choose New Drawing or Upload.": "Gambar tanda tangan tersimpan tidak tersedia. Pilih Gambar Baru atau Upload.",
  "Are you sure you want to delete this customer? This action cannot be undone.": "Yakin ingin menghapus customer ini? Tindakan ini tidak dapat dibatalkan.",
  "Are you sure you want to delete this partner data? This action cannot be undone.": "Yakin ingin menghapus data partner ini? Tindakan ini tidak dapat dibatalkan.",
  "Are you sure you want to delete this document?": "Yakin ingin menghapus dokumen ini?",
  "Submit this IM finish process? Approval will run through step 2.": "Submit proses finish IM ini? Approval akan berjalan sampai step 2.",
  "Resubmit this IM? The approval process will start from the beginning.": "Submit ulang IM ini? Proses approval akan dimulai dari awal.",
  "Are you sure you want to delete this entity? Related data may be affected.": "Yakin ingin menghapus entitas ini? Data yang terkait mungkin akan terpengaruh.",
  "Failed to connect to the server. Make sure the backend is running.": "Koneksi ke server gagal. Pastikan Backend menyala.",
  "Filling Out the Mandatory Employment Reporting Form": "Pengisian Form Wajib Lapor Ketenagakerjaan",
  "Your browser does not support the camera. Use the latest Chrome, Firefox, Safari, or Edge, or choose the 'Upload from Device' option.": "Browser Anda tidak mendukung kamera. Gunakan Chrome, Firefox, Safari, atau Edge terbaru, atau pilih opsi 'Upload from Device'.",
  "Camera permission denied. Open Settings > Privacy > Camera, then allow access for your browser, or use 'Upload from Device'.": "Izin kamera ditolak. Buka Settings > Privacy > Camera, lalu izinkan akses untuk browser Anda, atau gunakan 'Upload from Device'.",
  "Percentage must be a whole number without decimals.": "Persentase harus berupa angka bulat tanpa desimal.",
  "Percentage must be between 1 and 100.": "Persentase harus antara 1 sampai 100.",
  "Progress cannot be lower than the current value ({currentCompletion}%).": "Progress tidak bisa lebih kecil dari nilai saat ini ({currentCompletion}%).",
  "An evidence file is required when progress reaches 100%.": "File evidence wajib dipilih saat progress mencapai 100%.",
  "Enter a valid Google Spreadsheet link or Google Drive folder.": "Masukkan link Google Spreadsheet atau folder Google Drive yang valid.",
  "New value must be > ": "Nilai baru harus > ",
  "Batch update completed with some failures.": "Batch update selesai dengan sebagian kegagalan.",
  "Batch update failed to process.": "Batch update gagal diproses.",
  "Unsupported file format. Please use .xlsx or .xls": "Format file tidak didukung. Harap gunakan .xlsx atau .xls",
  "Failed to process progress reset.": "Reset progress gagal diproses.",
  "Not synchronized yet": "Belum disinkronisasi",
  "Batch failed: {firstFailureReason}": "Batch gagal: {firstFailureReason}",
  "Batch completed: {recordsSuccess} succeeded, {recordsSkipped} skipped, {recordsFailed} failed.": "Batch selesai: {recordsSuccess} berhasil, {recordsSkipped} skip, {recordsFailed} gagal.",
  "Planned: {value1}%": "Rencana: {value1}%",
  "Finish Submitted": "Diajukan Finish",
  "Extended": "Diperpanjang",
  "found": "ditemukan",
  "available": "tersedia",
  "Failed to update approval route": "Gagal memperbarui jalur approval",
  "Check-In": "Check-In",
  "Escalated": "Dieskalasi",
  "Report your arrival to the Security Post/Reception and ask for a \"Guest Card\".": "Laporkan kedatangan Anda ke POS SATPAM/Resepsionis dan minta \"Guest Card\".",
  "The office rooms and all areas are \"NO SMOKING\" except in designated places.": "Ruangan dalam kantor dan seluruh area adalah \"BEBAS ROKOK\" kecuali pada tempat yang ditentukan.",
  "Pick a free slot, let's make things happen.": "Pilih jadwal luang, let's make things happen.",
  "Search project name or ID...": "Cari nama atau ID proyek...",
  "Select the document value tier.": "Pilih value tier dokumen.",
  "Project ID": "ID Proyek",
  "Project name": "Nama proyek",
  "Projects available for selection when adding a Procurement document.": "Proyek yang dapat dipilih saat menambah dokumen Procurement.",
  "All Pages Mode": "Mode Semua Halaman",
  "✓ Confirm Position & Sign All {totalPages} Pages": "✓ Konfirmasi Posisi & TTD Semua {totalPages} Halaman",
  "Approvers are set automatically from Settings for a resubmission.": "Untuk submit ulang, approver ditentukan otomatis dari Settings.",
  "Stages 1-3 initial every page in one click; Stage 4 signs a single page as the final approval.": "Tahap 1-3 paraf semua halaman dalam satu klik; Tahap 4 TTD satu halaman sebagai final approval.",
  "Stage 1 initials every page in one click; Stage 2 signs a single page as the final approval.": "Tahap 1 paraf semua halaman dalam satu klik; Tahap 2 TTD satu halaman sebagai final approval.",
  "Under Rp 50,000,000: the requester picks one Stage 1 approver, then Approver 4 gives the final approval.": "Di bawah Rp 50.000.000: pengaju memilih satu approver Tahap 1, lalu Approver 4 memberi final approval.",
  "The requester picks one Stage 1 approver, then Approver 2 and Approver 3 initial the document. Stage 4 gives the final approval by value tier, except for Cancellation Letters, which are finalized by Approver 2.": "Pengaju memilih satu approver Tahap 1, lalu Approver 2 dan Approver 3 memaraf dokumen. Tahap 4 memberi final approval sesuai value tier, kecuali Cancellation Letter yang difinalkan oleh Approver 2.",
  "Initials every page for BAK and Others": "Paraf semua halaman untuk BAK dan Others",
  "BAK and Others · signs a single page · chosen by value tier": "BAK dan Others · TTD satu halaman · sesuai value tier",
  "Select Stage 4 Approver": "Pilih Approver Tahap 4",
  "Stages 1-3 must be different users; Stage 4 may repeat one of them.": "Tahap 1-3 harus pengguna berbeda; Tahap 4 boleh sama dengan salah satunya.",
  "Approver 2 initials every page after stage 1. Becomes the": "Approver 2 memaraf semua halaman setelah tahap 1. Menjadi",
  "Stage 3 · Approver": "Tahap 3 · Approver",
  "Approver 3 initials every page for BAK and Others documents. Not applicable to Cancellation Letter.": "Approver 3 memaraf semua halaman untuk dokumen BAK dan Others. Tidak berlaku untuk Cancellation Letter.",
  "Stage 4 · Final Approval": "Tahap 4 · Final Approval",
  "Signs one page for BAK and Others. The signer depends on the document value tier.": "TTD satu halaman untuk BAK dan Others. Penanda tangan bergantung pada value tier dokumen.",
  "The requester picks one Stage 1 approver, then Approver 2 and Approver 3 initial the document. Stage 4 gives the final approval by value tier.": "Pengaju memilih satu approver Tahap 1, lalu Approver 2 dan Approver 3 memaraf dokumen. Tahap 4 memberi final approval sesuai value tier.",
  "Initials every page": "Paraf semua halaman",
  "Signs a single page · chosen by value tier": "TTD satu halaman · sesuai value tier",
  "Approver 2 initials every page after stage 1.": "Approver 2 memaraf semua halaman setelah tahap 1.",
  "Approver 3 initials every page after stage 2.": "Approver 3 memaraf semua halaman setelah tahap 2.",
  "Signs one page as the final approval for every document type. The signer depends on the document value tier.": "TTD satu halaman sebagai final approval untuk semua tipe dokumen. Penanda tangan bergantung pada value tier dokumen.",
  "Signs one page as the final approval for every document type. The signer depends on the document value tier; under Rp 50,000,000 it follows Stage 1 directly.": "TTD satu halaman sebagai final approval untuk semua tipe dokumen. Penanda tangan bergantung pada value tier dokumen; di bawah Rp 50.000.000 langsung setelah Tahap 1.",
  "Approver 2 initials every page after stage 1. Only for documents of Rp 50,000,000 and above.": "Approver 2 memaraf semua halaman setelah tahap 1. Hanya untuk dokumen Rp 50.000.000 ke atas.",
  "Approver 3 initials every page after stage 2. Only for documents of Rp 50,000,000 and above.": "Approver 3 memaraf semua halaman setelah tahap 2. Hanya untuk dokumen Rp 50.000.000 ke atas.",
  "Stage 2 · Approver": "Tahap 2 · Approver",
  "Determines who gives the Stage 4 final approval.": "Menentukan siapa yang memberi final approval Tahap 4.",
  "{summary} {length} rows skipped — {preview}{more}.": "{summary} {length} baris dilewati — {preview}{more}.",
  "Signature (TTD)": "Tanda Tangan (TTD)",
  "Paraf: page 1 is placed on its own, then one position is used for pages 2 onward.": "Paraf: halaman 1 diatur sendiri, lalu satu posisi dipakai untuk halaman 2 dan seterusnya.",
  "Signature (TTD): signed once, on any page.": "Tanda tangan (TTD): satu kali, bebas di halaman mana saja.",
  "The requester picks one Stage 1 approver, then Approver 2 and Approver 3 paraf the document. Approver 4 signs it as the final approval.": "Pengaju memilih satu approver Tahap 1, lalu Approver 2 dan Approver 3 memaraf dokumen. Approver 4 menandatangani sebagai final approval.",
  "The requester picks one Stage 1 approver to paraf the document, then Approver 4 signs it as the final approval.": "Pengaju memilih satu approver Tahap 1 untuk memaraf dokumen, lalu Approver 4 menandatangani sebagai final approval.",
  "Stages 1-3 paraf page 1, then pages 2 onward in one click; Stage 4 signs once on any page.": "Tahap 1-3 paraf halaman 1, lalu halaman 2 dan seterusnya dalam satu klik; Tahap 4 TTD satu kali di halaman mana saja.",
  "Stage 1 parafs page 1, then pages 2 onward in one click; Stage 2 signs once on any page.": "Tahap 1 paraf halaman 1, lalu halaman 2 dan seterusnya dalam satu klik; Tahap 2 TTD satu kali di halaman mana saja.",
  "Approve & Paraf": "Setujui & Paraf",
  "Approve & Sign": "Setujui & Tanda Tangan",
  "Step 1 of 2 · Page 1 only": "Langkah 1 dari 2 · Hanya halaman 1",
  "Step 2 of 2 · Pages 2–{totalPages}": "Langkah 2 dari 2 · Halaman 2–{totalPages}",
  "Confirm Page 1 Position & Continue to Page 2": "Konfirmasi Posisi Halaman 1 & Lanjut ke Halaman 2",
  "✓ Confirm Position & Apply to Pages 2–{totalPages}": "✓ Konfirmasi Posisi & Terapkan ke Halaman 2–{totalPages}",
  "Parafs page 1, then pages 2 onward": "Paraf halaman 1, lalu halaman 2 dan seterusnya",
  "Signs once on any page · chosen by document type and value tier": "TTD satu kali di halaman mana saja · sesuai tipe dokumen dan value tier",
  "BAK of Rp 50,000,000 and above, and Others": "BAK Rp 50.000.000 ke atas, dan Lainnya",
  "BAK under Rp 50,000,000, and Cancellation Letter": "BAK di bawah Rp 50.000.000, dan Surat Pembatalan",
  "A rejection is emailed to the requester only. A completed document is emailed to the requester and its approvers.": "Penolakan hanya dikirim email ke pengaju. Dokumen yang selesai dikirim email ke pengaju dan para approver-nya.",
  "Completed Documents": "Dokumen Selesai",
  "Also emails the signed document to these users once its approval circulation is complete": "Dokumen yang sudah ditandatangani juga dikirim email ke pengguna ini setelah sirkulasi approval selesai",
  "Add Completion Recipient": "Tambah Penerima Dokumen Selesai",
  "No extra recipients yet.": "Belum ada penerima tambahan.",
  "The requester picks one approver from the Stage 1 list when submitting a document. A paraf is placed on page 1 first, then once for pages 2 onward.": "Pengaju memilih satu approver dari daftar Tahap 1 saat mengajukan dokumen. Paraf diletakkan di halaman 1 dulu, lalu satu kali untuk halaman 2 dan seterusnya.",
  "Approver 2 parafs after stage 1. Only for a BAK of Rp 50,000,000 and above, and Others.": "Approver 2 memaraf setelah tahap 1. Hanya untuk BAK Rp 50.000.000 ke atas, dan Lainnya.",
  "Approver 3 parafs after stage 2. Only for a BAK of Rp 50,000,000 and above, and Others.": "Approver 3 memaraf setelah tahap 2. Hanya untuk BAK Rp 50.000.000 ke atas, dan Lainnya.",
  "Signs once on any page as the final approval. A BAK under Rp 50,000,000 and a Cancellation Letter go straight from Stage 1 to the under Rp 50,000,000 signer; a BAK of Rp 50,000,000 and above and Others go to the other signer after Stage 3.": "TTD satu kali di halaman mana saja sebagai final approval. BAK di bawah Rp 50.000.000 dan Surat Pembatalan langsung dari Tahap 1 ke penanda tangan di bawah Rp 50.000.000; BAK Rp 50.000.000 ke atas dan Lainnya ke penanda tangan satunya setelah Tahap 3.",
  "Review & Paraf Document": "Tinjau & Paraf Dokumen",
  "Value Tier (Optional)": "Value Tier (Opsional)",
  "Optional. The route stays the same: Approver 1, 2 and 3 paraf, then Approver 4 signs.": "Opsional. Rutenya tetap: Approver 1, 2, dan 3 paraf, lalu Approver 4 tanda tangan.",
  "Optional. The route stays the same: Approver 1 parafs, then Approver 4 signs.": "Opsional. Rutenya tetap: Approver 1 paraf, lalu Approver 4 tanda tangan.",
  "Opportunities appear here once they reach the Qualification stage.": "Opportunity muncul di sini setelah masuk tahap Qualification.",
  "Save Notes": "Simpan Catatan",
  "No reason was recorded.": "Tidak ada alasan yang dicatat.",
  "File type not supported. Use PDF, Excel, Word or ZIP.": "Tipe file tidak didukung. Gunakan PDF, Excel, Word, atau ZIP.",
  "The file is larger than {max} MB.": "Ukuran file melebihi {max} MB.",
  "Sales Value must be greater than zero.": "Nilai Penjualan harus lebih dari nol.",
  "Needs (SOW, BOQ, etc) is required.": "Kebutuhan (SOW, BOQ, dll) wajib diisi.",
  "Duration (months) is required.": "Durasi (bulan) wajib diisi.",
  "Enter a valid link starting with http:// or https://": "Masukkan tautan yang valid, diawali http:// atau https://",
  "Please upload the GPI file.": "Silakan unggah file GPI.",
  "Update Dealsheet": "Perbarui Dealsheet",
  "Between 0 and 100": "Antara 0 dan 100",
  "Qualification Data": "Data Qualification",
  "e.g. 12": "mis. 12",
  "e.g. 25": "mis. 25",
  "Authority (User/Buyer)": "Otoritas (User/Buyer)",
  "If left empty, the Account Manager fills it in before requesting the negotiation approval.": "Jika dikosongkan, Account Manager mengisinya sebelum mengajukan approval Negotiation.",
  "Link or file": "Tautan atau file",
  "Click to choose a file or drop it here": "Klik untuk memilih file atau seret ke sini",
  "PDF, Excel, Word or ZIP — max 50MB": "PDF, Excel, Word, atau ZIP — maks 50MB",
  "PDF, Excel, Word, ZIP or RAR — max 50MB": "PDF, Excel, Word, ZIP, atau RAR — maks 50MB",
  "Submitting marks the task as Done and moves the opportunity to Proposal.": "Setelah dikirim, task menjadi Selesai dan opportunity pindah ke Proposal.",
  "Notes saved.": "Catatan tersimpan.",
  "Status updated.": "Status diperbarui.",
  "Dealsheet submitted. The opportunity moved to Proposal.": "Dealsheet terkirim. Opportunity pindah ke Proposal.",
  "Prepare the dealsheet for opportunities in Qualification. Submitting it moves the opportunity to Proposal.": "Siapkan dealsheet untuk opportunity di tahap Qualification. Setelah dikirim, opportunity pindah ke Proposal.",
  "Estimated Start": "Estimasi Mulai",
  "Request for {nextStage} sent. Waiting for the Chief Sales approval.": "Pengajuan ke {nextStage} terkirim. Menunggu persetujuan Chief Sales.",
  "Stage moved to {nextStage}": "Tahap pindah ke {nextStage}",
  "Chief Sales approval required": "Perlu persetujuan Chief Sales",
  "The opportunity stays in {currentStage} until the Chief Sales approves the request from the task list.": "Opportunity tetap di {currentStage} sampai Chief Sales menyetujui pengajuan dari daftar task.",
  "Submitted by {name}": "Dikirim oleh {name}",
  "These values come from the Business Analyst and are sent for approval as they are. You only need to add the project brief and the authority.": "Nilai ini berasal dari Business Analyst dan diajukan apa adanya. Anda hanya perlu mengisi project brief dan otoritas.",
  "Please complete the qualification data. It is reviewed by the Chief Sales before the opportunity moves to Proposal.": "Lengkapi data qualification. Data ini direview Chief Sales sebelum opportunity pindah ke Proposal.",
  "Negotiation Stage Requirements": "Persyaratan Tahap Negotiation",
  "Provide the PO Estimate and the GPI document, either as a link or as a file.": "Isi PO Estimate dan dokumen GPI, berupa tautan atau file.",
  "Choose the GPI file": "Pilih file GPI",
  "Browse": "Pilih",
  "Filled in by the Business Analyst. Change it if needed.": "Diisi oleh Business Analyst. Ubah bila perlu.",
  "Request {nextStage} Approval": "Ajukan Persetujuan {nextStage}",
  "Progress to {nextStage}": "Lanjut ke {nextStage}",
  "From the Analyst dealsheet": "Dari dealsheet Analyst",
  "A request is still waiting for approval.": "Masih ada pengajuan yang menunggu persetujuan.",
  "Awaiting Proposal Approval": "Menunggu Persetujuan Proposal",
  "Negotiation Approved": "Negotiation Disetujui",
  "Negotiation Request Rejected": "Pengajuan Negotiation Ditolak",
  "Review the dealsheet, then use Next Stage to add the project brief and authority and request the approval.": "Review dealsheet, lalu gunakan Tahap Berikutnya untuk mengisi project brief dan otoritas serta mengajukan persetujuan.",
  "Product Category:": "Kategori Produk:",
  "Product / Service:": "Produk / Layanan:",
  "Product / Service": "Produk / Layanan",
  "No brief was written for this step.": "Belum ada brief untuk langkah ini.",
  "Request submitted": "Pengajuan dikirim",
  "{role} approval": "Persetujuan {role}",
  "Rejected by": "Ditolak oleh",
  "Waiting for": "Menunggu",
  "Waiting for approval": "Menunggu persetujuan",
  "Please select a customer.": "Silakan pilih customer.",
  "Failed to update the opportunity.": "Gagal memperbarui opportunity.",
  "Failed to create the opportunity.": "Gagal membuat opportunity.",
  "Edit the project information and its product or solution. Stage changes go through the pipeline.": "Ubah informasi proyek serta produk atau solusinya. Perubahan tahap dilakukan lewat pipeline.",
  "A new opportunity starts in the Lead stage. Declare its product or solution now or later.": "Opportunity baru dimulai di tahap Lead. Produk atau solusinya bisa diisi sekarang atau nanti.",
  "New Lead": "Lead Baru",
  "Create": "Buat",
  "Project Information": "Informasi Proyek",
  "Search customer...": "Cari customer...",
  "No customer found": "Customer tidak ditemukan",
  "Product / Solution": "Produk / Solusi",
  "Solution": "Solusi",
  "Click the selected category again to clear it.": "Klik lagi kategori yang dipilih untuk mengosongkannya.",
  "Solution / Service Name": "Nama Solusi / Layanan",
  "Search and select from the catalog": "Cari dan pilih dari katalog",
  "Search name or SKU...": "Cari nama atau SKU...",
  "No {category} in the catalog yet.": "Belum ada {category} di katalog.",
  "The product catalog is empty.": "Katalog produk masih kosong.",
  "The list follows the selected category and comes from the Product Catalog.": "Daftar mengikuti kategori yang dipilih dan diambil dari Katalog Produk.",
  "Not declared": "Belum ditentukan",
  "Select...": "Pilih...",
  "Clear selection": "Hapus pilihan",
  "Search...": "Cari...",
  "No results found": "Tidak ada hasil",
  "Product not found.": "Produk tidak ditemukan.",
  "Product name is required.": "Nama produk wajib diisi.",
  "Choose the product category.": "Pilih kategori produk.",
  "Choose the product type.": "Pilih tipe produk.",
  "Choose the unit of measure.": "Pilih satuan (UOM).",
  "Unit price is required.": "Harga satuan wajib diisi.",
  "Please complete the required fields.": "Lengkapi kolom yang wajib diisi.",
  "Product updated successfully!": "Produk berhasil diperbarui!",
  "Failed to save the product.": "Gagal menyimpan produk.",
  "Failed to delete the product.": "Gagal menghapus produk.",
  "Product Type": "Tipe Produk",
  "Manage units": "Kelola satuan",
  "Select a unit": "Pilih satuan",
  "Search unit...": "Cari satuan...",
  "No unit found. Add it from Manage units.": "Satuan tidak ditemukan. Tambahkan lewat Kelola satuan.",
  "Failed to load the units of measure.": "Gagal memuat daftar satuan.",
  "Failed to save the unit of measure.": "Gagal menyimpan satuan.",
  "Unit of measure added.": "Satuan ditambahkan.",
  "Unit of measure updated.": "Satuan diperbarui.",
  "Unit of measure deleted.": "Satuan dihapus.",
  "Units of Measure (UOM)": "Satuan (UOM)",
  "Units (UOM)": "Satuan (UOM)",
  "Product Catalog": "Katalog Produk",
  "The units offered in the Unit field of a product.": "Daftar satuan yang tersedia di kolom Satuan pada produk.",
  "Unit Name": "Nama Satuan",
  "e.g. Pcs, Meter, Lot": "mis. Pcs, Meter, Lot",
  "No units of measure yet.": "Belum ada satuan.",
  "In use by products, cannot be deleted.": "Masih dipakai produk, tidak bisa dihapus.",
  "Delete Unit of Measure": "Hapus Satuan",
  "Are you sure you want to delete the unit \"{name}\"?": "Yakin ingin menghapus satuan \"{name}\"?",
  "Row {row}: {reason}": "Baris {row}: {reason}",
  "Change WBS Template": "Ganti Template WBS",
  "Change Template": "Ganti Template",
  "Submit IM Finish": "Ajukan Finish IM",
  "Resubmit IM": "Submit Ulang IM",
  "example: 150.000.000": "contoh: 150.000.000",
  "Discount (%)": "Diskon (%)",
  "Receive the review result and the SA PIC": "Terima hasil review dan SA PIC",
  "Responsibilities of the Head of SA and the SA PIC for Qualification and Proposal.": "Tanggung jawab Head of SA serta SA PIC pada Qualification dan Proposal.",
  "Confirm the Product or Solution category": "Konfirmasi kategori Product atau Solution",
  "The SA PIC receives the assignment": "SA PIC menerima penugasan",
  "Confirm Product or Solution": "Konfirmasi Product atau Solution",
  "Prepare the dealsheet for opportunities in Qualification. Submitted ones stay listed as history.": "Siapkan dealsheet untuk opportunity di tahap Qualification. Yang sudah dikirim tetap tampil sebagai riwayat.",
  "Analyst Task": "Task Analyst",
  "Open folder": "Buka folder",
  "No dealsheet has been submitted yet.": "Belum ada dealsheet yang dikirim.",
  "Scope & Timeline": "Lingkup & Jadwal",
  "Expected Timeline": "Perkiraan Jadwal",
  "Analyst Dealsheet": "Dealsheet Analyst",
  "GPI File": "File GPI",
  "Table view": "Tampilan tabel",
  "Filter Approval": "Filter Approval",
  "All Approvals": "Semua Approval",
  "No history yet.": "Belum ada riwayat.",
  "Submitted dealsheets are listed here with their approval status.": "Dealsheet yang sudah dikirim tampil di sini beserta status approval-nya.",
  "Pending approval": "Menunggu approval",
  "Superseded": "Digantikan",
  "Changed": "Berubah",
  "Compared": "Perbandingan",
  "{value} pts": "{value} poin",
  "This is the first version. A comparison appears here once a newer version is submitted.": "Ini versi pertama. Perbandingan muncul di sini setelah versi yang lebih baru dikirim.",
  "V{version} rejected": "V{version} ditolak",
  "Dealsheet V{version}": "Dealsheet V{version}",
  "Dealsheet Versions ({count})": "Versi Dealsheet ({count})",
  "required to reject": "wajib diisi untuk reject",
  "Write notes. To reject, explain what has to be revised...": "Tulis catatan. Untuk reject, jelaskan apa yang harus direvisi...",
  "Write the reason for the rejection first.": "Tulis dulu alasan penolakannya.",
  "V{version} in revision": "V{version} sedang direvisi",
  "{count} versions": "{count} versi",
  "The Business Analyst is preparing V{version}. The opportunity returns to Proposal once it is submitted.": "Business Analyst sedang menyiapkan V{version}. Opportunity kembali ke Proposal setelah versi itu dikirim.",
  "Open link": "Buka link",
  "File Attachment": "Lampiran File",
  "External Link": "Link Eksternal",
  "Compared with V{version}": "Dibandingkan dengan V{version}",
  "Loading preview...": "Memuat preview...",
  "Sheets": "Sheet",
  "This sheet is empty.": "Sheet ini kosong.",
  "Only the first {rows} rows and {columns} columns are shown. Download the file to see everything.": "Hanya {rows} baris dan {columns} kolom pertama yang ditampilkan. Download file untuk melihat semuanya.",
  "This file type cannot be previewed here. Download it to open it.": "Tipe file ini tidak bisa di-preview di sini. Download untuk membukanya.",
  "Sales Order management.": "Manajemen Sales Order.",
  "Create Room": "Buat Ruangan",
  "Manage Rooms": "Kelola Ruangan",
  "Unavailable": "Tidak Tersedia",
  "The rooms offered on the meeting booking page.": "Ruangan yang ditawarkan di halaman booking rapat.",
  "Editing {name}": "Mengubah {name}",
  "Room Name": "Nama Ruangan",
  "e.g. Jawa, Kamboja": "mis. Jawa, Kamboja",
  "e.g. Head Office, 2nd Floor": "mis. Head Office, Lantai 2",
  "Capacity": "Kapasitas",
  "Screen / Smart TV": "Layar / Smart TV",
  "Screen": "Layar",
  "Maintenance keeps the room on the list but closed for booking. Inactive hides it from the list.": "Pemeliharaan membuat ruangan tetap tampil tetapi tidak bisa dibooking. Tidak Aktif menyembunyikannya dari daftar.",
  "Photo": "Foto",
  "Choose Photo": "Pilih Foto",
  "Change Photo": "Ganti Foto",
  "JPG, PNG or WebP, at most 4 MB. Optional.": "JPG, PNG, atau WebP, maksimal 4 MB. Opsional.",
  "The photo must be a JPG, PNG or WebP image of at most 4 MB.": "Foto harus berupa gambar JPG, PNG, atau WebP berukuran maksimal 4 MB.",
  "Bookings": "Booking",
  "No meeting rooms yet.": "Belum ada ruang rapat.",
  "Has bookings, cannot be deleted. Set it to Inactive instead.": "Sudah punya booking, tidak bisa dihapus. Ubah statusnya menjadi Tidak Aktif.",
  "Delete Meeting Room": "Hapus Ruang Rapat",
  "Are you sure you want to delete the room \"{name}\"?": "Yakin ingin menghapus ruangan \"{name}\"?",
  "Meeting room added.": "Ruang rapat ditambahkan.",
  "Meeting room updated.": "Ruang rapat diperbarui.",
  "Meeting room deleted.": "Ruang rapat dihapus.",
  "Welcome": "Selamat datang",
  "Welcome, {name}": "Selamat datang, {name}",
  "Your Alita SSO account is not registered in AiBAS, so only the modules below are open to you.":
    "Akun Alita SSO Anda tidak terdaftar di AiBAS, jadi hanya modul di bawah ini yang terbuka untuk Anda.",
  "Champion": "Juara 1",
  "Runner-up": "Juara 2",
  "Third Place": "Juara 3",
  "Top 3 Account Managers": "3 Account Manager Teratas",
  "Ranked by number of deals won": "Peringkat berdasarkan jumlah deal yang dimenangkan",
  "Ranked by value of deals won": "Peringkat berdasarkan nilai deal yang dimenangkan",
  "Deals Won": "Deal Dimenangkan",
  "Deal Value Won": "Nilai Deal Dimenangkan",
  "Total Leads": "Total Lead",
  "Total Value": "Total Nilai",
  "No winner yet": "Belum ada pemenang",
  "No deals won in this period yet. The podium is still open.": "Belum ada deal yang dimenangkan pada periode ini. Podium masih terbuka.",
  "Show all {count} account managers": "Tampilkan semua {count} account manager",
  "Show less": "Tampilkan lebih sedikit",
  "Opportunity": "Opportunity",
  "Approve Finish": "Setujui Finish",
  "Clear Canvas": "Bersihkan Kanvas",
  "Draw Signature": "Gambar Tanda Tangan",
  "E-Sign": "E-Sign",
  "Edit Revision": "Edit Revisi",
  "Rejection": "Penolakan",
  "Save & Approve": "Simpan & Setujui",
  "Upload Image": "Unggah Gambar",
  "Created At": "Dibuat Pada",
  "Created By": "Dibuat Oleh",
  "Library": "Library",
  "Loading template...": "Memuat template...",
  "Standard stages and weights applied to project timelines, versioned per Delivery SOW Set.": "Tahapan dan bobot standar untuk timeline proyek, berversi per Delivery SOW Set.",
  "{count} template(s)": "{count} template",
  "No document has been uploaded for this PO yet.": "Belum ada dokumen yang diunggah untuk PO ini.",
  "Edit Mode": "Mode Edit",
  "Failed to load the purchase order.": "Gagal memuat purchase order.",
  "Internal Memo (Optional)": "Internal Memo (Opsional)",
  "Keep File": "Pertahankan File",
  "Loading purchase order...": "Memuat purchase order...",
  "New File": "File Baru",
  "No file selected": "Belum ada file dipilih",
  "PO changes saved.": "Perubahan PO tersimpan.",
  "Purchase order not found or you have no access to it.": "Purchase order tidak ditemukan atau Anda tidak punya akses.",
  "Search IM number or subject...": "Cari nomor atau perihal IM...",
  "Search SO number...": "Cari nomor SO...",
  "The current file is marked for deletion.": "File saat ini ditandai untuk dihapus.",
  "The PO file was not found on the server": "File PO tidak ditemukan di server",
  "The record points to a file that is no longer in storage. Upload the document again to restore the preview.": "Data PO menunjuk ke file yang sudah tidak ada di storage. Unggah ulang dokumennya agar pratinjau tampil kembali.",
  "Attach": "Lampirkan",
  "Attach {count} Document(s)": "Lampirkan {count} Dokumen",
  "Click to choose an Excel file (.xlsx, .xls, .csv)": "Klik untuk memilih file Excel (.xlsx, .xls, .csv)",
  "Columns read: PO Number, Customer, PO Date, Start Date, Expiry Date, PO Value (IDR) Exclude PPN. An export can be edited and imported again. Rows whose PO number already exists for the same customer are skipped.": "Kolom yang dibaca: PO Number, Customer, PO Date, Start Date, Expiry Date, PO Value (IDR) Exclude PPN. Hasil export bisa diedit lalu diimpor lagi. Baris dengan nomor PO yang sudah ada untuk customer yang sama akan dilewati.",
  "Continue to Bulk Attachments": "Lanjut ke Lampiran Massal",
  "Failed to download the import template.": "Gagal mengunduh template import.",
  "Failed to match the files with purchase orders.": "Gagal mencocokkan file dengan purchase order.",
  "Folder / File Name": "Nama Folder / File",
  "Import Data": "Impor Data",
  "Import Purchase Orders": "Import Purchase Order",
  "Import failed.": "Import gagal.",
  "Max. 10MB": "Maks. 10MB",
  "Name each sub-folder (or each file) after its PO number. Characters that cannot be used in a folder name are ignored when matching, so 190_09_ASM_01FS_2026 matches PO 190/09/ASM/01FS/2026.": "Beri nama setiap subfolder (atau setiap file) sesuai nomor PO-nya. Karakter yang tidak bisa dipakai di nama folder diabaikan saat pencocokan, jadi 190_09_ASM_01FS_2026 cocok dengan PO 190/09/ASM/01FS/2026.",
  "No PO with this number": "Tidak ada PO dengan nomor ini",
  "No files were found in the selection.": "Tidak ada file dalam pilihan.",
  "Reading files and matching PO numbers...": "Membaca file dan mencocokkan nomor PO...",
  "Select all": "Pilih semua",
  "Start Over": "Mulai Ulang",
  "Step 1: import the PO data from Excel. Step 2: attach the documents in bulk, matched by PO number.": "Langkah 1: impor data PO dari Excel. Langkah 2: lampirkan dokumen secara massal, dicocokkan berdasarkan nomor PO.",
  "The ZIP file could not be read.": "File ZIP tidak dapat dibaca.",
  "The files could not be read.": "File tidak dapat dibaca.",
  "Upload failed.": "Unggah gagal.",
  "You do not have permission to import purchase orders.": "Anda tidak punya izin untuk mengimpor purchase order.",
  "{count} attached": "{count} terlampir",
  "{count} failed": "{count} gagal",
  "{count} file(s)": "{count} file",
  "{count} file(s) ignored": "{count} file diabaikan",
  "{count} files found, a PO keeps one document": "Ada {count} file, satu PO hanya menyimpan satu dokumen",
  "{count} ignored": "{count} diabaikan",
  "{count} matched": "{count} cocok",
  "{count} without PO": "{count} tanpa PO",
  "— Same PO number at several customers —": "— Nomor PO sama di beberapa customer —",
  "Uploading": "Mengunggah",
  "Choose the PO": "Pilih PO",
  "Replaces current file": "Mengganti file lama",
  "Restores missing file": "Memulihkan file hilang",
  "1 · Excel Data": "1 · Data Excel",
  "2 · Bulk Attachments": "2 · Lampiran Massal",
  "Choose Folder": "Pilih Folder",
  "Choose ZIP": "Pilih ZIP",
  "Choose Files": "Pilih File",
  "Parent folder with one sub-folder per PO": "Folder induk dengan satu subfolder per PO",
  "The same folder, compressed as .zip": "Folder yang sama, dikompres sebagai .zip",
  "Several files named after their PO number": "Beberapa file yang dinamai sesuai nomor PO",
  "Only PDF, JPG and PNG files can be attached": "Hanya file PDF, JPG, dan PNG yang bisa dilampirkan",
  "Larger than 10MB": "Lebih dari 10MB",
  "This file is not a valid ZIP archive.": "File ini bukan arsip ZIP yang valid.",
  "ZIP64 archives are not supported. Split the archive or upload the folder instead.": "Arsip ZIP64 tidak didukung. Pecah arsipnya atau unggah foldernya langsung.",
  "The ZIP archive is damaged.": "Arsip ZIP rusak.",
  "Password-protected ZIP archives are not supported.": "Arsip ZIP berpassword tidak didukung.",
  "This browser cannot unpack ZIP files. Upload the folder instead.": "Browser ini tidak bisa membuka ZIP. Unggah foldernya langsung.",
  "PO number already exists for this customer": "Nomor PO sudah ada untuk customer ini",
  "PO Number is empty": "PO Number kosong",
  "Customer is empty": "Customer kosong",
  "PO Date is empty or not a valid date": "PO Date kosong atau bukan tanggal yang valid",
  "Expiry Date is before PO Date": "Expiry Date lebih awal dari PO Date",
  "Could not be saved": "Tidak dapat disimpan",
  "Back to PO List": "Kembali ke Daftar PO",
  // Weekly Corsec
  "Weekly application development update": "Update pengembangan aplikasi mingguan",
  "Weekly Application Development Update": "Update Pengembangan Aplikasi Mingguan",
  "Application": "Aplikasi",
  "Summary of progress, difficulty and success of the work on every application module.": "Ringkasan progres, tingkat kesulitan, dan keberhasilan pengerjaan setiap modul aplikasi.",
  "Period:": "Periode:",
  "Active week": "Minggu aktif",
  "Previous week": "Minggu sebelumnya",
  "Total Modules": "Total Modul",
  "Average Progress": "Rata-rata Progress",
  "Status Done": "Status Done",
  "Update Details per Module": "Rincian Update per Modul",
  "Change Log": "Log Perubahan",
  "Log": "Log",
  "Search module, description or tag...": "Cari modul, deskripsi, atau tag...",
  "{shown} of {total} modules shown": "{shown} dari {total} modul ditampilkan",
  "No module matches the filter.": "Tidak ada modul yang cocok dengan filter.",
  "Search this tag": "Cari tag ini",
  "success": "berhasil",
  "Difficulty": "Kesulitan",
  "Success Rate": "Success Rate",
  "Apps": "Apps",
  "Tags": "Tag",
  "Weeks": "Daftar minggu",
  "{done} of {total} done · {progress}%": "{done} dari {total} done · {progress}%",
  "New Week": "Minggu Baru",
  "Create Week {week}": "Buat Week {week}",
  "Edit Week": "Ubah Minggu",
  "Delete Week": "Hapus Minggu",
  "Delete this empty week?": "Hapus minggu kosong ini?",
  "Weekly Corsec could not be loaded": "Weekly Corsec tidak dapat dimuat",
  "No week yet": "Belum ada minggu",
  "Create the first week to start recording the weekly updates.": "Buat minggu pertama untuk mulai mencatat update mingguan.",
  "Week {week} has not been created yet": "Week {week} belum dibuat",
  "Create it to record this week's work; previous weeks stay available above.": "Buat minggu ini untuk mencatat pekerjaan minggu ini; minggu-minggu sebelumnya tetap bisa dibuka di atas.",
  "Weekly Corsec is only available to super admins.": "Weekly Corsec hanya tersedia untuk super admin.",
  "Add Item": "Tambah Item",
  "Edit Item": "Ubah Item",
  "Delete Item": "Hapus Item",
  "Delete {label}? The deletion is kept in the week's log.": "Hapus {label}? Penghapusan tetap tercatat di log minggu ini.",
  "+ New category...": "+ Kategori baru...",
  "New category name": "Nama kategori baru",
  "e.g. CRM": "mis. CRM",
  "Tags (comma separated)": "Tag (pisahkan dengan koma)",
  "e.g. Sales Pipeline, Proposal": "mis. Sales Pipeline, Proposal",
  "Period start": "Awal periode",
  "Period end": "Akhir periode",
  "The request failed.": "Permintaan gagal.",
  "The item was added.": "Item berhasil ditambahkan.",
  "The item was updated.": "Item berhasil diperbarui.",
  "The item was deleted.": "Item berhasil dihapus.",
  "The week was created.": "Minggu berhasil dibuat.",
  "The week was updated.": "Minggu berhasil diperbarui.",
  "The week was deleted.": "Minggu berhasil dihapus.",
  "No changes recorded yet.": "Belum ada perubahan yang tercatat.",
  "Week imported": "Minggu diimpor",
  "Week created": "Minggu dibuat",
  "Week updated": "Minggu diubah",
  "Item added": "Item ditambahkan",
  "Item updated": "Item diubah",
  "Item deleted": "Item dihapus",
  "{count} items": "{count} item",
  "Every change made to {week}.": "Semua perubahan pada {week}.",
  "Back to Tasks": "Kembali ke Tugas Saya",
  // CRM AM performance chart
  "Ranking": "Peringkat",
  "Show all {count}": "Tampilkan semua {count}",
  "No data for {metric} yet.": "Belum ada data {metric}.",
  "Deals won": "Deal won",
  "On progress": "On progress",
  "Total opportunities": "Total peluang",
  "by account manager": "per account manager",
  "Won": "Won",
  "Share of all deals won": "Porsi dari seluruh deal won",
  "Share of all opportunities in progress": "Porsi dari seluruh peluang yang sedang berjalan",
  "Share of all opportunities, including {count} dropped": "Porsi dari seluruh peluang, termasuk {count} yang dibatalkan",
  "Ranked by number of opportunities in progress": "Peringkat berdasarkan jumlah peluang yang sedang berjalan",
  "Ranked by value of opportunities in progress": "Peringkat berdasarkan nilai peluang yang sedang berjalan",
  "Ranked by number of opportunities": "Peringkat berdasarkan jumlah peluang",
  "Ranked by value of opportunities": "Peringkat berdasarkan nilai peluang",
  "{count} projects": "{count} proyek",
  // Internal memo expiry
  "Date - Expired Date": "Tanggal - Tanggal Kedaluwarsa",
  "{count} days overdue": "Lewat {count} hari",
  "{count} days left": "Sisa {count} hari",
  "Expires today": "Kedaluwarsa hari ini",
  // OPS batch evidence copy
  "{count} evidence file(s) are being copied to Google Drive in the background.": "{count} file evidence sedang disalin ke Google Drive di latar belakang.",
  "The stages whose evidence cannot be opened, and the later stages of the same row, are left out.": "Stage yang evidence-nya tidak dapat dibuka, beserta stage sesudahnya di baris yang sama, akan dilewati.",
  "Continue without these {count} evidence": "Lanjutkan tanpa {count} evidence ini",
  "Failed to queue the evidence again.": "Gagal mengantrekan ulang evidence.",
  "Evidence queued to be copied again.": "Evidence diantrekan untuk disalin ulang.",
  "Copy the batch evidence that failed to reach Google Drive again": "Salin ulang evidence batch yang gagal masuk ke Google Drive",
  "Retry failed evidence ({count})": "Ulangi evidence gagal ({count})",
  "The evidence could not be copied to Google Drive. Use Retry failed evidence.": "Evidence gagal disalin ke Google Drive. Gunakan tombol Ulangi evidence gagal.",
  "Progres tersimpan, evidence disalin di latar belakang": "Progres tersimpan, evidence disalin di latar belakang",
  "Evidence ditautkan": "Evidence ditautkan",
  // Dashly (shown as Dashly)
  "& Reports": "& Report",
  "(Empty)": "(Kosong)",
  "2 decimals": "2 desimal",
  "31 Des 2026": "31 Des 2026",
  "A slicer filters every visual of the same dataset in this report. Each viewer sets their own values.": "Slicer memfilter semua visual dari dataset yang sama di report ini. Setiap pembaca mengatur nilainya sendiri.",
  "Access granted.": "Akses diberikan.",
  "Access level": "Level akses",
  "Access removed.": "Akses dicabut.",
  "Add column": "Tambah kolom",
  "Add filter": "Tambah filter",
  "Add prefix": "Tambah awalan",
  "Add rule": "Tambah aturan",
  "Add step": "Tambah langkah",
  "Add suffix": "Tambah akhiran",
  "Add the first visual": "Tambahkan visual pertama",
  "Add this email as Viewer (untick Notify people):": "Tambahkan email ini sebagai Viewer (hapus centang Beri tahu orang):",
  "Add to report": "Tambahkan ke report",
  "Add value": "Tambah nilai",
  "Add visual": "Tambah visual",
  "Add visuals": "Tambah visual",
  "Add visuals from datasets you can view. Changes are saved right away.": "Tambahkan visual dari dataset yang bisa Anda lihat. Perubahan langsung tersimpan.",
  "Added": "Ditambahkan",
  "Aggregation": "Agregasi",
  "Aggregations": "Agregasi",
  "AiBAS Dashly": "AiBAS Dashly",
  "All conditions (AND)": "Semua kondisi (DAN)",
  "All items": "Semua item",
  "All statuses": "Semua status",
  "Any": "Bebas",
  "Any condition (OR)": "Salah satu kondisi (ATAU)",
  "Any signed-in AiBAS user can view (read only), even without the Dashly module.": "Semua pengguna AiBAS yang login bisa melihat (baca saja), walaupun tidak punya modul Dashly.",
  "Applied steps": "Langkah diterapkan",
  "Applying the steps to all rows...": "Menerapkan langkah ke semua baris...",
  "Area": "Area",
  "Ascending": "Naik (A→Z)",
  "Ask an administrator for the Dashly permission you need.": "Minta administrator memberikan izin Dashly yang Anda perlukan.",
  "Attribute column name": "Nama kolom atribut",
  "Audit": "Audit",
  "Automatic": "Otomatis",
  "Average": "Rata-rata",
  "Back to AiBAS": "Kembali ke AiBAS",
  "Back to datasets": "Kembali ke daftar dataset",
  "Back to reports": "Kembali ke daftar report",
  "Bar": "Batang horizontal",
  "Building preview...": "Menyiapkan preview...",
  "Cannot change '{value}' into {type}.": "Tidak dapat mengubah '{value}' menjadi {type}.",
  "Capitalize Each Word": "Huruf Besar Tiap Kata",
  "Card (KPI)": "Kartu (KPI)",
  "Cards for totals, column or line charts for trends, a table for details and slicers to filter.": "Kartu untuk total, grafik kolom atau garis untuk tren, tabel untuk detail, dan slicer untuk memfilter.",
  "Cards, charts, tables and slicers built from your datasets.": "Kartu, grafik, tabel, dan slicer dari dataset Anda.",
  "Category / axis": "Kategori / sumbu",
  "Category A→Z / oldest": "Kategori A→Z / terlama",
  "Category Z→A / newest": "Kategori Z→A / terbaru",
  "Change link": "Ganti link",
  "Change link…": "Ganti link…",
  "Change type": "Ubah tipe",
  "Character positions": "Posisi karakter",
  "Choose a column": "Pilih kolom",
  "Choose a dataset": "Pilih dataset",
  "Choose a dataset and fields to see a preview.": "Pilih dataset dan field untuk melihat preview.",
  "Choose columns": "Pilih kolom",
  "Choose range": "Pilih range",
  "Choose sheet {name}": "Pilih sheet {name}",
  "Chosen (in order)": "Dipilih (berurutan)",
  "Clear all slicers ({count})": "Hapus semua slicer ({count})",
  "Click the bottom-right cell, or close to keep the end empty.": "Klik sel kanan-bawah, atau tutup agar akhir range mengikuti data.",
  "Click the top-left cell of the table.": "Klik sel kiri-atas tabel.",
  "Close & Load": "Tutup & Load",
  "Close sheet": "Tutup sheet",
  "Column": "Kolom",
  "Column menu": "Menu kolom",
  "Column types": "Tipe kolom",
  "Column whose values become columns": "Kolom yang nilainya menjadi kolom",
  "Columns": "Kolom",
  "Columns (in order)": "Kolom (berurutan)",
  "Columns that stay (the others are unpivoted)": "Kolom yang tetap (sisanya di-unpivot)",
  "Columns to keep (in this order)": "Kolom yang dipertahankan (sesuai urutan ini)",
  "Combine header rows": "Gabung baris header",
  "Conditional column": "Kolom kondisional",
  "Conditions": "Kondisi",
  "Confidential": "Rahasia",
  "Confidential (export and link sharing restricted)": "Rahasia (export dan berbagi lewat link dibatasi)",
  "Confidential data can only be shared with specific people, not with everyone who has the link.": "Data rahasia hanya bisa dibagikan ke orang tertentu, tidak ke semua orang yang memiliki link.",
  "Confidential data: export and link sharing are restricted.": "Data rahasia: export dan berbagi lewat link dibatasi.",
  "Confidential data: the export is recorded in the audit log.": "Data rahasia: export dicatat di audit log.",
  "Configured": "Terkonfigurasi",
  "Count": "Jumlah",
  "Count (non-empty)": "Jumlah (tidak kosong)",
  "Count distinct": "Jumlah unik",
  "Count rows": "Jumlah baris",
  "Create a new link?": "Buat link baru?",
  "Create a report and add visuals from your datasets.": "Buat report dan tambahkan visual dari dataset Anda.",
  "Create link": "Buat link",
  "Create new link": "Buat link baru",
  "Data": "Data",
  "Data & Reports": "Data & Report",
  "Data labels": "Label data",
  "Data taken from Google Sheets, tidied with saved steps and ready for reports.": "Data dari Google Sheets, dirapikan dengan langkah tersimpan dan siap dipakai di report.",
  "Data type: {type}": "Tipe data: {type}",
  "Dataset": "Dataset",
  "Dataset name": "Nama dataset",
  "Dataset properties": "Properti dataset",
  "Dataset restored.": "Dataset dipulihkan.",
  "Datasets": "Dataset",
  "Datasets other people share with you appear here.": "Dataset yang dibagikan orang lain kepada Anda muncul di sini.",
  "Datasets per user": "Dataset per user",
  "Datasets shared with me": "Dataset dibagikan ke saya",
  "Date & time": "Tanggal & waktu",
  "Date part": "Bagian tanggal",
  "Date range": "Rentang tanggal",
  "Day": "Hari",
  "Day name": "Nama hari",
  "Day of week (number)": "Hari ke (angka)",
  "Decimal number": "Bilangan desimal",
  "Default": "Bawaan",
  "Default link expiry": "Masa berlaku default link",
  "Delete dataset?": "Hapus dataset?",
  "Delete report?": "Hapus report?",
  "Delete step": "Hapus langkah",
  "Delete step?": "Hapus langkah?",
  "Delete visual": "Hapus visual",
  "Delete visual?": "Hapus visual?",
  "Deleted datasets stay here for a while before they are removed for good.": "Dataset yang dihapus tersimpan di sini beberapa waktu sebelum dihapus permanen.",
  "Delimiter": "Pembatas",
  "Des 2026": "Des 2026",
  "Descending": "Turun (Z→A)",
  "Detail": "Detail",
  "Discard": "Buang",
  "Discard changes?": "Buang perubahan?",
  "Discard this draft?": "Buang draft ini?",
  "Display format": "Format tampilan",
  "Distinct": "Unik",
  "Do not use personal data (NIK, bank accounts, health data) unless it is really needed. Mark the dataset Confidential if it holds sensitive data.": "Jangan memakai data pribadi (NIK, nomor rekening, data kesehatan) kecuali benar-benar diperlukan. Tandai dataset sebagai Rahasia bila berisi data sensitif.",
  "Donut": "Donut",
  "Draft: Close & Load runs these steps on every row and saves the dataset.": "Draft: Tutup & Load menjalankan langkah ini ke semua baris dan menyimpan dataset.",
  "Drag to reorder": "Seret untuk mengubah urutan",
  "Duplicate": "Duplikat",
  "Duplicate column": "Duplikat kolom",
  "Edit properties": "Ubah properti",
  "Edit report": "Edit report",
  "Edit step": "Ubah langkah",
  "Edit visual": "Edit visual",
  "Editor": "Editor",
  "Editor preview": "Preview editor",
  "Editors can change the steps and refresh, but cannot share, delete or export confidential data.": "Editor bisa mengubah langkah dan me-refresh, tetapi tidak bisa membagikan, menghapus, atau mengekspor data rahasia.",
  "Else if": "Jika tidak, jika",
  "Empty + whole cell = empty cells": "Kosong + seluruh sel = sel kosong",
  "Empty = new links do not expire": "Kosong = link baru tidak kedaluwarsa",
  "Empty = no expiry": "Kosong = tanpa kedaluwarsa",
  "End cell": "Sel akhir",
  "End delimiter": "Pembatas akhir",
  "English": "Inggris",
  "Error": "Error",
  "Every import, load, share, link opening, export and setting change in Dashly.": "Setiap import, load, berbagi, pembukaan link, export, dan perubahan pengaturan di Dashly.",
  "Everyone in AiBAS with the link": "Semua pengguna AiBAS yang memiliki link",
  "Exact date": "Tanggal persis",
  "Example: ROUND([Nilai] / 1000000, 1) or IF([Status] = \"Won\", 1, 0)": "Contoh: ROUND([Nilai] / 1000000, 1) atau IF([Status] = \"Won\", 1, 0)",
  "Expires on": "Berlaku sampai",
  "Export data": "Export data",
  "Export files kept": "File export disimpan",
  "Export…": "Export…",
  "Extract": "Ekstrak",
  "Extract text": "Ekstrak teks",
  "Failed loads (7 days)": "Load gagal (7 hari)",
  "Fill down": "Isi ke bawah",
  "Filter": "Filter",
  "Filter on column": "Filter pada kolom",
  "Filter rows": "Filter baris",
  "Filter…": "Filter…",
  "Find": "Cari",
  "First 50 rows, actual values (formula results, not formulas).": "50 baris pertama, nilai aktual (hasil rumus, bukan rumusnya).",
  "First characters": "Karakter awal",
  "First value": "Nilai pertama",
  "Fix": "Perbaiki",
  "Format": "Format",
  "Format text": "Format teks",
  "Formula": "Rumus",
  "Formula column": "Kolom rumus",
  "Functions": "Fungsi",
  "Google Sheets": "Google Sheets",
  "Google Sheets link": "Link Google Sheets",
  "Google connection": "Koneksi Google",
  "Group by": "Kelompokkan",
  "Group by columns": "Kelompokkan berdasarkan kolom",
  "Group dates by": "Kelompokkan tanggal per",
  "Group the rest as Others": "Gabungkan sisanya sebagai Lainnya",
  "Has access": "Punya akses",
  "Header & range": "Header & range",
  "Header found on row {row}": "Header ditemukan di baris {row}",
  "Header rows": "Baris header",
  "Height": "Tinggi",
  "Home": "Beranda",
  "If": "Jika",
  "Import a Google Sheets link to create your first dataset.": "Import link Google Sheets untuk membuat dataset pertama Anda.",
  "Import data": "Import data",
  "Import: paste a Google Sheets link and pick a sheet.": "Import: tempel link Google Sheets dan pilih sheet.",
  "In trash": "Di sampah",
  "Indonesian": "Indonesia",
  "Indonesian format (1.234.567,89 · 31/12/2026) or English (1,234,567.89 · 12/31/2026). Codes with a leading zero should stay Text.": "Format Indonesia (1.234.567,89 · 31/12/2026) atau Inggris (1,234,567.89 · 12/31/2026). Kode dengan nol di depan sebaiknya tetap Teks.",
  "Dashly": "Dashly",
  "Internal": "Internal",
  "Item": "Item",
  "Item type": "Jenis item",
  "Keep": "Biarkan",
  "Label": "Label",
  "Large": "Besar",
  "Last characters": "Karakter akhir",
  "Last loaded": "Terakhir di-load",
  "Leave empty to follow the data, also after a refresh": "Kosongkan agar mengikuti data, juga setelah refresh",
  "Length": "Panjang",
  "Limits keep the server and the database healthy; retention removes data nobody uses.": "Batas menjaga server dan database tetap sehat; retensi menghapus data yang tidak dipakai.",
  "Limits: spreadsheet up to {mb} MB, {rows} rows and {cols} columns per dataset.": "Batas: spreadsheet maks {mb} MB, {rows} baris dan {cols} kolom per dataset.",
  "Link active": "Link aktif",
  "Link created.": "Link dibuat.",
  "Link disabled": "Link nonaktif",
  "Link not available": "Link tidak tersedia",
  "List of values": "Daftar nilai",
  "Load": "Load",
  "Load history": "Riwayat load",
  "Load now": "Load sekarang",
  "Load started.": "Load dimulai.",
  "Load the dataset to see its columns.": "Load dataset untuk melihat kolomnya.",
  "Loading": "Memuat",
  "Locale": "Format bahasa",
  "Match": "Cocokkan",
  "Max": "Maks",
  "Max columns per dataset": "Maks kolom per dataset",
  "Max legacy .xls size": "Maks ukuran .xls lama",
  "Max rows per dataset": "Maks baris per dataset",
  "Max sheets per spreadsheet": "Maks sheet per spreadsheet",
  "Max spreadsheet size": "Maks ukuran spreadsheet",
  "Max steps per recipe": "Maks langkah per resep",
  "Max unpacked size": "Maks ukuran setelah diekstrak",
  "Maximum": "Maksimum",
  "Medium": "Sedang",
  "Merge columns": "Gabung kolom",
  "Min": "Min",
  "Minimum": "Minimum",
  "Mode": "Mode",
  "Month (number)": "Bulan (angka)",
  "Month name": "Nama bulan",
  "More actions": "Aksi lainnya",
  "Move down": "Turunkan",
  "Move earlier": "Pindah ke depan",
  "Move later": "Pindah ke belakang",
  "Move up": "Naikkan",
  "My datasets": "Dataset saya",
  "My exports": "Export saya",
  "My quota": "Kuota saya",
  "My reports": "Report saya",
  "Navigator": "Navigator",
  "Network error. Check your connection and try again.": "Gangguan jaringan. Periksa koneksi lalu coba lagi.",
  "New column name": "Nama kolom baru",
  "New column name (empty = replace the column)": "Nama kolom baru (kosong = ganti kolom asal)",
  "New link": "Link baru",
  "New link created.": "Link baru dibuat.",
  "New name": "Nama baru",
  "New names": "Nama baru",
  "New report": "Report baru",
  "New step after the selected one": "Langkah baru setelah langkah terpilih",
  "No access yet": "Belum punya akses",
  "No data for these filters.": "Tidak ada data untuk filter ini.",
  "No datasets yet": "Belum ada dataset",
  "No header row found (columns will be named Kolom1…)": "Baris header tidak ditemukan (kolom akan bernama Kolom1…)",
  "No loads yet": "Belum ada load",
  "No matches.": "Tidak ada yang cocok.",
  "No reports yet": "Belum ada report",
  "No rows at this step.": "Tidak ada baris pada langkah ini.",
  "No rows match.": "Tidak ada baris yang cocok.",
  "No steps yet. Use the ribbon or the column menus.": "Belum ada langkah. Gunakan ribbon atau menu kolom.",
  "None": "Tidak ada",
  "Not configured": "Belum dikonfigurasi",
  "Nothing changed.": "Tidak ada perubahan.",
  "Nothing chosen yet": "Belum ada yang dipilih",
  "Number format": "Format angka",
  "Number of characters": "Jumlah karakter",
  "Number of parts": "Jumlah bagian",
  "Number of rows": "Jumlah baris",
  "Only loaded datasets you can view are listed.": "Hanya dataset yang sudah di-load dan bisa Anda lihat yang ditampilkan.",
  "Only the owner and the people and roles above.": "Hanya pemilik serta orang dan role di atas.",
  "Only the owner has access.": "Hanya pemilik yang punya akses.",
  "Only users and roles with the Dashly module are listed.": "Hanya user dan role yang punya modul Dashly yang ditampilkan.",
  "Open editor": "Buka editor",
  "Open in Google Sheets": "Buka di Google Sheets",
  "Open in Dashly": "Buka di Dashly",
  "Open the editor": "Buka editor",
  "Open the spreadsheet in Google Sheets and click Share.": "Buka spreadsheet di Google Sheets lalu klik Bagikan.",
  "Opened {count} time(s)": "Dibuka {count} kali",
  "Operator": "Operator",
  "Operators": "Operator",
  "Or set General access to \"Anyone with the link\". Only Google Sheets links are accepted.": "Atau ubah Akses umum menjadi \"Siapa saja yang memiliki link\". Hanya link Google Sheets yang diterima.",
  "Original value": "Nilai asli",
  "Otherwise": "Selain itu",
  "Owner": "Pemilik",
  "Ownership transferred.": "Kepemilikan dipindahkan.",
  "Part": "Bagian",
  "Part of the text": "Sebagian teks",
  "Paste a Google Sheets link, tidy the data step by step like Power Query, then build reports you can share privately.": "Tempel link Google Sheets, rapikan data langkah demi langkah seperti Power Query, lalu buat report yang bisa dibagikan secara privat.",
  "Paste the link of the spreadsheet. AiBAS reads every sheet so you can pick the data, then load it directly or tidy it first.": "Tempel link spreadsheet. AiBAS membaca semua sheet agar Anda bisa memilih data, lalu langsung me-load atau merapikannya dulu.",
  "People and roles": "Orang dan role",
  "Per-user quota": "Kuota per user",
  "Percent (0.125 → 12,5%)": "Persen (0,125 → 12,5%)",
  "Pick on sheet": "Pilih di sheet",
  "Pie": "Pie",
  "Pivot": "Pivot",
  "Positions (comma separated)": "Posisi (pisahkan dengan koma)",
  "Private link": "Link privat",
  "Properties": "Properti",
  "Quarter": "Kuartal",
  "Query timeout": "Batas waktu query",
  "Range": "Range",
  "Read spreadsheet": "Baca spreadsheet",
  "Reading the sheets of \"{name}\"...": "Membaca sheet \"{name}\"...",
  "Reading the spreadsheet...": "Membaca spreadsheet...",
  "Reapply steps": "Terapkan ulang langkah",
  "Recently opened": "Terakhir dibuka",
  "Redo": "Ulangi",
  "Refresh started.": "Refresh dimulai.",
  "Refresh started: the latest data is taken from Google Sheets.": "Refresh dimulai: data terbaru diambil dari Google Sheets.",
  "Refresh with this sheet": "Refresh dengan sheet ini",
  "Reload": "Muat ulang",
  "Remove access": "Cabut akses",
  "Remove blank rows": "Hapus baris kosong",
  "Remove bottom rows": "Hapus baris bawah",
  "Remove columns": "Hapus kolom",
  "Remove control characters": "Hapus karakter kontrol",
  "Remove duplicates": "Hapus duplikat",
  "Remove error rows": "Hapus baris error",
  "Remove filter": "Hapus filter",
  "Remove other columns": "Hapus kolom lainnya",
  "Remove top rows": "Hapus baris atas",
  "Rename": "Ganti nama",
  "Rename columns": "Ganti nama kolom",
  "Rename…": "Ganti nama…",
  "Replace errors": "Ganti error",
  "Replace values": "Ganti nilai",
  "Replace values…": "Ganti nilai…",
  "Replace with": "Ganti dengan",
  "Report": "Report",
  "Report name": "Nama report",
  "Report restored.": "Report dipulihkan.",
  "Report viewers can see every column shown in a table visual.": "Pembaca report bisa melihat semua kolom yang tampil di visual tabel.",
  "Report viewers see data only through its visuals, including every column shown in table visuals. They do not get access to the datasets.": "Pembaca report hanya melihat data lewat visualnya, termasuk semua kolom di visual tabel. Mereka tidak mendapat akses ke dataset.",
  "Reports other people share with you appear here.": "Report yang dibagikan orang lain kepada Anda muncul di sini.",
  "Reports shared with me": "Report dibagikan ke saya",
  "Restore steps": "Pulihkan langkah",
  "Restricted": "Terbatas",
  "Retention & links": "Retensi & link",
  "Role": "Role",
  "Row count": "Jumlah baris",
  "Row menu": "Menu baris",
  "Rows": "Baris",
  "Rows per page": "Baris per halaman",
  "Rows per user": "Baris per user",
  "Rows scanned": "Baris yang dipindai",
  "Rows shown": "Baris ditampilkan",
  "Rows stored": "Baris tersimpan",
  "Rows × columns": "Baris × kolom",
  "Rules (first match wins)": "Aturan (yang pertama cocok dipakai)",
  "Rupiah (Rp 1.250.000)": "Rupiah (Rp 1.250.000)",
  "Rupiah short (Rp 1,25 M)": "Rupiah singkat (Rp 1,25 M)",
  "Save step": "Simpan langkah",
  "Search a name or email...": "Cari nama atau email...",
  "Search a name, email or role...": "Cari nama, email, atau role...",
  "Search all columns...": "Cari di semua kolom...",
  "Search columns": "Cari kolom",
  "Search data": "Cari data",
  "Search datasets...": "Cari dataset...",
  "Search reports...": "Cari report...",
  "Search sheets": "Cari sheet",
  "Sensitivity": "Sensitivitas",
  "Separator": "Pemisah",
  "Series / legend (optional)": "Seri / legend (opsional)",
  "Settings saved.": "Pengaturan tersimpan.",
  "Share": "Bagikan",
  "Share link": "Link bagikan",
  "Shared": "Dibagikan",
  "Shared dataset · read only": "Dataset dibagikan · baca saja",
  "Shared report · read only": "Report dibagikan · baca saja",
  "Shared with me": "Dibagikan ke saya",
  "Sheet": "Sheet",
  "Show as table": "Tampilkan sebagai tabel",
  "Show chart": "Tampilkan grafik",
  "Show top": "Tampilkan teratas",
  "Showing the first {count} columns.": "Menampilkan {count} kolom pertama.",
  "Size of the file exported from Google": "Ukuran file hasil export dari Google",
  "Slicer": "Slicer",
  "Small": "Kecil",
  "Something went wrong ({status}).": "Terjadi kesalahan ({status}).",
  "Something went wrong.": "Terjadi kesalahan.",
  "Sort": "Urutkan",
  "Sort ascending": "Urutkan naik",
  "Sort by": "Urutkan berdasarkan",
  "Sort descending": "Urutkan turun",
  "Source (raw sheet)": "Sumber (sheet mentah)",
  "Split by": "Pisahkan berdasarkan",
  "Split column": "Pisah kolom",
  "Split column…": "Pisah kolom…",
  "Spreadsheet": "Spreadsheet",
  "Spreadsheet & dataset limits": "Batas spreadsheet & dataset",
  "Spreadsheets are read by this service account (read only):": "Spreadsheet dibaca oleh service account ini (baca saja):",
  "Start cell": "Sel awal",
  "Start delimiter": "Pembatas awal",
  "Start in three steps": "Mulai dalam tiga langkah",
  "Start position": "Posisi awal",
  "Step {n}": "Langkah {n}",
  "Steps after it may fail because they can depend on this step.": "Langkah setelahnya mungkin gagal karena bergantung pada langkah ini.",
  "Storage": "Penyimpanan",
  "Sum": "Jumlah total",
  "Table": "Tabel",
  "Taking \"{name}\" from Google...": "Mengambil \"{name}\" dari Google...",
  "Taking the latest data from Google Sheets and applying the steps...": "Mengambil data terbaru dari Google Sheets dan menerapkan langkah...",
  "Text": "Teks",
  "Text between delimiters": "Teks di antara pembatas",
  "The Google integration is not configured on the server. Contact the IT administrator.": "Integrasi Google belum dikonfigurasi di server. Hubungi admin IT.",
  "The current data stays available until the load finishes.": "Data saat ini tetap tersedia sampai load selesai.",
  "The current link stops working immediately. Anyone who needs access must get the new link.": "Link saat ini langsung tidak berlaku. Siapa pun yang butuh akses harus mendapat link baru.",
  "The dataset is ready.": "Dataset siap.",
  "The dataset moves to the trash and can be restored for a while.": "Dataset dipindahkan ke sampah dan masih bisa dipulihkan beberapa waktu.",
  "The dataset was moved to trash.": "Dataset dipindahkan ke sampah.",
  "The draft dataset is deleted.": "Draft dataset dihapus.",
  "The export failed. Try again.": "Export gagal. Coba lagi.",
  "The export follows the search, filters and sort of the data table. Up to 50,000 rows download directly; larger exports are prepared in the background and appear on the Dashly home page.": "Export mengikuti pencarian, filter, dan urutan tabel data. Sampai 50.000 baris langsung diunduh; export yang lebih besar disiapkan di latar belakang dan muncul di Beranda Dashly.",
  "The file is no longer available.": "File sudah tidak tersedia.",
  "The formula cannot be computed for this row.": "Rumus tidak bisa dihitung untuk baris ini.",
  "The last load failed": "Load terakhir gagal",
  "The link always asks for an AiBAS login. It never opens for anonymous visitors.": "Link selalu meminta login AiBAS. Link tidak pernah terbuka untuk pengunjung anonim.",
  "The load failed.": "Load gagal.",
  "The new owner gets full control. You keep access only if it is shared with you.": "Pemilik baru mendapat kendali penuh. Anda tetap punya akses hanya jika dibagikan ke Anda.",
  "The previous data is still shown.": "Data sebelumnya masih ditampilkan.",
  "The report moves to the trash and can be restored for a while. Its datasets are not affected.": "Report dipindahkan ke sampah dan masih bisa dipulihkan beberapa waktu. Datasetnya tidak terpengaruh.",
  "The sheet has more rows than allowed.": "Sheet punya lebih banyak baris dari yang diizinkan.",
  "The spreadsheet can stay private": "Spreadsheet tetap bisa privat",
  "The spreadsheet could not be read.": "Spreadsheet tidak bisa dibaca.",
  "The spreadsheet shows an error in this cell (for example #N/A or #DIV/0!).": "Spreadsheet menunjukkan error di sel ini (misalnya #N/A atau #DIV/0!).",
  "The steps are back to the last load.": "Langkah dikembalikan ke load terakhir.",
  "The steps go back to the version of the last load.": "Langkah kembali ke versi load terakhir.",
  "The steps of that load are back in the editor. Reapply to use them.": "Langkah dari load itu sudah kembali di editor. Terapkan ulang untuk memakainya.",
  "The steps stay the same; the sheet is matched by name.": "Langkah tetap sama; sheet dicocokkan berdasarkan nama.",
  "The transform editor works best on a desktop. On this screen it is read only.": "Editor transformasi paling nyaman dibuka di desktop. Di layar ini hanya baca.",
  "The visual is removed from the report.": "Visual dihapus dari report.",
  "Then": "Maka",
  "This dataset has not been loaded yet.": "Dataset ini belum pernah di-load.",
  "This dataset is open in the editor in another tab or device. Changes there can overwrite yours.": "Dataset ini sedang dibuka di editor pada tab atau perangkat lain. Perubahan di sana bisa menimpa perubahan Anda.",
  "This link does not open right now (disabled or expired).": "Link ini sedang tidak bisa dibuka (nonaktif atau kedaluwarsa).",
  "This report has no visuals yet": "Report ini belum punya visual",
  "This sheet has no table data.": "Sheet ini tidak berisi data tabel.",
  "Thousands separator": "Pemisah ribuan",
  "Tidy: choose the range and header row, fix types, remove what you do not need.": "Rapikan: pilih range dan baris header, perbaiki tipe, buang yang tidak perlu.",
  "Top users by rows": "User teratas berdasarkan baris",
  "Top-left cell of the table, e.g. B3": "Sel kiri-atas tabel, misalnya B3",
  "Transfer": "Pindahkan",
  "Transfer ownership": "Pindahkan kepemilikan",
  "Transfer ownership…": "Pindahkan kepemilikan…",
  "Transform": "Transformasi",
  "Transform data": "Transform data",
  "Trash": "Sampah",
  "Trash is empty": "Sampah kosong",
  "Trash kept": "Sampah disimpan",
  "Trim spaces": "Rapikan spasi",
  "True / false": "Benar / salah",
  "UPPERCASE": "HURUF BESAR",
  "Undo": "Batalkan",
  "Unpivot": "Unpivot",
  "Unsaved changes": "Perubahan belum tersimpan",
  "Unused spreadsheets kept": "Spreadsheet tak terpakai disimpan",
  "Up to": "Sampai",
  "Usage": "Pemakaian",
  "Use first row as headers": "Jadikan baris pertama header",
  "Use headers as first row": "Jadikan header baris pertama",
  "Use this row as headers": "Jadikan baris ini header",
  "Used by these reports; their visuals will show \"Dataset deleted\":": "Dipakai di report berikut; visualnya akan menampilkan \"Dataset dihapus\":",
  "Valid": "Valid",
  "Value column name": "Nama kolom nilai",
  "Value, high to low": "Nilai, besar ke kecil",
  "Value, low to high": "Nilai, kecil ke besar",
  "Values": "Nilai",
  "Values column": "Kolom nilai",
  "Values separated by commas": "Nilai dipisahkan koma",
  "View as reader": "Lihat sebagai pembaca",
  "Viewer": "Viewer",
  "Visual filters": "Filter visual",
  "Visual type": "Jenis visual",
  "Visualise: build a report with cards, charts and slicers, then share it.": "Visualisasikan: buat report berisi kartu, grafik, dan slicer, lalu bagikan.",
  "Who can open the link": "Siapa yang bisa membuka link",
  "Whole cell": "Seluruh sel",
  "Whole number": "Bilangan bulat",
  "Width": "Lebar",
  "Wk": "Mg",
  "Year-month": "Tahun-bulan",
  "You do not have access to this page": "Anda tidak punya akses ke halaman ini",
  "all columns": "semua kolom",
  "between": "di antara",
  "columns": "kolom",
  "contains": "mengandung",
  "data starts at {cell}": "data mulai di {cell}",
  "does not contain": "tidak mengandung",
  "does not equal": "tidak sama dengan",
  "e.g. Project Monitoring Q4": "mis. Monitoring Proyek Q4",
  "empty = end of data": "kosong = sampai akhir data",
  "end of data": "akhir data",
  "ends with": "diakhiri",
  "equals": "sama dengan",
  "from all {count} rows of the sheet": "dari semua {count} baris sheet",
  "greater than": "lebih besar dari",
  "greater than or equal": "lebih besar atau sama dengan",
  "hidden": "tersembunyi",
  "hours": "jam",
  "is empty": "kosong",
  "is not empty": "tidak kosong",
  "is not one of": "bukan salah satu dari",
  "is one of": "salah satu dari",
  "keep": "tetap",
  "last": "terakhir",
  "less than": "lebih kecil dari",
  "less than or equal": "lebih kecil atau sama dengan",
  "link": "link",
  "lowercase": "huruf kecil",
  "optional": "opsional",
  "preview from the first {count} rows": "preview dari {count} baris pertama",
  "s": "dtk",
  "same name": "nama sama",
  "sort / group results are based on the sample": "hasil urut / kelompok berdasarkan sampel",
  "starts with": "diawali",
  "step {n}": "langkah {n}",
  "until": "s/d",
  "{count} cell errors": "{count} sel error",
  "{count} cells hold formulas without a saved result. Open and save the file again.": "{count} sel berisi rumus tanpa hasil tersimpan. Buka dan simpan ulang file.",
  "{count} columns": "{count} kolom",
  "{count} datasets were created.": "{count} dataset dibuat.",
  "{count} distinct": "{count} unik",
  "{count} errors": "{count} error",
  "{count} row(s)": "{count} baris",
  "{count} rows": "{count} baris",
  "{count} rows shown": "{count} baris ditampilkan",
  "{count} sheets": "{count} sheet",
  "{count} sheets chosen: each becomes its own dataset.": "{count} sheet dipilih: masing-masing menjadi dataset sendiri.",
  "{count} steps": "{count} langkah",
  "{count} values": "{count} nilai",
  "{count} visuals": "{count} visual",
  "{rows} rows × {cols} columns": "{rows} baris × {cols} kolom",
  "Initial load": "Load awal",
  "Reapply": "Terapkan ulang",
  "queued": "antre",
  "running": "berjalan",
  "succeeded": "berhasil",
  "superseded": "digantikan",
  "Dashly Exports Ready": "Export Dashly Siap",
  "Choose a column for this step.": "Pilih kolom untuk langkah ini.",
  "Legend (several series)": "Legend (beberapa seri)",
  "Visualize": "Visualisasikan",
  "Run the saved steps again on the current spreadsheet snapshot.": "Jalankan ulang langkah tersimpan pada snapshot spreadsheet saat ini.",
  "Use another Google Sheets link or sheet with the same columns.": "Pakai link atau sheet Google Sheets lain dengan kolom yang sama.",
  "Name, description and sensitivity.": "Nama, deskripsi, dan sensitivitas.",
  "Download as CSV or Excel.": "Unduh sebagai CSV atau Excel.",
  "A new dataset with the same steps and spreadsheet.": "Dataset baru dengan langkah dan spreadsheet yang sama.",
  "Hand the dataset to another Dashly user.": "Serahkan dataset ke pengguna Dashly lain.",
  "Move to trash; it can be restored for a while.": "Pindahkan ke sampah; masih bisa dipulihkan beberapa waktu.",
  "A copy of this report with the same visuals, owned by you.": "Salinan report ini dengan visual yang sama, milik Anda.",
  "Hand the report to another Dashly user.": "Serahkan report ke pengguna Dashly lain.",
  "Choose at least one sheet.": "Pilih minimal satu sheet.",
  "Sheet to load: {names}": "Sheet yang di-load: {names}",
  // Dashly v1.3: projects, combined datasets and the report canvas.
  "A copy with all its elements.": "Salinan beserta semua elemennya.",
  "A dataset this one reads was updated; applying the steps again...": "Dataset yang dibaca dataset ini diperbarui; menerapkan langkah lagi...",
  "A free canvas: place, resize and layer charts, then present it.": "Kanvas bebas: letakkan, ubah ukuran, dan atur lapisan grafik, lalu presentasikan.",
  "A new dataset that joins this one with another on a key column.": "Dataset baru yang menggabungkan dataset ini dengan dataset lain lewat kolom kunci.",
  "A project groups the datasets and reports of one program or customer. Share the project and your team gets all of it.": "Project mengelompokkan dataset dan report satu program atau customer. Bagikan project-nya dan tim Anda mendapat semuanya.",
  "A project holds datasets and reports. Share the project and people get everything inside; share a single dataset or report for finer access.": "Project berisi dataset dan report. Bagikan project agar orang mendapat semua isinya; bagikan satu dataset atau report untuk akses yang lebih terbatas.",
  "A project holds datasets and reports; sharing it shares everything inside.": "Project berisi dataset dan report; membagikannya berarti membagikan semua isinya.",
  "A4 portrait": "A4 tegak",
  "Add a visual for this column": "Tambah visual untuk kolom ini",
  "Add another key column": "Tambah kolom kunci lain",
  "Add data": "Tambah data",
  "Add data from Google Sheets links; combine sheets on a key such as TPD ID.": "Tambahkan data dari link Google Sheets; gabungkan sheet lewat kunci seperti TPD ID.",
  "Add every match (rows can multiply)": "Tambahkan semua kecocokan (baris bisa bertambah)",
  "Add page": "Tambah halaman",
  "Add to canvas": "Tambahkan ke kanvas",
  "Align": "Ratakan",
  "Align bottom": "Rata bawah",
  "Align centre": "Rata tengah",
  "Align left": "Rata kiri",
  "Align middle": "Rata tengah vertikal",
  "Align right": "Rata kanan",
  "Align to page": "Ratakan ke halaman",
  "Align top": "Rata atas",
  "All changes saved": "Semua perubahan tersimpan",
  "All my projects": "Semua project saya",
  "All projects": "Semua project",
  "All projects ({count})": "Semua project ({count})",
  "All rows from both": "Semua baris dari keduanya",
  "Also has access through the project": "Juga punya akses lewat project",
  "Back to editing": "Kembali mengedit",
  "Back to projects": "Kembali ke daftar project",
  "Background": "Latar",
  "Body text": "Teks isi",
  "Bold": "Tebal",
  "Border": "Garis tepi",
  "Border color": "Warna garis tepi",
  "Bring forward": "Majukan",
  "Bring to front": "Paling depan",
  "Canvas": "Kanvas",
  "Card style": "Gaya kartu",
  "Change these in the project's sharing. A direct share above adds to it; the higher level wins.": "Ubah ini di pengaturan share project. Share langsung di atas menambahkannya; level yang lebih tinggi yang berlaku.",
  "Charts & data": "Grafik & data",
  "Charts without their own colors use the theme.": "Grafik tanpa warna sendiri memakai tema.",
  "Choose the column for :agg.": "Pilih kolom untuk :agg.",
  "Choose the key columns first.": "Pilih kolom kunci dulu.",
  "Choose the starting dataset, the dataset to merge and the key columns to see the combined rows.": "Pilih dataset awal, dataset yang digabung, dan kolom kuncinya untuk melihat hasil gabungan.",
  "Clear all filters": "Hapus semua filter",
  "Color": "Warna",
  "Column in the other dataset": "Kolom di dataset lain",
  "Column in this table": "Kolom di tabel ini",
  "Columns to add ({count})": "Kolom yang ditambahkan ({count})",
  "Combine": "Gabungkan",
  "Combine datasets": "Gabungkan dataset",
  "Combine with another dataset…": "Gabungkan dengan dataset lain…",
  "Combined dataset": "Dataset gabungan",
  "Combined datasets read this one; their next load will fail:": "Dataset gabungan berikut membaca dataset ini; load berikutnya akan gagal:",
  "Combined from": "Gabungan dari",
  "Content": "Isi",
  "Copy, paste, duplicate": "Salin, tempel, duplikat",
  "Corner radius": "Sudut membulat",
  "Create a project, e.g. one per program or customer.": "Buat project, misalnya satu per program atau customer.",
  "Create a report and design it on the canvas.": "Buat report dan desain di kanvas.",
  "Create and open canvas": "Buat dan buka kanvas",
  "Create combined dataset": "Buat dataset gabungan",
  "Create project": "Buat project",
  "Create your first project": "Buat project pertama Anda",
  "Custom": "Kustom",
  "Delete element?": "Hapus elemen?",
  "Delete page": "Hapus halaman",
  "Delete page \"{name}\"?": "Hapus halaman \"{name}\"?",
  "Delete project": "Hapus project",
  "Delete project?": "Hapus project?",
  "Delete {count} elements?": "Hapus {count} elemen?",
  "Design reports on a free canvas and share the project with your team.": "Desain report di kanvas bebas dan bagikan project ke tim Anda.",
  "Distribute horizontally": "Sebar merata horizontal",
  "Distribute vertically": "Sebar merata vertikal",
  "Double-click to rename": "Klik dua kali untuk mengganti nama",
  "Double-click to type": "Klik dua kali untuk mengetik",
  "Drag a column onto the page: numbers become a card, dates a trend line, text a column chart.": "Seret kolom ke halaman: angka jadi kartu, tanggal jadi garis tren, teks jadi grafik kolom.",
  "Duplicate page": "Duplikat halaman",
  "Edit data": "Edit data",
  "Edit data & fields": "Edit data & field",
  "Edit text": "Edit teks",
  "Element": "Elemen",
  "Ellipse": "Elips",
  "Every row stays; matching values are added, others stay empty (like XLOOKUP).": "Semua baris tetap; nilai yang cocok ditambahkan, sisanya kosong (seperti XLOOKUP).",
  "Exit presentation": "Keluar presentasi",
  "Fill": "Isi warna",
  "Finds my rows whose key is missing on the other side.": "Mencari baris saya yang kuncinya tidak ada di sisi lain.",
  "Fit": "Pas",
  "Forest": "Hutan",
  "Grape": "Anggur",
  "Hand the project to another Dashly user.": "Serahkan project ke pengguna Dashly lain.",
  "Hide in the report": "Sembunyikan di report",
  "Hold Alt while dragging to place freely.": "Tahan Alt saat menyeret untuk menaruh bebas.",
  "Ignore upper/lower case (spaces at the ends are always ignored)": "Abaikan huruf besar/kecil (spasi di ujung selalu diabaikan)",
  "Inner spacing": "Jarak dalam",
  "Input dataset updated": "Dataset masukan diperbarui",
  "Insert": "Sisipkan",
  "Italic": "Miring",
  "Its rows are the starting table; the others add columns to it.": "Barisnya menjadi tabel awal; dataset lain menambahkan kolom.",
  "Its {count} elements are deleted too.": "{count} elemennya ikut terhapus.",
  "Join sheets on a key such as TPD ID": "Gabungkan sheet lewat kunci seperti TPD ID",
  "Join sheets on a shared key, e.g. TPD ID, into one dataset for one visual.": "Gabungkan sheet lewat kunci yang sama, misalnya TPD ID, menjadi satu dataset untuk satu visual.",
  "Keep all my rows": "Pertahankan semua baris saya",
  "Keep proportions": "Jaga proporsi",
  "Keyboard": "Keyboard",
  "Kind": "Jenis",
  "Layer": "Lapisan",
  "Layer name": "Nama lapisan",
  "Layers": "Lapisan",
  "Line color": "Warna garis",
  "Lock": "Kunci",
  "Lock all": "Kunci semua",
  "Lock position": "Kunci posisi",
  "Long page (scroll)": "Halaman panjang (scroll)",
  "Manage access": "Kelola akses",
  "Match counts appear for keys from the starting dataset.": "Jumlah kecocokan muncul untuk kunci dari dataset awal.",
  "Match rows on": "Cocokkan baris berdasarkan",
  "Merge": "Gabung",
  "Merge another dataset": "Gabung dataset lain",
  "Merge with dataset": "Gabung dengan dataset",
  "Merges": "Menggabungkan",
  "Monochrome": "Monokrom",
  "Move left": "Geser ke kiri",
  "Move right": "Geser ke kanan",
  "Move to project": "Pindahkan ke project",
  "Move to project…": "Pindahkan ke project…",
  "Moved to the other project.": "Dipindahkan ke project lain.",
  "Name of the new dataset": "Nama dataset baru",
  "Name, description and color.": "Nama, deskripsi, dan warna.",
  "New project": "Project baru",
  "New project…": "Project baru…",
  "No datasets in this project yet": "Belum ada dataset di project ini",
  "No loaded datasets yet.": "Belum ada dataset yang ter-load.",
  "No project yet": "Belum ada project",
  "No reports in this project yet": "Belum ada report di project ini",
  "Not saved – retry": "Belum tersimpan – coba lagi",
  "Nothing shared with you yet": "Belum ada yang dibagikan ke Anda",
  "Nudge 1 px (10 px)": "Geser 1 px (10 px)",
  "Ocean": "Samudra",
  "Only loaded datasets you can view. Its latest loaded rows are used, and this dataset is reloaded when that one changes.": "Hanya dataset ter-load yang bisa Anda lihat. Baris terakhirnya yang dipakai, dan dataset ini di-load ulang saat dataset itu berubah.",
  "Only matching rows": "Hanya baris yang cocok",
  "Only possible when it has no datasets or reports.": "Hanya bisa jika tidak ada dataset atau report di dalamnya.",
  "Only the first": "Hanya yang pertama",
  "Only the owner can see and manage the member list.": "Hanya pemilik yang bisa melihat dan mengelola daftar anggota.",
  "Opacity": "Opasitas",
  "Open Transform": "Buka Transform",
  "Other projects": "Project lain",
  "Outline": "Garis luar",
  "Outline width": "Tebal garis",
  "Owned by me": "Milik saya",
  "Page actions": "Aksi halaman",
  "Page size": "Ukuran halaman",
  "Page {n}": "Halaman {n}",
  "Pages": "Halaman",
  "Paste a Google Sheets link to add the first dataset.": "Tempel link Google Sheets untuk menambah dataset pertama.",
  "People": "Orang",
  "People who only had access through the current project lose it; people of the new project get it. Direct shares stay.": "Orang yang hanya punya akses lewat project sekarang akan kehilangannya; orang di project baru mendapatkannya. Share langsung tetap ada.",
  "Position & size": "Posisi & ukuran",
  "Prefix for new columns (optional)": "Awalan untuk kolom baru (opsional)",
  "Present": "Presentasi",
  "Project owner · editor": "Pemilik project · editor",
  "Project restored.": "Project dipulihkan.",
  "Project settings": "Pengaturan project",
  "Project: create one for your program or customer.": "Project: buat satu untuk program atau customer Anda.",
  "Put the dataset in another project; its people get access.": "Pindahkan dataset ke project lain; orang di project itu mendapat akses.",
  "Put the report in another project; its people get access.": "Pindahkan report ke project lain; orang di project itu mendapat akses.",
  "Rectangle": "Persegi panjang",
  "Refresh started: the latest rows of the input datasets are combined again.": "Refresh dimulai: baris terbaru dari dataset masukan digabung ulang.",
  "Rename page": "Ganti nama halaman",
  "Report theme": "Tema report",
  "Result preview": "Pratinjau hasil",
  "Result: {count} rows": "Hasil: {count} baris",
  "Rounded panel": "Panel membulat",
  "Rows that exist on only one side are kept too.": "Baris yang hanya ada di satu sisi juga dipertahankan.",
  "Rows to keep": "Baris yang dipertahankan",
  "Rows without a match": "Baris tanpa pasangan",
  "Rows without a match on the other side are dropped.": "Baris tanpa pasangan di sisi lain dibuang.",
  "Save in project": "Simpan di project",
  "Search projects...": "Cari project...",
  "Select all on the page": "Pilih semua di halaman",
  "Selection": "Pilihan",
  "Send backward": "Mundurkan",
  "Send backward / bring forward": "Mundurkan / majukan",
  "Send to back": "Paling belakang",
  "Shadow": "Bayangan",
  "Shape": "Bentuk",
  "Shapes": "Bentuk",
  "Show": "Tampilkan",
  "Show grid": "Tampilkan grid",
  "Show title": "Tampilkan judul",
  "Size": "Ukuran",
  "Smart guides": "Panduan pintar",
  "Snap to grid (8 px)": "Tempel ke grid (8 px)",
  "Standard 4:3": "Standar 4:3",
  "Start from": "Mulai dari",
  "Start with a project, add Google Sheets data, tidy and combine it like Power Query, then design reports on a free canvas and share them privately.": "Mulai dengan project, tambahkan data Google Sheets, rapikan dan gabungkan seperti Power Query, lalu desain report di kanvas bebas dan bagikan secara privat.",
  "Subtitle": "Subjudul",
  "Sunset": "Senja",
  "Take only the first match": "Ambil kecocokan pertama saja",
  "Text color": "Warna teks",
  "The combined dataset is loading. It appears in the Data panel when it is ready.": "Dataset gabungan sedang di-load. Akan muncul di panel Data saat siap.",
  "The element is removed from the report. This cannot be undone.": "Elemen dihapus dari report. Ini tidak bisa dibatalkan.",
  "The page is empty.": "Halaman ini kosong.",
  "The project moves to the trash. It can only be deleted when it no longer holds datasets or reports.": "Project dipindah ke tempat sampah. Hanya bisa dihapus jika sudah tidak berisi dataset atau report.",
  "This dataset has no number columns, so Sum and Average are not available. Change a column's type to a whole or decimal number in Transform, or use Count / Count distinct.": "Dataset ini tidak punya kolom angka, jadi Sum dan Rata-rata tidak tersedia. Ubah tipe kolom menjadi bilangan bulat atau desimal di Transform, atau pakai Jumlah / Jumlah unik.",
  "This page is empty. Insert a chart, text or shape.": "Halaman ini kosong. Sisipkan grafik, teks, atau bentuk.",
  "This project": "Project ini",
  "Title text": "Teks judul",
  "To give someone just one report or dataset, share that item instead.": "Untuk memberi seseorang satu report atau dataset saja, bagikan item tersebut.",
  "Transparent background": "Latar transparan",
  "Two sharing layers: people of the project reach everything here; a single dataset or report can also be shared on its own.": "Dua lapis share: orang di project mendapat semua isi di sini; satu dataset atau report juga bisa dibagikan sendiri.",
  "Undo / redo": "Urungkan / ulangi",
  "Unlock": "Buka kunci",
  "Unlock all": "Buka kunci semua",
  "Use shapes as panels behind charts; send them to the back in Layers.": "Pakai bentuk sebagai panel di belakang grafik; kirim ke paling belakang di Lapisan.",
  "Viewers can open every report and dataset in the project. Editors can also change them and add new ones. Only the owner manages sharing and deletes the project.": "Viewer bisa membuka semua report dan dataset di project. Editor juga bisa mengubahnya dan menambah yang baru. Hanya pemilik yang mengelola share dan menghapus project.",
  "Viewers open every dataset and report in this project; editors can also change them and add new ones. Sharing, deleting and transferring stay with the owner of each item.": "Viewer membuka semua dataset dan report di project ini; editor juga bisa mengubah dan menambah yang baru. Share, hapus, dan alih kepemilikan tetap di pemilik tiap item.",
  "Visualise: design a report on the canvas with cards, charts and slicers, then share it.": "Visualisasikan: desain report di kanvas dengan kartu, grafik, dan slicer, lalu bagikan.",
  "Vivid": "Cerah",
  "When a key appears more than once": "Jika kunci muncul lebih dari sekali",
  "Who can open this project": "Siapa yang bisa membuka project ini",
  "Whole organization": "Seluruh organisasi",
  "Widescreen 16:9": "Layar lebar 16:9",
  "You can change the size of every page later in the canvas.": "Ukuran tiap halaman bisa diubah nanti di kanvas.",
  "Zoom / pan": "Zoom / geser",
  "Zoom in": "Perbesar",
  "Zoom out": "Perkecil",
  "copy": "salinan",
  "e.g. Dismantle Monitoring 2026": "mis. Monitoring Dismantle 2026",
  "e.g. Sheet 2": "mis. Sheet 2",
  "e.g. TPD with SOW and Dismantle": "mis. TPD dengan SOW dan Dismantle",
  "from all {count} rows of the starting dataset": "dari semua {count} baris dataset awal",
  "no suitable column": "tidak ada kolom yang cocok",
  "reloads by itself when these are loaded again": "ter-load ulang otomatis saat dataset tersebut di-load ulang",
  "{count} datasets": "{count} dataset",
  "{count} elements selected": "{count} elemen dipilih",
  "{count} keys appear more than once on the other side": "{count} kunci muncul lebih dari sekali di sisi lain",
  "{count} members": "{count} anggota",
  "{count} reports": "{count} report",
  "{count} rows have no match on the other side": "{count} baris tidak punya pasangan di sisi lain",
  "{count} rows of the other side are not used": "{count} baris dari sisi lain tidak terpakai",
  "{matched} of {total} rows found a match ({share}%)": "{matched} dari {total} baris menemukan pasangan ({share}%)",
  "left": "kiri",
  "center": "tengah",
  "right": "kanan",
  "top": "atas",
  "middle": "tengah",
  "bottom": "bawah",
  "keep all rows": "semua baris",
  "only matches": "hanya yang cocok",
  "all rows": "semua baris",
  "without match": "tanpa pasangan",
  "Choose a dataset and the fields for this visual.": "Pilih dataset dan field untuk visual ini.",
  "Hold": "Menunggu",
  "Continue": "Lanjutkan",
  "Save draft": "Simpan draft",
  "Create draft": "Buat draft",
  "Download PDF": "Unduh PDF",
  "Row {row}": "Baris {row}",
  "Request failed.": "Permintaan gagal.",
  "Action failed.": "Aksi gagal.",
  "Choose an Excel file first.": "Pilih file Excel terlebih dahulu.",
  "Choose an Excel file": "Pilih file Excel",
  "max 10 MB": "maks 10 MB",
  "OPS · Install Stage": "OPS · Tahap Install",
  "Close the Install stage of each TPD with an RFS checklist and its Google Drive evidence.": "Selesaikan tahap Install setiap TPD dengan RFS checklist beserta evidence Google Drive-nya.",
  "Install Stage · TPD": "Tahap Install · TPD",
  "Open TPDs come first; TPDs at 100% stay at the bottom.": "TPD yang belum selesai tampil di atas; TPD 100% tetap ada di paling bawah.",
  "Search TPD, link ID, or RFS...": "Cari TPD, link ID, atau RFS...",
  "No TPD matches the search.": "Tidak ada TPD yang cocok dengan pencarian.",
  "No project at the Install stage yet. The SO must be Released and its WBS must have an Install stage.": "Belum ada project di tahap Install. SO harus Released dan WBS-nya harus memiliki tahap Install.",
  "Completed · Install 100% or RFS approved": "Selesai · Install 100% atau RFS disetujui",
  "RFS · {status}": "RFS · {status}",
  "No RFS yet": "Belum ada RFS",
  "Fill RFS": "Isi RFS",
  "Back to TPD list": "Kembali ke daftar TPD",
  "New RFS for TPD {tpd}": "RFS baru untuk TPD {tpd}",
  "Not created": "Belum dibuat",
  "From Sales Order": "Dari Sales Order",
  "The Sales Order has no SOW for this TPD, so choose it here.": "Sales Order belum mencantumkan SOW untuk TPD ini, jadi pilih di sini.",
  "Link ID New Link / Upgrade": "Link ID New Link / Upgrade",
  "RFS checklist": "Checklist RFS",
  "Checked automatically from the evidence links.": "Tercentang otomatis dari link evidence.",
  "RFS date and all 11 captures": "Tanggal RFS dan 11 capture lengkap",
  "Capture NMS NE and FE": "Capture NMS NE dan FE",
  "Capture ISR NE and FE": "Capture ISR NE dan FE",
  "Evidence from Google Drive": "Evidence dari Google Drive",
  "Installation capture": "Capture instalasi",
  "Open {label}": "Buka {label}",
  "Approval pages": "Halaman approval",
  "Network Acceptance": "Network Acceptance",
  "Any user with RFS approve access": "Siapa pun dengan akses approve RFS",
  "Approval steps appear after submission.": "Tahap approval muncul setelah diajukan.",
  "Delete draft": "Hapus draft",
  "Choose the SOW first.": "Pilih SOW terlebih dahulu.",
  "RFS draft saved.": "Draft RFS tersimpan.",
  "RFS draft created.": "Draft RFS dibuat.",
  "RFS step approved.": "Tahap RFS disetujui.",
  "RFS rejected.": "RFS ditolak.",
  "RFS draft deleted.": "Draft RFS dihapus.",
  "Unable to load the RFS checklist.": "Gagal memuat RFS checklist.",
  "Unable to load the RFS.": "Gagal memuat RFS.",
  "Unable to save the RFS.": "Gagal menyimpan RFS.",
  "Approve {rfs}?": "Setujui {rfs}?",
  "Your approval signs the current Network Acceptance step.": "Persetujuan Anda menandatangani tahap Network Acceptance saat ini.",
  "Approve RFS": "Setujui RFS",
  "Reject {rfs}?": "Tolak {rfs}?",
  "The RFS goes back to the requester to be revised.": "RFS dikembalikan ke requester untuk direvisi.",
  "Reject RFS": "Tolak RFS",
  "Delete {rfs}?": "Hapus {rfs}?",
  "The draft and its evidence links are removed. This cannot be undone.": "Draft beserta link evidence-nya dihapus. Tindakan ini tidak bisa dibatalkan.",
  "Delete {rfs}": "Hapus {rfs}",
  "Reason for rejection": "Alasan penolakan",
  "Approval note (optional)": "Catatan approval (opsional)",
  "Write what has to be revised.": "Tulis apa yang harus direvisi.",
  "Import RFS Checklist Excel": "Import Excel RFS Checklist",
  "Download the template: it lists every open TPD of the eligible projects.": "Unduh template: berisi semua TPD yang belum selesai dari project yang memenuhi syarat.",
  "Fill the SOW (when the SO has none), RFS date and the eleven Google Drive links.": "Isi SOW (bila SO belum mencantumkannya), tanggal RFS, dan sebelas link Google Drive.",
  "Upload the file. Rows of different projects can share one sheet.": "Unggah file. Baris dari project berbeda boleh dalam satu sheet.",
  "{success} of {total} rows saved, {failed} failed.": "{success} dari {total} baris tersimpan, {failed} gagal.",
  "Your sign type": "Jenis tanda tangan Anda",
  "Place your signature on every page, from page 1 to the last.": "Bubuhkan tanda tangan di setiap halaman, dari halaman 1 sampai terakhir.",
  "Place your signature on one page you choose, usually the signature page.": "Bubuhkan tanda tangan di satu halaman pilihan, biasanya halaman tanda tangan.",
  "Approve without a signature; nothing is added to the PDF.": "Setujui tanpa tanda tangan; tidak ada yang ditambahkan ke PDF.",
  "Evidence cannot be a script or program file.": "Evidence tidak boleh berupa file script atau program.",
  "The evidence file is larger than {max} MB.": "File evidence lebih dari {max} MB.",
  "Evidence preview": "Pratinjau evidence",
  "Choose a file or drop it here": "Pilih file atau tarik ke sini",
  "or paste a screenshot with": "atau tempel screenshot dengan",
  "Any file type (PDF, images, Office, ZIP, ...). Max. {max} MB.": "Semua jenis file (PDF, gambar, Office, ZIP, ...). Maks. {max} MB.",
  "Document Logo": "Logo Dokumen",
  "RFS Document Logo": "Logo Dokumen RFS",
  "Unable to load the logos.": "Gagal memuat logo.",
  "Unable to save the logo.": "Gagal menyimpan logo.",
  "RFS logo updated.": "Logo RFS diperbarui.",
  "RFS logo reset to the default.": "Logo RFS dikembalikan ke default.",
  "The logo at the top right of every RFS PDF page, per project. PNG or JPG, max. 2 MB.": "Logo di kanan atas setiap halaman PDF RFS, per project. PNG atau JPG, maks. 2 MB.",
  "No project is at the Install stage yet.": "Belum ada project di tahap Install.",
  "Default logo": "Logo default",
  "Custom logo": "Logo khusus",
  "Logo of {name}": "Logo {name}",
  "No logo": "Tidak ada logo",
  "Use default": "Pakai default",
  "Upload logo": "Unggah logo",
  "Use a PNG or JPG image.": "Gunakan gambar PNG atau JPG.",
  "The image is larger than {max} MB.": "Gambar lebih dari {max} MB.",
  "Evidence type": "Jenis evidence",
  "Give every capture as": "Semua capture diisi sebagai",
  "Image": "Gambar",
  "Drive link": "Link Drive",
  "Saved in Google Drive": "Tersimpan di Google Drive",
  "Replace image": "Ganti gambar",
  "Create the draft first, then images can be uploaded.": "Buat draft dulu, lalu gambar bisa diunggah.",
  "Image for {label}: click, then paste with Ctrl+V or drop a file": "Gambar untuk {label}: klik, lalu tempel dengan Ctrl+V atau tarik file",
  "Click here and press Ctrl+V, or drop an image": "Klik di sini lalu tekan Ctrl+V, atau tarik gambar",
  "Unable to load the PM Vendor list.": "Gagal memuat daftar PM Vendor.",
  "Choose who signs as PM Vendor.": "Pilih siapa yang tanda tangan sebagai PM Vendor.",
  "Draw the signature first.": "Gambar tanda tangan terlebih dahulu.",
  "Choose a signature image first.": "Pilih gambar tanda tangan terlebih dahulu.",
  "{name} has no saved signature yet. Draw or upload one.": "{name} belum punya tanda tangan tersimpan. Gambar atau unggah dulu.",
  "Unable to submit the RFS.": "Gagal mengajukan RFS.",
  "Sign as PM Vendor": "Tanda tangan sebagai PM Vendor",
  "{rfs} goes to the XLSMART approvals after this signature.": "{rfs} lanjut ke approval XLSMART setelah tanda tangan ini.",
  "PM Vendor": "PM Vendor",
  "Choose who signs": "Pilih penanda tangan",
  "Saved signature of {name}": "Tanda tangan tersimpan {name}",
  "Sign & submit": "Tanda tangan & ajukan",
  "RFS signed and submitted for approval.": "RFS sudah ditandatangani dan diajukan untuk approval.",
  "Signs when the RFS is submitted": "Tanda tangan saat RFS diajukan",
  "Signed": "Ditandatangani",
  "RFS signed and approved.": "RFS sudah ditandatangani dan disetujui.",
  "Not signed yet": "Belum ditandatangani",
  "Saved, but AiBAS cannot open the Drive file of {captures}, so it is not copied to the TPD folder and the PDF cannot show it. Share the file with {account} (Viewer), or give it as an image.": "Tersimpan, tapi AiBAS tidak bisa membuka file Drive untuk {captures}, jadi file tidak disalin ke folder TPD dan tidak tampil di PDF. Share file ke {account} (Viewer), atau isi sebagai gambar.",
  "the AiBAS Google Drive account": "akun Google Drive AiBAS",
  "Official (00:00)": "Resmi (00:00)",
  "Temporary (12:00)": "Sementara (12:00)",
  "The latest AX data ({heldBack}) looked incomplete and was held back. These are the last valid figures; AiBAS retries automatically.": "Data AX terbaru ({heldBack}) tampak tidak lengkap dan ditahan. Angka di bawah adalah data valid terakhir; AiBAS mencoba ulang otomatis.",
  "Temporary figures: the S-curve keeps the official close of {date} until the 00:00 sync.": "Angka sementara: S-curve tetap memakai data resmi {date} sampai sync pukul 00:00.",
  "Actual budget follows the official AX close (00:00), latest {date}": "Actual budget mengikuti data resmi AX (00:00), terakhir {date}",
  "Progress is ahead of budget use": "Progress lebih cepat dari penggunaan budget",
  "Progress and budget use are balanced": "Progress dan penggunaan budget seimbang",
  "Budget is used faster than progress": "Budget terpakai lebih cepat dari progress",
  "Budget Not Synced": "Budget belum tersinkron",
  "Budget has not been synchronized from AX yet": "Budget belum tersinkron dari AX",
  "No Budget": "Budget belum tersedia",
  "No budget is set for this project": "Proyek ini belum memiliki budget",
  "Variance = Actual Progress − Budget Utilization; within ±{tolerance} pp is On Budget.": "Variance = Actual Progress − Budget Utilization; dalam ±{tolerance} pp dianggap On Budget.",
  "Consumed compared with Total Budget, independent of progress.": "Consumed dibandingkan Total Budget, terlepas dari progress.",
  "Over Budget Limit": "Melebihi Total Budget",
  "Within Budget": "Dalam Total Budget",
  "Budget Health": "Budget Health",
  "All Budget Health": "Semua Budget Health",
  "Variance": "Variance",
  "No Sales Order linked": "Belum terhubung ke Sales Order",
  "Budget is used {gap} pp faster than progress": "Budget terpakai {gap} pp lebih cepat dari progress",
  "Progress is {gap} pp ahead of budget use": "Progress {gap} pp lebih cepat dari penggunaan budget",
  "Progress and budget use are within ±{tolerance} pp": "Progress dan penggunaan budget masih dalam ±{tolerance} pp",
  "Ordered, paid from the remaining budget": "Sudah dipesan, dibayar dari sisa budget",
  "Budget vs Progress": "Budget vs Progress",
  "Separate from the project health status.": "Terpisah dari status kesehatan proyek.",
  "Under Budget": "Under Budget",
  "On Budget": "On Budget",
  "Consumed of approved budget": "Terpakai dari budget yang disetujui",
  "No GPI lines yet": "Belum ada baris GPI",
  "Project Value (SO):": "Nilai Proyek (SO):",
  "How {title} is calculated": "Cara menghitung {title}",
  "Progress (%) = Σ Weighted of every WBS stage": "Progress (%) = Σ Weighted seluruh stage WBS",
  "Weighted = Stage Completion × Stage Weight (%) ÷ 100": "Weighted = Completion Stage × Bobot Stage (%) ÷ 100",
  "Progress is 100% once every stage except Complete has reached 100%.": "Progress menjadi 100% setelah semua stage selain Complete mencapai 100%.",
  "Recalculated on every progress submission.": "Dihitung ulang setiap kali progress disubmit.",
  "the latest submitted progress of each TPD per stage, and the stage weights of the project's WBS template.": "progress terakhir yang disubmit untuk setiap TPD per stage, dan bobot stage dari template WBS proyek.",
  "TPD Weight = Value (TPD) ÷ Σ Value (TPD) of the project": "Bobot TPD = Value (TPD) ÷ Σ Value (TPD) proyek",
  "Stage Completion = Σ (TPD Weight × TPD Completion in that stage)": "Completion Stage = Σ (Bobot TPD × Completion TPD di stage tersebut)",
  "Value (TPD) = Σ Quantity × Sales Price of all GPI rows with that TPD ID, so a TPD split over several rows counts once, in full.": "Value (TPD) = Σ Quantity × Sales Price dari semua baris GPI dengan TPD ID tersebut, sehingga TPD yang terbagi di beberapa baris dihitung sekali secara utuh.",
  "A TPD worth Rp 0 carries no weight. Only when no TPD has any value does every TPD count equally.": "TPD bernilai Rp 0 tidak memiliki bobot. Hanya jika tidak ada TPD yang bernilai, semua TPD dihitung sama rata.",
  "TPD Completion is the highest submission for that TPD and stage; the Complete stage is reached automatically when all other stages of the TPD are 100%.": "Completion TPD adalah submission tertinggi untuk TPD dan stage tersebut; stage Complete tercapai otomatis saat semua stage lain pada TPD sudah 100%.",
  "Budget Used (%) = Consumed ÷ Total Budget × 100": "Budget Used (%) = Consumed ÷ Total Budget × 100",
  "Consumed: consumed budget synced from AX (00:00 and 12:00).": "Consumed: budget terpakai hasil sinkron AX (00:00 dan 12:00).",
  "Total Budget: Revised Budget (Approval) from AX; the baseline budget until AX has an approval budget.": "Total Budget: Revised Budget (Approval) dari AX; memakai baseline budget selama AX belum memiliki approval budget.",
  "Commitment (PO) is not counted as used.": "Commitment (PO) tidak dihitung sebagai terpakai.",
  "Shown as - when the project has no budget or AX has not synced it yet.": "Ditampilkan - jika proyek belum memiliki budget atau belum tersinkron dari AX.",
  "Value (row) = Quantity × Sales Price": "Value (baris) = Quantity × Sales Price",
  "Value (TPD) = Σ Value (row) of every GPI row with the same TPD ID": "Value (TPD) = Σ Value (baris) dari setiap baris GPI dengan TPD ID yang sama",
  "Value (Sales) = Σ Value (TPD) of the project": "Value (Sales) = Σ Value (TPD) proyek",
  "Every GPI row is counted exactly once. Rows without a TPD ID, or marked Expense / Additional, are not part of the value.": "Setiap baris GPI dihitung tepat satu kali. Baris tanpa TPD ID, atau bertanda Expense / Additional, tidak termasuk dalam nilai.",
  "The same Value (TPD) is the weight of each TPD in the progress calculation.": "Value (TPD) yang sama menjadi bobot setiap TPD dalam perhitungan progress.",
  "Value (Sales) is financial information only; it is not used in any score.": "Value (Sales) hanya informasi finansial; tidak dipakai dalam score apa pun.",
  "GPI lines of the project's Sales Order.": "baris GPI pada Sales Order proyek.",
  "Project Overview": "Ringkasan Proyek",
  "How the values are calculated": "Cara menghitung nilai",
  "Budget": "Budget",
  "Value (Sales)": "Value (Sales)",
  "Progress of every project": "Progress seluruh proyek",
  "Search projects": "Cari proyek",
  "Project name or ID": "Nama atau ID proyek",
  "Project Name / ID": "Nama Proyek / ID",
  "{tpds} TPD · {lines} GPI rows": "{tpds} TPD · {lines} baris GPI",
  "{tpds} TPD": "{tpds} TPD",
  "No TPD value": "Belum ada nilai TPD",
  "Previous year": "Tahun sebelumnya",
  "Next year": "Tahun berikutnya",
  "{tpds} TPD weighted by their Value (Sales)": "{tpds} TPD dibobot dengan Value (Sales)",
  "{tpds} TPD weighted equally (no TPD has a value)": "{tpds} TPD dibobot sama rata (tidak ada TPD yang bernilai)",
  "Σ Value (TPD): {value}": "Σ Value (TPD): {value}",
  "{count} TPD worth Rp 0 carry no weight.": "{count} TPD bernilai Rp 0 tidak memiliki bobot.",
  "Score (pp) = Progress (%) − Budget Used (%)": "Score (pp) = Progress (%) − Budget Used (%)",
  "Above +{tolerance} pp: Under Budget, progress is ahead of spending.": "Di atas +{tolerance} pp: Under Budget, progress lebih cepat dari pemakaian budget.",
  "Between −{tolerance} and +{tolerance} pp: On Budget.": "Antara −{tolerance} dan +{tolerance} pp: On Budget.",
  "Below −{tolerance} pp: Over Budget, budget is used faster than progress.": "Di bawah −{tolerance} pp: Over Budget, budget terpakai lebih cepat dari progress.",
  "Rounded to one decimal before it is compared. A project without progress is scored with 0% progress. No score (-) only when the project has no budget or AX has not synced it yet.": "Dibulatkan satu desimal sebelum dibandingkan. Proyek yang belum ada progress tetap dihitung dengan progress 0%. Tidak ada score (-) hanya jika proyek belum memiliki budget atau belum tersinkron dari AX.",
  "Only percentages are compared; Value (Sales) in Rupiah is not part of the score. It is separate from the Project Health status and the Portfolio Score (SPI/CPI).": "Hanya persentase yang dibandingkan; Value (Sales) dalam Rupiah tidak termasuk dalam score. Score ini terpisah dari status Project Health dan Portfolio Score (SPI/CPI).",
  "Score": "Score",
  "Progress, budget used, sales value and score of every project": "Progress, budget terpakai, nilai penjualan, dan score seluruh proyek",
  "Reset filters": "Reset filter",
  "No project matches the filters": "Tidak ada proyek yang sesuai filter",
  "No Score": "Tanpa Score",
  "On Budget within ±{tolerance} pp": "On Budget dalam ±{tolerance} pp",
  "The WBS stages could not be loaded. Try again.": "Stage WBS tidak dapat dimuat. Silakan coba lagi.",
  "WBS stages of every project, with the value achieved and TPDs per stage": "Stage WBS seluruh proyek, dengan nilai tercapai dan TPD per stage",
  "WBS stages of every project, with the TPDs per stage": "Stage WBS seluruh proyek, dengan TPD per stage",
  "WBS Stages": "Stage WBS",
  "Summary": "Ringkasan",
  "WBS": "WBS",
  "Loading WBS stages": "Memuat stage WBS",
  "TPD": "TPD",
  "No WBS stages yet: the project has no Sales Order or no TPD.": "Belum ada stage WBS: proyek belum memiliki Sales Order atau TPD.",
  "No WBS stages yet.": "Belum ada stage WBS.",
  "Value Achieved": "Nilai Tercapai",
  "TPD done": "TPD selesai",
  "Progress by": "Progress berdasarkan",
  "Value (Rp)": "Nilai (Rp)",
  "Quantity (TPD)": "Kuantitas (TPD)",
  "Progress by Quantity (TPD)": "Progress berdasarkan Kuantitas (TPD)",
  "Previous stages": "Stage sebelumnya",
  "Next stages": "Stage berikutnya",
  "Stage %: every TPD counts once": "Stage %: setiap TPD dihitung satu kali",
  "{started} of {total} TPDs have progress in this stage": "{started} dari {total} TPD sudah ada progress di stage ini",
  "Value %: this amount as a share of the project value": "Value %: nominal ini terhadap nilai proyek",
  "No TPD of this project has a value, so its stages weigh every TPD equally.": "Tidak ada TPD proyek ini yang bernilai, sehingga setiap TPD dibobot sama rata.",
  "Value achieved (stage) = Σ (Value (TPD) × TPD Completion in the stage ÷ 100)": "Nilai tercapai (stage) = Σ (Value (TPD) × Completion TPD di stage ÷ 100)",
  "Stage % = Σ TPD Completion in the stage ÷ number of TPDs": "Stage % = Σ Completion TPD di stage ÷ jumlah TPD",
  "Value % = Value achieved ÷ Σ Value (TPD) × 100": "Value % = Nilai tercapai ÷ Σ Value (TPD) × 100",
  "Stage % counts every TPD once, so it follows the Progress Update terminal.": "Stage % menghitung setiap TPD satu kali, sehingga mengikuti Progress Update.",
  "Value % weighs each TPD by its value. It is the stage completion behind the project progress, so it can differ from Stage %.": "Value % membobot setiap TPD dengan nilainya. Angka ini dasar progress proyek, sehingga bisa berbeda dari Stage %.",
  "TPD: TPDs at 100% in the stage, out of all TPDs of the project.": "TPD: jumlah TPD yang sudah 100% di stage, dari seluruh TPD proyek.",
  "Stages come from the project's WBS template, in stage order.": "Stage diambil dari template WBS proyek sesuai urutan.",
  "Add Host": "Tambah host",
  "Add VM": "Tambah VM",
  "All hosts": "Semua host",
  "All {count} servers will be deleted. This cannot be undone, so export the inventory first.": "Seluruh {count} server akan dihapus. Tindakan ini tidak bisa dibatalkan, jadi ekspor inventaris dulu.",
  "Cells copied from Excel": "Sel yang disalin dari Excel",
  "Changing this IP moves all of this host's VMs to the new IP.": "Mengubah IP ini memindahkan semua VM host ini ke IP baru.",
  "Choose a file": "Pilih file",
  "Choose a host": "Pilih host",
  "Clear filters": "Hapus filter",
  "Columns, in this order: Server Name, Processor (Core), Processor (GHz), RAM (GB), Storage (GB), Host IP (If VM), IP Address, Tipe, Status.": "Kolom, sesuai urutan: Server Name, Processor (Core), Processor (GHz), RAM (GB), Storage (GB), Host IP (If VM), IP Address, Tipe, Status.",
  "Core": "Core",
  "Delete all": "Hapus semua",
  "Delete host and VMs": "Hapus host dan VM",
  "Delete server": "Hapus server",
  "Delete the whole inventory?": "Hapus seluruh inventaris?",
  "Delete {count} servers": "Hapus {count} server",
  "Delete {name}?": "Hapus {name}?",
  "Export Excel": "Ekspor Excel",
  "Freed: {cores} core · {ram} GB RAM": "Dibebaskan: {cores} core · {ram} GB RAM",
  "Host": "Host",
  "Host {ip}": "Host {ip}",
  "Hosts": "Host",
  "Hosts and VMs in one place: allocated capacity, what is used, and what is left on each host.": "Host dan VM di satu tempat: kapasitas, yang terpakai, dan sisa di setiap host.",
  "IP address": "Alamat IP",
  "Import servers": "Impor server",
  "Import your Excel inventory, or add the first host by hand.": "Impor inventaris dari Excel, atau tambahkan host pertama secara manual.",
  "Informational only: the capacity of a host that is off still counts in the totals.": "Hanya informasi: kapasitas host yang Off tetap dihitung di total.",
  "Left {amount}{unit}": "Sisa {amount}{unit}",
  "Move or delete this host's {count} VM(s) to change its type.": "Pindahkan atau hapus {count} VM host ini untuk mengubah tipenya.",
  "Name or IP": "Nama atau IP",
  "No host": "Tanpa host",
  "No servers match this search.": "Tidak ada server yang cocok dengan pencarian ini.",
  "No servers yet": "Belum ada server",
  "Optional for a VM.": "Opsional untuk VM.",
  "Over-allocated {amount}{unit}": "Kelebihan {amount}{unit}",
  "Paste from Excel": "Tempel dari Excel",
  "RAM (GB)": "RAM (GB)",
  "Rows are matched by IP, or by name and host for a VM without an IP. Existing rows are updated, not duplicated.": "Baris dicocokkan lewat IP, atau nama dan host untuk VM tanpa IP. Baris yang sudah ada diperbarui, tidak digandakan.",
  "Save changes": "Simpan perubahan",
  "Server Inventory": "Inventaris Server",
  "Server name": "Nama server",
  "Storage (GB)": "Storage (GB)",
  "This host and its {count} VM(s) will be deleted. This cannot be undone.": "Host ini dan {count} VM-nya akan dihapus. Tindakan ini tidak bisa dibatalkan.",
  "This server will be deleted. This cannot be undone.": "Server ini akan dihapus. Tindakan ini tidak bisa dibatalkan.",
  "Totals": "Total",
  "Type {count} to confirm": "Ketik {count} untuk konfirmasi",
  "Unable to export the server inventory.": "Gagal mengekspor inventaris server.",
  "Unable to load the server inventory.": "Gagal memuat inventaris server.",
  "Upload file": "Unggah file",
  "VMs off": "VM Off",
  "VMs without a host": "VM tanpa host",
  "{active} active · {off} off": "{active} aktif · {off} off",
  "{created} new, {updated} updated, {unchanged} unchanged, {skipped} skipped, {corrected} corrected.": "{created} baru, {updated} diperbarui, {unchanged} tidak berubah, {skipped} dilewati, {corrected} dikoreksi.",
  "{ip} (no host)": "{ip} (tanpa host)",
  "{name} deleted.": "{name} dihapus.",
  "Weekly Update": "Update Mingguan",
  "Infra Server": "Infra Server",
  "Corsec · Infrastructure": "Corsec · Infrastruktur",
  "Corsec sections": "Bagian Corsec",
  "Fill in {field}.": "Isi {field}.",
  "No VMs on this host yet.": "Belum ada VM di host ini.",
  "All servers": "Semua server",
  "{shown} of {total} shown": "{shown} dari {total} ditampilkan",
  "Not counted on any host until moved.": "Tidak dihitung di host mana pun sampai dipindahkan.",
  "Move to a host": "Pindahkan ke host",
  "Core (active VMs)": "Core (VM aktif)",
  "RAM (active VMs)": "RAM (VM aktif)",
  "{count} core of off VMs not counted": "{count} core VM off tidak dihitung",
  "{count} GB of off VMs not counted": "{count} GB VM off tidak dihitung",
  "Disks of off VMs still count": "Disk VM off tetap dihitung",
  "Used {share}%": "Terpakai {share}%",
  "{active} VM active · {off} off": "{active} VM aktif · {off} off",
  "VM off · {count}": "VM Off · {count}",
  "Import / export": "Impor / ekspor",
  "Download the inventory as Excel, in the columns the import reads.": "Unduh inventaris sebagai Excel, dengan kolom yang sama seperti impor.",
  "See all ({count})": "Lihat semua ({count})",
  "Turn off": "Matikan",
  "Turn on": "Aktifkan",
  "Turn off {name}": "Matikan {name}",
  "Turn on {name}": "Aktifkan {name}",
  "Utility": "Utilitas",
  "Tools & Support": "Alat & Dukungan",
  "Community": "Komunitas",
  "Learn & Share": "Belajar & Berbagi",
  "Coming soon": "Segera hadir",
  "Internal tools for everyday work: report IT problems and build reports from your data.": "Alat internal untuk pekerjaan sehari-hari: laporkan kendala IT dan buat laporan dari data Anda.",
  "IT Helpdesk": "IT Helpdesk",
  "Report a problem with an application, laptop, printer, internet or email, and follow it until it is solved.": "Laporkan kendala aplikasi, laptop, printer, internet, atau email, lalu pantau sampai selesai.",
  "Report an issue": "Laporkan kendala",
  "You have no active tickets": "Anda tidak punya tiket aktif",
  "{count} active tickets": "{count} tiket aktif",
  "Pull data from Google Sheets, tidy and combine it, then design reports and share them privately.": "Ambil data dari Google Sheets, rapikan dan gabungkan, lalu rancang laporan dan bagikan secara privat.",
  "Guides for every AiBAS module, a place to ask questions, and learning material for the team.": "Panduan setiap modul AiBAS, tempat bertanya, dan materi belajar untuk tim.",
  "Manual Book": "Manual Book",
  "Step-by-step user manuals for the AiBAS modules.": "Manual pengguna langkah demi langkah untuk modul AiBAS.",
  "No manuals for your role yet": "Belum ada manual untuk role Anda",
  "{count} manuals for your role": "{count} manual untuk role Anda",
  "Q&A": "Tanya Jawab",
  "Ask how something works in AiBAS and get answers from colleagues and module owners.": "Tanyakan cara kerja fitur AiBAS dan dapatkan jawaban dari rekan dan pemilik modul.",
  "AiBAS Academy": "AiBAS Academy",
  "Short lessons and onboarding paths to learn AiBAS module by module.": "Materi singkat dan jalur onboarding untuk mempelajari AiBAS per modul.",
  "User manuals for the AiBAS modules you work in. Each one opens as a PDF in a new tab.": "Manual pengguna untuk modul AiBAS yang Anda pakai. Setiap manual terbuka sebagai PDF di tab baru.",
  "Manuals for more modules are on the way. Ask your administrator if you need access to an existing one.": "Manual untuk modul lain sedang disiapkan. Hubungi administrator jika Anda butuh akses ke manual yang sudah ada.",
  "{module} · PDF": "{module} · PDF",
  "Manuals for the other modules will be added here as they are written.": "Manual modul lain akan ditambahkan di sini setelah selesai ditulis.",
  "Submit agreements, letters and legality documents, then follow the approval and signing flow.": "Ajukan perjanjian, surat, dan dokumen legalitas, lalu ikuti alur approval dan tanda tangan.",
  "Work the pipeline as an Account Manager: customers, opportunities and the steps up to Won or Drop.": "Kelola pipeline sebagai Account Manager: customer, opportunity, dan langkah sampai Won atau Drop.",
  "Questions and answers are coming": "Tanya jawab segera hadir",
  "AiBAS Academy is coming": "AiBAS Academy segera hadir",
  "My tickets": "Tiket saya",
  "IT HELPDESK": "IT HELPDESK",
  "IT DESK": "DESK IT",
  "Inbox": "Inbox",
  "Topics": "Topik",
  "DATA": "DATA",
  "UTILITY": "UTILITAS",
  "COMMUNITY": "KOMUNITAS",
  "Too many requests. Wait a moment and try again.": "Terlalu banyak permintaan. Tunggu sebentar lalu coba lagi.",
  "#{position} of {total}": "#{position} dari {total}",
  "+{count} more": "+{count} lainnya",
  "Add a note for the requester.": "Tambahkan catatan untuk pemohon.",
  "Add module": "Tambah modul",
  "Add note": "Tambah catatan",
  "Add service": "Tambah layanan",
  "All actions": "Semua aksi",
  "All active": "Semua aktif",
  "Any category": "Semua kategori",
  "Any priority": "Semua prioritas",
  "Any status": "Semua status",
  "Any topic": "Semua topik",
  "Anyone": "Siapa saja",
  "Applications: an AiBAS module or another internal system.": "Aplikasi: modul AiBAS atau sistem internal lain.",
  "Assignee": "Petugas",
  "Assignee changed": "Petugas diubah",
  "Attach a JPG, PNG or PDF file.": "Lampirkan file JPG, PNG, atau PDF.",
  "Avg. first response": "Rata-rata respons pertama",
  "Avg. time to resolve": "Rata-rata waktu selesai",
  "Back to list": "Kembali ke daftar",
  "Cancel ticket": "Batalkan tiket",
  "Cancel ticket {no}?": "Batalkan tiket {no}?",
  "Choose the application module.": "Pilih modul aplikasi.",
  "Choose the service.": "Pilih layanan.",
  "Choose…": "Pilih…",
  "Close ticket": "Tutup tiket",
  "Composer": "Penulis balasan",
  "Delete ticket": "Hapus tiket",
  "Delete ticket {no}?": "Hapus tiket {no}?",
  "Describe the issue in at least 10 characters.": "Jelaskan kendala minimal 10 karakter.",
  "Devices and services: laptop, printer, internet, email.": "Perangkat dan layanan: laptop, printer, internet, email.",
  "Drop a file here or choose one": "Tarik file ke sini atau pilih file",
  "Earlier tickets": "Tiket sebelumnya",
  "Email": "Email",
  "Every change to tickets and topics, newest first.": "Setiap perubahan tiket dan topik, terbaru di atas.",
  "Every open ticket in the order the IT team works on them. Refreshes every 30 seconds.": "Semua tiket terbuka sesuai urutan pengerjaan Tim IT. Diperbarui setiap 30 detik.",
  "First response": "Respons pertama",
  "Handled by": "Ditangani oleh",
  "Helpdesk audit log": "Audit log helpdesk",
  "Helpdesk dashboard": "Dashboard helpdesk",
  "Helpdesk queue": "Antrian helpdesk",
  "Helpdesk topics": "Topik helpdesk",
  "IT desk": "Desk IT",
  "IT team": "Tim IT",
  "In progress": "Diproses",
  "Include what you were doing, the error message and since when.": "Sertakan apa yang sedang Anda lakukan, pesan error, dan sejak kapan.",
  "Internal note": "Catatan internal",
  "Internal note added": "Catatan internal ditambahkan",
  "Is the issue solved?": "Kendala sudah selesai?",
  "It disappears from the desk and from the requester's list. The audit log keeps a record.": "Tiket hilang dari desk dan dari daftar pemohon. Audit log tetap menyimpan catatannya.",
  "JPG, PNG or PDF, up to {size} MB": "JPG, PNG, atau PDF, maksimal {size} MB",
  "Keep ticket": "Biarkan tiket",
  "Last activity": "Aktivitas terakhir",
  "Latest activity": "Aktivitas terbaru",
  "Loading…": "Memuat…",
  "Low": "Rendah",
  "Me": "Saya",
  "Message to the requester": "Pesan untuk pemohon",
  "Message to the requester (required)": "Pesan untuk pemohon (wajib)",
  "Modules (ITApps)": "Modul (ITApps)",
  "Move {no} to {status}": "Pindahkan {no} ke {status}",
  "New module name": "Nama modul baru",
  "New service name": "Nama layanan baru",
  "New tickets, last 14 days": "Tiket masuk, 14 hari terakhir",
  "Newest first": "Terbaru dulu",
  "No active tickets": "Tidak ada tiket aktif",
  "No closed tickets yet": "Belum ada tiket selesai",
  "No entries match": "Tidak ada catatan yang cocok",
  "No open tickets right now.": "Tidak ada tiket terbuka saat ini.",
  "No tickets here": "Tidak ada tiket di sini",
  "No tickets in the last 30 days.": "Tidak ada tiket dalam 30 hari terakhir.",
  "Nobody yet": "Belum ada",
  "Not picked up yet": "Belum diambil",
  "Note (optional)": "Catatan (opsional)",
  "Note for the requester": "Catatan untuk pemohon",
  "Number, name, email, text  ( / )": "Nomor, nama, email, teks  ( / )",
  "Off": "Nonaktif",
  "Oldest first": "Terlama dulu",
  "Only the IT team sees this note": "Hanya Tim IT yang melihat catatan ini",
  "Order": "Urutan",
  "Page {page} of {pages}": "Halaman {page} dari {pages}",
  "Past SLA": "Lewat SLA",
  "Pick a ticket": "Pilih tiket",
  "Priority changed": "Prioritas diubah",
  "Queue #{position}": "Antrian #{position}",
  "Queue order": "Urutan antrian",
  "Remove attachment {name}": "Hapus lampiran {name}",
  "Reply sent": "Balasan terkirim",
  "Reply sent to the requester": "Balasan terkirim ke pemohon",
  "Reply to requester": "Balas pemohon",
  "Reply to the IT team": "Balas ke Tim IT",
  "Report IT problems and follow them until they are solved.": "Laporkan kendala IT dan pantau sampai selesai.",
  "Reported": "Dilaporkan",
  "Reported as": "Dilaporkan sebagai",
  "Resolved": "Selesai",
  "Resolved today": "Selesai hari ini",
  "SLA": "SLA",
  "Search tickets": "Cari tiket",
  "Send report": "Kirim laporan",
  "Services (ITInfra)": "Layanan (ITInfra)",
  "Status after this reply": "Status setelah balasan ini",
  "Status changed": "Status diubah",
  "Take": "Ambil",
  "Tell us what the issue is about.": "Sebutkan kendalanya tentang apa.",
  "The IT team will stop working on it. Report a new issue if the problem comes back.": "Tim IT akan berhenti menanganinya. Laporkan kendala baru jika masalah muncul lagi.",
  "The file is larger than {size} MB.": "File lebih besar dari {size} MB.",
  "The modules (ITApps) and services (ITInfra) people pick when they report an issue.": "Modul (ITApps) dan layanan (ITInfra) yang dipilih saat melaporkan kendala.",
  "The queue is empty": "Antrian kosong",
  "The ticket closes by itself in {days} days. Reply below if it is not fixed yet.": "Tiket ditutup otomatis dalam {days} hari. Balas di bawah jika belum beres.",
  "Ticket": "Tiket",
  "Ticket cancelled": "Tiket dibatalkan",
  "Ticket number or detail": "Nomor tiket atau detail",
  "Ticket views": "Tampilan tiket",
  "Ticket {no} deleted": "Tiket {no} dihapus",
  "Ticket {no} sent": "Tiket {no} terkirim",
  "Tickets": "Tiket",
  "Top topics, last 30 days": "Topik teratas, 30 hari terakhir",
  "Topic": "Topik",
  "Topic added": "Topik ditambahkan",
  "Topic saved": "Topik disimpan",
  "Topic turned off": "Topik dinonaktifkan",
  "Topic turned on": "Topik diaktifkan",
  "Try another view or clear the filters.": "Coba tampilan lain atau hapus filter.",
  "Type a name first.": "Isi nama terlebih dahulu.",
  "Urgent": "Mendesak",
  "Use j and k to move through the list, r to reply.": "Pakai j dan k untuk berpindah tiket, r untuk membalas.",
  "View queue": "Lihat antrian",
  "Wait for requester": "Tunggu pemohon",
  "What happened?": "Apa yang terjadi?",
  "When something is not working, report it here and the IT team will pick it up.": "Jika ada yang tidak berfungsi, laporkan di sini dan Tim IT akan menanganinya.",
  "Which application?": "Aplikasi apa?",
  "Which service?": "Layanan apa?",
  "Workload right now and how fast the IT team answers. Figures refresh every minute.": "Beban kerja saat ini dan kecepatan respons Tim IT. Angka diperbarui setiap menit.",
  "Write a reply first.": "Tulis balasan terlebih dahulu.",
  "Write the note first.": "Tulis catatan terlebih dahulu.",
  "You took the ticket": "Tiket Anda ambil",
  "Your ticket": "Tiket Anda",
  "always last, always on": "selalu paling bawah, selalu aktif",
  "e.g. Sales Order": "mis. Sales Order",
  "e.g. VPN": "mis. VPN",
  "just now": "baru saja",
  "reported the issue": "melaporkan kendala",
  "updated {when}": "diperbarui {when}",
  "{count} d": "{count} hr",
  "{count} d ago": "{count} hari lalu",
  "{count} h": "{count} jam",
  "{count} h ago": "{count} jam lalu",
  "{count} min": "{count} mnt",
  "{count} min ago": "{count} mnt lalu",
  "{count} tickets": "{count} tiket",
  "3 months": "3 bulan",
  "30 days": "30 hari",
  "7 days": "7 hari",
  "Being worked on": "Sedang dikerjakan",
  "By priority": "Per prioritas",
  "By status": "Per status",
  "Download CSV": "Unduh CSV",
  "Every ticket has someone on it.": "Semua tiket sudah ada petugasnya.",
  "Hi, {name}": "Halo, {name}",
  "IT Helpdesk • What people pick when they report an issue: ITApps {apps}, ITInfra {infra}": "IT Helpdesk • Pilihan saat melaporkan kendala: ITApps {apps}, ITInfra {infra}",
  "IT Helpdesk • {active} active, {reply} waiting for your reply": "IT Helpdesk • {active} aktif, {reply} menunggu balasan Anda",
  "IT Helpdesk • {open} open, {unassigned} unassigned": "IT Helpdesk • {open} terbuka, {unassigned} belum ada petugas",
  "Internal tools for everyday work": "Alat internal untuk pekerjaan sehari-hari",
  "Issue": "Kendala",
  "Late on the response or resolve target": "Terlambat dari target respons atau penyelesaian",
  "New {noun}": "{noun} baru",
  "No active tickets. Everything is working.": "Tidak ada tiket aktif. Semua berjalan lancar.",
  "No ticket resolved in this period.": "Belum ada tiket selesai di periode ini.",
  "No tickets in this period.": "Tidak ada tiket di periode ini.",
  "No topics match": "Tidak ada topik yang cocok",
  "Nothing is late. Nice work.": "Tidak ada yang terlambat. Kerja bagus.",
  "Older": "Lebih lama",
  "Open tickets": "Tiket terbuka",
  "Open {title} in the desk": "Buka {title} di desk",
  "Reported by you and not closed yet": "Anda laporkan dan belum ditutup",
  "Search number, name, email or text": "Cari nomor, nama, email, atau teks",
  "Search topics": "Cari topik",
  "See all": "Lihat semua",
  "Since midnight": "Sejak tengah malam",
  "The IT team asked something or solved it": "Tim IT bertanya atau sudah menyelesaikannya",
  "This week": "Minggu ini",
  "Tickets by category": "Tiket per kategori",
  "Tickets in line right now": "Tiket dalam antrian saat ini",
  "Tickets received": "Tiket masuk",
  "Tools": "Alat",
  "Top topics": "Topik teratas",
  "Updated {when}": "Diperbarui {when}",
  "Waiting for someone to take them": "Menunggu diambil petugas",
  "Waiting for the requester": "Menunggu pemohon",
  "Waiting for your reply": "Menunggu balasan Anda",
  "Yesterday": "Kemarin",
  "Your active tickets": "Tiket aktif Anda",
  "Your recent tickets": "Tiket terbaru Anda",
  "Your ticket is #{position} in line • refreshes every 30 seconds": "Tiket Anda di antrian #{position} • diperbarui setiap 30 detik",
  "from the previous 3 months": "dari 3 bulan sebelumnya",
  "from the previous 30 days": "dari 30 hari sebelumnya",
  "from the previous 7 days": "dari 7 hari sebelumnya",
  "module": "Modul",
  "service": "Layanan",
  "{active} active, {unassigned} unassigned": "{active} aktif, {unassigned} belum ada petugas",
  "{count} resolved today": "{count} selesai hari ini",
  "{count} s ago": "{count} dtk lalu",
  "Conversation": "Percakapan",
  "Files": "File",
  "Hide ticket details": "Sembunyikan detail tiket",
  "Show ticket details": "Tampilkan detail tiket",
  "Ticket details": "Detail tiket",
  "Message {name}…": "Pesan untuk {name}…",
  "No files attached.": "Belum ada file terlampir.",
  "Note for the IT team only…": "Catatan khusus Tim IT…",
  "Reply": "Balas",
  "This ticket is {status}. Replies are closed.": "Tiket ini {status}. Balasan sudah ditutup.",
  "Timing": "Waktu",
  "Views": "Tampilan",
  "{first}–{last} of {total}": "{first}–{last} dari {total}",
  "{position} of {total}": "{position} dari {total}",
  "Previous ticket": "Tiket sebelumnya",
  "Next ticket": "Tiket berikutnya",
  "Ticket created": "Tiket dibuat",
  "Comment added": "Komentar ditambahkan",
  "Ticket deleted": "Tiket dihapus",
  "Tickets exported": "Tiket diekspor",
  "Topic created": "Topik dibuat",
  "Topic updated": "Topik diperbarui",
  "Topic switched": "Topik diaktifkan/nonaktifkan",
  "Try another action or date range.": "Coba aksi atau rentang tanggal lain.",
};
